export default {
  // 酒店知识库独立语言块，保留原有语言内容。
  hotelKnowledge: {
    "title": "Kho kiến thức khách sạn",
    "tip": "Quản lý câu hỏi và câu trả lời của khách sạn hiện tại.",
    "created": "Thời gian tạo",
    "updated": "Thời gian cập nhật",
    "to": "đến",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "question": "Câu hỏi",
    "answer": "Câu trả lời",
    "tags": "Thẻ",
    "questionSearch": "Tìm câu hỏi theo từ khóa",
    "tagSearch": "Tìm thẻ theo từ khóa",
    "search": "Tìm kiếm",
    "reset": "Đặt lại",
    "create": "Thêm",
    "batchDelete": "Xóa mục đã chọn",
    "loadFailed": "Không thể tải. Vui lòng thử lại.",
    "notFilled": "Chưa điền",
    "actions": "Thao tác",
    "view": "Xem toàn bộ nội dung",
    "edit": "Chỉnh sửa",
    "delete": "Xóa",
    "details": "Chi tiết kiến thức",
    "missingTitle": "Thiếu nội dung cũ",
    "missingView": "Câu hỏi hoặc câu trả lời của bản ghi này chưa được điền. Vui lòng bổ sung trước khi lưu.",
    "missingForm": "Câu hỏi hoặc câu trả lời chưa được điền. Vui lòng bổ sung trước khi lưu.",
    "noDetails": "Không có chi tiết",
    "close": "Đóng",
    "enterQuestion": "Vui lòng nhập câu hỏi",
    "enterAnswer": "Vui lòng nhập câu trả lời",
    "answerPlaceholder": "Vui lòng nhập câu trả lời; có thể nhập nhiều dòng.",
    "tagPlaceholder": "Nhập thẻ rồi nhấn Enter để thêm",
    "tagTip": "Nhấn Enter để thêm thẻ. Dấu phẩy và dấu cách không tách thẻ. Tổng độ dài thẻ tối đa là 512 ký tự.",
    "cancel": "Hủy",
    "save": "Lưu",
    "chooseHotel": "Vui lòng chọn khách sạn trước",
    "empty": "Không có dữ liệu",
    "editTitle": "Chỉnh sửa kiến thức",
    "createTitle": "Thêm kiến thức",
    "tagRequired": "Vui lòng thêm ít nhất một thẻ",
    "tagText": "Thẻ phải là văn bản. Hãy xóa và thêm lại.",
    "tagBlank": "Thẻ không được để trống. Hãy xóa và thêm lại.",
    "tagsTooLong": "Nội dung thẻ quá dài. Hãy rút ngắn và thử lại.",
    "questionTooLong": "Câu hỏi không được vượt quá 512 ký tự",
    "answerTooLong": "Câu trả lời không được vượt quá 5000 ký tự",
    "invalidRecord": "Thông tin bản ghi không hợp lệ. Vui lòng mở lại để chỉnh sửa.",
    "editSuccess": "Chỉnh sửa thành công",
    "createSuccess": "Thêm thành công",
    "deleteLimit": "Mỗi lần chỉ được xóa tối đa 100 bản ghi",
    "confirmBatch": "Xác nhận xóa {count} bản ghi đã chọn trên trang này? Sau khi xóa không thể khôi phục.",
    "confirmOne": "Xác nhận xóa bản ghi này? Sau khi xóa không thể khôi phục.",
    "deleteConfirm": "Xác nhận xóa",
    "confirmDelete": "Xác nhận xóa",
    "deleteSuccess": "Xóa thành công",
    "dataChanged": "Dữ liệu đã thay đổi. Vui lòng làm mới danh sách và thử lại."
  },
  // 本次 AI 用量同步独立追加，保留原有语言块。
  aiUsageSync: {
    "beta": "Beta",
    "title": "Thống kê sử dụng AI",
    "priceConfig": "Cấu hình giá loại phòng",
    "dateRange": "Khoảng ngày",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "scene": "Loại thông báo",
    "all": "Tất cả",
    "callStatus": "Trạng thái gọi",
    "callStatusLabel": "Thông tin trạng thái gọi",
    "running": "Đang thực hiện",
    "success": "Thành công",
    "failed": "Thất bại",
    "tokenStatus": "Dữ liệu sử dụng",
    "tokenStatusLabel": "Thông tin dữ liệu sử dụng",
    "known": "Đã có dữ liệu",
    "unknownUsage": "Chưa có dữ liệu",
    "query": "Tra cứu",
    "reset": "Đặt lại",
    "categoryError": "Không thể tải loại thông báo",
    "retry": "Tải lại",
    "chooseHotel": "Vui lòng chọn khách sạn trước",
    "dailyUsage": "Mức sử dụng AI hằng ngày",
    "noCallsFiltered": "Không có lượt gọi phù hợp với bộ lọc.",
    "statisticsError": "Không thể tải thống kê sử dụng",
    "loadingTrend": "Đang tải xu hướng…",
    "details": "Chi tiết lượt gọi",
    "detailsError": "Không thể tải chi tiết lượt gọi",
    "loading": "Đang tải…",
    "noCalls": "Chưa có bản ghi lượt gọi",
    "waiting": "Đang chờ tra cứu",
    "callTime": "Thời gian gọi",
    "usage": "Mức sử dụng AI",
    "requestInfo": "Thông tin yêu cầu",
    "requestId": "ID yêu cầu: ",
    "requestDetails": "Chi tiết yêu cầu",
    "totalUsage": "Tổng mức sử dụng AI",
    "callCount": "Số lượt gọi",
    "successCount": "Số lượt gọi thành công",
    "unknownCount": "Số lượt gọi chưa rõ mức sử dụng",
    "today": "Hôm nay",
    "last7": "7 ngày qua",
    "last30": "30 ngày qua",
    "thisMonth": "Tháng này",
    "pending": "Chờ thống kê",
    "unknown": "Không xác định",
    "usageLabel": "Mức sử dụng: ",
    "callCountLabel": "Số lượt gọi: ",
    "unknownCountLabel": "Số lượt gọi chưa rõ mức sử dụng: ",
    "missingUsage": "Một số lượt gọi chưa có dữ liệu sử dụng",
    "usageAxis": "Mức sử dụng",
    "description": "Thống kê các lượt gọi AI đã ghi nhận của khách sạn hiện tại, không gồm trò chuyện chưa liên kết khách sạn. Ngày tính theo giờ Bắc Kinh.",
    "callStatusHelp": "Đang thực hiện, thành công và thất bại là trạng thái gọi nền tảng. Thành công không có nghĩa là thông báo đã được tạo.",
    "usageHelp": "Đã có dữ liệu: biết mức sử dụng, kể cả bằng không. Chưa có dữ liệu: có bản ghi nhưng chưa rõ mức sử dụng, không tính vào tổng; không phụ thuộc thành công hay thất bại.",
    "invalidDates": "Chọn khoảng ngày hợp lệ. Ngày bắt đầu không được sau ngày kết thúc và cả hai không được sau hôm nay theo giờ Bắc Kinh."
  },
    navbar: {
        searchHotel: 'Tìm khách sạn',
        nightAudit: 'Kiểm toán đêm',
        nightAuditWarning: 'Đang thực hiện kiểm toán đêm, vui lòng thử lại sau',
        groupBooking: 'Đoàn',
    },

    common: {
        logo: 'Logo',
        bundleSale: 'Bán gói',
        splitTax: 'Chi tiết thuế',
        taxIncluded: 'Đã bao gồm thuế',
        taxExcluded: 'Chưa bao gồm thuế',
        businessFeeUnit: 'Đơn vị tính phí',
        fixedAmount: 'Số tiền cố định',
        percentage: 'Tỷ lệ phần trăm',
        pleaseEnter: 'Vui lòng nhập',
        confirmCheckInOutTime: 'Bạn đã đặt phòng nhận phòng vào {checkIn} và trả phòng vào {checkOut}. Vui lòng xác nhận ngày nhận và trả phòng.',
        tax: 'Thuế',
        expenseWithTax: 'Chi phí (đã bao gồm thuế)',
        totalProductPrice: 'Tổng giá trị sản phẩm',
        expenseWithoutTax: 'Chi phí (chưa bao gồm thuế)',
        roomFeeWithoutTax: 'Tiền phòng (chưa bao gồm thuế)',
        salesAmountWithoutTax: 'Doanh thu (chưa bao gồm thuế)',
        taxIncludedPrice: 'Giá bao gồm thuế',
        title: 'Hệ thống quản lý khách sạn EaseHUB',
        billingCycleType: 'Loại chu kỳ thanh toán',
        weeklySettlement: 'Đối soát hàng tuần',
        monthlySettlement: 'Đối soát hàng tháng',
        accountReceivablePayment: 'Thanh toán công nợ phải thu',
        noResults: 'Không tìm thấy thông tin khách sạn liên quan',
        shiftHandover: 'Bàn giao ca',
        salesClerk: 'Thu ngân',
        currentShift: 'Ca hiện tại',
        requestFailed: 'Yêu cầu thất bại',
        confirmModify: 'Xác nhận chỉnh sửa',
        operationSuccess: 'Thao tác thành công!',
        individualBooking: 'Đặt phòng',
        longBooking: 'Lưu trú dài hạn',
        cashPay: 'Thanh toán tiền mặt',
        cashPayment: 'Thanh toán trực tiếp',
        doorCard: 'Thẻ phòng',
        more: 'Thêm',
        success: 'Thành công',
        close: 'Đóng',
        loadingEllipsis: 'Đang tải...',
        cancel: 'Hủy',
        printReport: 'In',
        printTime: 'Thời gian in',
        businessDay: 'Ngày kinh doanh',
        operationDate: 'Ngày thao tác',
        subject: 'Hạng mục',
        amount: 'Số tiền',
        save: 'Lưu',
        yuan: '',
        confirm: 'Xác nhận',
        nextStep: 'Bước tiếp theo',
        all: 'Tất cả',
        immediateQuery: 'Tra cứu ngay',
        action: 'Thao tác',
        pleaseSelect: 'Vui lòng chọn',
        pleaseInput: 'Vui lòng nhập',
        inputYuan: 'Vui lòng nhập ',
        yes: 'Có',
        no: 'Không',
        remark: 'Ghi chú',
        delete: 'Xóa',

        oneHour: '1 giờ',
        twoHours: '2 giờ',
        threeHours: '3 giờ',
        fourHours: '4 giờ',
        fiveHours: '5 giờ',
        sixHours: '6 giờ',
        sevenHours: '7 giờ',
        eightHours: '8 giờ',

        saveSuccess: 'Lưu thành công',
        notice: 'Thông báo',
        status: 'Trạng thái',
        cancelled: 'Đã hủy',
        booked: 'Đã đặt',
        hardLoading: 'Đang tải...',
        startDate: 'Ngày bắt đầu',
        endDate: 'Ngày kết thúc',
        Deadline: 'Hạn chót',

        name2: 'Tên',
        roomNumber: 'Số phòng',
        checkInDate3: 'Ngày nhận phòng',
        checkOutDate3: 'Ngày trả phòng',
        unitPrice3: 'Đơn giá',
        quantity: 'Số lượng',

        addBook: 'Thêm bộ tài khoản',
        bookName: 'Tên bộ tài khoản',
        accountOfConsumption: 'Hạng mục chi tiêu',
        details3: 'Chi tiết',
        id: 'ID',
        commodityDetail: 'Chi tiết sản phẩm',
        externalDocumentNumber: 'Số chứng từ bên ngoài',
        accountOfPayment2: 'Hạng mục thanh toán',
        strikeABalance: 'Xóa công nợ',
        pleaseFillInRemarks2: 'Vui lòng nhập ghi chú',

        search: 'Tìm kiếm',

        nationality: 'Quốc tịch',
        sex: 'Giới tính',
        male: 'Nam',
        female: 'Nữ',
        nation: 'Dân tộc',
        contactInformation2: 'Thông tin liên hệ',
        dateOfBirth: 'Ngày sinh',
        documentType: 'Loại giấy tờ',
        address2: 'Địa chỉ',
        documentNumber: 'Số giấy tờ',
        validityOfVisa: 'Hiệu lực visa',
        visaType: 'Loại visa',
        visaNumber: 'Số visa',

        pleaseEnterYourIdNumber: 'Vui lòng nhập số CMND/CCCD',
        pleaseEnterTheCorrectIdNumber4: 'Vui lòng nhập số CMND/CCCD hợp lệ',
        pleaseFillInYourName2: 'Vui lòng nhập tên',
        pleaseSelectDocumentType: 'Vui lòng chọn loại giấy tờ',

        dontWorryAboutGoldMembers2: 'Thành viên Vàng Qingzhu',
        goEasyOnThePlatinumMembers2: 'Thành viên Bạch Kim Qingzhu',
        lightOnDiamondMembers2: 'Thành viên Kim Cương Qingzhu',
        unregisteredMember: 'Khách chưa đăng ký',

        ok2: 'Đồng ý',
        issuingAuthority: 'Cơ quan cấp',
        idPhoto: 'Ảnh giấy tờ',
        qingzhuGroup: 'Tập đoàn Qingzhu',
        mobilePhoneNumber: 'Số điện thoại',
        view: 'Xem',
        activated: 'Đã kích hoạt',
        nonmember: 'Không phải thành viên',
        coupon: 'Phiếu giảm giá',
        ranking5: 'Xếp hạng',
        hotelName4: 'Tên khách sạn',
        isNotSet: 'Chưa thiết lập',
        yu: 'Còn lại',
        noVacancy: 'Hết phòng',
        consumption: 'Chi tiêu',
        refund: 'Hoàn tiền',
        iGotIt2: 'Đã hiểu',

        startANightTrial: 'Bắt đầu kiểm toán đêm',
        operator: 'Người thao tác',
        handledBy: 'Người xử lý',
        to: 'Đến',
        currentBusinessDay: 'Ngày kinh doanh hiện tại',

        ok: 'OK',

        morningShift2: 'Ca sáng',
        middleShift2: 'Ca chiều',
        nightShift2: 'Ca đêm',

        pleaseEnterYourName: 'Vui lòng nhập tên',
        selectAll: 'Chọn tất cả',
        pleaseEnterContent: 'Vui lòng nhập nội dung',
        serialNumber: 'Số thứ tự',

        address: 'Địa chỉ',
        signatureOfAuthorizer: 'Chữ ký người ủy quyền',
        signature3: 'Chữ ký',

        roomType: 'Loại phòng',
        dayRate: 'Giá ngày',
        checkInTime: 'Nhận phòng',
        checkOutTime: 'Trả phòng',
        settlementAmount: 'Số tiền thanh toán',
        hotelAddress: 'Địa chỉ khách sạn',

        selectDate: 'Chọn ngày',
        selectionTime: 'Chọn thời gian',

        cancelCard: 'Hủy thẻ',
        thisCardIsEmptyPleaseMakeABusinessCardFirst: 'Thẻ này trống, vui lòng tạo thẻ trước.',
        logoutSuccessful: 'Hủy thẻ thành công',
        cardCancellationFailure: 'Hủy thẻ thất bại',
        contactSupport: 'Vui lòng liên hệ bộ phận kỹ thuật để kiểm tra dịch vụ phần cứng',

        submit: 'Gửi',
        contactPerson6: 'Người liên hệ',
        contactNumber2: 'Số liên hệ',
        merchant3: 'Đối tác',
        Submitsuccessfully: 'Gửi thành công',

        smallProgram: 'Mini Program',
        technicalSupport: 'Hỗ trợ kỹ thuật',
        roomBillCheck: 'Đối chiếu hóa đơn phòng',
        financialAssistant: 'Trợ lý tài chính',
        settlementCycle: 'Chu kỳ đối soát',

        refundSuccessful: 'Hoàn tiền thành công',
        beingRefunded: 'Đang hoàn tiền',
        refundFailure: 'Hoàn tiền thất bại',

        channel: 'Kênh',
        cloakroom: 'Ngừng bán phòng',
        infiniteQuantity: 'Số lượng không giới hạn',
        compute: 'Tính toán',
        dateOfSale: 'Ngày bán',
        originalPrice: 'Giá gốc',
        pleaseEnterTheOriginalPrice: 'Vui lòng nhập giá gốc',

        member: 'Thành viên',
        salesAmount: 'Doanh thu',
        amountOfConsumption: 'Số tiền tiêu dùng',
        protocolUnit: 'Đơn vị hợp đồng doanh nghiệp',
        subjectDesc: 'Mô tả hạng mục',
        qzOrderNo: 'Mã đơn Qingzhu',
        checkInType: 'Loại nhận phòng',
        checkInOutDate: 'Ngày nhận / trả phòng',
        channelOrderNo: 'Mã đơn kênh',
        pleaseEnterTheCorrectPhoneNumber3: 'Vui lòng nhập số điện thoại hợp lệ',

        logs: 'Nhật ký',
        walkIn: 'Khách vãng lai',
        businessCardPrintingSuccess: 'Tạo thẻ thành công',
        exportSuccessfully2: 'Xuất thành công',
        exportFailure: 'Xuất thất bại',
        other: 'Khác',
        toBeProcessed: 'Chờ xử lý',
        completed: 'Đã hoàn thành',

        commonProduct: 'Sản phẩm tiêu chuẩn',
        freeRoomProducts: 'Sản phẩm phòng miễn phí',

        makeACard: 'Tạo thẻ',

        day: 'Ngày',
        points2: 'Phút',

        sunday: 'CN',
        monday: 'T2',
        tuesday: 'T3',
        wednesday: 'T4',
        thursday: 'T5',
        friday: 'T6',
        saturday: 'T7',

        lose: 'Thất bại',
        since: 'Từ',

        amountTotal: 'Tạm tính',
        total: 'Tổng cộng',

        tradeName: 'Tên sản phẩm',
        orderStatus: 'Trạng thái đơn hàng',
        orderNumber: 'Mã đơn hàng',

        anonymousUser: 'Người dùng ẩn danh',

        commentTime: 'Thời gian đánh giá',
        merchantReply: 'Phản hồi của khách sạn',
        recoveryTime: 'Thời gian phản hồi',
        recover: 'Phản hồi',

        pleaseWriteAResponseOfAtLeast10Words: 'Vui lòng nhập ít nhất 10 ký tự',
        replyTextMinimum10Words: 'Nội dung phản hồi phải có ít nhất 10 ký tự',

        negativeComment: 'Đánh giá tiêu cực',

        cancel2: 'Hủy',

        commentTemplateManagement: 'Quản lý mẫu phản hồi đánh giá',

        modifiedSuccessfully: 'Chỉnh sửa thành công',

        hygiene: 'Vệ sinh',
        service: 'Dịch vụ',
        facility: 'Tiện nghi',
        position: 'Vị trí',

        appeal: 'Khiếu nại',

        successfullyDeleted: 'Xóa thành công',
        replySuccessfully2: 'Phản hồi thành công',

        theMobilePhoneNumberFormatIsIncorrect5: 'Định dạng số điện thoại không hợp lệ',

        none4: 'Không có',

        thisFunctionHasNotBeenOpenedIfYouNeedToOpenPleaseClickOpen:
            'Chức năng này chưa được kích hoạt. Nếu cần sử dụng, vui lòng nhấn để kích hoạt.',

        noCommentsYet: 'Chưa có đánh giá',

        picture: 'Hình ảnh',

        guestName: 'Tên khách',

        handle: 'Xử lý',
        edit: 'Chỉnh sửa',
        type: 'Loại',

        salesman: 'Nhân viên kinh doanh',

        successfulOperation: 'Thao tác thành công',

        pleaseEnterTheCompanyName2: 'Vui lòng nhập tên công ty',

        customerType: 'Loại khách hàng',

        effective: 'Đang hoạt động',
        inVain: 'Không hoạt động',

        valid: 'Hợp lệ',

        forbidden: 'Đã vô hiệu hóa',
        enable: 'Kích hoạt',

        companyName2: 'Tên công ty',

        favorable2: 'Giảm giá',

        day2: 'Ngày',

        telephone: 'Điện thoại',

        pleaseEnterThePhoneNumber: 'Vui lòng nhập số điện thoại',

        mailbox: 'Email',

        accountName: 'Tên tài khoản',

        startTime: 'Thời gian bắt đầu',
        endTime: 'Thời gian kết thúc',

        beingSubmitted: 'Đang gửi',

        pleaseSelectGender: 'Vui lòng chọn giới tính',

        confirmDeletion: 'Xác nhận xóa',

        letMeThinkItOver: 'Để tôi suy nghĩ thêm',

        theSizeOfTheUploadedPictureCannotExceed:
            'Kích thước ảnh tải lên không được vượt quá',

        identificationCard2: 'CMND/CCCD',
        editor: 'Người chỉnh sửa',

        topLine: 'Trực tuyến',
        downline: 'Ngoại tuyến',

        validity: 'Hiệu lực',

        fullDayRoom: 'Phòng cả ngày',
        hourlyRoom: 'Phòng theo giờ',

        append3: 'Thêm',

        immediatelyReduce3: 'Giảm giá trực tiếp',

        activityName2: 'Tên chương trình',

        sort: 'Danh mục',

        on: 'Bật',

        amountOfGift2: 'Giá trị quà tặng',

        pleaseFillIn2: 'Vui lòng điền',

        pleaseSelectADate: 'Vui lòng chọn ngày',

        roomFeeConsumption: 'Chi phí tiền phòng',

        selectFile: 'Chọn tệp',

        uploadFailure: 'Tải lên thất bại',

        uploadSuccessfully: 'Tải lên thành công',

        print: 'In',

        dateRange: 'Khoảng thời gian',

        reupload: 'Tải lên lại',

        printBill: 'In hóa đơn',

        cardNumber: 'Số thẻ',

        paymentMethod: 'Phương thức thanh toán',

        payMethod: 'Hình thức thanh toán',

        balance: 'Số dư',

        membershipCardNumber: 'Số thẻ thành viên',

        birthday: 'Ngày sinh',

        tradingHours: 'Thời gian giao dịch',

        enterAMaximumOf50Characters: 'Nhập tối đa 50 ký tự',

        membersMobileNumber: 'Số điện thoại thành viên',

        time: 'Thời gian',

        modifyInformation: 'Chỉnh sửa thông tin',

        lengthOfStay: 'Số đêm lưu trú',

        roomListNumber: 'Mã đơn phòng',

        roomTypeName: 'Tên loại phòng',

        settleAccounts: 'Thanh toán',

        accountNumber: 'Số tài khoản',

        paymentRecord: 'Lịch sử thanh toán',

        paymentAmount: 'Số tiền thanh toán',

        paymentVerificationCode: 'Mã xác thực thanh toán',

        enterInAnAccount: 'Ghi nhận vào tài khoản',

        pleaseSelectACollectionSet: 'Vui lòng chọn bộ tài khoản phải thu',

        pleaseSelectTheAccountNumber: 'Vui lòng chọn tài khoản',

        pleaseSelectAPaymentMethod: 'Vui lòng chọn phương thức thanh toán',

        vipSignature: 'Chữ ký VIP',

        amountNotWrittenOff3: 'Số tiền chưa đối trừ',

        availableCredit3: 'Hạn mức tín dụng khả dụng',

        maximumAmount4: 'Số tiền tối đa',

        whetherItIsValidOrNot: 'Có hiệu lực hay không',

        enabledSuccessfully: 'Kích hoạt thành công',

        disableSuccessfully: 'Vô hiệu hóa thành công',

        roomNumberName: 'Số phòng - Tên',

        payment2: 'Thanh toán',

        operatingTime: 'Thời gian thao tác',

        classes: 'Ca làm việc',

        transfer: 'Chuyển khoản',

        accountOutstanding2: 'Chưa thanh toán',

        accountClosed: 'Đã thanh toán',

        rolledOut: 'Đã chuyển ra',

        haveStruckOff: 'Đã đối trừ',

        noRoomChargeIsGenerated: 'Chưa phát sinh tiền phòng',

        date3: 'Ngày',

        itemName4: 'Tên hạng mục',

        pleaseEnterRemarks2: 'Vui lòng nhập ghi chú',

        entryAndDepartureTime: 'Thời gian nhận / trả phòng',

        roomRate: 'Giá phòng',

        preAuthorizationAmount: 'Số tiền tạm giữ',

        room: 'Phòng',

        settlement: 'Đối soát',

        pleaseSelectMemberInformation: 'Vui lòng chọn thông tin thành viên',

        pleaseFillInThePaymentVerificationCode: 'Vui lòng nhập mã xác thực thanh toán',

        accountNumber3: 'Số tài khoản',

        successfulEntry: 'Ghi nhận thành công',

        externalOrderNumber: 'Mã đơn bên ngoài',

        transferTo: 'Chuyển đến',

        beAuthorized: 'Đã ủy quyền',

        haveAlreadySettled: 'Đã thanh toán',

        authorizationMode: 'Hình thức ủy quyền',

        authorizedAmount: 'Số tiền được ủy quyền',

        authorizationTime: 'Thời gian ủy quyền',

        productType: 'Loại sản phẩm',

        pleaseEnterTheChannelNumber: 'Vui lòng nhập mã đơn của kênh',

        derive: 'Xuất dữ liệu',
        unwritten: 'Chưa đối trừ',

        cancelled3: 'Đã đối trừ',

        lehuiScanTheCode: 'Lehui - Quét mã',

        amountOnAccount3: 'Số tiền đã ghi nhận',

        billingTime5: 'Thời gian ghi nhận',

        nameOfGuest3: 'Tên khách',

        roomNumber3: 'Số phòng',

        people: 'Người',

        nameOfExpenseItem: 'Tên hạng mục chi phí',

        viewDetails: 'Xem chi tiết',

        bankOfDeposit: 'Ngân hàng mở tài khoản',

        bankCardNumber4: 'Số tài khoản ngân hàng',

        toBeConfirmed2: 'Chờ xác nhận',

        rejected: 'Đã từ chối',

        adjustmentAmount: 'Số tiền điều chỉnh',

        meituan: 'Meituan',

        totalOrderAmount: 'Tổng giá trị đơn hàng',

        lightSettlementWithMerchants: 'Đối soát Qingzhu & Khách sạn',

        membershipDistribution: 'Chia sẻ doanh thu thành viên',

        crossStoreRebate: 'Hoàn tiền liên khách sạn',

        avoidCommissionSubsidies: 'Trợ cấp hoa hồng Qingzhu',

        membershipIncentiveSettlement: 'Đối soát khuyến khích thành viên',

        theUnitedStatesGroupDirectlyConnected: 'Kết nối trực tiếp Meituan',

        flyingPigsConnectDirectly: 'Kết nối trực tiếp Fliggy',

        fullNameOfTheBank4: 'Tên đầy đủ của ngân hàng',

        accountBankAbbreviation4: 'Tên viết tắt ngân hàng',

        theLocationOfTheBank4: 'Địa điểm ngân hàng',

        pleaseEnterYourFullBankName2: 'Vui lòng nhập tên đầy đủ của ngân hàng',

        pleaseSelectBankAbbreviation2: 'Vui lòng chọn tên viết tắt ngân hàng',

        pleaseSelectYourBankLocation2: 'Vui lòng chọn địa điểm ngân hàng',

        pleaseEnterYourBankCardNumber2: 'Vui lòng nhập số tài khoản ngân hàng',

        modificationTime2: 'Thời gian chỉnh sửa',

        bankExample: 'Ví dụ: ICBC Chi nhánh XX',

        companyNameNote: 'Lưu ý: Nếu là tài khoản doanh nghiệp, vui lòng nhập tên công ty',

        causeOfFailure: 'Nguyên nhân thất bại',

        pleaseEnterYourPhoneNumber: 'Vui lòng nhập số điện thoại',

        downloadStatement: 'Tải xuống bảng đối soát',

        operationLog: 'Nhật ký thao tác',

        ctripDirectConnection: 'Kết nối trực tiếp Ctrip',

        directConnectionInTheSameDirection: 'Kết nối trực tiếp Tongcheng',

        flyingPig: 'Fliggy',

        ctrip: 'Ctrip',

        roomNight: 'Đêm phòng',

        pictureUpload: 'Tải lên hình ảnh',

        aSinglePictureMustNotBeLargerThan: 'Dung lượng mỗi ảnh không được vượt quá',

        checkInRoomType2: 'Loại phòng nhận phòng',

        checkInPerson: 'Khách nhận phòng',

        hotelSellingPrice: 'Giá bán của khách sạn',

        effectiveDate3: 'Ngày hiệu lực',

        viewExamples: 'Xem ví dụ',

        underReview: 'Đang xét duyệt',

        billingType: 'Loại hóa đơn',

        invoiceTitle2: 'Tiêu đề hóa đơn',

        pleaseEnterTheInvoiceTitle2: 'Vui lòng nhập tiêu đề hóa đơn',

        invoiceHasBeenIssued: 'Đã xuất hóa đơn',

        haveBeenCancelled: 'Đã hủy',

        paymentStatus: 'Trạng thái thanh toán',

        preferentialPrice: 'Giá ưu đãi',

        gateRate: 'Giá niêm yết',

        availableRoom: 'Phòng còn trống',

        orderableNumber: 'Số lượng có thể đặt',

        numberOfRoomsReserved: 'Số phòng đã đặt',

        breakfast: 'Bữa sáng',

        copyOf: 'Bản',

        dailyRate: 'Giá theo ngày',

        typeOfTouristSource3: 'Phân khúc thị trường',

        namephoneNumbermembershipNumber: 'Tên / Điện thoại / Mã thành viên',

        selectTimePoint5: 'Chọn thời điểm',

        externalChannel3: 'Kênh bên ngoài',

        retentionTime3: 'Thời gian giữ phòng',

        contactName2: 'Tên người liên hệ',

        numberOfDays: 'Số ngày',

        pleaseSelectAProtocolUnit3: 'Vui lòng chọn đơn vị hợp đồng',

        pleaseEnterTheNameOfTheExternalChannel2: 'Vui lòng nhập tên kênh bên ngoài',

        pleaseFillInTheMembershipInformation3: 'Vui lòng nhập thông tin thành viên',

        pleaseFillInTheReservationName2: 'Vui lòng nhập tên đặt phòng',

        pleaseFillInTheReservationNumber2: 'Vui lòng nhập số điện thoại đặt phòng',

        theAmountCanOnlyBeEnteredInNumbers2: 'Số tiền chỉ được nhập bằng số',

        noMemberInformationFound: 'Không tìm thấy thông tin thành viên',

        noProtocolUnitIsQueried2: 'Không tìm thấy đơn vị hợp đồng',

        bulkRepricing: 'Điều chỉnh giá hàng loạt',

        totalRoomRate6: 'Tổng tiền phòng',

        trialCalculationOfHousePrice3: 'Tính thử giá phòng',

        free: 'Miễn phí',

        between: 'Phòng',

        upgradeRoomType: 'Nâng cấp loại phòng',

        printOrNot: 'Có in hay không',

        predepartureTime2: 'Thời gian trả phòng dự kiến',

        rooms: 'Phòng',
        averageHousePrice: 'Giá phòng trung bình',

        arrivalTime: 'Thời gian đến',

        creationTime: 'Thời gian tạo',

        advancedSearch: 'Tìm kiếm nâng cao',

        simpleSearch: 'Tìm kiếm đơn giản',

        price: 'Giá',

        orderTaking: 'Nhận đơn',

        sellingPrice: 'Giá bán',

        floorPrice: 'Giá sàn',

        channelName2: 'Tên kênh',

        bookingSuccessful2: 'Đặt phòng thành công',

        checkedIn2: 'Đã nhận phòng',

        cancelSuccessfully2: 'Hủy thành công',

        sorting: 'Sắp xếp',

        invoiceNumber2: 'Số hóa đơn',

        taxIdentificationNumber: 'Mã số thuế',

        emailAddress: 'Địa chỉ email',

        eTicket: 'Hóa đơn VAT điện tử (Đặc biệt)',

        eTicket2: 'Hóa đơn VAT điện tử (Thông thường)',

        paperTicket: 'Hóa đơn VAT giấy (Đặc biệt)',

        paperTicket2: 'Hóa đơn VAT giấy (Thông thường)',

        void: 'Đã hủy',

        teamType: 'Loại đoàn',

        teamName: 'Tên đoàn',

        markUpAmount: 'Số tiền tăng giá',

        productName: 'Tên sản phẩm',

        lengthOfStay2: 'Số đêm lưu trú',

        hours: 'Giờ',

        checkIn: 'Nhận phòng',

        changeRooms: 'Đổi phòng',

        rowHouse: 'Xếp phòng',

        printCheckInSlip: 'In phiếu nhận phòng',

        proceedWith: 'Tiếp tục',

        rowHouseSuccess2: 'Xếp phòng thành công',

        toCheckIn: 'Chờ nhận phòng',

        checkedOut: 'Đã trả phòng',

        onAccount: 'Đã ghi công nợ',

        basicInformation: 'Thông tin cơ bản',

        prepayment: 'Thanh toán trước',

        originalHouseType: 'Loại phòng ban đầu',

        seeMore: 'Xem thêm',

        thisRoomSupportsSmartDoorLocks: 'Phòng này hỗ trợ khóa cửa thông minh',

        listingStatus: 'Trạng thái đơn phòng',

        checkin: 'Nhận phòng',

        preionization2: 'Trả phòng trước',

        weekTitle: 'Tuần',

        thePriceActuallyPaidByTheGuest: 'Giá thực tế khách đã thanh toán',

        late3: 'N',

        late4: 'Ngày',

        nonCancellable2: 'Không thể hủy',

        one: 'Một',

        two: 'Hai',

        three: 'Ba',

        four: 'Bốn',

        five: 'Năm',

        six: 'Sáu',

        lightweightDistribution: 'Phân phối Qingzhu',

        liveAndTravelLightly: 'Công tác Qingzhu',

        jingdongDirectLink: 'Kết nối trực tiếp JD',

        baiduMapDirectConnection: 'Kết nối trực tiếp Baidu Map',

        tiktokDirectConnection: 'Kết nối trực tiếp TikTok',
        ctripSingleStore: 'Ctrip cửa hàng đơn',
        agoda: 'Agoda',
        meituanHomestay: 'Meituan Homestay',
        tujiaHomestay: 'Tujia Homestay',
        booking: 'Booking',
        expedia: 'Expedia',
        preCancelable: 'Có thể hủy trước khi lưu trú',

        partialWriteOff: 'Đối trừ một phần',

        tookEffect: 'Đã có hiệu lực',

        loseEffectiveness: 'Mất hiệu lực',

        joinAHouse3: 'Ghép phòng',

        bookingInformation: 'Thông tin đặt phòng',

        pleaseSelectARoom3: 'Vui lòng chọn phòng',

        houseInformation: 'Thông tin phòng liên kết',

        thereIsNoRowHouse: 'Chưa xếp phòng',

        reasonsForChangingRooms3: 'Lý do đổi phòng',

        numberOfRooms7: 'Tổng số phòng',

        typeOfOperation3: 'Loại thao tác',
        exchangeAndUpgradeReport2: 'Báo cáo đổi phòng & nâng cấp phòng',

        noDataAvailable2: 'Không có dữ liệu',

        pleaseSelectABusinessDayRange2: 'Vui lòng chọn khoảng ngày kinh doanh',

        exportReport: 'Xuất báo cáo',

        accountName3: 'Tên hạng mục',

        aMaximumOf31DaysCanBeQueried: 'Khoảng thời gian truy vấn tối đa là 31 ngày',

        naturalDay2: 'Ngày tự nhiên',

        otherConsumption3: 'Chi tiêu khác',

        aggregateConsumption3: 'Tổng chi tiêu',

        aggregateConsumptionTaxIncluded: 'Tổng chi tiêu (đã bao gồm thuế)',

        materialType: 'Loại vật tư',

        materialName: 'Tên vật tư',

        storageTypeSell: 'Bán',

        materialCode: 'Mã vật tư',

        materialUnit: 'Đơn vị',

        inStorageNum: 'Số lượng nhập kho',

        outStorageNum: 'Số lượng xuất kho',

        selectTime: 'Chọn thời gian',

        floor: 'Tầng',

        lumpSumPayment3: 'Tổng số tiền thanh toán',

        ifTheRateIsGreaterThanHalfDayTheRateIsLessThanFullDay:
            'Nếu số tiền vượt quá giá phòng nửa ngày nhưng thấp hơn giá phòng cả ngày thì tính theo giá phòng cả ngày',

        businessDate: 'Ngày kinh doanh',

        calculationFormula: 'Công thức tính',

        manualRoomFeeCalculationHalfDayRoomFee05BedNightFullDayRoomFee1BedNight:
            'Tính thủ công tiền phòng bổ sung: Phòng nửa ngày = 0,5 đêm phòng, phòng cả ngày = 1 đêm phòng',

        halfDayRoomFeeTheAmountChargedIsLessThanOrEqualToHalfTheRoomRate:
            'Phòng nửa ngày: Phụ phí ≤ 50% giá phòng',

        fullDayRoomFeeTheAmountChargedIsGreaterThanOrEqualToTheRoomRateAndTheAmountExceedsTheRoomRateBy2TimesRecord2BedNightsAndSoOn:
            'Phòng cả ngày: Phụ phí ≥ giá phòng. Nếu vượt quá 2 lần giá phòng thì ghi nhận 2 đêm phòng, tương tự cho các trường hợp khác.',

        rentedBedNightsExcludeFreeRoomsAndSelfUsedRoomNights:
            'Đêm phòng cho thuê không bao gồm phòng miễn phí và phòng sử dụng nội bộ',

        subtotal: 'Tạm tính',

        totalOccupancy3: 'Tổng số phòng',

        lettingRate: 'Tỷ lệ lấp đầy',

        inResidenceDate: 'Ngày lưu trú',

        bookingDate: 'Ngày đặt phòng',

        exposureNumber2: 'Số lần hiển thị',

        numberOfVisitors3: 'Lượt truy cập',

        onlineChannel3: 'Kênh trực tuyến',

        reasonForDeactivation: 'Lý do ngừng hoạt động',

        downTime: 'Thời gian ngừng hoạt động',

        enterAMaximumOf20Characters: 'Nhập tối đa 20 ký tự',

        checkInInformation: 'Thông tin nhận phòng',

        numberOfRooms6: 'Số lượng phòng',

        totalPrice: 'Tổng giá',

        paymentInformation2: 'Thông tin thanh toán',

        pleaseSelectAProduct: 'Vui lòng chọn sản phẩm',

        viewOrderDetails: 'Xem chi tiết đơn hàng',

        automaticallyJumpToOrderDetails: 'Tự động chuyển đến chi tiết đơn hàng',

        addHoming3: 'Thêm khách cùng phòng',

        getVerificationCode: 'Lấy mã xác thực',

        pleaseSelectTheNumberOfRoomsFirst: 'Vui lòng chọn số lượng phòng trước',

        theNumberOfReservedRoomsCannotBeGreaterThanTheNumberOfAvailableRooms:
            'Số phòng đặt không được vượt quá số phòng còn trống',

        pleaseEnterAmount: 'Vui lòng nhập số tiền',

        makeAReservation: 'Đặt phòng',

        increaseRoomType: 'Thêm loại phòng',

        deleteRoomType: 'Xóa loại phòng',

        store: 'Khách sạn',

        meituanDirectNew: 'Meituan Direct (Mới)',

        outOfService: 'Ngừng phục vụ',

        smokeFreeOrNot: 'Không hút thuốc',

        roomOrientation: 'Hướng phòng',

        windowCondition: 'Tình trạng cửa sổ',

        windowed: 'Có cửa sổ',

        windowless: 'Không có cửa sổ',

        innerFenestra: 'Cửa sổ trong',

        roomCharacteristics: 'Đặc điểm phòng',

        airAndClean: 'Trống sạch',

        airViscus: 'Trống bẩn',

        dendrojing: 'Ở sạch',

        astriction: 'Ở bẩn',

        continuousStaySpecial: 'Ưu đãi lưu trú dài ngày',

        orderEarlyAndReduceMore: 'Ưu đãi đặt sớm',

        discountValue: 'Mức giảm giá',

        select: 'Chọn',

        becameInvalid: 'Mất hiệu lực',

        dateOfOperation: 'Ngày thao tác',

        promotionalAllocation: 'Cấu hình khuyến mãi',

        promotionManagement: 'Quản lý khuyến mãi',

        operationContent2: 'Nội dung thao tác',

        turnOnAutomaticDeferral: 'Bật gia hạn giá tự động',

        productSetup: 'Cấu hình sản phẩm',

        thePriceShallNotBeLessThan20YuanAndShallNotBeHigherThan999998Yuan:
            'Giá không được thấp hơn 20 và không được cao hơn 999998000',

        iKnow: 'Tôi đã hiểu',

        dataSpecification: 'Mô tả dữ liệu',
        settings: 'Cài đặt',

        restrictSales: 'Hạn chế bán',

        pleaseEnterPrice: 'Vui lòng nhập giá',

        modificationFailure: 'Chỉnh sửa thất bại',

        deletionFailure: 'Xóa thất bại',

        product: 'Sản phẩm',

        pleaseSelectChannel: 'Vui lòng chọn kênh',

        standardProduct: 'Sản phẩm tiêu chuẩn',

        bindingSuccessful: 'Liên kết thành công',

        lobby: 'Sảnh',

        inventoryQuantity: 'Số lượng tồn kho',

        uploadPictures: 'Tải lên hình ảnh',

        currentlyLimitedTo10Images: 'Hiện tại giới hạn tối đa 10 hình ảnh',

        pictureSizeMustBeLargerThan: 'Kích thước hình ảnh phải lớn hơn',

        warn3: 'Cảnh báo',

        theInputContentOfTheCurrentPageDoesNotMeetTheSpecificationsPleaseCheck:
            'Nội dung nhập trên trang hiện tại không đúng quy định, vui lòng kiểm tra',

        layer: 'Tầng',

        untie: 'Hủy liên kết',

        cipher5: 'Mật khẩu',

        pleaseEnterYourAccountNumber: 'Vui lòng nhập tài khoản',

        pleaseEnterPassword4: 'Vui lòng nhập mật khẩu',

        obtainTheSmsVerificationCode: 'Nhận mã xác thực SMS',

        disposition: 'Cấu hình',

        passwordType: 'Loại mật khẩu',

        setANewPassword: 'Đặt mật khẩu mới',

        pleaseEnterYourNewPassword: 'Vui lòng nhập mật khẩu mới',

        confirmPassword: 'Xác nhận mật khẩu',

        pleaseEnterYourPasswordAgain: 'Vui lòng nhập lại mật khẩu',

        electronicPriceBoard: 'Bảng giá phòng điện tử',

        operationInstruction: 'Hướng dẫn thao tác',

        cardholder: 'Chủ thẻ',

        contact: 'Người liên hệ',

        pleaseEnterTheCardholderName: 'Vui lòng nhập tên chủ thẻ',

        cardholderNameIsRequired: 'Tên chủ thẻ là bắt buộc',

        theCardholderNameMustBe2To5CharactersLong:
            'Tên chủ thẻ phải từ 2 đến 5 ký tự',

        remarksRequired: 'Ghi chú là bắt buộc',

        selectCardType: 'Chọn loại thẻ',

        windowType2: 'Loại cửa sổ',

        suspensionOfSale: 'Ngừng bán',

        enterMaterialName: 'Nhập tên vật tư',

        modifyTarget: 'Mục tiêu điều chỉnh',

        theRecommendedTargetValueIsEstimatedBasedOnTheChangeTrendOfTheDataInTheSamePeriodLastYearAndTheActualDataOfLastMonth:
            'Giá trị mục tiêu đề xuất được ước tính dựa trên xu hướng thay đổi dữ liệu cùng kỳ năm trước kết hợp với dữ liệu thực tế của tháng trước',

        dayUnit: '{day} ngày',

        checkInOperator: 'Nhân viên làm thủ tục nhận phòng',

        months: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12'
        ],

        week: {
            mon: 'Thứ Hai',
            tue: 'Thứ Ba',
            wed: 'Thứ Tư',
            thu: 'Thứ Năm',
            fri: 'Thứ Sáu',
            sat: 'Thứ Bảy',
            sun: 'Chủ Nhật',
        },

        pleaseSelectStatus: 'Trạng thái sản phẩm',

        pleaseSelectPre: 'Hiển thị bán trước',

        pleaseSelectEb: 'Sản phẩm EB',
    },
    language: {
        zh: '中文',
        en: 'EN',
        zhHk: '繁体',
        th: 'ไทย',
        id: 'Indonesian',
        es: 'Español',
        vi: 'Tiếng Việt',
    },
    activitySign: {
        eventDate: 'Ngày hoạt động',
        alreadyRegistered: 'Đã đăng ký',
        signUpActivity: 'Hoạt động có thể đăng ký',
        noRegistrationIsAvailable: 'Hiện không có hoạt động nào có thể đăng ký',
        registeredActivity: 'Hoạt động đã đăng ký',
        thereAreNoRegisteredActivities: 'Chưa có hoạt động nào đã đăng ký',
        thereAreNoCanceledEvents: 'Chưa có hoạt động nào bị hủy',
        signUp: 'Đăng ký',
    },

    componentsCostprint8cmprint: {
        dateOfConsumption: 'Ngày tiêu dùng',
    },

    componentsCostprinta4template: {
        totalConsumption: 'Tổng chi tiêu',
        dateOfConsumption: 'Ngày tiêu dùng',
        feeName: 'Tên khoản phí',
    },

    componentsCounter: {
        theGoodsAreOnlyInStock: 'Sản phẩm này chỉ còn',
        thereIsNotEnoughStockOfThisCommodity: 'Tồn kho của sản phẩm này không đủ',
    },

    componentsNowpayaccounthandle: {
        modifyTheBookSuccessfully: 'Chỉnh sửa bộ tài khoản thành công',
        bookModification: 'Chỉnh sửa bộ tài khoản',
        pleaseEnterABookName: 'Vui lòng nhập tên bộ tài khoản',
        pleaseSelectTheConsumerCategory: 'Vui lòng chọn danh mục tiêu dùng',
        newAccountSuccessfully: 'Thêm bộ tài khoản thành công',
    },

    componentsRecorddetail: {
        memberInfo: 'Tên thành viên / Số thẻ',
    },

    componentsRushbalance: {
        successfulWriteOff: 'Điều chỉnh công nợ thành công',
    },

    componentsShoppinggoods: {
        onlyAvailable: 'Chỉ hiển thị sản phẩm còn hàng',
        commodityCategory: 'Danh mục sản phẩm',
        pleaseEnterTheProductName: 'Vui lòng nhập tên sản phẩm',
        noDataIsQueried: 'Không tìm thấy dữ liệu',
        name3: 'Tên',
        purchaseQuantity: 'Số lượng mua',
        vendibility: 'Có thể bán',
        allGoods: 'Tất cả sản phẩm',
    },

    componentsAddroomer: {
        addLabel: 'Thêm nhãn',
        noCustomerProfile: 'Khách lưu trú này chưa có hồ sơ khách hàng',
        guestSaveFailedRetry: 'Lưu khách lưu trú thất bại, vui lòng thử lại',
        changeOccupancy: 'Chỉnh sửa khách lưu trú',
        increaseOccupancy: 'Thêm khách lưu trú',
        validityPeriod: 'Thời hạn hiệu lực giấy tờ',
        startDate: 'Ngày bắt đầu',
        addGuest: 'Thêm khách',
        atLeastOneGuest: 'Phải giữ lại ít nhất một khách',
        guest: 'Khách lưu trú',
        enterGuestName: 'Vui lòng nhập tên của {name}',
        enterValidPhone: 'Vui lòng nhập số điện thoại hợp lệ của {name}',
        selectDocumentType: 'Vui lòng chọn loại giấy tờ của {name}',
        enterDocumentNumber: 'Vui lòng nhập số giấy tờ của {name}',
    },

    componentsAnnouncement: {
        noticeBoard: 'Bảng thông báo',
    },
    componentsIdentifyMembers: {
        memberInformation: 'Thông tin thành viên',
        pleaseFillInTheGuestMobilePhoneNumberQuickIdentificationInformation:
            'Vui lòng nhập số điện thoại của khách để nhanh chóng xác thực thông tin',
        guestsCanUpgradeToAHigherLevelMembership:
            'Khách có thể nâng cấp lên cấp độ thành viên cao hơn',
        l: 'Cấp',
        unnamed: 'Chưa xác thực danh tính',
        inRealName: 'Đã xác thực danh tính',
        points: 'Điểm thưởng',
        memberRightsAndInterests: 'Quyền lợi thành viên',
        patron: 'Khách',
        unfold: 'Mở rộng',
        unactivated: 'Chưa kích hoạt',
        membershipSalesCopy: 'Nội dung giới thiệu hội viên',
        bookingDiscount: 'Ưu đãi đặt phòng',
        costPerformance: 'Giá trị thẻ',
        memberPoints: 'Điểm thành viên',
        lateCheckOut: 'Trả phòng muộn',
        copywritingType: 'Loại nội dung',
        afterTheGuestAuthenticatesThemselvesInThelightStayHotelReservationMiniProgramTheyCanReceiveA18YuanFreeBirthdayGiftCouponOrParticipateInExclusiveOffers:
            'Sau khi xác thực danh tính trên Mini Program "Qingzhu Hotel Booking", khách có thể nhận phiếu quà tặng sinh nhật trị giá 18 hoặc tham gia các chương trình ưu đãi độc quyền',
        afterTheGuestLogsInForTheFirstTimeInThelightStayHotelReservationMiniProgramTheyCanActivateTheirMembershipAndEnjoyExclusiveMemberBenefits:
            'Khách chỉ cần đăng nhập lần đầu vào Mini Program "Qingzhu Hotel Booking" để kích hoạt tư cách thành viên và tận hưởng các quyền lợi độc quyền',
        lightStayMemberLevelNonMember: 'Cấp độ thành viên Qingzhu: Không phải thành viên',
        lightStayMembershipLevel: 'Cấp độ thành viên Qingzhu',
    },

    componentsSellcard: {
        employeeLastWeeksCardSalesList: 'Bảng xếp hạng bán thẻ tuần trước của nhân viên',
        dragLeftAndRightToViewTheTable: 'Kéo trái hoặc phải để xem bảng',
        hotelLastWeeksCardSalesList: 'Bảng xếp hạng bán thẻ tuần trước của khách sạn',
        cardSalesRanking: 'Bảng xếp hạng bán thẻ',
        employee2: 'Nhân viên',
        numberOfCardsSold: 'Số lượng thẻ đã bán',
        amountOfCommission: 'Tiền hoa hồng',
    },

    detailcomponentsOnecarddialog: {
        waitingGuestToSwipeCard: 'Đang chờ khách quẹt thẻ',
        paymentInProcess: 'Đang thanh toán',
        guestPaymentSuccess: 'Khách thanh toán thành công',
        guestPaymentFailedPleaseInitiatePaymentAgain:
            'Khách thanh toán thất bại, vui lòng thực hiện thu tiền lại',
    },

    customerPSearch: {
        singleStoreMembershipLevel: 'Cấp độ thành viên',
        enterYourNamePhoneNumberAndCardNumber:
            'Nhập tên, số điện thoại hoặc số thẻ để tìm kiếm',
    },

    customerPTable: {
        topUp: 'Nạp tiền',
        gift: 'Tặng',
        viewMembers2: 'Xem thành viên',
        modifyMembership2: 'Chỉnh sửa thành viên',
        storedValueDeduction: 'Khấu trừ số dư',
        integralChange2: 'Điều chỉnh điểm',
        integralQuery2: 'Tra cứu điểm',
        storedValueQuery2: 'Tra cứu số dư',
        rechargeAllAccumulatedRechargeAmounts:
            'Nạp tiền: Tổng số tiền đã nạp',
        giftAllAccumulatedGiftAmounts:
            'Tặng: Tổng số tiền đã tặng',
        consumptionAllAccumulatedConsumptionAmounts:
            'Tiêu dùng: Tổng số tiền đã tiêu dùng',
        refundAllAccumulatedRefundAmounts:
            'Hoàn tiền: Tổng số tiền đã hoàn',
        distributionSettings: 'Cài đặt phân phối',
    },

    componentsNightaudit: {
        theCurrentBusinessDayIs: 'Ngày kinh doanh hiện tại là',
        startTheNightTrial: 'Bắt đầu chạy kiểm toán đêm',
        theNightTrialIsInProgressAndCannotBeClosed:
            'Kiểm toán đêm đang được thực hiện, không thể đóng',
        immediateFeedback: 'Phản hồi ngay',
        nightAuditCompleted: 'Kiểm toán đêm hoàn tất',
        nightTrialInProgress: 'Đang kiểm toán đêm',
        nightTrialNewsNotice2: 'Thông báo kiểm toán đêm',
        nightAuditFailedPleaseHandleAccordingToThePromptAndPerformTheNightAuditAgainIfYouEncounterAnyProblemsPleaseContactTechnicalSupport:
            'Kiểm toán đêm thất bại, vui lòng xử lý theo hướng dẫn rồi thực hiện lại. Nếu gặp vấn đề, hãy liên hệ bộ phận hỗ trợ kỹ thuật',
    },

    componentsNightauditGrayEnv: {
        nightTrialNewsNotice2: 'Thông báo kiểm toán đêm',
        procedure: 'Bước thực hiện',
        mistake: 'Lỗi',
        carryOut: 'Thực hiện',
        nightAuditFailureToEncounterProblemsCanBeInTheMorningAfter8OclockAsSoonAsPossibleToContactTechnicalSupportToHelpSolve:
            'Nếu kiểm toán đêm thất bại, vui lòng liên hệ hỗ trợ kỹ thuật sau 8 giờ sáng để được hỗ trợ xử lý sớm nhất',
        whenAnErrorOccursTheNightAuditStopsPleaseConfirmItCarefully:
            'Khi xảy ra lỗi, quá trình kiểm toán đêm sẽ dừng lại. Vui lòng kiểm tra kỹ trước khi tiếp tục',
    },

    componentsOpenPageLayout: {
        backToHomePage: 'Quay về trang chủ',
    },

    componentsShiftchoose: {
        pleaseSelectFlightSchedule: 'Vui lòng chọn ca làm việc',
        hello: ', xin chào!',
    },

    baseBasemultipleselect: {
        thisOptionWasNotFound: 'Không tìm thấy tùy chọn này',
    },

    printsettingHalfprint: {
        test: 'Kiểm tra',
        print: 'In',
        trisection: 'Chia thành 3 phần',
        printInThirds: 'In theo 3 phần',
        printInHalf: 'In theo 2 phần',
    },

    printsettingPrint: {
        print: 'In',
    },

    printsettingSmallprint: {
        feeName: 'Tên khoản phí',
        totalConsumption: 'Tổng chi tiêu',
    },

    hardwareIdcardbtn: {
        readIdentityCard: 'Đọc thẻ căn cước',
    },
    hardwareReaddoorcard: {
        pleasePlaceYourKeyCardOnTheCardReader: 'Vui lòng đặt thẻ phòng lên đầu đọc thẻ',
        effectiveTime: 'Thời gian hiệu lực',
        failureTime: 'Thời gian hết hiệu lực',
        readCard: 'Đọc thẻ',
        failedToObtainTheLockInformationProcedure: 'Không thể lấy thông tin khóa cửa',
        thisCardIsNotAGuestCardPleaseReBusinessCardPrinting:
            'Thẻ này không phải thẻ khách, vui lòng tạo thẻ lại',
        wheatDoorLockPlugInReadCard: 'Plugin khóa cửa Maitian - Đọc thẻ',
        the: '',
        wheatDoorLockPlugInCancellationCard: 'Plugin khóa cửa Maitian - Hủy thẻ',
        cardReadingFailure: 'Đọc thẻ thất bại',
    },

    componentsFeedback: {
        selectAttachment: 'Chọn tệp đính kèm',
        viewFeedbackLog: 'Xem lịch sử phản hồi',
        commitFailure: 'Gửi thất bại',
        problemFeedback3: 'Phản hồi vấn đề',
        pleaseEnterTheContactName4: 'Vui lòng nhập tên người liên hệ',
        pleaseEnterAContactNumber3: 'Vui lòng nhập số điện thoại liên hệ',
        uploadAttachment2: 'Tải lên tệp đính kèm',
        pleaseEnterADetailedDescriptionOfTheProblem2:
            'Vui lòng nhập mô tả chi tiết vấn đề',
        theUploadedFilesCannotExceed:
            'Tệp tải lên không được vượt quá',
        aMaximumOfFiveFilesCanBeUploaded2:
            'Tối đa 5 tệp được phép tải lên',
        aMaximumOfFiveFilesCanBeUploadedTheSizeOfEachFileCannotExceed20Mb:
            'Tối đa 5 tệp, mỗi tệp không vượt quá 20MB, hỗ trợ các định dạng',
        pleaseExplainTheProblemAndEnterTheQqNumberToFacilitateContact:
            'Vui lòng mô tả vấn đề và nhập số QQ để tiện liên hệ',
    },

    componentsFeedjump: {
        lightWinTreasureSmallProgram: 'Mini Program EaseHUB',
        scanCodeUsingASmallProgram: 'Quét mã bằng Mini Program',
        realTimeControlOfRoomStatus: 'Quản lý tình trạng phòng theo thời gian thực',
        onlineOneClickPriceAdjustment: 'Điều chỉnh giá trực tuyến chỉ với một cú nhấp',
        memberDevelopmentTools: 'Công cụ phát triển thành viên',
        moreFeaturesComingOnline: 'Nhiều tính năng khác đang được triển khai',
        hotelOperationCarefulAssistant: 'Trợ lý quản lý khách sạn tận tâm',
    },

    componentsGethelp: {
        getHelp: 'Nhận hỗ trợ',
    },

    componentsGoappshop: {
        applicationMarket: 'Chợ ứng dụng',
    },

    componentsJointrain: {
        attendTraining: 'Tham gia đào tạo',
    },

    componentsLeftcontent: {
        hotelOperationsManager: 'Quản lý vận hành khách sạn',
        cityOperationsManager: 'Quản lý vận hành khu vực',
        customerServiceHotline: 'Đường dây nóng chăm sóc khách hàng',
    },

    componentsTrain: {
        trainingCoursesAreInFullSwing:
            'Các khóa đào tạo đang diễn ra sôi nổi',
        getDetailedTrainingNoticesAndMaterials:
            'Nhận thông báo và tài liệu đào tạo chi tiết',
        followThelightStaySystemServicePublicAccount:
            'Theo dõi tài khoản công khai "Dịch vụ hệ thống Qingzhu"',
        basicCourseIntroductorySeries:
            'Khóa cơ bản: Chuỗi bài giảng nhập môn',
        mondayAndWednesday1430Start:
            'Bắt đầu lúc 14:30 thứ Hai và thứ Tư hàng tuần',
        advancedCourseComplexScenesCommonQuestionsRecentNewFeatures:
            'Khóa nâng cao: Tình huống phức tạp + Câu hỏi thường gặp + Tính năng mới',
        friday1430Start:
            'Bắt đầu lúc 14:30 thứ Sáu hàng tuần',
    },

    merchantPCtxTab: {
        oldFinancialReconciliationSystem:
            'Hệ thống đối soát tài chính cũ',
        lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
            'Khoản trợ cấp hoa hồng Qingzhu đã được chuyển sang mục Khuyến khích thành viên, vui lòng xác nhận hóa đơn tại đó',
    },

    merchantPCtxTab1: {
        oldFinancialReconciliationSystem:
            'Hệ thống đối soát tài chính cũ',
        lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
            'Khoản trợ cấp hoa hồng Qingzhu đã được chuyển sang mục Khuyến khích thành viên, vui lòng xác nhận hóa đơn tại đó',
    },

    merchantPSearchqu: {
        enterHotelName: 'Nhập tên khách sạn',
    },

    payIndex: {
        toBePaid: 'Chờ thanh toán',
        pleaseScanQrCodeToCompletePayment:
            'Vui lòng quét mã QR để hoàn tất thanh toán',
        canBeClosedAfter: 'Có thể đóng sau',
        paymentSuccess: 'Thanh toán thành công',
        automaticShutdownInSeconds: 'Tự động đóng sau vài giây',
        automaticPageRefresh: 'Tự động làm mới trang',
        duringThePayment: 'Đang thanh toán',
        paymentAnomaly: 'Thanh toán bất thường',
        ifThePaymentIsAbnormalContactTechnicalSupport:
            'Thanh toán bất thường, vui lòng liên hệ hỗ trợ kỹ thuật',
        paymentFailure: 'Thanh toán thất bại',
        payOff: 'Đóng thanh toán',
        waitForTheUserToScanTheCode: 'Đang chờ người dùng quét mã',
        currentStatusOfLehuiPayment:
            'Trạng thái thanh toán hiện tại của Lehui',
        theGunScannedTheCodeSuccessfully:
            'Thiết bị quét mã đã quét thành công',
        theUserHasPaidSuccessfully:
            'Người dùng đã thanh toán thành công',
        ifTheUserDoesNotPayItCanBeReRecordedInTheFinancePage:
            'Nếu người dùng chưa thanh toán, có thể ghi nhận lại tại trang tài chính',
    },

    sellCalctable: {
        maximumPromotion: 'Mức khuyến mãi tối đa',

        nonMemberSellingPricebrestimatedSettlementPrice:
            'Giá bán khách không phải thành viên<br>/Giá đối soát dự kiến',

        ordinaryMemberSellingPricebrestimatedSettlementPrice:
            'Giá bán thành viên thường<br>/Giá đối soát dự kiến',

        goldMemberSellingPricebrestimatedSettlementPrice:
            'Giá bán thành viên Vàng<br>/Giá đối soát dự kiến',

        platinumMemberSellingPricebrestimatedSettlementPrice:
            'Giá bán thành viên Bạch Kim<br>/Giá đối soát dự kiến',

        diamondMemberSellingPricebrestimatedSettlementPrice:
            'Giá bán thành viên Kim Cương<br>/Giá đối soát dự kiến',
    },
    sellPTableTdNew: {
        noData: 'Không có dữ liệu',
    },

    sellPricecalc: {
        channelSellingPriceCalculator: 'Công cụ tính giá bán theo kênh',
        selectRoomType: 'Chọn loại phòng',
        pleaseSelectRoomType: 'Vui lòng chọn loại phòng',
        selectProduct: 'Chọn sản phẩm',
        pleaseSelectAProductName: 'Vui lòng chọn tên sản phẩm',
        selectSaleDate: 'Chọn ngày bán',
        distributionChannel: 'Kênh phân phối',
        pleaseSelectTheDistributionChannelNamenotRequired:
            'Vui lòng chọn tên kênh phân phối (không bắt buộc)',
        canNotExceed: 'Không được vượt quá',
        pleaseSelectASaleDate: 'Vui lòng chọn ngày bán',
        figure: 'Số',
    },

    filtersIndex: {
        all: 'Tất cả',
        sinceThe: 'Từ',
        free: 'Miễn phí',
        group: 'Đoàn',
        association: 'Hợp đồng',
        theClock: 'Theo giờ',
        long: 'Dài hạn',
        inapplicability: 'Không áp dụng',
        haveProcessed: 'Đã xử lý',
        notProcessed: 'Chưa xử lý',

        averageSalesRate: 'Giá phòng bán trung bình',
        consumptionNight: 'Đêm phòng tiêu thụ',
        averageHousePriceOfConsumption: 'Giá phòng tiêu thụ trung bình',
        onlinePermeability: 'Tỷ lệ thâm nhập trực tuyến',
        cancelNight: 'Đêm phòng hủy',
        rejectionNight: 'Đêm phòng từ chối',
        channelProvision: 'Cung cấp bởi kênh',
        theHotelProvides: 'Cung cấp bởi khách sạn',
    },

    jsonBookertypeoptions: {
        singleStoreMember: 'Thành viên khách sạn',
        lightLivingMember: 'Thành viên Qingzhu',
    },

    layoutIndex: {
        collapseMenuBar: 'Thu gọn thanh menu',
    },

    componentsNavbar: {
        shiftManagement: 'Quản lý bàn giao ca',
        helpCenter: 'Trung tâm trợ giúp',
        logout: 'Đăng xuất',

        reportTitle: 'Báo cáo tổng hợp bàn giao ca',

        headers: {
            income: 'Thu nhập',
            expend: 'Chi tiêu',
            total: 'Tổng số tiền',
        },
    },

    componentsSidemessage: {
        orderNotice: 'Thông báo đơn hàng',
        orderMessageReceivedNotification:
            'Đã nhận được thông báo đơn hàng',

        youDoNotHaveOrderManagementPermission:
            'Bạn chưa được cấp quyền quản lý đơn hàng',

        ignore: 'Bỏ qua',

        order: 'Tin nhắn đơn hàng',

        noData: 'Chưa có tin nhắn mới',

        system: 'Tin nhắn hệ thống',

        settlement: 'Tin nhắn đối soát',

        dynamic: 'Tin nhắn động thái',

        serviceManagement: 'Quản lý yêu cầu dịch vụ',

        roomService: 'Dịch vụ phòng',

        itemBorrow: 'Mượn vật dụng',

        extendStay: 'Dịch vụ gia hạn lưu trú',

        manualEntry: 'Nhập đơn thủ công',

        confirmOrder: 'Xác nhận đơn',

        viewOrder: 'Xem đơn hàng',

        youDoNotHaveAccessToEbkOrderManagement:
            'Bạn chưa được cấp quyền quản lý đơn hàng EBK',

        youReceive: 'Bạn nhận được',

        aNewMessage: 'tin nhắn mới',

        have: 'Có',

        orderMessage: 'tin nhắn đơn hàng',

        aNewSystemMessage: 'tin nhắn hệ thống mới',

        aNewSettlementMessage: 'tin nhắn đối soát mới',
    },

    componentsSoundnotice: {
        playOut: 'Phát xong',
        theVoicePromptsThatAMessageIsReceived:
            'Thông báo bằng giọng nói khi nhận được tin nhắn',
    },

    nightcheckNightStart: {
        nightTrialSequence: 'Quy trình kiểm toán đêm',
        nightAuditInstructions2: 'Hướng dẫn kiểm toán đêm',
    },

    nightcheckNightTip: {
        theHotelHasNotBeenAuditedAtNightInOrderToAvoidAffectingTheHotelsRevenueDataPleaseStartTheNightAuditAsSoonAsPossible:
            'Khách sạn chưa thực hiện kiểm toán đêm. Để tránh ảnh hưởng đến dữ liệu doanh thu, vui lòng thực hiện kiểm toán đêm sớm nhất có thể',

        nightAuditInstructions2: 'Hướng dẫn kiểm toán đêm',

        beforeTheNightAuditPleaseBeSureToCheckWhetherTheHotelsAccountingDataIsCorrectInAdvanceToAvoidAffectingTheHotelsRevenue:
            'Trước khi kiểm toán đêm, vui lòng kiểm tra kỹ dữ liệu kế toán của khách sạn để tránh ảnh hưởng đến doanh thu',

        pleaseConfirmThatAllCheckInAndCheckOutOrdersForTheCurrentBusinessDayHaveBeenProcessed:
            'Vui lòng xác nhận rằng tất cả đơn nhận phòng và trả phòng trong ngày kinh doanh hiện tại đã được xử lý',

        youHaveSetUpANightAuditToAutomaticallyCancelTheStoreOrdersThatHaveNotArrived:
            'Bạn đã thiết lập tự động hủy các đơn đặt phòng chưa đến khi thực hiện kiểm toán đêm',

        preArrivalAutoCheckIn: 'Bạn đã thiết lập tự động nhận phòng cho đơn dự kiến đến khi kiểm toán đêm',
        preArrivalAutoNoshow: 'Bạn đã thiết lập tự động đánh dấu no-show cho đơn dự kiến đến khi kiểm toán đêm',
        preDepartureAutoCheckOut: 'Bạn đã thiết lập tự động trả phòng cho đơn dự kiến đi khi kiểm toán đêm',
        preDepartureAutoExtendStay: 'Bạn đã thiết lập tự động gia hạn lưu trú cho đơn dự kiến đi khi kiểm toán đêm',

        theEarliestTimeForManualNightAuditIs:
            'Thời gian sớm nhất để thực hiện kiểm toán đêm thủ công là',

        nightAuditProcess: 'Quy trình kiểm toán đêm',

        hotelBusinessDaysAreNowGreaterThanNaturalDays:
            'Ngày kinh doanh hiện tại của khách sạn đã lớn hơn ngày tự nhiên',

        nightAuditReminder: 'Nhắc nhở kiểm toán đêm',

        hotelBusinessDay: 'Ngày kinh doanh của khách sạn',

        currentNaturalDay: 'Ngày tự nhiên hiện tại',

        viewLogs: 'Xem nhật ký',

        theNightTrialWasCompleted: 'Đã hoàn thành kiểm toán đêm',

        nightAuditStartTimeCanNotBeEarlierThan21OclockCanNotPerformNightAuditOperationOh:
            'Thời gian bắt đầu kiểm toán đêm không được sớm hơn 21:00, không thể thực hiện kiểm toán đêm',

        thereIsAnOngoingNightTrialPleaseDoNotRepeatTheProcedure:
            'Đang có kiểm toán đêm đang thực hiện, vui lòng không thao tác lặp lại',
    },

    nightcheckNightTipGrayEnv: {
        theCurrentBusinessDayOfTheHotelIsLongerThanTheNaturalDayOrTheNightAuditCanNotStartEarlierThan21OclockCanNotPerformTheNightAuditOperation:
            'Ngày kinh doanh hiện tại của khách sạn đã vượt quá ngày tự nhiên hoặc thời gian bắt đầu kiểm toán đêm sớm hơn 21:00, không thể thực hiện kiểm toán đêm',

        theNightTrialHasNotBeenCompletedPleaseExecuteTheNightTrialAsSoonAsPossible:
            'Kiểm toán đêm chưa hoàn thành, vui lòng thực hiện sớm nhất có thể',
    },

    globalMethodsmixin: {
        hotelChangeAlert: 'Thông báo thay đổi khách sạn',

        theHotelIsCurrentlyFrom: 'Khách sạn hiện tại đã được chuyển từ',

        switchTo: 'sang',
    },

    regularIndex: {
        pleaseEnterTheCorrectEmailAddress:
            'Vui lòng nhập đúng địa chỉ email',

        pleaseEnterTheCorrectIdNumber:
            'Vui lòng nhập đúng số CMND/CCCD',

        pleaseEnterTheCorrectIdNumber2:
            'Vui lòng nhập đúng số giấy tờ',
    },

    sidebarLogo: {
        helpCenter2: 'Trung tâm trợ giúp',
    },

    modulesMember: {
        drench: 'Qingzhu',
    },

    modulesUser: {
        client: 'Khách hàng',

        membershipManagement: 'Quản lý thành viên',

        singleStoreMemberManagement:
            'Quản lý thành viên khách sạn',

        storeValueManagement:
            'Quản lý số dư khách sạn',

        singleStorePointsSetting:
            'Cài đặt điểm thưởng khách sạn',

        storeValueReport:
            'Báo cáo số dư khách sạn',

        failedToObtainOperationInformationProcedure:
            'Không thể lấy thông tin vận hành',

        billReconciliation:
            'Đối soát hóa đơn',

        paymentRecord:
            'Lịch sử chuyển khoản',

        expenseStatement:
            'Sao kê chi phí',
    },
    utilsAddroute: {
        initializesTheReceivableFinancialMenu: 'Khởi tạo menu tài chính khoản phải thu',
    },

    utilsDoorcard: {
        initializationFailure: 'Khởi tạo thất bại',
        noKeyCardReaderPlugInFound: 'Không tìm thấy plugin đầu đọc thẻ phòng',
        cardReadingError: 'Lỗi đọc thẻ',
        plugIn: 'Plugin',
        cardReadingResult: 'Kết quả đọc thẻ',
        cardReadingFailure: 'Đọc thẻ thất bại',
        businessCardWriteData: 'Ghi dữ liệu vào thẻ',
        businessCardPrintingResult: 'Kết quả tạo thẻ',
        businessCardFailure: 'Tạo thẻ thất bại',
        logoutStatusCode: 'Mã trạng thái hủy thẻ',
        logoutFailure: 'Hủy thẻ thất bại',
    },

    utilsDoorcardmaitian: {
        noKeyCardReaderPlugInFound: 'Không tìm thấy plugin đầu đọc thẻ phòng',
        cancelTheCardSuccessfully: 'Hủy thẻ thành công',
        readTheCardSuccessfully: 'Đọc thẻ thành công',
    },

    utilsEnum: {
        roomInNeedOfRepair: 'Phòng cần sửa chữa',
        guestRequest: 'Yêu cầu của khách',
        hotelRowRoomDemand: 'Yêu cầu xếp phòng của khách sạn',

        inProcess: 'Đang xử lý',
        alreadyEnded: 'Đã kết thúc',

        storeOrderPreArrivalHasNotBeenChecked: 'Kiểm tra đơn đặt phòng chưa đến',
        leaveTheRoomForInspectionToday: 'Kiểm tra phòng dự kiến trả hôm nay',
        generateRoomChargesInTheRoom: 'Tạo tiền phòng cho khách đang lưu trú',
        cleanRoomToDirtyRoom: 'Chuyển phòng sạch sang phòng bẩn',
        switchingDay: 'Chuyển đổi ngày kinh doanh',

        preArrivalNoShowRoomListPending: 'Khách chưa đến, đơn phòng chờ nhận phòng',
        preSeparationIsNotSeparated: 'Dự kiến trả phòng nhưng chưa trả',

        allRoomChargesAreGeneratedAndRecordedInTheAccount:
            'Tạo toàn bộ tiền phòng và ghi nhận vào tài khoản',

        roomChange: 'Thay đổi trạng thái phòng',

        generateCureReport: 'Tạo báo cáo cố định',

        shopHourRoom: 'Phòng theo giờ tại khách sạn',

        onlineHourRoom: 'Phòng theo giờ trực tuyến',

        presaleFullDayRoomProduct: 'Sản phẩm phòng cả ngày bán trước',

        presaleClockRoomProduct: 'Sản phẩm phòng theo giờ bán trước',
    },

    utilsFreego: {
        theCardReaderIsNotConnectedToTheComputer:
            'Đầu đọc thẻ chưa được kết nối với máy tính',

        checkValueError: 'Lỗi kiểm tra dữ liệu',

        passwordError: 'Sai mật khẩu',

        readCard: 'Đọc thẻ',

        cardReaderCommunicationIsNormal:
            'Kết nối với đầu đọc thẻ bình thường',

        businessCardPrintingSoftwareIsNotOpened:
            'Phần mềm tạo thẻ chưa được mở',

        theReaderIsNotConnectedOrTheSoftwareIsNotOpen:
            'Đầu đọc chưa kết nối hoặc phần mềm chưa được mở',

        sorryYourBrowserDoesNotSupportCardReaderPleaseUseChrome:
            'Trình duyệt hiện tại không hỗ trợ đầu đọc thẻ, vui lòng sử dụng trình duyệt Chrome',
    },

    utilsIdcard: {
        idCardReaderIsConnectedToScanYourIdCardConnectTheIdCardScannerToYourComputerAndRefreshThePage:
            'Đầu đọc CCCD đã được kết nối. Để quét giấy tờ, vui lòng kết nối thiết bị với máy tính và làm mới trang',

        toScanDocumentsInstallTheIdCardReaderControl:
            'Để quét giấy tờ, vui lòng cài đặt tiện ích đầu đọc CCCD',

        abnormalReadingIdCardPleaseRefreshAndTryAgain:
            'Đọc CCCD bất thường, vui lòng làm mới và thử lại',

        noIdInformationIsReadPleaseCheckWhetherTheIdCardIsPlacedOrPlacedInTheCorrectPosition:
            'Không đọc được thông tin giấy tờ, vui lòng kiểm tra lại vị trí đặt CCCD',
    },

    utilsIndex: {
        justNow: 'Vừa xong',

        aMinuteAgo: 'phút trước',

        hoursAgo: 'giờ trước',

        month: 'Tháng',

        when: 'Giờ',

        connectionSuccessful: 'Kết nối thành công',

        theGlobalConnectionIsClosed: 'Kết nối toàn cục đã đóng',

        yourBrowserDoesNotSupportIt: 'Trình duyệt của bạn không hỗ trợ',
    },

    utilsLinktopage: {
        contactTheAdministratorToEnableIt:
            'Vui lòng liên hệ quản trị viên để kích hoạt',

        noCorrespondingLedgerFound:
            'Không tìm thấy bộ tài khoản tương ứng',

        accountReceivable: 'Khoản phải thu',

        administrativeAuthority: 'Quyền quản trị',
    },

    utilsRequest: {
        doNotRepeatRequests: 'Vui lòng không gửi yêu cầu lặp lại',

        noFlightFoundPleaseSelectAgain:
            'Không tìm thấy ca làm việc, vui lòng chọn lại',

        systemErrorPleaseContactTechnicalSupport:
            'Lỗi hệ thống, vui lòng liên hệ hỗ trợ kỹ thuật',

        networkException: 'Lỗi mạng',

        requestTimedOutPleaseRefreshThePage:
            'Yêu cầu đã hết thời gian chờ, vui lòng làm mới trang',

        requestTimeout: 'Hết thời gian chờ',

        requestFailed: 'Yêu cầu thất bại',
    },

    utilsSharestorage: {
        putInTheInitialMarker: 'Đánh dấu lần đầu',
    },

    appdetailIndex: {
        specification: 'Thông số',

        contactBusinessManager: 'Liên hệ quản lý kinh doanh',

        buyNow: 'Mua ngay',

        applicationIntroduction: 'Giới thiệu ứng dụng',

        workingHours: 'Giờ làm việc',

        pleaseSelectProductSpecifications:
            'Vui lòng chọn quy cách sản phẩm',
    },

    applistIndex: {
        fullApplication: 'Tất cả ứng dụng',

        haveOpened: 'Đã kích hoạt',

        haveNotOpened: 'Chưa kích hoạt',

        inService: 'Đang kích hoạt',

        contactBusinessManager: 'Liên hệ quản lý kinh doanh',

        workingHours: 'Giờ làm việc',

        openImmediately: 'Kích hoạt ngay',

        immediateRenewal: 'Gia hạn ngay',

        expiredDays: 'Đã hết hạn {days} ngày',

        daysLeftToExpire: 'Còn {days} ngày đến hạn',
    },

    createorderIndex: {
        goToPay: 'Đi thanh toán',

        remaining: 'Còn lại',

        orderProduct2: 'Sản phẩm đặt mua',

        purchaser2: 'Người mua',

        specification: 'Thông số',

        successfulCustomsOrder2: 'Đóng đơn thành công',
    },
    createorderPay: {
        amountPaid: 'Số tiền thanh toán',
        paymentCountdown: 'Đếm ngược thanh toán',
        qrCodeHasExpired: 'Mã QR đã hết hạn',
        updateNow: 'Cập nhật ngay',
        payment3: 'Thanh toán',
        scanQRCode: 'Vui lòng sử dụng WeChat/Alipay quét mã QR để thanh toán',
    },

    orderlistIndex: {
        orderDate: 'Ngày đặt mua',
        product: 'Sản phẩm',
        toBePaid: 'Chờ thanh toán',
        paymentSuccess: 'Thanh toán thành công',
        paymentFailure: 'Thanh toán thất bại',
        refunded: 'Đã hoàn tiền',
        partialRefund: 'Hoàn tiền một phần',
        goToPay: 'Đi thanh toán',
        orderTime: 'Thời gian đặt mua',
        orderProduct2: 'Sản phẩm đặt mua',
        orderSpecification: 'Quy cách đặt mua',
        refundAmount: 'Số tiền hoàn',
        orderEffectiveTime: 'Thời gian hiệu lực đơn hàng',
        purchaser2: 'Người mua',
        orderOperation: 'Thao tác đơn hàng',
        successfulCustomsOrder2: 'Đóng đơn thành công',
    },

    commentChannelComment: {
        modifyReply: 'Chỉnh sửa phản hồi',
        setAsTemplate: 'Đặt làm mẫu',
        selectRecommendedTemplate: 'Chọn mẫu đề xuất',
        inputReplyContentNoMoreThan10WordsAndNoMoreThan500Words:
            'Nhập nội dung phản hồi, từ 10 đến 500 ký tự',
        theMaximumResponseTextIs500Characters: 'Nội dung phản hồi tối đa 500 ký tự',
        areYouSureYouWantToDeleteReplies: 'Xác nhận xóa phản hồi này?',
    },

    commentCommentTempManage: {
        newTemplate: 'Tạo mẫu mới',
        goodReputation: 'Đánh giá tốt',
        delete2: 'Xóa',
        templateName: 'Tên mẫu',
        replyClassification: 'Phân loại phản hồi',
        replyContent2: 'Nội dung phản hồi',
        pleaseEnterAtLeast10Characters: 'Vui lòng nhập ít nhất 10 ký tự',
        keyword: 'Từ khóa',
        pleaseEnterTheKeywordsThatYouWantToMatchTheCommentsSeparatedByCommas:
            'Vui lòng nhập từ khóa cần khớp với đánh giá, phân tách bằng dấu phẩy',
        pleaseEnterATemplateName: 'Vui lòng nhập tên mẫu',
        theValueCanContainNoMoreThan15Characters: 'Độ dài không quá 15 ký tự',
        pleaseSelectAReplyCategory: 'Vui lòng chọn phân loại phản hồi',
        pleaseEnterTheReplyContent: 'Vui lòng nhập nội dung phản hồi',
        '10To500CharactersInLength': 'Độ dài từ 10 đến 500 ký tự',
        theValueContainsAMaximumOf50Characters: 'Độ dài tối đa 50 ký tự',
        definitiveDeletion: 'Xác nhận xóa',
        deletingATemplateSucceeded: 'Xóa mẫu thành công',
        creatingATemplateSucceeded: 'Tạo mẫu thành công',
    },

    commentComment: {
        reasonForNotPassing: 'Lý do không được duyệt',
        setAsTemplate: 'Đặt làm mẫu',
        replyAgain: 'Phản hồi lại',
        reappeal: 'Khiếu nại lại',
        inComplaint: 'Đang khiếu nại',
        typeOfAppeal: 'Loại khiếu nại',
        statementOfAppeal: 'Nội dung khiếu nại',
        selectRecommendedTemplate: 'Chọn mẫu đề xuất',
        inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
            'Nhập nội dung phản hồi, từ 10 đến 300 ký tự',
        theMaximumResponseTextIs500Characters: 'Nội dung phản hồi tối đa 500 ký tự',
        areYouSureYouWantToDeleteReplies: 'Xác nhận xóa phản hồi này?',
    },

    commentComplain: {
        onceYourComplaintHasBeenReviewedTheCommentWillBeAutomaticallyDeleted:
            'Sau khi khiếu nại của bạn được duyệt, hệ thống sẽ tự động xóa đánh giá này',
        youCanUploadUpToFivePictures: 'Có thể tải lên tối đa 5 hình ảnh',
        launchAComplaint: 'Gửi khiếu nại',
        typeOfAppeal: 'Loại khiếu nại',
        statementOfAppeal: 'Nội dung khiếu nại',
        uploadCredentials: 'Tải lên bằng chứng',
        pleaseFillInTheContact: 'Vui lòng nhập người liên hệ',
        pleaseEnterTheCorrectName: 'Vui lòng nhập đúng họ tên',
        pleaseSelectTheAppealType: 'Vui lòng chọn loại khiếu nại',
        theCauseOfTheComplaintMustBeAtLeast10Words: 'Lý do khiếu nại phải có ít nhất 10 ký tự',
        theMaximumCauseOfAppealIs300Words: 'Lý do khiếu nại tối đa 300 ký tự',
        underAppeal: 'Đang gửi khiếu nại',
        addAppealSuccess: 'Gửi khiếu nại thành công',
    },

    commentIndex: {
        totalEvaluation: 'Tất cả đánh giá',
        waitForReply: 'Chờ phản hồi',
        appealed: 'Đã khiếu nại',
        allRoomTypes: 'Tất cả loại phòng',
        noReplyYet: 'Chưa phản hồi',
        toBeReviewed: 'Chờ xét duyệt',
        notPass: 'Không được duyệt',
        alreadyPassed: 'Đã duyệt',
    },

    commentMain: {
        deleteReplySucceeded: 'Xóa phản hồi thành công',
        modifiedReplySucceeded: 'Chỉnh sửa phản hồi thành công',
    },

    commentPreview: {
        viewPicture: 'Xem hình ảnh',
    },

    commentReplyList: {
        replyDate: 'Ngày',
        commentChannel: 'Kênh đánh giá',
        review2: 'Đánh giá',
        replyContent2: 'Nội dung phản hồi',
        commentReply: 'Phản hồi đánh giá',
        modifyReply: 'Chỉnh sửa phản hồi',
        deleteReply: 'Xóa phản hồi',
        meituanReview: 'Đánh giá Meituan',
        ctripReview: 'Đánh giá Ctrip',
        whereToComment: 'Đánh giá Qunar',
        sameTripReview: 'Đánh giá Tongcheng Travel',
        dianpingReviews: 'Đánh giá Dianping',
        flyingPigReview: 'Đánh giá Fliggy',
        parallelComment: 'Đánh giá Tongcheng',
    },
    commentScore: {
        renewal: 'Cập nhật',
        guestImpression: 'Ấn tượng của khách',
        overallGuestRating: 'Điểm đánh giá tổng thể của khách',
    },

    complainDetail: {
        issueDetails: 'Chi tiết vấn đề',
        processingDetails: 'Chi tiết xử lý',
        serviceProblem: 'Vấn đề dịch vụ',
        healthProblem: 'Vấn đề vệ sinh',
        processor: 'Người xử lý',
        processingTime: 'Thời gian xử lý',
        communicationSituation: 'Tình hình trao đổi',
    },

    complainHandle: {
        successfulProcessing: 'Xử lý thành công',
        problemHandling: 'Xử lý vấn đề',
        roomInformation: 'Thông tin phòng',
        guestInformation: 'Thông tin khách',
        communicationSituation: 'Tình hình trao đổi',
        enterAMaximumOf300Characters: 'Nhập tối đa 300 ký tự',
        pleaseEnterTheProcessingResult: 'Vui lòng nhập kết quả xử lý',
    },

    complainIndex: {
        submissionDate: 'Ngày gửi',
        processed: 'Đã xử lý',
        submissionTime: 'Thời gian gửi',
        feedbackProblem: 'Vấn đề phản hồi',
        untreated: 'Chưa xử lý',
        viewTheResults: 'Xem kết quả',
    },

    ebkComment: {
        inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
            'Nhập nội dung phản hồi, từ 10 đến 300 ký tự',
        theMaximumResponseTextIs300Characters:
            'Nội dung phản hồi tối đa 300 ký tự',
        modifiedReplySucceeded: 'Chỉnh sửa phản hồi thành công',
    },

    ebkGrade: {
        guestImpression: 'Ấn tượng của khách',
    },

    ebkIndex: {
        totalEvaluation: 'Tất cả đánh giá',
        waitForReply: 'Chờ phản hồi',
    },

    customerCompany: {
        new: 'Thêm mới',
        whetherToAllowHangingAccounts2: 'Cho phép công nợ hay không',
        loginListHidesRates: 'Ẩn giá phòng trên phiếu đăng ký',
        confirmAction: 'Xác nhận {action} khách hàng doanh nghiệp "{name}"?',
    },

    customerDialog: {
        whetherToAllowHangingAccounts2: 'Cho phép công nợ hay không',

        theRegistrationFormHidesTheRoomRate:
            'Ẩn giá phòng trên phiếu đăng ký',

        addACorporateClient: 'Thêm khách hàng doanh nghiệp',

        changeCorporateAccount: 'Chỉnh sửa khách hàng doanh nghiệp',

        companyInformation: 'Thông tin công ty',

        forShort: 'Tên viết tắt',

        pleaseEnterCompanyAbbreviation:
            'Vui lòng nhập tên viết tắt công ty',

        code: 'Mã',

        pleaseEnterTheCode: 'Vui lòng nhập mã',

        legalPerson: 'Người đại diện pháp luật',

        pleaseEnterTheLegalPersonName:
            'Vui lòng nhập tên người đại diện pháp luật',

        fax: 'Fax',

        pleaseEnterTheFaxNumber:
            'Vui lòng nhập số fax',

        city: 'Thành phố',

        postcode: 'Mã bưu chính',

        pleaseEnterPostalCode:
            'Vui lòng nhập mã bưu chính',

        pleaseEnterDiscountRatio:
            'Vui lòng nhập tỷ lệ ưu đãi',

        enterAMaximumOf100Characters:
            'Nhập tối đa 100 ký tự',

        contactInformation: 'Thông tin liên hệ',

        pleaseEnterTheContactNumber:
            'Vui lòng nhập số điện thoại liên hệ',

        pleaseEnterEmail:
            'Vui lòng nhập email',

        setUp: 'Thiết lập công nợ',

        pleaseEnterYourAccountName:
            'Vui lòng nhập tên tài khoản',

        accountType: 'Loại tài khoản',

        maximumAmount: 'Hạn mức tối đa',

        pleaseEnterDiscount:
            'Vui lòng nhập mức chiết khấu',

        pleaseEnterAnIntegerBetween0And100:
            'Vui lòng nhập số nguyên từ 0 đến 100',

        pleaseEnterTheCorrect11DigitMobileNumber:
            'Vui lòng nhập đúng số điện thoại 11 chữ số',

        pleaseEnterName:
            'Vui lòng nhập tên',

        pleaseEnterTheContactName3:
            'Vui lòng nhập tên người liên hệ',

        creditAccount: 'Tài khoản tín dụng',

        theCreditLimitCannotBeExceeded:
            'Không được vượt quá hạn mức tín dụng',

        enterRange:
            'Vui lòng nhập số trong khoảng từ 1 đến 365',
    },

    customerIndex: {
        protocolUnitToBeDeveloped:
            'Đơn vị hợp đồng (chưa phát triển)',
    },

    heavenlyEyeCallThePolice: {
        alarmEvent: 'Sự kiện cảnh báo',

        shootingTime: 'Thời gian chụp',

        theFollowingGuestsHaveNotBeenAddedToTheWhiteListSelectTheGuestsThatMatchThePhoto:
            'Những khách dưới đây chưa được thêm vào danh sách trắng, vui lòng chọn khách phù hợp với ảnh',

        stranger: 'Người lạ',

        whiteAdded: 'Đã thêm vào danh sách trắng',

        ignored: 'Đã bỏ qua',

        whitelist: 'Thêm vào danh sách trắng',

        environmentalPhotograph: 'Ảnh môi trường',

        facePhoto: 'Ảnh khuôn mặt',

        pleaseSelectUser:
            'Vui lòng chọn người dùng',
    },

    heavenlyEyeWhiteList: {
        personnelType: 'Loại nhân sự',

        addStaff: 'Thêm mới',

        pleaseEnterTheRoomNumber:
            'Vui lòng nhập số phòng',

        employee2: 'Nhân viên',

        dweller: 'Khách lưu trú',

        avatar: 'Ảnh đại diện',

        photograph: 'Ảnh',

        pleaseSelectEnterName:
            'Vui lòng chọn hoặc nhập tên',

        pleaseCompleteTheFormBeforeSubmitting:
            'Vui lòng hoàn thành biểu mẫu trước khi gửi',

        inputLabelDuplication:
            'Nhãn nhập bị trùng lặp',

        pleaseEnterTheLabelContent:
            'Vui lòng nhập nội dung nhãn',

        doNotEnterLabelsInMoreThan10Words:
            'Nhãn không được vượt quá 10 ký tự',

        whetherToDeleteTheWhitelist:
            'Xác nhận xóa nhân viên khỏi danh sách trắng?',

        uploadImageFormat:
            'Ảnh tải lên chỉ hỗ trợ định dạng JPG hoặc PNG!',
    },

    hicList: {
        dateOfPresentation: 'Ngày báo cáo',

        dataExport: 'Xuất dữ liệu',

        bookingChannel: 'Kênh đặt phòng',

        bodyTemperature: 'Nhiệt độ cơ thể',

        healthStatus: 'Tình trạng sức khỏe',

        theHealthInformationCollectionReportIsSuccessfullyExportedProcedure:
            'Xuất báo cáo thu thập thông tin sức khỏe thành công',

        failedToExportTheHealthInformationCollectionReportProcedure:
            'Xuất báo cáo thu thập thông tin sức khỏe thất bại',
    },
    hicQrCode: {
        downloadPicture: 'Tải xuống hình ảnh',
    },

    marketActivity: {
        couponType: 'Loại phiếu giảm giá',
        couponName: 'Tên phiếu giảm giá',
        beOffline: 'Đã ngừng hiển thị',
        terminated: 'Đã chấm dứt',
        full: 'Đủ',
        reduction: 'Giảm',
        fromTheDateOfReceipt: 'Tính từ ngày nhận phiếu',
        withinDays: 'Có hiệu lực trong số ngày',
        thisParameterIsValidWithinAFixedPeriod: 'Có hiệu lực trong khoảng thời gian cố định',
        restrictedRoomNight: 'Giới hạn đêm phòng',
        unlimited: 'Không giới hạn',
        oneNight: 'Một đêm phòng',
        discountType: 'Loại ưu đãi',
        validForTimePeriod: 'Có hiệu lực trong khoảng thời gian',
        instructionsForUse: 'Hướng dẫn sử dụng',
        selectionOfParticipatingGoods: 'Chọn sản phẩm tham gia',
        allGoods: 'Tất cả sản phẩm',
        platform: 'Nền tảng',
        theNameOfTheCouponWillBeDisplayedToTheUserPleaseFillItInCarefully:
            'Tên phiếu giảm giá sẽ hiển thị cho người dùng, vui lòng nhập cẩn thận',
        denomination: 'Mệnh giá',
        fillInTheCouponAmountdiscountAmount: 'Nhập số tiền phiếu giảm giá (số tiền ưu đãi)',
        pleaseSelectTheYearMonthAndDay2: 'Vui lòng chọn năm, tháng, ngày',
        instructionsWillBeDisplayedToTheUserPleaseFillInCarefully:
            'Hướng dẫn sử dụng sẽ hiển thị cho người dùng, vui lòng nhập cẩn thận',
        viewActivity: 'Xem hoạt động',
        maxOut: 'Giảm khi đạt mức',
        availableForBooking1Room1NightOnly: 'Chỉ áp dụng khi đặt 1 phòng 1 đêm',
        events: 'Hoạt động',
        orderNeedsToBeFull: 'Đơn hàng cần đạt',
        issued: 'Đã phát hành',
        haveBeenUsed: 'Đã sử dụng',
        expired2: 'Đã hết hạn',
        editCoupon: 'Chỉnh sửa phiếu giảm giá',
        addCoupon: 'Thêm phiếu giảm giá',
        pleaseSelectTheOfferType: 'Vui lòng chọn loại ưu đãi',
        pleaseEnterExpiryDate2: 'Vui lòng nhập thời hạn hiệu lực',
        pleaseSelectExpirationDate: 'Vui lòng chọn thời hạn hiệu lực',
        pleaseEnterTheCouponName2: 'Vui lòng nhập tên phiếu giảm giá',
        amountCanOnlyBeEnteredInPositiveIntegersPleaseReEnter:
            'Số tiền chỉ được nhập số nguyên dương, vui lòng nhập lại',
        successfulActivation: 'Kích hoạt thành công',
        deactivated: 'Đã hủy kích hoạt',
        pleaseConfirmWhetherYouWantToTerminate: 'Vui lòng xác nhận có muốn chấm dứt hay không',
        terminationSuccess: 'Chấm dứt thành công',
        cancelledTermination: 'Đã hủy chấm dứt',
        pleaseEnterTheValidityPeriod: 'Vui lòng nhập nội dung tương ứng với thời hạn hiệu lực',
        createACoupon: 'Tạo phiếu giảm giá',
        unedited: 'Đã hủy chỉnh sửa',
        discountTemplate: 'Giảm trực tiếp { money }',
        fullReductionTemplate: 'Giảm { minAmount } khi đạt mức',
        validityDaysTemplate: 'Có hiệu lực trong { day } ngày kể từ ngày nhận phiếu',
        activationConfirmation:
            'Sau khi phiếu được kích hoạt sẽ không thể chỉnh sửa, xác nhận kích hoạt?',
        importValidationWarning:
            'Một số khách sạn nhập vào có kết quả kiểm tra bất thường, có tiếp tục không?',
    },

    marketActivitydata: {
        classificationSpecification: 'Mô tả phân loại',
        data: 'Dữ liệu',
        marketingRevenue: 'Doanh thu marketing',
        marketingExpenses: 'Chi phí marketing',
        numberOfContacts: 'Số người tiếp cận',
        numberOfVisitors: 'Số người truy cập',
        numberOfTransactions: 'Số người giao dịch',
        revenueDescription: 'Doanh thu phát sinh từ người dùng được tiếp cận trong 30 ngày',
        costDescription: 'Chi phí phát sinh từ marketing trong 30 ngày',
        reachCountDescription: 'Số người dùng được hoạt động marketing tiếp cận trong 30 ngày',
        visitCountDescription:
            'Số người dùng đã truy cập khách sạn này sau khi được tiếp cận trong 30 ngày',
        orderCountDescription:
            'Số người dùng đã đặt đơn sau khi được tiếp cận trong 30 ngày',
    },

    marketCrowddata: {
        subdivide: 'Phân nhóm',
        classificationSpecification: 'Mô tả phân loại',
        numberOfPeople: 'Số người',
        membersWhoHaveStayedAtThisStore: 'Thành viên từng lưu trú tại khách sạn này',
        allMembers: 'Tất cả thành viên',
        usersWhoHaveStayedInThisStoreInThePast1Year:
            'Người dùng từng lưu trú tại khách sạn này trong 1 năm gần đây',
        lowFrequencyMember: 'Thành viên tần suất thấp',
        usersWhoHaveStayedInTheLast1YearButHaveNotStayedInTheLast3Months:
            'Người dùng từng lưu trú trong 1 năm gần đây nhưng 3 tháng gần đây chưa lưu trú',
        loyalUser: 'Người dùng trung thành',
        usersWhoHaveStayedAtLeast3TimesInTheLast1Year:
            'Người dùng đã lưu trú từ 3 lần trở lên trong 1 năm gần đây',
        lostUsers: 'Người dùng đã mất',
        usersWhoHaveStayedInThePast2YearsAndHaveNotStayedInThePast1Year:
            'Người dùng từng lưu trú trong 2 năm gần đây nhưng 1 năm gần đây chưa lưu trú',
        interestedMember: 'Thành viên quan tâm',
        interestedUserGroupsOfThisStore: 'Nhóm người dùng quan tâm đến khách sạn này',
        inThePast7DaysTheUserHasEnteredTheHomepageOfTheMiniProgramOfTheHotelAndHasNotPlacedAnOrder:
            'Trong 7 ngày gần đây, người dùng đã vào trang chủ Mini Program của khách sạn này nhưng chưa đặt đơn',
        localInterestUserGroups: 'Nhóm người dùng quan tâm cùng thành phố',
        inThePast7DaysIHaveSearchedTheCityAndHotelWhereTheHotelIsLocated:
            'Trong 7 ngày gần đây đã tìm kiếm thành phố hoặc khách sạn nơi khách sạn này tọa lạc',
        orEnteredOtherHotelsInTheCityButDidNotPlaceAnOrder:
            'Hoặc đã vào các khách sạn khác trong cùng thành phố nhưng chưa đặt đơn',
        intraCityUserGroup: 'Nhóm người dùng cùng thành phố',
        usersWhoHaveStayedInTheCityInTheLast30DaysAreNotUsersOfThisStore:
            'Người dùng đã lưu trú tại thành phố này trong 30 ngày gần đây nhưng không phải khách của khách sạn này',
        createActivity: 'Tạo hoạt động',
        lowFrequencyUser: 'Người dùng tần suất thấp',
        marketingSuggestion:
            'Gợi ý: Hãy tạo hoạt động marketing kịp thời để giữ chân người dùng và tăng đơn đặt phòng!',
    },

    marketDatakb: {
        crowdDataBulletinBoard: 'Bảng dữ liệu nhóm người dùng',
        activityDataKanban: 'Bảng dữ liệu hoạt động',
    },

    marketDistribution: {
        releaseTime: 'Thời gian phát hành',
        events: 'Hoạt động',
        releaseMode: 'Phương thức phát hành',
        smsSending: 'Gửi SMS',
        publicAccount: 'Tài khoản công khai',
        stopSmsPlatformPush: 'Dừng gửi từ nền tảng SMS Qingzhu',
        stopThePublicAccountPush: 'Dừng gửi từ tài khoản công khai Qingzhu',
        iHaveReadAndAgree: 'Tôi đã đọc và đồng ý',
        precisionMarketingRules: 'Quy tắc marketing chính xác',
        pleaseReadAndAgree: 'Vui lòng đọc và đồng ý',
        warmReminder: 'Lưu ý',
        issue: 'Phát hành',
        couponName: 'Tên phiếu giảm giá',
        pleaseEnterTheCouponName2: 'Vui lòng nhập tên phiếu giảm giá',
        sendingCrowd: 'Nhóm người nhận',
        pleaseSelectTheSender: 'Vui lòng chọn nhóm người nhận',
        quantityIssued: 'Số lượng phát hành',
        pleaseFillInTheNumberOfIssuedCards: 'Vui lòng nhập số lượng phiếu phát hành',
        sendingMode: 'Phương thức gửi',
        notificationTemplate: 'Mẫu thông báo',
        pleaseSelectANotificationTemplate: 'Vui lòng chọn mẫu thông báo',
        projectedCost: 'Chi phí dự kiến',
        allUsers: 'Tất cả người dùng',
        interestedUsersOfThisStore: 'Người dùng quan tâm đến khách sạn này',
        lostUsers: 'Người dùng đã mất',
        loyalUser: 'Người dùng trung thành',
        lowFrequencyUser: 'Người dùng tần suất thấp',
        interestedUsersInTheSameCity: 'Người dùng quan tâm cùng thành phố',
        localUser: 'Người dùng cùng thành phố',
        unactivated: 'Chưa kích hoạt',
        terminated: 'Đã chấm dứt',
        voucherInformation: 'Thông tin phiếu phát hành',
        issuer: 'Người phát hành',
        pleaseEnterTheReleaseQuantity: 'Vui lòng nhập số lượng phát hành',
        couponIssuedSuccessfully: 'Phát hành phiếu giảm giá thành công',
        pleaseEnterCoupon: 'Vui lòng nhập phiếu giảm giá',
        sendBatch: 'Lô gửi',
        pleaseEnterTheCorrectCoupon: 'Vui lòng nhập đúng phiếu giảm giá',
        perPersonUnit: 'Phiếu/người',
        rule1:
            '1. Không nên tạo hoạt động marketing quá thường xuyên. Qingzhu có cơ chế chống làm phiền ở phía người dùng, trong một khoảng thời gian nhất định người dùng chỉ có thể nhận số lượng giới hạn thông báo marketing/SMS.',
        rule2:
            '2. Để tránh khách sạn lạm dụng thông báo marketing/SMS, gây làm phiền không cần thiết cho người dùng và ảnh hưởng đến hình ảnh thương hiệu khách sạn, chức năng này giới hạn mỗi người dùng chỉ nhận 1 lần thông báo trong 7 ngày trên từng kênh gửi.',
        rule3:
            '3. Thông báo marketing/SMS không đảm bảo gửi thành công toàn bộ, hiệu quả tiếp cận lấy theo thực tế.',
        rule4:
            '4. Đối với thông báo marketing/SMS gửi không thành công, chi phí marketing sẽ được hoàn lại và bản ghi gửi cần ghi rõ thành công hoặc thất bại.',
    },

    marketRules: {
        rulesRulesRules: 'Quy tắc',
    },
    memberActivityManage: {
        longTerm: 'Dài hạn',
        customInterval: 'Khoảng thời gian tùy chỉnh',
        activeTime: 'Thời gian hoạt động',
        addActivity: 'Thêm mới',
        editingActivity: 'Chỉnh sửa hoạt động',
        editGear: 'Chỉnh sửa mức',
        addGear: 'Thêm mức',
        unlimited: 'Không giới hạn',
        rechargeAmount2: 'Số tiền nạp',
        enabledState: 'Trạng thái kích hoạt',
        activeState: 'Trạng thái hoạt động',
        pleaseEditTheAddedGears: 'Vui lòng chỉnh sửa các mức đã thêm',
    },

    memberIntegralSetting: {
        integralRatioSetting: 'Cài đặt tỷ lệ tích điểm',
        points: 'Điểm',
        automaticCumulativePointSetting: 'Cài đặt tự động tích điểm',
        storedValueConsumption: 'Tiêu dùng bằng số dư',
        nonCumulativeIntegral: 'Không tích điểm',
        pleaseFillInThePointsRatioSetting: 'Vui lòng nhập cài đặt tỷ lệ tích điểm',
        pleaseSelectTheAutomaticAccumulationPointSetting: 'Vui lòng chọn cài đặt tự động tích điểm',
        roomAndStoredConsumption: 'Chi phí phòng + Tiêu dùng bằng số dư',
        integralRatioLimit: 'Tỷ lệ tích điểm chỉ được giới hạn trong khoảng 0.01~1000',
    },

    memberMemberManage: {
        pleaseArrangeMemberInformationAccordingToTheRequirementsInTheTemplate:
            'Vui lòng sắp xếp thông tin thành viên theo yêu cầu trong mẫu',
        downloadTemplate: 'Tải mẫu',
        freeCommissionPolicyTips: 'Thông báo chính sách miễn hoa hồng',
        downloadFailureData: 'Tải dữ liệu thất bại',
        normal: 'Bình thường',
        registrationTime: 'Thời gian đăng ký',
        entryTime: 'Thời gian nhập liệu',
        augment: 'Tăng',
        decrease: 'Giảm',
        singleStoreStoredValueBillPrinting: 'In hóa đơn số dư của khách sạn',
        theAmountOfMemberStoredValueIsOnlyAvailableInThisStoreAndIsNotAvailableInOtherStores:
            'Số dư của thành viên chỉ có thể sử dụng tại khách sạn này, không thể sử dụng tại khách sạn khác',
        currentMembersHaveUnusedBalancesOrPointsPleaseConfirmWhetherToDisable:
            'Thành viên hiện còn số dư hoặc điểm chưa sử dụng, vui lòng xác nhận có muốn vô hiệu hóa không',
        lightLivingMember: 'Thành viên Qingzhu',
        startOfEntryDate: 'Ngày bắt đầu nhập liệu',
        dateOfEntry: 'Ngày kết thúc nhập liệu',
        membershipIntroduction: 'Nhập thành viên',
        memberExport: 'Xuất thành viên',
        newMember: 'Thêm thành viên',
        viewGrade: 'Xem cấp độ',
        viewMembers2: 'Xem thành viên',
        storedValueQuery2: 'Tra cứu số dư',
        transactionType: 'Loại giao dịch',
        registered: 'Đã đăng ký',
        unregistered: 'Chưa đăng ký',
        theAmountOfThisStoredValue: 'Số tiền nạp lần này',
        storedValueActivity: 'Hoạt động nạp tiền',
        eventGiftAmount: 'Số tiền tặng từ hoạt động',
        currentStoredValueBalance: 'Số dư hiện tại',
        storageTime: 'Thời gian nạp',
        currentBalance: 'Số dư hiện tại',
        topUpTheTotalAmount: 'Tổng số tiền nạp',
        totalGiftAmount: 'Tổng số tiền tặng',
        totalPayment: 'Tổng số tiền thanh toán',
        totalRefundAmount: 'Tổng số tiền hoàn',
        singleStoreMembershipLevel: 'Cấp độ thành viên',
        storePoints: 'Điểm của khách sạn',
        storedValueAccumulation: 'Tổng số dư đã nạp',
        incorrectEmailFormat: 'Định dạng email không đúng',
        membershipLevel: 'Cấp độ thành viên',
        occupation: 'Nghề nghiệp',
        pleaseEnterOccupation: 'Vui lòng nhập nghề nghiệp',
        salespersonName: 'Tên nhân viên kinh doanh',
        salespersonId: 'ID nhân viên kinh doanh',
        pleaseEnterSalespersonId: 'Vui lòng nhập ID nhân viên kinh doanh',
        pleaseEnterTheSalespersonsName: 'Vui lòng nhập tên nhân viên kinh doanh',
        pleaseSelectTheYearMonthAndDay2: 'Vui lòng chọn năm tháng ngày',
        detailedAddress: 'Địa chỉ chi tiết',
        lv: 'Cấp',
        gradeName: 'Tên cấp độ',
        variableIntegral: 'Điểm thay đổi',
        pointBalance: 'Số dư điểm',
        transactionAmount: 'Số tiền giao dịch',
        changeType: 'Loại thay đổi',
        changeOfAmount: 'Số lượng thay đổi',
        pleaseEnterAnInteger: 'Vui lòng nhập số nguyên',
        topUpActivity: 'Hoạt động nạp tiền',
        pleaseSelectAnActivity: 'Vui lòng chọn hoạt động',
        activeGear: 'Mức hoạt động',
        rechargeAmount2: 'Số tiền nạp',
        pleaseEnterTheRechargeAmount: 'Vui lòng nhập số tiền nạp',
        amountReceivable: 'Số tiền phải thu',
        printDocuments: 'In chứng từ',
        deductionAmount: 'Số tiền khấu trừ',
        pleaseEnterTheAmountOfDeduction: 'Vui lòng nhập số tiền khấu trừ',
        increaseTheIntegral: 'Tăng điểm',
        reduceIntegral: 'Giảm điểm',
        filling: 'Nạp',
        send: 'Tặng',
        pleaseEnterTheCorrectIdNumber: 'Vui lòng nhập đúng số CMND/CCCD',
        pleaseEnterTheCorrectIdNumber2: 'Vui lòng nhập đúng số giấy tờ',
        pleaseFillInTheIdNumber: 'Vui lòng nhập số giấy tờ',
        operationFailure: 'Thao tác thất bại',
        youDoNotHaveAccessRightsPleaseContactLightLiveOperationsToAddPermissions:
            'Bạn không có quyền truy cập, vui lòng liên hệ bộ phận vận hành Qingzhu để thêm quyền',
        currentLimitSelect1FilePleaseRemoveAndAdd:
            'Hiện chỉ cho phép chọn 1 tệp, vui lòng xóa rồi thêm lại',
        memberDataIsExportedSuccessfullyProcedure: 'Xuất dữ liệu thành viên thành công',
        memberDataFailedToBeExportedProcedure: 'Xuất dữ liệu thành viên thất bại',
        noDataAvailableAtThisTime: 'Hiện chưa có dữ liệu',
        memberImportTemplateDownloadedSuccessfully: 'Tải mẫu nhập thành viên thành công',
        failedToDownloadTheMemberImportTemplate: 'Tải mẫu nhập thành viên thất bại',
        modifyMembership2: 'Chỉnh sửa thành viên',
        addAMemberSuccessfully: 'Thêm thành viên thành công',
        renewMemberSuccessfully: 'Cập nhật thành viên thành công',
        integralChange2: 'Thay đổi điểm',
        memberRecharge: 'Nạp tiền thành viên',
        deductionOfStoredValue: 'Khấu trừ số dư',
        scoreChangeSuccess: 'Thay đổi điểm thành công',
        memberRechargeSuccessfully: 'Nạp tiền thành viên thành công',
        theDeductionOfStoredValueIsSuccessful: 'Khấu trừ số dư thành công',
        integralQuery2: 'Tra cứu điểm',
        pleaseEnterSalesman: 'Vui lòng nhập nhân viên kinh doanh',
        definitiveRemoval: 'Xác nhận xóa',
        derivedInformation: 'Thông tin xuất dữ liệu',
        memberDataExportInformation: 'Thông tin xuất dữ liệu thành viên.xlsx',
        memberImportTemplate: 'Mẫu nhập thành viên.xlsx',
        totalMembers: 'Tổng cộng {memberTotal} thành viên',
        xlsFormatOnly: 'Chỉ hỗ trợ tệp định dạng XLS',
        commissionRefundNotice:
            'Từ ngày 01/02/2021, thành viên được nhập lần đầu bằng chức năng "Nhập thành viên", sau khi đặt phòng và lưu trú tại khách sạn này qua Mini Program Qingzhu, toàn bộ hoa hồng phát sinh sẽ được hoàn lại!',
        enabled: 'Đã bật',
        disabled: 'Chưa bật',
        idTypeAndNumber: 'Loại giấy tờ / Số giấy tờ',
        distributionSettings: 'Cài đặt phân phối',
        setAsAPromotionalUser: 'Đặt làm người dùng quảng bá',
    },
    memberMemberReport: {
        ordinaryMember: 'Thành viên thường',
        goldMember: 'Thành viên Vàng',
        platinumMember: 'Thành viên Bạch Kim',
        diamondMember: 'Thành viên Kim Cương',

        enterYourNamePhoneNumberAndIdNumber:
            'Nhập tên, số điện thoại hoặc số giấy tờ',

        membership: 'Danh tính thành viên',

        activateStore: 'Khách sạn kích hoạt',

        ourStore: 'Khách sạn hiện tại',

        otherStores: 'Khách sạn khác',

        sourceOfDevelopment: 'Nguồn phát triển',

        activationDate: 'Ngày kích hoạt',

        dateOfPurchase: 'Ngày mua',

        purchaseTime: 'Thời gian mua',

        memberNickname: 'Biệt danh thành viên',

        memberName: 'Tên thành viên',

        membershipIdNumber: 'Số giấy tờ thành viên',

        activationTime: 'Thời gian kích hoạt',

        currentLevelDevelopmentSource:
            'Nguồn phát triển của cấp độ hiện tại',

        currentLevelPurchaseTime:
            'Thời gian mua cấp độ hiện tại',
    },

    memberSaveReport: {
        downloadReport: 'Tải báo cáo',

        totalAmountOfStoredValue:
            'Tổng số tiền nạp',

        totalGiftAmount:
            'Tổng số tiền tặng',

        totalConsumptionAmount:
            'Tổng số tiền tiêu dùng',

        totalAmountOfRefund:
            'Tổng số tiền hoàn trả tiêu dùng',

        user: 'Người dùng',

        transactionType: 'Loại giao dịch',

        storedValue: 'Nạp tiền',

        consumptionRefund: 'Hoàn tiền tiêu dùng',

        membershipLevel: 'Cấp độ thành viên',

        storedValueAmount: 'Số tiền nạp',

        amountOfRefund: 'Số tiền hoàn trả',

        memberStoredValueReport:
            'Báo cáo số dư thành viên.xlsx',

        theMemberStoredValueReportIsSuccessfullyExported:
            'Xuất báo cáo số dư thành viên thành công',

        failedToExportTheMemberStoredValueReport:
            'Xuất báo cáo số dư thành viên thất bại',

        searchPlaceholder:
            'Số điện thoại / Giấy tờ / Tên / Số thẻ',
    },

    clientClient: {
        guestTag: 'Nhãn khách',

        pleaseEnterYourContactInformation:
            'Vui lòng nhập thông tin liên hệ',

        pleaseEnterYourNationality:
            'Vui lòng nhập quốc tịch',

        pleaseEnterNationality:
            'Vui lòng nhập dân tộc',

        pleaseEnterAddress:
            'Vui lòng nhập địa chỉ',

        age: 'Tuổi',

        customerLabel: 'Nhãn khách hàng',

        modifyGuestInformation:
            'Chỉnh sửa thông tin khách',

        inputLabelDuplication:
            'Nhãn nhập bị trùng lặp',

        pleaseEnterTheLabelContent:
            'Vui lòng nhập nội dung nhãn',

        doNotEnterLabelsInMoreThan10Words:
            'Nhãn không được vượt quá 10 ký tự',
    },

    financeIndex: {
        pleaseCancelRenewFirst:
            'Vui lòng hủy gia hạn lưu trú trước khi thực hiện trả phòng',

        addAnotherItem:
            'Thêm hạng mục khác',

        checkInOrderNumber:
            'Mã đơn nhận phòng',

        adjustFinance:
            'Điều chỉnh tài chính',

        batchTransfer:
            'Chuyển khoản hàng loạt',

        checkOut:
            'Trả phòng công nợ',

        pleaseEnterTheRoomNumber:
            'Vui lòng nhập số phòng',

        pleaseEnterRoomTypeName:
            'Vui lòng nhập tên loại phòng',

        pleaseEnterChannel:
            'Vui lòng nhập kênh',

        pleaseEnterCheckInTime:
            'Vui lòng nhập thời gian nhận phòng',

        pleaseEnterYourDepartureTime:
            'Vui lòng nhập thời gian trả phòng',

        pleaseEnterAccount:
            'Vui lòng nhập hạng mục',

        entryTime2:
            'Thời gian ghi sổ',

        pleaseEnterTheCreditDate:
            'Vui lòng nhập thời gian ghi sổ',

        consumptionAmountyuan:
            'Số tiền tiêu dùng (¥)',

        pleaseEnterTheAmountSpent:
            'Vui lòng nhập số tiền tiêu dùng',

        paymentAmountyuan:
            'Số tiền thanh toán (¥)',

        pleaseEnterThePaymentAmount:
            'Vui lòng nhập số tiền thanh toán',

        editBill:
            'Chỉnh sửa hóa đơn',

        checkOut2:
            'Thanh toán và trả phòng',

        cancelAccount:
            'Hủy thanh toán',

        partialClosing:
            'Thanh toán một phần',

        accountAdjustment:
            'Điều chỉnh tài khoản',

        smallGoodsAreAccountedFor:
            'Ghi sổ hàng hóa nhỏ',

        pleaseSelectAPaymentHistory:
            'Vui lòng chọn lịch sử thanh toán',

        pleaseFillInTheAmountOfPayment:
            'Vui lòng nhập số tiền thanh toán',

        yourAccountInformationIsEmptyPleaseEnterTheAccountBeforePrinting:
            'Thông tin tài khoản trống, vui lòng ghi sổ trước khi in',

        theRoomNumberCannotBeEmptyPleaseCheckWhetherThePagePathIsCorrect:
            'Mã đơn phòng không được để trống, vui lòng kiểm tra đường dẫn trang',

        smallwares:
            'Hàng hóa nhỏ',

        creditOrdersDoNotSupportPartialCheckout:
            'Đơn tín dụng không hỗ trợ thanh toán một phần',

        pleaseSelectTheOrderYouWantToCheckOut:
            'Vui lòng chọn đơn cần thanh toán',

        creditBookingIsNotSupportedPleaseCheckOutDirectly:
            'Đơn tín dụng không hỗ trợ công nợ, vui lòng thanh toán và trả phòng trực tiếp',

        pleaseSelectACover:
            'Vui lòng chọn bộ tài khoản',

        unionpayScanCode:
            'UnionPay - Quét mã',

        checkOutSuccessfully:
            'Trả phòng thành công',

        securityDeposit:
            'Tiền đặt cọc',

        warmReminder:
            'Lưu ý',

        signOut:
            'Hủy',

        cancelled:
            'Đã hủy',

        the: '',

        wheatDoorLockPlugInCancellationCard:
            'Plugin khóa cửa Maitian - Hủy thẻ',

        whetherTheKeyCardHasBeenCancelled:
            'Thẻ phòng đã được hủy hay chưa',

        selectUnsettledAccountsWarning:
            'Vui lòng chọn các khoản "Chưa thanh toán"',

        feizhuRoomFeeValidation:
            'Tiền phòng Fliggy phải ≥ 0, tiền phòng hiện tại: {roomRateFees}',

        feizhuNonRoomFeeValidation:
            'Khoản "không phải tiền phòng" của Fliggy phải ≥ 0, giá trị hiện tại: {fees}',

        pleaseSelectUnsettledAccounts:
            'Vui lòng chọn khoản chưa thanh toán',

        additionalChargeAmountEmpty:
            'Số tiền phụ thu trống, vui lòng thao tác lại',
    },

    financeMangementOld: {
        accountType: 'Loại tài khoản',

        creditAccount: 'Tài khoản tín dụng',

        prepaidAccount: 'Tài khoản trả trước',

        settlementPeriod: 'Chu kỳ thanh toán',

        maximumAmount: 'Hạn mức tối đa',

        theMaximumMustBeGreaterThanZero:
            'Hạn mức tối đa phải lớn hơn 0',

        theMaximumAmountCannotBeGreaterThan100Million:
            'Hạn mức tối đa không được vượt quá 100 triệu',

        theStartTimeCannotBeEqualToTheEndTime:
            'Thời gian bắt đầu không được bằng thời gian kết thúc',

        theStartTimeCannotBeLaterThanTheEndTime:
            'Thời gian bắt đầu không được lớn hơn thời gian kết thúc',

        pleaseSelectAnEndTime:
            'Vui lòng chọn thời gian kết thúc',

        theEndTimeCannotBeEqualToTheStartTime:
            'Thời gian kết thúc không được bằng thời gian bắt đầu',

        theEndTimeCannotBeLaterThanTheStartTime:
            'Thời gian kết thúc không được nhỏ hơn thời gian bắt đầu',

        pleaseEnterTheBillingPeriod:
            'Vui lòng nhập chu kỳ thanh toán',

        settlementPeriodCanOnlyBeEnteredInNumbers:
            'Chu kỳ thanh toán chỉ được nhập số',

        newAccount:
            'Thêm tài khoản mới',

        pleaseFillInTheAccountName:
            'Vui lòng nhập tên tài khoản',

        pleaseFillInTheCompanyName:
            'Vui lòng nhập tên công ty',

        pleaseSelectAnAccountType:
            'Vui lòng chọn loại tài khoản',

        pleaseSelectAChannelName:
            'Vui lòng chọn tên kênh',
    },

    financeMangement: {
        creditAccount: 'Tài khoản tín dụng',

        prepaidAccount: 'Tài khoản trả trước',

        enableConfirmation:
            'Sau khi kích hoạt, đơn vị hợp đồng này sẽ hỗ trợ công nợ. Bạn có muốn kích hoạt không?',

        disableConfirmation:
            'Sau khi vô hiệu hóa, đơn vị hợp đồng này sẽ không còn hỗ trợ công nợ. Bạn có muốn vô hiệu hóa không?',
    },

    foodRoomAccountFinance: {
        foodSource: 'Nguồn thực phẩm',
        foodRoomAccountLabel: 'Tài khoản phòng ăn uống',
        foodOrderNo: 'Số đơn Food',
        fmisAccountSerialNo: 'Số seri tài khoản FMIS',
        chargedAmount: 'Số tiền ghi nợ',
        notAllowedSplit: 'Tài khoản phòng ăn uống không thể tách hóa đơn',
        notAllowedRush: 'Tài khoản phòng ăn uống không thể hủy bút toán',
        notAllowedTransfer: 'Tài khoản phòng ăn uống không thể chuyển khoản',
        notAllowedPartialSettlement: 'Tài khoản phòng ăn uống không hỗ trợ thanh toán một phần',
    },
    financeMixin: {
        onlinePaymentAccountsAreNotAllowedToOpen:
            'Hạng mục thanh toán trực tuyến không cho phép tách hóa đơn',

        smallCommodityAccountsCanNotBeDismantled:
            'Hạng mục hàng hóa nhỏ không thể tách hóa đơn',

        negativeDebtCannotBeBroken:
            'Khoản âm không thể tách hóa đơn',

        accountsReceivableAreNotAllowedToBeDebunked:
            'Hạng mục khoản phải thu không được phép tách hóa đơn',

        debitsAreNotAllowedInThisAccount:
            'Hạng mục này không cho phép tách hóa đơn',

        onlinePaymentRefundAccountDoesNotAllowForChargebacks:
            'Khoản hoàn tiền thanh toán trực tuyến không cho phép bù trừ',

        theAccountHasBeenRefundedAndCannotBeCharged:
            'Khoản này đã được hoàn tiền, không được phép bù trừ',

        refundedAccountsCannotBeCharged:
            'Khoản đã hoàn tiền không thể bù trừ',

        thisAccountIsNotAllowedToBeCharged:
            'Hạng mục này không cho phép bù trừ',

        businessDayHasBeenSwitchedNoChargeIsAllowed:
            'Ngày kinh doanh đã chuyển đổi, không được phép bù trừ',

        splitBill: 'Tách hóa đơn',

        transfer: 'Chuyển khoản',

        offset: 'Bù trừ',

        refund: 'Hoàn tiền đặt cọc',
    },
    detailcomponentsAccountlisttable: {
        onAccount: 'Đã ghi công nợ',
    },

    detailcomponentsAddjudge: {
        theRoomChargeIsExcessive: 'Phụ thu tiền phòng quá lớn',
        chargeJudgment: 'Đánh giá phụ thu',
        addOnOption: 'Tùy chọn phụ thu',
        generatedRoomCharge: 'Tạo tiền phòng',
        pleaseFillInTheAdditionalRoomCharge: 'Vui lòng nhập tiền phòng phụ thu',
        theAdditionalAmountCannotBe0: 'Số tiền phụ thu không được bằng 0',
    },

    detailcomponentsAdjustaccounts: {
        reconciliationSuccess: 'Điều chỉnh tài khoản thành công',
        accountAdjustment: 'Điều chỉnh tài khoản',
        accountOfReconciliation: 'Hạng mục điều chỉnh',
        incorrectTransferAmountFormatupToTwoDecimalPlaces:
            'Định dạng số tiền điều chỉnh không chính xác (tối đa 2 chữ số thập phân)',
        theTransferAmountCannotBe: 'Số tiền điều chỉnh không được bằng',
        theTransferAmountCannotBeGreaterThan100Million:
            'Số tiền điều chỉnh không được vượt quá 100 triệu',
    },

    detailcomponentsArsuitselect: {
        receivableSet: 'Bộ tài khoản phải thu',
        creditOrderCheckoutTip:
            'Đơn credit stay phải được ghi nhận công nợ khi trả phòng',
        nonProtocolOrderArTip:
            'Đơn của đơn vị không theo hợp đồng không thể ghi nhận công nợ',
    },

    detailcomponentsBackout: {
        closedSuccessfully: 'Hủy thanh toán thành công',
        cancelAccount: 'Hủy thanh toán',
        confirmationRevocation: 'Xác nhận hủy',
        pleaseSelectTheBillYouWantToCancel:
            'Vui lòng chọn hóa đơn cần hủy',
    },

    detailcomponentsBorrow: {
        return: 'Hoàn trả',

        itemBorrowingReminder: 'Nhắc nhở mượn vật dụng',

        borrowARoom: 'Phòng mượn',

        quantityBorrowed: 'Số lượng mượn',

        returnQuantity: 'Số lượng hoàn trả',

        loanDate2: 'Ngày mượn',

        returnOrNot: 'Đã trả hay chưa',

        whetherToReturnAll: 'Trả lại toàn bộ hay không',

        amountOfCompensation: 'Số tiền bồi thường',

        onlyNumbersGreaterThan0CanBeEntered:
            'Chỉ được nhập số lớn hơn 0',

        partOfTheReturnCanOnlyBeLessThanTheAmountBorrowed:
            'Số lượng trả một phần phải nhỏ hơn số lượng đã mượn',

        returned: 'Đã hoàn trả',

        noReturn: 'Chưa hoàn trả',

        returnSuccessfully: 'Hoàn trả thành công',
    },

    detailcomponentsColorblock: {
        financialType: 'Loại tài chính',
        accountingType: 'Loại tài khoản',
        orderForGoods: 'Đơn hàng',
    },

    detailcomponentsCommon: {
        unionpayScanCode: 'UnionPay - Quét mã',
        insufficientMemberBalance:
            'Số dư thành viên là {balance} NDT, vui lòng chọn phương thức thu tiền khác',
    },

    detailcomponentsCreditsettletip: {
        creditSettleAlert:
            'Lưu ý: Đơn đặt phòng tín dụng Fliggy, tiền phòng thực tế thanh toán là {roomRate} NDT, chi phí ngoài tiền phòng là {nonRoomRate} NDT. Vui lòng xác nhận số tiền chính xác trước khi gửi yêu cầu thanh toán và trả phòng.',
    },

    detailcomponentsDivideaccounts: {
        additionalDebits: 'Thêm tách hóa đơn',

        totalAmount: 'Tổng số tiền',

        totalDebitsTaken: 'Tổng số tiền đã tách',

        totalUndismantledLoans: 'Tổng số tiền chưa tách',

        successfulDismantling: 'Tách hóa đơn thành công',

        borrowMoney: 'Tách hóa đơn',

        loanAmount: 'Số tiền tách',

        upTo150Words: 'Tối đa 150 ký tự',

        closedAccount: 'Đã tách hóa đơn',

        tenAtMost: 'Tối đa 10 dòng tách hóa đơn',

        theAmountOfDebitsIsNotEqualToTheTotalAmount:
            'Tổng số tiền tách không bằng tổng số tiền',

        theDebitAmountMustBeFilledInAndGreaterThan:
            'Số tiền tách là bắt buộc và phải lớn hơn',
    },

    detailcomponentsEnteraccount: {
        cashCnyReceipt: 'Thu tiền mặt RMB',

        accountEntry: 'Hạng mục ghi sổ',

        amountRecorded: 'Số tiền ghi sổ',

        pleaseFillInTheAmountOfPayment:
            'Vui lòng nhập số tiền ghi sổ',

        pleaseSelectAPaymentMethod:
            'Vui lòng chọn phương thức thanh toán',

        entriesCannotBeEmpty:
            'Hạng mục ghi sổ không được để trống',

        theAmountRecordedCannotBe:
            'Số tiền ghi sổ không được bằng 0',

        pleaseFillInUnitPrice:
            'Vui lòng nhập đơn giá',

        unitPriceCannotBeZero:
            'Đơn giá không được bằng 0',

        pleaseFillInServings:
            'Vui lòng nhập số lượng',

        servingsCannotBeZero:
            'Số lượng không được bằng 0',

        pleaseSelectMealDate:
            'Vui lòng chọn ngày dùng bữa',

        ArRefundCannotExceedBalance:
            'Số tiền hoàn trả AR không được lớn hơn số dư AR',
    },
    detailcomponentsExpandcolumn: {
        memberName: 'Tên thành viên',
        receivableSet: 'Bộ tài khoản phải thu',
        from: 'Từ',
        orderForGoods: 'Đơn hàng',
        rollOutTo: 'Chuyển ra đến',
        refundedAmount: 'Đã hoàn: {amount} NDT',
    },

    detailcomponentsHangaccounts: {
        checkOut: 'Trả phòng công nợ',
        reasonForPayment: 'Lý do ghi công nợ',
    },

    detailcomponentsHourroomfeeconfirm: {
        roomRateConfirmation: 'Xác nhận tiền phòng',
        roomRate2: 'Số tiền phòng',
    },

    detailcomponentsPartsettle: {
        partialClosing: 'Thanh toán một phần',
        pleaseFillInTheAmountOfPayment: 'Vui lòng nhập số tiền thanh toán',
        pleaseSelectAPaymentHistory: 'Vui lòng chọn lịch sử thanh toán',
    },

    detailcomponentsPreauthcheck: {
        authorizedSettlement: 'Thanh toán ủy quyền',
    },

    detailcomponentsPreauthtemplate: {
        cancelAuthorizationPleaseWait: 'Đang hủy ủy quyền, vui lòng đợi',
        succeededInCancelingAuthorization: 'Hủy ủy quyền thành công',
        thereIsAnOutstandingPreAuthorizationRecordInTheRoom:
            'Trong phòng tồn tại bản ghi ủy quyền trước chưa thanh toán',
        confirmThatYouWantToCancelAuthorization: 'Xác nhận hủy ủy quyền',
        roomPaymentRequired: 'Phòng cần {action} số tiền:',
        orderCanceledWarning: 'Đơn hàng đã hủy, không thể {action}',
        roomCheckedInWarning: 'Phòng đã nhận, không thể {action}',
        roomCheckedOutWarning: 'Trạng thái phòng là "Đã trả phòng", không thể {action}',
    },

    detailcomponentsRefundtip: {
        refundReminder: 'Nhắc nhở hoàn tiền',
        whenUsingAnOnlineRefundTheAmountWillBeRefundedToTheAccountFromWhichTheGuestPaid:
            'Khi sử dụng hoàn tiền trực tuyến, số tiền sẽ được hoàn về tài khoản mà khách đã thanh toán',
        whenUsingAOneCardRefundSystem:
            'Khi sử dụng hoàn tiền thẻ một chạm, số tiền sẽ được hoàn về tài khoản mà khách đã thanh toán',
    },

    detailcomponentsSmallwarecost: {
        smallwares: 'Hàng hóa nhỏ',
        smallGoodsEnteredTheAccountSuccessfully: 'Ghi sổ hàng hóa nhỏ thành công',
        smallGoodsAreAccountedFor: 'Ghi sổ hàng hóa nhỏ',
        payOrNot: 'Đã thanh toán hay chưa',
        pleaseEnterTheExternalOrderNumber: 'Vui lòng nhập mã đơn bên ngoài',
        pleaseSelectASmallItem: 'Vui lòng chọn hàng hóa nhỏ',
        insufficientMemberBalance:
            'Số dư thành viên là {balance} NDT, vui lòng chọn bên thu tiền khác',
    },

    detailcomponentsTransferaccounts: {
        transferMoney: 'Chuyển khoản',
        transferToAccount: 'Tài khoản chuyển đến',
        pleaseSelectValidTransferAccount: 'Vui lòng chọn tài khoản chuyển đến hợp lệ',
        transferSuccess: 'Chuyển khoản thành công',
        batchTransferSuccess: 'Chuyển khoản hàng loạt thành công',
    },

    mangementMember: {
        orderType: 'Loại đơn hàng',
        receivableOrders: 'Khoản phải thu của đơn hàng',
        totalAmountNotApproved: 'Tổng số tiền chưa xác nhận',
        approvedTotalAmount: 'Tổng số tiền đã xác nhận',
        amountAvailable: 'Số tiền khả dụng',
        amountSpent: 'Số tiền đã sử dụng',
        whetherToWriteOffAllTheReceivables:
            'Có muốn xóa toàn bộ khoản phải thu không?',
        whetherToReverseWriteOffAllTheReceivables:
            'Có muốn đảo xóa toàn bộ khoản phải thu không?',
        cancelAfterVerification: 'Xóa khoản phải thu',
        reverseWriteOff: 'Đảo xóa khoản phải thu',
        depositInAdvance: 'Tiền gửi trước',
        dateOfPosting: 'Ngày ghi công nợ',
        pleaseEnterTheOrderNumber: 'Vui lòng nhập mã đơn hàng',
        completeWriteOff: 'Xóa toàn bộ',
        completeReverseWriteOff: 'Đảo xóa toàn bộ',
        batchWriteOff: 'Xóa hàng loạt',
        batchReverseWriteOff: 'Đảo xóa hàng loạt',
        records: 'Bản ghi',
        advanceCredit: 'Ghi nhận trả trước',
        thePrepaidAmountMustBeGreaterThanZero: 'Số tiền trả trước phải lớn hơn 0',
        theAmountInAdvanceCannotBeGreaterThan100Million:
            'Số tiền trả trước không được vượt quá 100 triệu',
        checkTheDepartureDateUpToOneMonth:
            'Ngày trả phòng chỉ được truy vấn tối đa trong vòng một tháng',
        noAccountPleaseCreateANewOne: 'Không có bộ tài khoản, vui lòng tạo mới',
        allWereSuccessfullyWrittenOff: 'Xóa toàn bộ thành công',
        allWriteOffsFailed: 'Xóa toàn bộ thất bại',
        noWriteOffIsAllowedOnTheDayReceivableIsGenerated:
            'Không cho phép xóa khoản phải thu trong ngày phát sinh khoản phải thu',
        pleaseSelectTheItemsYouWantToWriteOff:
            'Vui lòng chọn các hạng mục cần xóa',
        listOfAccountsReceivable3XLS: 'Danh sách khoản phải thu.xls',
        prepaymentAmountRequired: 'Vui lòng nhập số tiền trả trước',
        prepaymentAmountFormatError:
            'Định dạng số tiền trả trước không đúng (tối đa 2 chữ số thập phân)',
    },

    mangementTablerow: {
        paidInAmount: 'Số tiền thực thu',
    },

    mangementVerificatemodal: {
        successfulWriteOff: 'Xóa khoản phải thu thành công',
        cancelAfterVerification: 'Xóa khoản phải thu',
        reverseWriteOff: 'Đảo xóa khoản phải thu',
        generationTime: 'Thời gian phát sinh',
        amountWrittenOff2: 'Số tiền xóa',
        pleaseFillInTheWriteOffAmount: 'Vui lòng nhập số tiền cần xóa',
        theAmountToBeWrittenOffCannotBeGreaterThanTheAmountThatCanBeWrittenOff:
            'Số tiền cần xóa không được lớn hơn số tiền có thể xóa',
    },

    mangementVerifyrecordsmodal: {
        records: 'Bản ghi',
        lot: 'Lô',
    },

    merchantChargeList: {
        accumulatedUncreditedNightsInArrearsDuringTheContractPeriod:
            'Tổng số đêm phòng nợ chưa khấu trừ trong thời hạn hợp đồng',
        hideZeroAmounts: 'Không hiển thị các khoản bằng 0',
    },

    merchantCheckBill: {
        confirmationCheck: 'Xác nhận đối chiếu',
        afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
            'Sau khi xác nhận, việc thanh toán sẽ được thực hiện theo hóa đơn này',
        appealChannel: 'Kênh khiếu nại',
        causeOfAppeal: 'Lý do khiếu nại',
        youCanEnterUpTo150Words: 'Có thể nhập tối đa 150 ký tự',
        accountName: 'Tên tài khoản ngân hàng',
        roomBillCheck: 'Đối chiếu hóa đơn phòng',
        memberIncentiveCheck: 'Đối chiếu khuyến khích thành viên',
        confirmed: 'Đã xác nhận',
        reasonForAdjustment: 'Lý do điều chỉnh',
        deductibleTarget: 'Đối tượng khấu trừ',
        currentDeduction: 'Khấu trừ kỳ này',
        deductible: 'Đã khấu trừ',
        confirmationTime: 'Thời gian xác nhận',
        rejectionTime: 'Thời gian từ chối',
        liveLightlyInTheDirectCamp: 'Qingzhu trực doanh',
        new: 'Thêm mới',
        appealSuccessfully: 'Khiếu nại thành công',
        checkSuccessfully: 'Đối chiếu thành công',
        currDeductionDesc:
            '1. Khấu trừ kỳ này là số dương, nghĩa là Qingzhu khấu trừ số tiền của khách sạn. 2. Khấu trừ kỳ này là số âm, nghĩa là hoàn trả tiền cho khách sạn.',
        qzMerchantSettleDesc:
            'Thanh toán giữa Qingzhu và khách sạn = Tổng giá trị đơn hàng - Khấu trừ kỳ này',
    },

    merchantInfoManage: {
        changeLetter: 'Thư thay đổi',
        note: 'Ghi chú',
        paymentCanOnlyBeMadeAfterTheModificationOfTheReceivingAccountIsApprovedIfTheCurrentSettlementPaymentIsToBePaidThePaymentWillStillBeMadeAccordingToTheOriginalAccount:
            'Việc thanh toán chỉ có thể thực hiện sau khi thay đổi tài khoản nhận tiền được phê duyệt. Nếu hiện có khoản thanh toán đối soát chờ chi trả, hệ thống vẫn sẽ chi trả theo tài khoản cũ',
        groundsForRejection: 'Lý do từ chối',
        downloadTheAttachmentTemplate2: 'Tải mẫu tệp đính kèm',
        viewingModificationLogs2: 'Xem nhật ký chỉnh sửa',
        thisSettlementInformationIsUsedForRoomFeeSettlementAndCanOnlyBeModifiedByTheHotelOwnerPleaseAddItWithCaution:
            'Thông tin đối soát này dùng cho thanh toán tiền phòng và chỉ chủ khách sạn được chỉnh sửa, vui lòng thêm cẩn thận',
        thisAccountIsUsedForTheSettlementOfRoomChargesAndCanOnlyBeModifiedByTheHotelOwnerPleaseModifyItCarefullyUploadTheChangeLetterAndAffixTheOfficialSealAsRequired:
            'Tài khoản nhận tiền này dùng cho thanh toán tiền phòng và chỉ chủ khách sạn được chỉnh sửa. Vui lòng chỉnh sửa cẩn thận, tải lên thư thay đổi và đóng dấu công ty theo yêu cầu',
        modifyLog2: 'Nhật ký chỉnh sửa',
        beforeModification3: 'Trước khi chỉnh sửa',
        receivablesAccountManagement2: 'Quản lý tài khoản nhận tiền',
        bankAccountName4: 'Tên chủ tài khoản ngân hàng',
        letterOfRequestForChange2: 'Thư đề nghị thay đổi',
        pleaseEnterYourBankName2: 'Vui lòng nhập tên chủ tài khoản ngân hàng',
        pleaseUploadTheRequestForChange2: 'Vui lòng tải lên thư đề nghị thay đổi',
        afterModification2: 'Sau khi chỉnh sửa',
        afterDownloadingTheApplicationChangeLetterYouNeedToPrintItOutSignAndSealItAndThenUploadThePictureOrPdfFile:
            'Sau khi tải thư đề nghị thay đổi, cần in ra, ký tên và đóng dấu, sau đó tải lên hình ảnh hoặc tệp PDF',
        onlyJpgPngAndPdfFilesCanBeUploaded:
            'Chỉ hỗ trợ tải lên tệp định dạng JPG, PNG và PDF',
    },
    merchantMerchantHelper: {
        smallProgramSettlementRules: 'Vấn đề quy tắc thanh toán Mini Program',
        settlementOfPaymentProblems: 'Vấn đề thanh toán và chuyển khoản',
        smallProgramSettlementRulesCommonProblems:
            'Các câu hỏi thường gặp về quy tắc thanh toán Mini Program',
        frequentlyAskedQuestionsAboutSettlementPayments:
            'Các câu hỏi thường gặp về thanh toán và chuyển khoản',

        q1SettlementCriteria: 'Q1: Hóa đơn nào có thể được thanh toán?',
        a1SettlementCriteria:
            'Tiêu chuẩn thanh toán của chúng tôi là đơn hàng đã hoàn thành và khách đã trả phòng.',

        q2PmsCancellation: 'Q2: Nếu hóa đơn PMS bị hủy thì xử lý thế nào?',
        a2PmsCancellation:
            'Nếu PMS ở trạng thái hủy, tiêu chuẩn thanh toán của chúng tôi là: sau khi khách yêu cầu hủy và được hoàn tiền, cần liên hệ đội ngũ CSKH để thực hiện quy trình hoàn tiền.',

        q1AuditTime: 'Q1: Thời gian xét duyệt thanh toán là khi nào?',
        a1AuditTime:
            'Trước thứ Sáu hàng tuần, hóa đơn thanh toán trực kết của tuần kế tiếp sẽ được tải lên hệ thống thanh toán. Khách sạn chỉ cần xác nhận hóa đơn trước thứ Năm tuần sau để nhận tiền.',

        q2PaymentTime: 'Q2: Sau khi khách sạn xác nhận hóa đơn thì khi nào được thanh toán?',
        a2PaymentTime:
            'Các khách sạn đã xác nhận hóa đơn sẽ được thanh toán vào thứ Năm. Các khoản thanh toán thất bại trước đó cũng sẽ được thanh toán bổ sung từ thứ Năm đến thứ Sáu.',

        q3CheckPayment: 'Q3: Làm thế nào để kiểm tra xem đã được thanh toán chưa?',
        a3CheckPayment:
            'Khách sạn có thể kiểm tra trong mục Lịch sử thanh toán.',

        q4RejectedStatement:
            'Q4: Nếu bảng đối soát bị từ chối thì sao? Khi nào được thanh toán?',
        a4RejectedStatement:
            'Đối với hóa đơn bị khách sạn từ chối, trụ sở chính sẽ xem xét lại. Sau khi điều chỉnh xong, nếu khách sạn xác nhận hóa đơn trước thứ Năm thì sẽ được thanh toán trong ngày thứ Năm; nếu chưa xác nhận thì sẽ chuyển sang đợt thanh toán thứ Năm tuần tiếp theo.',
    },

    merchantRemitRecord: {
        roomChargePaymentRecords: 'Lịch sử thanh toán tiền phòng',
        memberIncentiveRecord: 'Lịch sử thưởng thành viên',
        fundsToBeRemitted: 'Chờ thanh toán',
        remitting: 'Đang thanh toán',
        remittedMoney: 'Đã thanh toán',
        paymentFailure2: 'Thanh toán thất bại',
        collectionAccount: 'Tài khoản nhận tiền',
        payee: 'Người nhận tiền',
        statusUpdateTime: 'Thời gian cập nhật trạng thái',
        paymentTime: 'Thời gian thanh toán',
        timeToInitiateAPayment: 'Thời gian khởi tạo thanh toán',
    },

    merchantSettleInfo: {
        pleaseScanTheQrCodeOfYourCloudAccountToBindYourBankCard:
            'Vui lòng quét mã QR tài khoản đám mây để liên kết thẻ ngân hàng',
        bindBankCard: 'Liên kết thẻ ngân hàng',
        completeInformation: 'Thông tin cá nhân',
        bankAccountName4: 'Tên chủ tài khoản ngân hàng',
        idNumber: 'Số CMND/CCCD',
        pleaseEnterYourBankName2: 'Vui lòng nhập tên chủ tài khoản ngân hàng',
        pleaseEnterYourIdNumber2: 'Vui lòng nhập số CMND/CCCD',
        idNumberFormatIsIncorrectPleaseReEnter:
            'Định dạng số CMND/CCCD không đúng, vui lòng nhập lại',
        phoneNumberFormatIsIncorrectPleaseReEnter:
            'Định dạng số điện thoại không đúng, vui lòng nhập lại',
        pleaseUpload: 'Vui lòng tải lên',
        internalUserHidden: 'Người dùng nội bộ không hiển thị',
        amountPendingPayment: 'Số tiền {amount}, sẽ được thanh toán sau',
    },

    billCheckBillDetails: {
        channelDetails: 'Chi tiết kênh',
        whereToConnectDirectly: 'Kết nối trực tiếp Qunar',
        drench: 'Qingzhu',
        cityWide: 'Cùng thành phố',
        whereToGo: 'Qunar',
        distribution: 'Phân phối',
        tradeCaravan: 'Du lịch công tác',
        statementOfAccount: 'Bảng đối soát',
        qzSettleFormula:
            'Thanh toán giữa Qingzhu và khách sạn = Số tiền quyết toán đơn hàng + Hoàn tiền do khách sạn chịu + Ưu đãi do khách sạn chịu + Khoản công ích của khách sạn',
        merchantDiscountNote:
            'Khi đơn hàng trong kỳ có phát sinh hoàn tiền, số tiền ưu đãi do khách sạn chịu sẽ bằng 0',
    },

    billCheckBill: {
        turnDown: 'Từ chối',
        ticketReceived: 'Đã nhận hóa đơn',
        forThePublic: 'Doanh nghiệp',
        forPrivacy: 'Cá nhân',
        expenseDetail: 'Chi tiết chi phí',

        confirmationCheck: 'Xác nhận đối soát',
        afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
            'Sau khi xác nhận, việc thanh toán sẽ được thực hiện theo hóa đơn này',

        perfectInformation: 'Hoàn thiện thông tin',
        causeOfAppeal: 'Lý do khiếu nại',
        youCanEnterUpTo150Words: 'Tối đa 150 ký tự',

        creditDetails: 'Chi tiết khấu trừ',
        roomNightCreditDetails: 'Chi tiết khấu trừ đêm phòng',

        invoiceManagement: 'Quản lý hóa đơn',
        sellersName: 'Tên bên bán',
        invoiceNumber: 'Số hóa đơn',
        invoiceDate: 'Ngày hóa đơn',
        invoiceAmount2: 'Giá trị hóa đơn',
        electronicInvoiceOrNot: 'Có phải hóa đơn điện tử hay không',
        invoiceFile: 'Tệp hóa đơn',
        reasonForRejectingInvoice: 'Lý do từ chối hóa đơn',

        theTotalAmountOfTheOrderIncludesTheAmountOfThePreviousBillAndTheMerchantSettlementAmountLessThan0:
            'Tổng số tiền đơn hàng đã bao gồm số tiền quyết toán giữa Qingzhu và khách sạn của kỳ trước có giá trị nhỏ hơn 0',

        quantityDueForTheCurrentPeriod: 'Số lượng cần khấu trừ kỳ này',
        actualAmountOfDeductionForTheCurrentPeriod:
            'Số lượng thực tế được khấu trừ kỳ này',
        amountDeductedForTheNightOfThePeriod:
            'Số tiền khấu trừ đêm phòng trong kỳ',
        uncreditedQuantityForTheCurrentPeriod:
            'Số lượng chưa được khấu trừ kỳ này',

        pleaseEnter150WordsOrLess:
            'Vui lòng nhập không quá 150 ký tự',

        pleaseEnterTheInvoiceHoldersInformation:
            'Vui lòng nhập thông tin người xuất hóa đơn',

        pleaseEnterTheInvoiceNumber:
            'Vui lòng nhập số hóa đơn',

        pleaseEnterExpiryDate2:
            'Vui lòng nhập thời hạn hiệu lực',

        pleaseSelectTheInvoiceType:
            'Vui lòng chọn loại hóa đơn',

        pleaseSelectWhetherToEInvoice:
            'Vui lòng chọn có phải hóa đơn điện tử hay không',

        pleaseUploadTheInvoicePhoto:
            'Vui lòng tải lên ảnh hóa đơn',

        pleaseFillInTheAmount:
            'Vui lòng nhập số tiền',

        specialTicket: 'Hóa đơn VAT đặc biệt',
        ordinaryTicket: 'Hóa đơn VAT thông thường',

        expenseItem: 'Hạng mục chi phí',
        amountIncurred: 'Số tiền phát sinh',
        source: 'Nguồn',
        instructions: 'Mô tả',

        confirmationTime: 'Thời gian xác nhận',
        groupReceiptStatus: 'Trạng thái nhận hóa đơn của tập đoàn',
        rejectionTime: 'Thời gian từ chối',
        whetherTheInvoiceHasBeenEntered:
            'Hóa đơn đã được nhập hay chưa',

        feeDetails: 'Chi tiết chi phí',
        fileUpload: 'Tải tệp lên',

        uploadAMaximumOf5Images:
            'Tối đa tải lên 5 hình ảnh',

        appealSuccessfully: 'Khiếu nại thành công',
        checkSuccessfully: 'Đối soát thành công',

        theSizeOfTheUploadedCompressedPackageCannotExceed:
            'Dung lượng tệp nén tải lên không được vượt quá',

        onlyTheUploadFormatIsSupported:
            'Chỉ hỗ trợ định dạng tải lên',

        theCompressedPackageFileCannotBeLargerThan:
            'Tệp nén không được lớn hơn',

        amountOfDeductionForTheCurrentPeriod:
            'Số tiền khấu trừ kỳ này',

        theMerchantNeedsToInvoiceTheAmount:
            'Số tiền khách sạn cần xuất hóa đơn',

        billingDetails: 'Chi tiết hóa đơn',

        currentAdrAmount: 'Số tiền ADR kỳ này',

        settlementSystemUpgrade:
            'Để đáp ứng yêu cầu của ngân hàng về quyết toán vốn, nâng cao hiệu quả thanh toán và hoàn thiện thông tin đủ điều kiện thanh toán, tập đoàn đang nâng cấp hệ thống quyết toán. Hiện cần bổ sung các thông tin theo yêu cầu của ngân hàng!',

        confirmPreviousBills:
            'Vui lòng xác nhận hóa đơn của các kỳ trước, nếu không hóa đơn của kỳ mới sẽ không hiển thị',

        paperInvoiceInstructions:
            'Đối với hóa đơn giấy, phí chuyển phát do bên gửi thanh toán. Hóa đơn gửi thu phí người nhận sẽ bị từ chối. Người nhận hóa đơn: Qingzhu Distribution Electronic Invoice; Điện thoại: 15901580289. Nếu là hóa đơn giấy, Qingzhu sẽ kiểm tra sau khi nhận được hóa đơn.',

        uploadFormatRestrictions:
            'Lưu ý: Hỗ trợ tải lên một trong các định dạng pdf, hình ảnh, word, tệp nén hoặc ofd. PDF và OFD hỗ trợ tối đa 5 tệp, mỗi tệp tối đa 3MB; hình ảnh tối đa 5 ảnh, mỗi ảnh tối đa 3MB, hỗ trợ jpg/jpeg/png; Word tối đa 1 tệp, tối đa 20MB; tệp nén tối đa 1 tệp, tối đa 20MB, hỗ trợ rar/zip/7z.',

        cumulativeUndeductedNights:
            'Tổng số đêm phòng nợ chưa khấu trừ trong thời hạn hợp đồng (trước khi khấu trừ kỳ này)',

        invoiceDuplicate:
            'Số hóa đơn bị trùng lặp. Vui lòng kiểm tra lại. Nếu số hóa đơn chính xác, hãy ghi rõ lý do sử dụng cùng một hóa đơn trong phần ghi chú.',

        pdfSizeExceeded: 'Dung lượng PDF tải lên không được vượt quá 3MB!',
        ofdSizeExceeded: 'Dung lượng OFD tải lên không được vượt quá 3MB!',
        wordSizeExceeded: 'Dung lượng Word tải lên không được vượt quá 20MB!',
        singleFormatOnly: 'Chỉ hỗ trợ một loại định dạng!',
    },

    billCheckMemberDetails: {
        memberIncentiveDetails: 'Chi tiết thưởng thành viên',
        memberIncentiveStatement: 'Bảng đối soát thưởng thành viên',
    },

    billDeductionDetails: {
        feeDetails: 'Chi tiết chi phí',
        statementDetailsSheet: 'Chi tiết bảng đối soát',
    },

    billRemitRecord: {
        collectionAccount: 'Tài khoản nhận tiền',
        payee: 'Người nhận tiền',
        statusUpdateTime: 'Thời gian cập nhật trạng thái',
        timeToInitiateAPayment: 'Thời gian khởi tạo thanh toán',
        paymentTime: 'Thời gian thanh toán',
    },

    billCheckDetails: {
        channelOrderDetails: 'Chi tiết đơn hàng kênh',
        merchantRefunds: 'Hoàn tiền do khách sạn chịu',
        merchantConcession: 'Ưu đãi do khách sạn chịu',
        channelOrderNumber: 'Mã đơn hàng kênh',
        reasonForAdjustment3: 'Lý do điều chỉnh',
        adjustmentType: 'Loại điều chỉnh',
        originalOrderPrice: 'Giá gốc đơn hàng',
        memberDiscount: 'Chiết khấu thành viên',
        skimpingOnCommission: 'Hoa hồng Qingzhu',
        payChannelCommission: 'Hoa hồng kênh thanh toán',
        amountOfMerchantWelfare: 'Khoản công ích của khách sạn',
        refundNight: 'Đêm phòng hoàn tiền',
        totalRefundAmount: 'Tổng số tiền hoàn',
        stayEasyAndRefundCommission: 'Hoa hồng hoàn tiền của Qingzhu',
        subsidy: 'Trợ cấp',
        saleCardOrderNumber: 'Mã đơn bán thẻ',
        membershipLevel: 'Cấp độ thành viên',
        dateOfRegistration: 'Ngày đăng ký',
        referrer: 'Người giới thiệu',
        amountPaid: 'Số tiền thanh toán',
        merchantsShareTheAmount: 'Số tiền chia lợi nhuận cho khách sạn',
        employeeShareAmount: 'Số tiền chia lợi nhuận cho nhân viên',
        shareAmount: 'Số tiền chia lợi nhuận',
        rebateRatio: 'Tỷ lệ hoàn hoa hồng',
        commissionRebate: 'Số tiền hoàn hoa hồng',
        distributionSubchannel: 'Kênh phân phối phụ',
        channelCost: 'Giá gốc của kênh',
        lightSettlementWithMerchantsOrder:
            'Thanh toán giữa Qingzhu và khách sạn (Đơn hàng)',
        lightUndertakeDiscounts:
            'Ưu đãi do Qingzhu chịu',
    },
    billDedetails: {
        currentAmountReceivable: 'Khoản phải thu kỳ này',
        amountOfDeductionForTheCurrentPeriod: 'Số tiền khấu trừ kỳ này',
        remainingAmountOfDeduction: 'Số tiền khấu trừ còn lại',
        pleasureManagementFee: 'Phí quản lý Yuexiang',
        brandManagementFee: 'Phí quản lý thương hiệu',
        mastersCommission: 'Chi phí quản lý khách sạn',
        otherExpenses: 'Chi phí khác',
        openingDate: 'Ngày khai trương',
        preferentialPolicy: 'Chính sách ưu đãi',
        managementFeeStartDate: 'Ngày bắt đầu thu phí quản lý',
        thisPeriodOfBusinessSelfPromotion: 'Khuyến mãi tự triển khai kỳ này',
        enjoyCommissionRate: 'Tỷ lệ hoa hồng Yuexiang',
        enjoyManagementFeeForThisPeriod: 'Phí quản lý Yuexiang kỳ này',
        currentAdjustmentExpense: 'Chi phí điều chỉnh kỳ này',
        reasonsForAdjustingExpensesInTheCurrentPeriod: 'Lý do điều chỉnh chi phí kỳ này',
        notPaidInThePreviousPeriod: 'Chưa thanh toán kỳ trước',
        currentReceivable: 'Khoản phải thu kỳ này',
        currentPaid: 'Đã thanh toán kỳ này',
        balanceDue: 'Số tiền còn phải thanh toán',
        brandCommissionRate: 'Tỷ lệ hoa hồng thương hiệu',
        currentBrandManagementFee: 'Phí quản lý thương hiệu kỳ này',
        monthlyRate: 'Tiêu chuẩn thu phí hàng tháng',
        currentObjective: 'Mục tiêu kỳ này',
        totalPmsRevenueForThePeriod: 'Tổng doanh thu PMS kỳ này',
        totalPmsReceivableForThePeriod: 'Tổng khoản phải thu PMS kỳ này',
    },

    chargeIndex: {
        expenseItem: 'Hạng mục chi phí',
        totalAmountPayable: 'Tổng số tiền phải trả',
        cashPayable: 'Số tiền mặt phải trả',
        creditPayable: 'Số tiền khấu trừ phải trả',
        deductionAdjustment: 'Điều chỉnh khấu trừ',
        deductible: 'Đã khấu trừ',
        residualCredit: 'Khấu trừ còn lại',
        managementFeeStartDate: 'Ngày bắt đầu thu phí quản lý',
        currentObjective: 'Mục tiêu kỳ này',
        currentPeriodAdjustment: 'Điều chỉnh kỳ này',
        notPaidInThePreviousPeriod: 'Chưa thanh toán kỳ trước',
        currentReceivable: 'Khoản phải thu kỳ này',
        currentPaid: 'Đã thanh toán kỳ này',
        balanceDue: 'Số tiền còn phải thanh toán',
    },

    commonIndex: {
        accountName: 'Tên chủ tài khoản',
        collectionAccountType: 'Loại tài khoản nhận tiền',
        distributionRoomBillReconciliation: 'Đối soát hóa đơn phòng phân phối',
        memberIncentiveCheck: 'Đối soát thưởng thành viên',
        directSellingRoomFeePaymentRecords: 'Lịch sử thanh toán tiền phòng bán trực tiếp',
        distributeRoomChargePaymentRecords: 'Lịch sử thanh toán tiền phòng phân phối',
        memberIncentiveRecord: 'Lịch sử thưởng thành viên',
        confirmed: 'Đã xác nhận',
        reasonForAdjustment: 'Lý do điều chỉnh',
        settlementGrounds: 'Lý do quyết toán',
        operationDetails: 'Chi tiết thao tác',
        merchantRefunds: 'Hoàn tiền do khách sạn chịu',
        merchantConcession: 'Ưu đãi do khách sạn chịu',
        amountOfMerchantWelfare: 'Khoản công ích của khách sạn',
        americanOrder: 'Đơn hàng Meituan',
        flyingPigOrder: 'Đơn hàng Fliggy',
        lightLiveMiniProgramOrder: 'Đơn hàng Mini Program Qingzhu',
        memberShareAmount: 'Số tiền chia lợi nhuận thành viên',
        theAmountOfCrossStoreRefund: 'Số tiền hoàn hoa hồng liên cửa hàng',
        lightlyAdjustTheAmount: 'Số tiền điều chỉnh của Qingzhu',
        reasonForAdjustment3: 'Lý do điều chỉnh',
        fundsToBeRemitted: 'Chờ thanh toán',
        remitting: 'Đang thanh toán',
        remittedMoney: 'Đã thanh toán',
        paymentFailure2: 'Thanh toán thất bại',
        lightSettlementWithMerchantsOrder: 'Thanh toán giữa Qingzhu và khách sạn (Đơn hàng)',
    },

    infoInfoManage: {
        note: 'Lưu ý',
        theApplicationChangeLetterNeedsToBePrintedOutAndSignedWithTheOfficialSealAfterDownloadingIfThePrintIs2PagesPleaseAffixTheSealAndUploadThePicture:
            'Sau khi tải đơn đề nghị thay đổi, cần in ra, ký tên và đóng dấu. Nếu tài liệu gồm 2 trang, vui lòng đóng dấu giáp lai rồi tải ảnh lên.',
        submitAndModifyTheAuditProcessOfTheReceivingAccountOnlyAfterTheAuditIsPassedCanThePaymentBeMadeTheRejectedAccountWillNotBeMade:
            'Sau khi gửi yêu cầu thay đổi tài khoản nhận tiền, chỉ khi được phê duyệt mới có thể thanh toán. Tài khoản bị từ chối sẽ không được thanh toán.',
        beforeModification3: 'Trước khi thay đổi',
        pleaseBePatientWhileTheInformationIsBeingReviewed:
            'Thông tin đang được xét duyệt, vui lòng chờ',
        groundsForRejection: 'Lý do từ chối',
        downloadTheAttachmentTemplate2: 'Tải mẫu đính kèm',
        forPrivacy: 'Cá nhân',
        forThePublic: 'Doanh nghiệp',
        auditStatus: 'Trạng thái xét duyệt',
        viewingModificationLogs2: 'Xem nhật ký thay đổi',
        pleaseUploadYourBankCardInformationAsSoonAsPossibleToAvoidAffectingYourPaymentProgress:
            'Vui lòng tải lên thông tin tài khoản ngân hàng sớm để tránh ảnh hưởng đến tiến độ thanh toán',
        modifyLog2: 'Nhật ký thay đổi',
        receivablesAccountManagement2: 'Quản lý tài khoản nhận tiền',
        collectionAccountType: 'Loại tài khoản nhận tiền',
        pleaseSelectACollectionAccountType: 'Vui lòng chọn loại tài khoản nhận tiền',
        bankAccountName5: 'Tên tài khoản ngân hàng',
        recipientsCellPhoneNumber: 'Số điện thoại người nhận tiền',
        pleaseEnterTheRecipientsMobilePhoneNumber:
            'Vui lòng nhập số điện thoại người nhận tiền',
        payeeIdNumber: 'Số CMND/CCCD người nhận tiền',
        pleaseEnterThePayeeIdNumber:
            'Vui lòng nhập số CMND/CCCD người nhận tiền',
        payeeIdCardFront: 'Mặt trước CMND/CCCD người nhận tiền',
        reverseOfPayeeIdCard: 'Mặt sau CMND/CCCD người nhận tiền',
        uploadContractAttachment: 'Tải lên hợp đồng đính kèm',
        letterOfRequestForChange2: 'Đơn đề nghị thay đổi',
        pleaseEnterTheBankAccountName:
            'Vui lòng nhập tên tài khoản ngân hàng',
        pleaseEnterTheLegalPersonName:
            'Vui lòng nhập tên người đại diện pháp luật',
        legalPersonNameCanOnlyBeEnteredInChineseCharactersPleaseReEnter:
            'Tên người đại diện pháp luật chỉ được nhập bằng ký tự tiếng Trung',
        phoneNumberFormatIsIncorrectPleaseReEnter:
            'Định dạng số điện thoại không đúng, vui lòng nhập lại',
        pleaseEnterYourIdNumber2:
            'Vui lòng nhập số CMND/CCCD',
        idNumberFormatIsWrongCanOnlyEnterNumbersAndUppercaseLettersPleaseReEnter:
            'Định dạng CMND/CCCD không đúng, chỉ được nhập số và chữ in hoa',
        pleaseEnterAUnifiedSocialCreditCode:
            'Vui lòng nhập mã số tín dụng xã hội thống nhất',
        onlyNumbersAndLettersAreSupportedPleaseReEnter:
            'Chỉ hỗ trợ chữ và số, vui lòng nhập lại',
        pleaseUploadTheRequestForChange2:
            'Vui lòng tải lên đơn đề nghị thay đổi',
        frontOfIdentityCard: 'Mặt trước CMND/CCCD',
        reverseOfIdCard: 'Mặt sau CMND/CCCD',
        businessLicense: 'Giấy phép kinh doanh',
        pleaseUploadTheContractAttachment:
            'Vui lòng tải lên hợp đồng đính kèm',
        afterModification2: 'Sau khi thay đổi',
        corporateName: 'Tên người đại diện pháp luật',
        unifyTheSocialCreditCode:
            'Mã số tín dụng xã hội thống nhất',
        legalPersonMobilePhoneNumber:
            'Số điện thoại người đại diện pháp luật',
        pleaseEnterTheFrenchPhoneNumber:
            'Vui lòng nhập số điện thoại người đại diện pháp luật',
        legalPersonIdNumber:
            'Số CMND/CCCD người đại diện pháp luật',
        pleaseEnterTheCorporateIdNumber:
            'Vui lòng nhập số CMND/CCCD người đại diện pháp luật',
        corporateIdentityCardFront:
            'Mặt trước CMND/CCCD người đại diện pháp luật',
        reverseOfCorporateIdentityCard:
            'Mặt sau CMND/CCCD người đại diện pháp luật',
        pleaseUpload: 'Vui lòng tải lên',
        fileUpload: 'Tải tệp lên',
        uploadAMaximumOf2Images:
            'Tối đa tải lên 2 hình ảnh',
        theSizeOfTheUploadedProfilePictureCannotExceed:
            'Dung lượng ảnh tải lên không được vượt quá',
        uploadPictureFormatOnlySupported:
            'Chỉ hỗ trợ định dạng hình ảnh',
        onlyJpgJpegAndPngFilesCanBeUploaded:
            'Chỉ hỗ trợ tệp JPG, JPEG và PNG',
        onlyJpgJpegPngFilesCanBeUploadedPleaseUploadTheChangeLetterAsAPhoto:
            'Chỉ hỗ trợ JPG, JPEG, PNG. Vui lòng chụp ảnh đơn thay đổi và tải lên',
        pleaseWaitFileUploadIsNotComplete:
            'Vui lòng đợi, quá trình tải tệp chưa hoàn tất',
        contractStampPageRequired:
            'Trang hợp đồng có đóng dấu (bắt buộc)',
        otherPagesOptional:
            'Các trang khác (không bắt buộc, tối đa 2 ảnh)',
        contractStampInstructions:
            'Trang hợp đồng có đóng dấu phải chứa thông tin tài khoản nhận tiền của bên B và được đóng dấu công ty.',
        individualMobileNote:
            'Lưu ý: Nếu là hộ kinh doanh cá thể, nhập số điện thoại của chủ hộ',
        individualNameNote:
            'Lưu ý: Nếu là hộ kinh doanh cá thể, nhập tên chủ hộ',
        individualIdNote:
            'Lưu ý: Nếu là hộ kinh doanh cá thể, nhập số CMND/CCCD của chủ hộ',
        individualRegNumberNote:
            'Lưu ý: Nếu là hộ kinh doanh cá thể, nhập số đăng ký kinh doanh',
        maxTwoImages: 'Tối đa 2 hình ảnh',
        recipientLegalMobile:
            'Số điện thoại người nhận tiền / người đại diện pháp luật',
        recipientLegalIdNumber:
            'CMND/CCCD người nhận tiền / người đại diện pháp luật',
    },

    invoicingAddInvoicingApplication: {
        billingApplication: 'Đơn đăng ký xuất hóa đơn',
        expenseType: 'Loại chi phí:',
        totalAmountApplied: 'Tổng số tiền đăng ký',
        theApplicationAmountIsIncorrect:
            'Số tiền đăng ký không hợp lệ',
        status: 'Trạng thái:',
        causeOfRejection: 'Lý do từ chối:',
        billingInformation: 'Thông tin hóa đơn:',
        pleaseEnterPhoneNumber: 'Vui lòng nhập số điện thoại',
        dutyNumber: 'Mã số thuế',
        pleaseEnterYourTaxId: 'Vui lòng nhập mã số thuế',
        pleaseEnterYourAccountBank: 'Vui lòng nhập ngân hàng mở tài khoản',
        pleaseEnterTheAddress: 'Vui lòng nhập địa chỉ',
        openABankAccount: 'Số tài khoản ngân hàng',
        pleaseEnterYourBankAccountNumber:
            'Vui lòng nhập số tài khoản ngân hàng',
        pleaseEnterEmail: 'Vui lòng nhập email',
        pickUpTelephone: 'Điện thoại người nhận',
        pleaseEnterTheReceivingPhoneNumber:
            'Vui lòng nhập số điện thoại người nhận',
        mailingAddress: 'Địa chỉ nhận thư',
        pleaseEnterYourMailingAddress:
            'Vui lòng nhập địa chỉ nhận thư',
        addressee: 'Người nhận',
        pleaseEnterTheRecipient:
            'Vui lòng nhập người nhận',
        repudiationPeriod: 'Kỳ bị từ chối:',
        claimPeriod: 'Kỳ đăng ký:',
        pleaseEnterTheAmountRequested:
            'Vui lòng nhập số tiền đăng ký',
        theNumberCannotExceed15Digits:
            'Số không được vượt quá 15 chữ số',
        pleaseEnterTheCorrectNumber:
            'Vui lòng nhập số hợp lệ',
        paymentPeriod: 'Kỳ thanh toán',
        availableAmount: 'Số tiền có thể xuất hóa đơn',
        amountApplied2: 'Số tiền đăng ký',
        pleaseSelectTheBillingType5:
            'Vui lòng chọn loại hóa đơn',
        receipt: 'Biên lai',
        pleaseEnterTitle: 'Vui lòng nhập tiêu đề hóa đơn',
        generalInvoice: 'Hóa đơn thường (điện tử)',
        specialInvoice: 'Hóa đơn VAT đặc biệt (điện tử)',
    },
    invoicingInvoicingApplication: {
        applicationDate: 'Ngày đăng ký',
        billingApplication: 'Đơn đăng ký xuất hóa đơn',
        expenseType: 'Loại chi phí',
        amountApplied2: 'Số tiền đăng ký',
        expressNumber: 'Mã vận đơn',
        alreadyRequested: 'Đã đăng ký',
    },

    preauthorizationIndex: {
        turn: 'Chuyển',
        increaseAuthorization: 'Tăng ủy quyền',
        authorizationFailure: 'Ủy quyền thất bại',
        settlementTime: 'Thời gian thanh toán',
        preAuthorizationDetailsLightWinTreasureHotelManagementSystem:
            'Chi tiết ủy quyền trước - Hệ thống quản lý khách sạn EaseHUB',
        declined: 'Đã từ chối',
        flyingPigCreditDoesNotSupportPreAuthorization:
            'Fliggy Credit Stay hiện chưa hỗ trợ ủy quyền trước',
        newAuthorization: 'Thêm ủy quyền mới',
        cancelAuthorizationPleaseWait: 'Đang hủy ủy quyền, vui lòng đợi',
        succeededInCancelingAuthorization: 'Hủy ủy quyền thành công',
        pleaseWaitForTheSettlementAuthorization:
            'Đang thanh toán ủy quyền, vui lòng đợi',
        confirmThatYouWantToCancelAuthorization:
            'Xác nhận hủy ủy quyền',
        orderStatusWarning: 'Đơn hàng {status}, không thể {action}',
        roomStatusWarning: 'Phòng đã nhận, không thể {action}',
        roomCheckoutWarning: "Trạng thái phòng là 'Đã trả phòng', không thể {action}",
    },

    componentsAuthsettle: {
        payment3: 'Thanh toán',
        paidInAmount: 'Số tiền thực thu',
        settlementSuccess: 'Thanh toán thành công',
        authorizedSettlement: 'Thanh toán ủy quyền',
        accountEntry: 'Hạng mục ghi sổ',
        pleaseFillInTheAuthorizedAmount: 'Vui lòng nhập số tiền ủy quyền',
        theActualAmountReceivedMustBeGreaterThan0:
            'Số tiền thực thu phải lớn hơn 0',
        theActualAmountReceivedCannotBeGreaterThanTheAuthorizedAmount:
            'Số tiền thực thu không được lớn hơn số tiền ủy quyền',
    },

    componentsBanklist: {
        bankOfChina: 'Ngân hàng Trung Quốc',
        industrialAndCommercialBankOfChina: 'Ngân hàng Công thương Trung Quốc',
        industrialAndCommercialBankOfChina3: 'ICBC',
        agriculturalBankOfChina: 'Ngân hàng Nông nghiệp Trung Quốc',
        agriculturalBankOfChina3: 'Ngân hàng Nông nghiệp Trung Quốc',
        chinaConstructionBank: 'Ngân hàng Xây dựng Trung Quốc',
        chinaConstructionBank3: 'CCB',
        postalSavingsBankOfChina: 'Ngân hàng Tiết kiệm Bưu điện Trung Quốc',
        postalSavingsBank: 'Ngân hàng Tiết kiệm Bưu điện',
        bankOfCommunications: 'Ngân hàng Giao thông',
        chinaMerchantsBank: 'Ngân hàng Chiêu thương Trung Quốc',
        shanghaiPudongDevelopmentBank: 'Ngân hàng Phát triển Phố Đông Thượng Hải',
        shanghaiPudongDevelopmentBank3: 'Ngân hàng Phố Đông',
        chinaCiticBank: 'Ngân hàng CITIC Trung Quốc',
        everbrightBank: 'Ngân hàng Everbright',
        chinaMinshengBank: 'Ngân hàng Dân Sinh Trung Quốc',
        minshengBank: 'Ngân hàng Dân Sinh',
        guangdongDevelopmentBank: 'Ngân hàng Phát triển Quảng Đông',
        guangfaBank: 'Ngân hàng Guangfa',
        pingAnBank: 'Ngân hàng Ping An',
        industrialBank: 'Ngân hàng Công nghiệp',
        huaxiaBank: 'Ngân hàng Hoa Hạ',
        bankOfShanghai: 'Ngân hàng Thượng Hải',
        bankOfBeijing: 'Ngân hàng Bắc Kinh',
        bohaiBank: 'Ngân hàng Bột Hải',
        zheshangBank: 'Ngân hàng Zheshang',
        huishangBank: 'Ngân hàng Huishang',
        hsbc: 'Ngân hàng HSBC',
        hangSengBank: 'Ngân hàng Hang Seng',
        hengfengBank: 'Ngân hàng Hengfeng',
    },

    componentsExpandcolumn: {
        bankName: 'Tên ngân hàng',
        authorizationCode: 'Mã ủy quyền',
        from: 'Từ',
        rollOutTo: 'Chuyển ra đến',
    },

    componentsTransferaccounts: {
        transferMoney: 'Chuyển khoản',
        transferToAccount: 'Tài khoản chuyển đến',
        authorizationFailure: 'Ủy quyền thất bại',
    },

    componentsUpdateauthorization: {
        automaticSettlementAfterExpiration: 'Tự động thanh toán sau khi hết hiệu lực',
        authorizationCode: 'Mã ủy quyền',
        bankName: 'Tên ngân hàng',
        pleaseFillInTheAuthorizedAmount: 'Vui lòng nhập số tiền ủy quyền',
        newAuthorization: 'Thêm ủy quyền mới',
        modifyAuthorization: 'Chỉnh sửa ủy quyền',
        renewal: 'Cập nhật',
    },

    componentsCancelorder: {
        reminderThisOrderIsAnEbOrderPleaseVerifyTheOtaOrderStatusBeforeCancellation:
            'Lưu ý: Đơn hàng này là đơn EB, vui lòng xác minh trạng thái đơn OTA trước khi hủy',
        orderCancelledSuccessfully: 'Hủy đơn hàng thành công',
        cancelAnOrder2: 'Hủy đơn hàng',
        cancellationReason: 'Lý do hủy',
        remarks5100Words: 'Ghi chú (5-100 ký tự)',
        replyTextMinimum5Words: 'Nội dung phản hồi tối thiểu 5 ký tự',
        pleaseSelectACancellationReason: 'Vui lòng chọn lý do hủy',
        originalStayWillBeCancelled: 'Đơn gia hạn lưu trú gốc sẽ tự động bị hủy',
        cancellationRules: 'Quy tắc hủy',
        channelDescription: 'Mô tả kênh',
        refundScore: 'Hoàn điểm',
        refundCoupon: 'Hoàn phiếu ưu đãi',
        orderMessage: 'Lời nhắn đơn hàng',
        pleaseEnterOrderMessage: 'Vui lòng nhập lời nhắn đơn hàng',
        directCancelSuccessComment: 'Hủy đơn hàng thành công',
    },

    componentsEditcontactinfo: {
        modifyAContact: 'Chỉnh sửa người liên hệ',
        pleaseEnterThe11DigitPhoneNumber: 'Vui lòng nhập số điện thoại 11 chữ số',
    },

    componentsEditorder: {
        modifyTheOrder2: 'Chỉnh sửa đơn hàng',
        selectDate1: 'Chọn ngày 1',
        selectDate2: 'Chọn ngày 2',
        contactNumber4: 'Số điện thoại liên hệ',
        theRetentionTimeMustNotBeLessThanTheCurrentTime:
            'Thời gian giữ phòng không được nhỏ hơn thời gian hiện tại',
        theRetentionTimeShallNotBeLessThanTheEstimatedArrivalTime:
            'Thời gian giữ phòng không được nhỏ hơn thời gian dự kiến đến',
        theRetentionTimeMustNotBeLongerThanThePreDepartureTime:
            'Thời gian giữ phòng không được lớn hơn thời gian dự kiến trả phòng',
        doNotRepeatThisOperationWhileSubmittingChanges:
            'Đang gửi chỉnh sửa, vui lòng không thao tác lặp lại',
        orderModificationSuccessful: 'Chỉnh sửa đơn hàng thành công',
    },

    componentsEditOrderV2: {
        addedRoomsOverAvailability: 'Số phòng thêm mới không được vượt quá số phòng còn trống',
        arrivalBeforeToday: 'Ngày nhận phòng của đơn phòng mới không được sớm hơn hôm nay',
        assignedRoom: 'Đã xếp phòng {room}',
        availabilityLoading: 'Đang tải số phòng trống của loại phòng này. Vui lòng thử lại sau',
        availableCount: 'Có thể đặt: {count}',
        checkedInRoom: 'Đã nhận phòng {room}',
        checkedOutRoom: 'Đã trả phòng {room}',
        chooseArrivalTime: 'Chọn thời gian nhận phòng',
        chooseDepartureTime: 'Chọn thời gian trả phòng',
        detailLoadFailed: 'Không thể tải dữ liệu chỉnh sửa đơn hàng phiên bản mới',
        detailLoadRetry: 'Không thể tải dữ liệu chỉnh sửa đơn hàng phiên bản mới. Vui lòng thử lại',
        discountLabel: 'Giảm {discount}% so với giá niêm yết',
        invalidStay: 'Vui lòng chọn thời gian nhận và trả phòng hợp lệ',
        keepOneRoom: 'Sau khi chỉnh sửa phải giữ lại ít nhất một đơn phòng hợp lệ',
        latestPriceFailed: 'Không thể tải giá mới nhất. Vui lòng điều chỉnh ngày lưu trú và thử lại',
        latestPriceLoading: 'Đang tải giá mới nhất. Vui lòng gửi lại sau',
        longStayAtLeastTenDays: 'Đặt phòng dài hạn phải có thời gian lưu trú ít nhất 10 ngày',
        longStayAtMostOneYear: 'Đặt phòng dài hạn không được vượt quá một năm',
        longStayNoMorning: 'Đặt phòng dài hạn không hỗ trợ phòng sáng sớm',
        markedCancelled: 'Đã đánh dấu hủy',
        newRoomOrder: 'Đơn phòng mới',
        newRoomPriceLoading: 'Đang tải ngày lưu trú và giá của đơn phòng mới. Vui lòng gửi lại sau',
        noReducibleRoom: 'Không có đơn phòng tạm thời hoặc chờ nhận phòng nào có thể giảm cho loại phòng này',
        otherStatus: 'Trạng thái khác',
        phonePlaceholder: 'Nhập số điện thoại di động',
        productPriceFailed: 'Không thể tải sản phẩm và giá khách sạn. Vui lòng thử lại',
        roomNumberValue: 'Phòng {room}',
        roomOrderDetails: 'Chi tiết',
        roomTypeInfo: 'Thông tin loại phòng',
        roomTypeNoProduct: 'Không có sản phẩm khách sạn khả dụng cho loại phòng này',
        stayChangedClearRoom: 'Ngày lưu trú đã thay đổi. Phòng đã xếp trước đó bị xóa; vui lòng xếp lại phòng',
        stayPriceRefreshFailed: 'Không thể tải giá sau khi thay đổi ngày lưu trú. Vui lòng thử lại',
        stayProductPriceFailed: 'Không thể tải sản phẩm và giá cho kỳ lưu trú đã chọn. Vui lòng thử lại',
        stayProductUnavailable: 'Không có sản phẩm khách sạn khả dụng cho loại phòng này trong kỳ lưu trú đã chọn',
        storeProductMissing: 'Không tìm thấy sản phẩm khách sạn',
        temporaryRoomOrder: 'Đơn phòng tạm thời',
        unassignedSummary: '{count} phòng đang chờ xếp',
    },
    componentsEditroomorder: {
        modifyingTheAgreedUnitInformationWillRecalculateAllRoomRatesInTheOrder:
            'Chỉnh sửa thông tin đơn vị hợp đồng sẽ tính lại toàn bộ giá phòng trong đơn hàng',
        modifyRoomList: 'Chỉnh sửa đơn phòng',
    },

    componentsEditroomprice: {
        modifyTheHousePrice: 'Chỉnh sửa giá phòng',
        theCurrentPriceCalendarCannotBeModified: 'Lịch giá hiện tại không thể chỉnh sửa',
        updatePriceCalendarSuccessfully: 'Cập nhật lịch giá thành công',
    },
    componentsLevelup: {
        payTheBill: 'Trả phí',
        partUpgrade: 'Nâng cấp',
        confirmTheUpgrade: 'Xác nhận nâng cấp',
        currentRoomType: 'Loại phòng hiện tại',
        reselection: 'Chọn lại',
        chargeOrNot: 'Có tính phí hay không',
        currentTotalHousePrice: 'Tổng giá phòng hiện tại',
        totalRateAfterUpgrade: 'Tổng giá phòng sau nâng cấp',
        priceDifference: 'Chênh lệch giá',
        upgradeCause: 'Lý do nâng cấp',
        enterAMaximumOf150Words: 'Tối đa 150 ký tự',
        pleaseChooseWhetherToCharge: 'Vui lòng chọn có tính phí hay không',
        pleaseEnterTheUpgradeReason: 'Vui lòng nhập lý do nâng cấp',
        inTheCaseOfPaymentTheSpreadCannotBeLessThanOrEqualTo0:
            'Trong trường hợp tính phí, chênh lệch giá phải lớn hơn 0',
        reminderIfYouUpgradeTheRoomTypeBetweenTheNightAuditAnd0600PleaseManuallyHandleTheRoomRateDifference:
            'Lưu ý: Nếu nâng cấp loại phòng trong khoảng thời gian từ sau kiểm toán đêm đến 06:00, vui lòng xử lý chênh lệch giá phòng thủ công',
    },

    componentsSeeroomprice: {
        viewRoomRates: 'Xem giá phòng',
    },

    componentsStay: {
        theCurrentRoomTypeIsSoldOutPleaseSelectAnotherDate:
            'Loại phòng hiện tại đã hết, vui lòng chọn ngày khác',
        existingRoomSingleChargeCheckOut:
            'Trả phòng bằng tài khoản công nợ của đơn phòng hiện tại',
        theAccountOfTheExistingHouseBillIsTransferredToTheNewHouseBill:
            'Chuyển công nợ của đơn phòng hiện tại sang đơn phòng mới rồi trả phòng',
        promptTheCurrentRoomIsALinkedRoomBillAfterExtendingTheStayYouNeedToManuallyAddTheNewRoomBillToTheLinkedRooms:
            'Lưu ý: Phòng hiện tại thuộc đơn phòng liên kết. Sau khi gia hạn lưu trú, cần thêm thủ công đơn phòng mới vào phòng liên kết',
        nonStoreSingleCanNotSustain:
            'Đơn không phải của khách sạn không hỗ trợ gia hạn lưu trú',
        youCannotRenewYourStayUntilTheCheckOutDate:
            'Chưa đến ngày trả phòng, không thể gia hạn lưu trú',
        extendStayadvance: 'Gia hạn / Trả phòng sớm',
        originalOrder2: 'Đơn hàng gốc',
        continuationPrice: 'Giá gia hạn',
        changeTheCheckOutTime: 'Thay đổi thời gian trả phòng',
        selectDateTime: 'Chọn ngày giờ',
        continuationPriceRule: 'Quy tắc giá gia hạn',
        swapOrder: 'Đổi đơn hàng',
        nameAndMobilePhoneNumberOfThePersonWhoMadeTheReservation:
            'Tên và số điện thoại người đặt phòng',
        subscriber: 'Người đặt phòng',
        roomAccountProcessing: 'Xử lý tài khoản phòng',
        pleaseSelectTheRenewalPriceRule:
            'Vui lòng chọn quy tắc giá gia hạn',
        checkOutTimeCannotBeLessThanTheCurrentTime:
            'Thời gian trả phòng không được nhỏ hơn thời gian hiện tại',
        theRenewalOfStayIsSuccessful:
            'Gia hạn lưu trú thành công',
        pleaseSelectANewOrder:
            'Vui lòng chọn đơn hàng mới',
        theRenewalOfTheOrderDoesNotSupportTheFlyingPigCreditOrder:
            'Gia hạn bằng đổi đơn không hỗ trợ đơn Fliggy Credit Stay',
        extendStayadvanceSuccess:
            'Gia hạn / Trả phòng sớm thành công',
        roomNumber: 'Số phòng',
        checkInPerson: 'Khách lưu trú',
        checkOutTime: 'Thời gian trả phòng',
        makeCard: 'Tạo thẻ',
        booked: 'Ghi sổ',
        close: 'Đóng',
    },

    componentsTools: {
        pendingClosing: 'Chờ yêu cầu thanh toán',
        closingSuccessful: 'Yêu cầu thanh toán thành công',
        failedToApplyForClosing: 'Yêu cầu thanh toán thất bại',
        firstNightRate: 'Giá đêm đầu tiên',
        lateNightRate: 'Giá đêm cuối cùng',
        maximumHousePrice: 'Giá phòng cao nhất',
        minimumRoomRate: 'Giá phòng thấp nhất',
    },

    ebkorderIndex: {
        priceDescription: 'Giải thích giá',
        merchantPromotionTotalAmountBorneByTheMerchant:
            'Khuyến mãi của khách sạn = Tổng số tiền do khách sạn chịu',
        totalSellingPriceTotalOrderAmountMerchantPromotion:
            'Tổng giá bán = Tổng giá trị đơn hàng - Khuyến mãi của khách sạn',
        totalCommissionTotalSellingPriceCommissionRate:
            'Tổng hoa hồng = Tổng giá bán × Tỷ lệ hoa hồng',
        totalBasePriceTotalSellingPriceTotalCommission:
            'Tổng giá gốc = Tổng giá bán - Tổng hoa hồng',
        userPaymentAmountActuallyPaidByTheUser:
            'Khách thanh toán = Số tiền thực tế khách đã trả',
        totalOrder: 'Tổng giá trị đơn hàng',
        totalSellingPrice: 'Tổng giá bán',
        userPayment: 'Khách thanh toán',
        totalCommission: 'Tổng hoa hồng',
        totalFloorPrice: 'Tổng giá gốc',
        merchantPromotion: 'Khuyến mãi của khách sạn',
        viewOrder: 'Xem đơn hàng',
        orderTransferMethod: 'Phương thức chuyển đơn',
        removalOfOrder: 'Chuyển đơn',
        contactAndMobilePhoneNumber:
            'Người liên hệ, số điện thoại',
        channelOrderStatus: 'Trạng thái đơn hàng kênh',
        orderStatus: 'Trạng thái chuyển đơn',
        channelOrderNumber: 'Mã đơn hàng kênh',
        channelType: 'Loại phòng kênh',
        expectedArrivalexpectedDeparture:
            'Dự kiến đến / Dự kiến đi',
        bookingType: 'Loại đặt phòng',
        estimatedTimeOfArrival: 'Thời gian dự kiến đến',
        orderCreationTime: 'Thời gian tạo đơn',
        inBooking: 'Đang đặt phòng',
        bookingFailed: 'Đặt phòng thất bại',
        bookingException: 'Lỗi đặt phòng',
        initialRejection: 'Từ chối lần đầu',
        canceling: 'Đang hủy',
        otherStates: 'Trạng thái khác',
        movedOrder: 'Đã chuyển đơn',
        unmovedOrder: 'Chưa chuyển đơn',
        createTimeDesc: 'Thời gian tạo giảm dần',
        createTimeAsc: 'Thời gian tạo tăng dần',
        arriveTimeDesc: 'Thời gian đến giảm dần',
        arriveTimeAsc: 'Thời gian đến tăng dần',
        ebkOrderCheckMsg: 'Không có dữ liệu, nhấn để bổ sung',
    },

    ebkorderUnbindtip: {
        youDoNotHaveAMeituanAccount:
            'Bạn chưa liên kết tài khoản Meituan',
        pleaseSetItInmoresystemSettingsebAccountAuthorization:
            'Vui lòng thiết lập tại [Thêm] - [Cài đặt hệ thống] - [Ủy quyền tài khoản EB]',
        clickToGo: 'Nhấn để chuyển đến',
    },

    invoiceInvoiceDetail: {
        personage: 'Cá nhân',
        firm: 'Doanh nghiệp',
        headerType: 'Loại tiêu đề hóa đơn',
        invoiceAmount2: 'Số tiền hóa đơn',
        pleaseEnterTheInvoiceAmount:
            'Vui lòng nhập số tiền hóa đơn',
        pleaseEnterTheInvoiceNumber2:
            'Vui lòng nhập số hóa đơn',
        invoiceGroup: 'Nhóm hóa đơn',
        selectRoomList: 'Chọn đơn phòng',
        orderAmount: 'Số tiền đơn hàng',
        pleaseEnterTheInvoiceTitleToSearch:
            'Vui lòng nhập tiêu đề hóa đơn để tìm kiếm',
        pleaseEnterYourTaxIdentificationNumber:
            'Vui lòng nhập mã số thuế',
        unitAddress: 'Địa chỉ đơn vị',
        pleaseEnterTheAddressOfTheUnit:
            'Vui lòng nhập địa chỉ đơn vị',
        telephoneNumber: 'Số điện thoại',
        bankOfDeposit2: 'Ngân hàng mở tài khoản',
        pleaseEnterYourBank:
            'Vui lòng nhập ngân hàng mở tài khoản',
        bankAccount: 'Tài khoản ngân hàng',
        pleaseEnterYourBankAccount:
            'Vui lòng nhập tài khoản ngân hàng',
        pleaseEnterYourEmailAddress:
            'Vui lòng nhập địa chỉ email',
        invoiceMailingAddress: 'Địa chỉ nhận hóa đơn',
        pleaseEnterTheInvoiceMailingAddress:
            'Vui lòng nhập địa chỉ nhận hóa đơn',
        billingNote: 'Ghi chú xuất hóa đơn',
        pleaseEnterYourBillingRemarks:
            'Vui lòng nhập ghi chú xuất hóa đơn',
        pleaseSelectTheBillingType5:
            'Vui lòng chọn loại hóa đơn',
        pleaseSelectAHeaderType:
            'Vui lòng chọn loại tiêu đề hóa đơn',
        fillInAtLeastOneEMailAndMailingAddress:
            'Phải điền ít nhất Email hoặc Địa chỉ nhận thư',
    },

    invoiceInvoiceList: {
        toBeInvoiced: 'Chờ xuất hóa đơn',
        pleaseEnterYourTaxIdentificationNumber:
            'Vui lòng nhập mã số thuế',
        pleaseEnterTheInvoiceNumber2:
            'Vui lòng nhập số hóa đơn',
        newInvoice: 'Thêm hóa đơn mới',
        invoiceType: 'Loại hóa đơn',
        invoiceAmount: 'Số tiền hóa đơn',
        billingTime: 'Thời gian xuất hóa đơn',
    },
    invoiceRoomInvoiceAssociationSearch: {
        roomListInvoiceList2: 'Danh sách hóa đơn đơn phòng',
        namePhoneNumberRoomNumber: 'Tên khách lưu trú, số điện thoại, số phòng',
    },

    invoiceRoomInvoiceList: {
        roomListInvoiceList2: 'Danh sách hóa đơn đơn phòng',
        accumulatedInvoiceAmount: 'Tổng số tiền hóa đơn lũy kế',
        toBeInvoiced: 'Chờ xuất hóa đơn',
        newInvoice: 'Thêm hóa đơn mới',
        invoiceType: 'Loại hóa đơn',
        invoiceAmount: 'Số tiền xuất hóa đơn',
        billingTime: 'Thời gian xuất hóa đơn',
    },

    orderListBaseinfo: {
        getThePhoneNumber: 'Lấy số điện thoại',
        preSaleVoucherNumber: 'Mã phiếu bán trước',
        contractNumber: 'Mã hợp đồng',
        invoice: 'Hóa đơn',
        promotionalActivity: 'Hoạt động khuyến mãi',
        estimatedSettlementAmount: 'Số tiền quyết toán dự kiến',
        pack: 'Gói quà',
        selfServiceReservation: 'Đặt phòng qua máy tự phục vụ',
        theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
            'Hóa đơn của đơn hàng này do kênh bán hàng cung cấp cho khách',
        thisOrderIsInvoicedByYourHotelToTheGuest:
            'Đơn hàng này do khách sạn của bạn xuất hóa đơn cho khách',
        theAmountIsForReferenceOnlyTheSpecificSettlementAmountIsSubjectToTheBill:
            'Số tiền này chỉ mang tính tham khảo, số tiền quyết toán cụ thể vui lòng căn cứ theo hóa đơn',
        systemRemark: 'Ghi chú hệ thống',
        sellerRemark: 'Ghi chú của khách sạn',
    },

    orderListCheckIn: {
        handleSuccessfully: 'Xử lý thành công',
        viewCheckInInformation: 'Xem thông tin nhận phòng',
        handleAgain: 'Xử lý lại',
        handlingFailure: 'Xử lý thất bại',
        theNameCannotBeBlank2: 'Tên không được để trống',
        theIdTypeCannotBeEmpty: 'Loại giấy tờ không được để trống',
        theIdNumberCannotBeEmpty: 'Số giấy tờ không được để trống',
        pleaseArrangeTheRoomFirst: 'Vui lòng xếp phòng trước',
        checkInData: 'Dữ liệu phiếu đăng ký nhận phòng',
    },

    orderListDetail: {
        checkInStatus: 'Tình trạng nhận phòng',
        total: 'Tổng cộng',
        chargedToAccount: 'Đã ghi công nợ',
        natureTraffic: 'Lưu lượng tự nhiên',
        natureOrderTip: 'Đơn hàng này đến từ kênh đặt phòng trực tiếp của Qingzhu',
        preCheckInForm: 'Phiếu nhận phòng trước',
        continuationOrder: 'Đơn gia hạn lưu trú',
        liveOnCredit: 'Credit Stay',
        preSaleVoucherReservationForm: 'Phiếu đặt trước bằng phiếu bán trước',
        meituanEbOrder: 'Đơn EB Meituan',
        ctripEbOrder: 'Đơn EB Ctrip',
        flash: 'Flash Stay',
        fullGuarantee: 'Bảo đảm toàn phần',
        roomListInformation: 'Thông tin đơn phòng',
        automaticRowHouse: 'Tự động xếp phòng',
        bulkCheckIn: 'Nhận phòng hàng loạt',
        unterracedHouse: 'Chưa xếp phòng',
        upgrades: 'Nâng cấp',
        prefabricatedKeyCard: 'Tạo thẻ phòng trước',
        modifyTheOrder2: 'Chỉnh sửa đơn hàng',
        cancelAnOrder2: 'Hủy đơn hàng',
        rejectAnOrder: 'Từ chối đơn',
        pleaseArrangeTheRoomBeforePreformingTheKeyCard:
            'Vui lòng xếp phòng trước khi tạo thẻ phòng trước',
        theListingHasBeenCancelled: 'Đơn phòng này đã bị hủy',
        noRoomingAllowedAfterThePreDepartureTime:
            'Sau thời gian dự kiến trả phòng không được phép xếp phòng',
        allListingsAreAlreadyFurnished: 'Tất cả đơn phòng đã được xếp phòng',
        theAutomaticPlatoonSucceeded: 'Tự động xếp phòng thành công',
        someRowhousesAreSuccessful: 'Một phần xếp phòng thành công',
        smartCheckInBusinessHasNotOpenedTheFunction:
            'Khách sạn sử dụng nhận phòng thông minh chưa kích hoạt chức năng này',
        thisOrderIsARenewalOrderCheckInMayAffectTheOriginalRoomRenewal:
            'Đơn hàng này là đơn gia hạn lưu trú, làm thủ tục nhận phòng có thể ảnh hưởng đến gia hạn của phòng ban đầu',
        thisOrderIsARenewalOrderWhichMayAffectTheContinuationOfTheOriginalRoom:
            'Đơn hàng này là đơn gia hạn lưu trú, tiếp tục xử lý có thể ảnh hưởng đến gia hạn của phòng ban đầu',
        exceedDepartureDate: 'Đã quá ngày dự kiến trả phòng, không được nâng cấp loại phòng',
        theCurrentTimeHasExceededTheCheckOutTimeCannotUpgradeTheRoom:
            'Thời gian hiện tại đã quá thời gian trả phòng, không hỗ trợ nâng cấp/đổi phòng',
        cancelingTheCurrentRowSucceededProcedure: 'Hủy xếp phòng hiện tại thành công',
        orderAcceptedSuccessfully: 'Nhận đơn thành công',
        successfulRejection: 'Từ chối đơn thành công',
        thisActionWillCancelTheListingWhetherToContinue:
            'Thao tác này sẽ hủy đơn phòng, có tiếp tục không?',
    },

    orderListGiftinfodetail: {
        packageName: 'Tên gói quà',
        packageValue: 'Giá trị gói quà',
        wayOfGiving: 'Hình thức tặng',
        dateOfPresentation2: 'Ngày tặng',
        packageDetails: 'Chi tiết gói quà',
        oneDeliveryPerRoom: 'Mỗi phòng tặng một lần',
        complimentaryOnceADayPerRoom: 'Mỗi phòng tặng một lần mỗi ngày',
    },
    orderListOrderDetail: {
        orderDetails: 'Chi tiết đơn hàng',
        finance3: 'Tài chính',
        preAuthorizationDetail: 'Chi tiết ủy quyền trước',
    },

    orderListOrderList: {
        durationOfResidence: 'Thời gian lưu trú',
        bookingTime: 'Thời gian đặt phòng',
        preCheckInForm: 'Phiếu nhận phòng trước',
        housePig: 'Fang Xiaozhu',
        presaleTicket: 'Phiếu bán trước',
        multipleSearch: 'Tìm kiếm tổng hợp',
        nameMobilePhoneNumberOrderNumberChannelNumberQuery:
            'Tra cứu theo tên, số điện thoại, mã đơn hàng hoặc mã đơn kênh',
        selfServiceReservation: 'Đặt phòng tự phục vụ',
        rejectAnOrder: 'Từ chối đơn',
        individualTraveler: 'Khách lẻ',
        team2: 'Đoàn',
        estimate: 'Dự kiến đến',
        firstDayPrice: 'Giá ngày đầu',
        areYouSureYouWantToTakeTheOrder: 'Bạn có chắc muốn nhận đơn này không?',
        orderAcceptedSuccessfully: 'Nhận đơn thành công',
        booked: 'Đã đặt',
        refused: 'Đã từ chối',
        extendStayCheckInImpact:
            'Đơn hàng này là đơn gia hạn lưu trú, việc nhận phòng có thể ảnh hưởng đến việc gia hạn của phòng gốc',
        exceededDepartureCannotUpgrade:
            'Đã quá 6 giờ sáng ngày dự kiến trả phòng, không được nâng cấp loại phòng',
        exceededCheckoutCannotUpgrade:
            'Đã quá thời gian trả phòng, không hỗ trợ nâng cấp hoặc đổi phòng',
        exceededDepartureCannotArrangeRoom:
            'Đã quá thời gian dự kiến trả phòng, không được xếp phòng',
        preArrivalNotArrived: 'Dự kiến đến nhưng chưa đến',
        noshow: 'No-show',
    },

    orderListNoShow: {
        title: 'No-show',
        noshowReason: 'Lý do no-show',
        remarkPlaceholder: 'Ghi chú (5-100 ký tự)',
        remarkMinLength: 'Ghi chú phải có ít nhất 5 ký tự',
        pleaseSelectNoshowReason: 'Vui lòng chọn lý do no-show',
    },

    orderListPricedetail: {
        channelCost: 'Giá gốc kênh',
        eventDiscount: 'Ưu đãi chương trình',
        guestActivityDiscount: 'Ưu đãi hoạt động cho khách',
        memberDiscount: 'Giảm giá thành viên',
        guestMembershipDiscount: 'Ưu đãi thành viên của khách',
        sameTripExclusiveOffer: 'Ưu đãi độc quyền Tongcheng',
        guestTongchengExclusiveDiscount: 'Ưu đãi độc quyền Tongcheng cho khách',
        guestPurchasePrice: 'Giá khách thanh toán',
        activityDiscountAndHotelSellingPriceExplanationThereWillBeADifferenceBetweenTheGuestsOfThisChannelAndTheSettlementBillYouCanClickpricePromptToViewTheActualAmountPaidByTheGuests:
            'Giải thích ưu đãi chương trình và giá bán khách sạn: Số tiền khách thanh toán trên kênh này có thể khác với hóa đơn quyết toán. Nhấn "Nhắc nhở giá" để xem số tiền thực tế khách đã thanh toán.',
        priceDetails: 'Chi tiết giá',
        memberBenefits: 'Ưu đãi thành viên',
        jointMemberBenefits: 'Ưu đãi thành viên liên kết',
    },

    orderListPromotiondetail: {
        eventDetails2: 'Chi tiết chương trình',
        preferentialRules: 'Quy tắc ưu đãi',
    },

    orderListPromotiondetailnew: {
        eventDetails2: 'Chi tiết chương trình',
        dateCondition: 'Điều kiện ngày áp dụng',
        bookingConditions: 'Điều kiện đặt phòng',
        preferentialRules: 'Quy tắc ưu đãi',
        participationDate: 'Ngày tham gia',
    },

    orderListRefuse: {
        areYouSureYouWantToDeclineThisOrder:
            'Bạn có chắc chắn muốn từ chối đơn hàng này không?',
        confirmationRejection: 'Xác nhận từ chối đơn',
        successfulRejection: 'Từ chối đơn thành công',
        theOrderWillBeClosedAtTheSameTime:
            'Sau khi từ chối, đơn phòng liên quan cũng sẽ được đóng',
        overbookingSetup: 'Thiết lập bán vượt phòng',
    },

    orderListTip: {
        useWechatToScanThecheckInQrCodeAtTheFrontDeskToOpenTheOrderInquiryPage:
            'Dùng WeChat quét mã QR nhận phòng tại quầy lễ tân để mở trang tra cứu đơn hàng',
        fillInTheBookingPersonsNameMobilePhoneNumberAndCheckInDateToCheckTheBookingForm:
            'Nhập tên người đặt phòng, số điện thoại và ngày nhận phòng để tra cứu đơn đặt phòng',
        selectTheBookingFormThatNeedsToBeCheckedInAndSelectTheRoomWhereYouWantToAddPeopleToFillInTheInformation:
            'Chọn đơn đặt phòng cần nhận phòng và chọn phòng cần thêm khách để nhập thông tin',
        atThisPointYouCanViewTheRoomAlertInThePreOrderDetailsAfterFillingInTheInformationOfAllTheGuestsClickThecheckInButtonToCheckInTheGuests:
            'Lúc này bạn có thể xem cảnh báo phòng trong chi tiết đơn đặt trước. Sau khi hoàn tất thông tin khách lưu trú, nhấn "Nhận phòng" để làm thủ tục cho khách',
        atThisPointYouCanSeeInTheListDetailsThatThePersonHasBeenAddedSuccessfully:
            'Lúc này bạn có thể thấy khách lưu trú đã được thêm thành công trong chi tiết đơn phòng',
        off: 'Đóng',
        theUserHasCompletedTheProcedure: 'Người dùng đã hoàn tất thủ tục',
        pleaseGuideTheGuestsTocheckInInTheFollowingWay:
            'Vui lòng hướng dẫn khách thực hiện nhận phòng theo các bước sau',
        afterTheGuestsFillInAndSubmitThePageWillDisplaypleaseBringYourIdToTheFrontDeskForVerification:
            'Sau khi khách điền và gửi thông tin, hệ thống sẽ hiển thị "Vui lòng mang giấy tờ tùy thân đến quầy lễ tân để xác minh"',
        pleaseGuideTheGuestsToAddAdditionalGuestsAsFollows:
            'Vui lòng hướng dẫn khách thêm người lưu trú theo các bước sau',
    },

    groupOrderAddroomer: {
        validityPeriod: 'Thời hạn hiệu lực',
        addmodifyCheckInGuests: 'Thêm/Sửa khách nhận phòng',
        pleaseEnterAddress: 'Vui lòng nhập địa chỉ',
        startDate: 'Ngày bắt đầu',
        currentSubscript: 'Chỉ số hiện tại',
    },

    groupOrderIndex: {
        bulkCheckIn: 'Nhận phòng hàng loạt',
        automaticRowHouse: 'Tự động xếp phòng',
        checkInAddition: 'Thêm khách nhận phòng',
        pleaseSelectTheRoomYouWantToCheckIn:
            'Vui lòng chọn phòng cần làm thủ tục nhận phòng',
        theEmptyAndDirtyRoomYouSelectedIsConfirmedToCheckIn:
            'Bạn đã chọn phòng trống nhưng bẩn, xác nhận vẫn nhận phòng?',
        checkInSuccessful: 'Nhận phòng thành công',
        roomNoLongerAvailablePleaseChangeToAnotherRoomNumber:
            'Phòng đã ngừng sử dụng, vui lòng chọn số phòng khác',
        theRoomIsOccupiedPleaseChangeToAnotherRoomNumber:
            'Phòng hiện đang có khách lưu trú, vui lòng chọn số phòng khác',
        pleaseArrangeTheRoomBeforeChoosing:
            'Vui lòng xếp phòng trước khi chọn',
        allListingsAreAlreadyFurnished:
            'Tất cả đơn phòng đã được xếp phòng',
        theAutomaticPlatoonSucceeded:
            'Tự động xếp phòng thành công',
        pleaseListTheRoomFirstAndThenAddTheGuest:
            'Vui lòng xếp phòng trước rồi mới thêm khách nhận phòng',
        succeededInCancelingTheRowHouse:
            'Hủy xếp phòng thành công',
    },

    presalecouponsPredetail: {
        ticketName: 'Tên phiếu bán trước',
        presaleTicket: 'Phiếu bán trước',
        saleOrderNumber: 'Mã đơn bán',
        purchaseTime: 'Thời gian mua',
        advanceOrder: 'Đơn đặt trước',
        availableProduct: 'Sản phẩm khả dụng',
        commodityContent: 'Nội dung sản phẩm',
        ruleInformation: 'Thông tin quy định',
        availableTime: 'Thời gian có thể đặt',
        checkInTime2: 'Thời gian có thể nhận phòng',
        markUpRule: 'Quy tắc phụ thu',
        cancellationRules: 'Quy tắc hủy đặt chỗ',
        paymentInformation: 'Thông tin thanh toán',
        crossedPrice: 'Giá niêm yết',
        chineseFood: 'Ẩm thực Trung Hoa',
        dinner2: 'Bữa tối',
        bookedBedtotalBedHours: 'Đã đặt / Tổng số đêm (giờ)',
        raiseAPrice: 'Phụ thu',
        meituanDirectNew: 'Kết nối trực tiếp Meituan (Mới)',
        officialWebsiteDirect: 'Website chính thức',
        ctripSingleStore: 'Ctrip cửa hàng đơn',
        agoda: 'Agoda',
        meituanHomestay: 'Meituan Homestay',
        tujiaHomestay: 'Tujia Homestay',
        booking: 'Booking',
        expedia: 'Expedia',
    },

    presalecouponsPrelist: {
        dateOfPayment: 'Ngày thanh toán',
        productId: 'ID sản phẩm',
        sellOrderNumber: 'Mã đơn bán',
        noAppointment: 'Chưa đặt lịch',
        completeWriteOff: 'Đối soát toàn bộ',
        completeReverseWriteOff: 'Hủy đối soát toàn bộ',
        refunded: 'Đã hoàn tiền',
        orderNumber2: 'Mã đơn hàng',
        timeOfPayment: 'Thời gian thanh toán',
        bookedBedtotalBedHours: 'Đã đặt / Tổng số đêm (giờ)',
    },
    hardwareParking: {
        parkingLotManagement: 'Quản lý bãi đỗ xe',
        parkingLotDescription: 'Hỗ trợ nhận diện biển số tự động khi vào và ra',
        settings: 'Cài đặt',
        parkingLotConfig: 'Cấu hình bãi đỗ xe',
        currentDevice: 'Thiết bị hiện tại',
        unboundDeviceTip: 'Khách sạn hiện tại chưa liên kết thiết bị bãi đỗ xe',
        sidPlaceholder: 'Vui lòng nhập SID',
        secretKeyPlaceholder: 'Vui lòng nhập SecretKey',
        enableStatus: 'Trạng thái bật',
        hotelNotBoundWarning: 'Khách sạn hiện tại chưa liên kết thiết bị bãi đỗ xe',
        enterSidAndSecretKey: 'Vui lòng nhập SID và SecretKey',
        saveSuccess: 'Lưu thành công',
        saveFailed: 'Lưu thất bại',
        configFailed: 'Cấu hình thất bại',
        parkingDeviceEnabled: 'Thiết bị bãi đỗ xe đã được bật',
        parkingDeviceDisabled: 'Thiết bị bãi đỗ xe đã được tắt',
        fetchHardwareRelationFailed: 'Lấy quan hệ liên kết phần cứng thất bại',
        fetchConfigFailed: 'Lấy cấu hình bãi đỗ xe thất bại',
    },
    roomOrderListVehicleDialog: {
        title: 'Biển số xe',
        platePlaceholder: 'Vui lòng nhập biển số xe',
        add: 'Thêm',
        plateNo: 'Biển số xe',
        enterPlateWarning: 'Vui lòng nhập biển số xe',
        enterPlateFormatWarning: 'Định dạng biển số xe không chính xác',
        addSuccess: 'Thêm thành công',
        deleteConfirm: 'Bạn có chắc muốn xóa biển số xe này không?',
        deleteSuccess: 'Xóa thành công',
    },
    roomOrderListDetail: {
        vehiclePlateNo: 'Biển số xe',
        saveFailed: 'Lưu thất bại',
        currentOrderRenewalFailed:
            'Đơn gia hạn hiện tại chưa thành công, không thể xem chi tiết đơn gia hạn',
        documentInfoNotFound: 'Không tìm thấy thông tin giấy tờ',
        cancelStay: 'Hủy gia hạn lưu trú',
        enterRemarkContent: 'Vui lòng nhập nội dung ghi chú',
        systemRemark: 'Ghi chú hệ thống',
        merchantRemark: 'Ghi chú khách sạn',
        originalStayOrder: 'Đơn gốc gia hạn',
        newStayOrder: 'Đơn mới gia hạn',
        continued: 'Gia hạn',
        downloadIdPhoto: 'Tải ảnh giấy tờ',
        uploadedToPolice: 'Đã tải lên hệ thống công an',
        reuploadToPolice: 'Tải lại lên hệ thống công an',
        cancelStaySuccess: 'Hủy gia hạn lưu trú thành công',
        enterNumber: 'Vui lòng nhập số lượng',
        liveOnCredit: 'Lưu trú tín dụng',
        duration: 'Thời lượng',
        invoice: 'Hóa đơn',
        roomInformation2: 'Thông tin phòng',
        numberOfGuests: 'Số khách lưu trú',
        doorLockCode: 'Mật khẩu khóa cửa',
        generatePassword: 'Tạo mật khẩu',
        resetPassword: 'Đặt lại mật khẩu',
        passwordInvalidation: 'Vô hiệu hóa mật khẩu',
        idNumber2: 'Số giấy tờ',
        guestAddress: 'Địa chỉ khách',
        theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
            'Hóa đơn của đơn hàng này do kênh bán hàng cung cấp cho khách',
        thisOrderIsInvoicedByYourHotelToTheGuest:
            'Hóa đơn của đơn hàng này do khách sạn của bạn cung cấp cho khách',
        originalOrder2: 'Đơn hàng gốc',
        swapOrder: 'Đổi đơn hàng',
        faceCollection: 'Thu thập khuôn mặt',
        invoice2: 'Xuất hóa đơn',
        sendPassword: 'Gửi mật khẩu',
        upgradeTheRoom: 'Nâng cấp phòng',
        extendStayadvance: 'Gia hạn/Trả phòng sớm',
        transferToFullDayRoom: 'Chuyển sang phòng cả ngày',
        decamping: 'Giảm người ở cùng',
        increaseCohabitation: 'Thêm người ở cùng',
        checkInSlip4: 'Phiếu đăng ký nhận phòng',
        reinstatement: 'Khôi phục nhận phòng',
        renewalOrder2: 'Đơn gia hạn',
        roomChangeConfirmationForm3: 'Phiếu xác nhận đổi phòng',
        conferenceCorps: 'Đoàn hội nghị',
        tourParty: 'Đoàn du lịch',
        confirmNeedToResumeCheckIn: 'Xác nhận khôi phục nhận phòng',
        operationReminder: 'Nhắc nhở thao tác',
        reinstatedCheckInSuccessful: 'Khôi phục nhận phòng thành công',
        fullDayRoomTransfersAreNotSupportedForOnlineOrders:
            'Đơn trực tuyến không hỗ trợ chuyển sang phòng cả ngày',
        whetherToCancelTheRowRoomAndTransferToTheFullDay:
            'Có hủy xếp phòng và chuyển sang phòng cả ngày không?',
        areYouSureYouWantToChangeToAFullDayRoom:
            'Bạn có chắc muốn chuyển sang phòng cả ngày không?',
        checkOutTimeWillBeChangedTo2:
            'Sau khi chuyển sang phòng cả ngày, thời gian trả phòng sẽ được điều chỉnh thành',
        theRoomIsIn: 'Phòng đang ở trạng thái',
        existingRowHouse: 'Đã được xếp phòng',
        conversionToFullDayRoomSuccessful:
            'Chuyển sang phòng cả ngày thành công',
        flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
            'Đơn FlyPig Credit Stay không hỗ trợ liên phòng',
        generatePassword2: 'Đang tạo mật khẩu',
        passwordGeneratedSuccessfully: 'Tạo mật khẩu thành công',
        areYouSureYouWantToResetYourCurrentPassword:
            'Bạn có chắc muốn đặt lại mật khẩu hiện tại không?',
        resetPassword2: 'Đang đặt lại mật khẩu',
        resetPasswordSuccessfully: 'Đặt lại mật khẩu thành công',
        areYouSureYouWantToInvalidateYourCurrentPassword:
            'Bạn có chắc muốn vô hiệu hóa mật khẩu hiện tại không?',
        thePasswordIsInvalid: 'Đang vô hiệu hóa mật khẩu',
        thePasswordIsInvalidProcedure: 'Vô hiệu hóa mật khẩu thành công',
        theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
            'Đã quá thời gian trả phòng, không hỗ trợ đổi phòng',
        theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
            'Đã quá thời gian trả phòng, không hỗ trợ nâng cấp phòng',
        theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
            'Đã quá 6 giờ sáng ngày trả phòng, không hỗ trợ nâng cấp phòng',
        theGuestHasAppliedForOnlineRenewalAndMayNotBeAbleToRenewTheOrder:
            'Khách đã đăng ký gia hạn trực tuyến, tiếp tục xử lý có thể không thực hiện được gia hạn đổi đơn',
        flyingPigCreditOrdersCanNotBeSustained2:
            'Đơn FlyPig Credit không hỗ trợ gia hạn lưu trú',
        itHasPassedTheCheckOutDateAndCannotBeExtended2:
            'Đã quá ngày trả phòng, không thể gia hạn lưu trú',
        successfulRoomExchange2: 'Đổi phòng thành công',
        upgradedRoomTypeData: 'Dữ liệu loại phòng được nâng cấp',
        theOtherRoomsInTheOrderHaveCheckedOutAndThecustomerTypeCannotBeModified:
            'Các phòng khác trong đơn đã trả phòng, không thể chỉnh sửa "Loại khách hàng"',
        theGuestHasAppliedForOnlineRenewalAndConfirmedTheNeedToContinueChangingRooms:
            'Khách đã đăng ký gia hạn trực tuyến, xác nhận tiếp tục đổi phòng?',
    },

    roomOrderListGroupRoomDetail: {
        contactNumber4: 'Số điện thoại liên hệ',
        aTotalOf: 'Tổng cộng',
        occupancyStatus: 'Tình trạng lưu trú',
        onAccount2: 'Đã ghi nợ',
        rollOut: 'Chuyển ra',
        setAsMaster: 'Đặt làm đơn chính',
        rescission: 'Hủy liên phòng',
        teamRegistrationSheet: 'Phiếu đăng ký đoàn',
        numberOfRooms: 'Số lượng phòng',
        confirmToCancelTheHouseRelationship:
            'Xác nhận hủy quan hệ liên phòng',
        successfullyDisconnectingTheHouse:
            'Hủy liên phòng thành công',
        rollOutSuccess: 'Chuyển ra thành công',
        setTheMasterOrderToSucceed:
            'Đặt làm đơn chính thành công',
    },

    roomOrderListMinusroomer: {
        residentGuest: 'Khách đang lưu trú',
        reduceRoommateSuccess:
            'Giảm người ở cùng thành công',
        decamping: 'Giảm người ở cùng',
        pleaseSelectTheNumberOfPeopleYouWantToReduce:
            'Vui lòng chọn khách cần giảm',
        keepAtLeastOneOccupantInTheRoom:
            'Phòng phải giữ lại ít nhất một khách lưu trú',
    },

    roomOrderListRelativeRoom: {
        roomOrder: 'Phiếu phòng',
        reservationOrder: 'Đơn đặt phòng',
        pendingCheckIn: 'Chờ nhận phòng',
        pleaseSelectARoomOrder: 'Vui lòng chọn phiếu phòng',
        linkRoomNumber: 'Mã liên phòng',
        inTheRoom: 'Phòng đang ở',
        residentialTeam: 'Đoàn đang lưu trú',
        flyingPigCreditDoesNotSupportHousing:
            'FlyPig Credit không hỗ trợ liên phòng',
        directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
            'Kênh kết nối trực tiếp không hỗ trợ tạo liên phòng hoặc đoàn với kênh khách sạn',
        guestsNameMobilePhoneNumberAndRoomNumber:
            'Tên khách, số điện thoại, số phòng',
        teamNameBookingPersonNameMobilePhoneNumber:
            'Tên đoàn, tên người đặt, số điện thoại',
        pleaseSelectATeam: 'Vui lòng chọn đoàn',
        joinTheTeamSuccessfully:
            'Tham gia đoàn thành công',
        joinTheRoomSuccessfully:
            'Tham gia liên phòng thành công',
    },

    roomOrderListRollin: {
        flyingPigCreditDoesNotSupportHousing:
            'FlyPig Credit không hỗ trợ liên phòng',
        directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
            'Kênh kết nối trực tiếp không hỗ trợ tạo liên phòng hoặc đoàn với kênh khách sạn',
        transferIn: 'Chuyển vào liên phòng',
        namePhoneNumberRoomNumber2:
            'Tên khách, số điện thoại, số phòng',
        succeededInJoiningTheHouse:
            'Tham gia liên phòng thành công',
    },
    roomOrderListRoomOrderDetail: {
        twinRooms: 'Phòng liên kết',
        roomList: 'Danh sách phòng',
        noRoomListingInformationAvailable: 'Không có thông tin phòng',
        manage: 'Quản lý',
        fullState: 'Tất cả trạng thái',
        finance3: 'Tài chính',
        preAuthorizationDetail: 'Chi tiết tiền ủy quyền trước',
        houseDetails: 'Chi tiết liên phòng',
        listingDetails: 'Chi tiết phòng',
        thereAreNoOccupants: 'Chưa có khách lưu trú',
    },

    roomOrderListRoomOrderList: {
        durationOfResidence: 'Thời gian lưu trú',
        bookingTime: 'Thời gian đặt phòng',
        room2: 'Phòng',
        doNotGift: 'Không tặng',
        nameMobilePhoneNumberOrderNumberChannelNumberQuery:
            'Tìm kiếm theo tên, số điện thoại, mã đơn hàng, mã đơn kênh',
        multipleSearch: 'Tìm kiếm tổng hợp',
        bonusPoints: 'Tặng điểm thưởng',
        subscriber: 'Người đặt phòng',
        subscriberNumber: 'Số điện thoại người đặt',
        areYouSureYouWantToGiveAwayPoints:
            'Bạn có chắc muốn tặng điểm thưởng không?',
        rewardPointsSuccessfully: 'Tặng điểm thưởng thành công',
        guestphone: 'Khách lưu trú/Số điện thoại',
        actualCheckoutTime: 'Thời gian trả phòng thực tế',
    },

    faceFacedialog: {
        faceCollection: 'Thu thập khuôn mặt',
        faceCollectionSuccess: 'Thu thập khuôn mặt thành công',
        faceCollectionFailure: 'Thu thập khuôn mặt thất bại',
        takeAPicture: 'Chụp ảnh',
        upload: 'Tải lên',
        upCross: 'Đang tải lên',
        uploadingPhotosPleaseCloseLater:
            'Đang tải ảnh lên, vui lòng đóng sau',
        pleaseTakeAPictureFirst: 'Vui lòng chụp ảnh trước',
        collectionSuccess: 'Thu thập thành công',
        collectionFailedPleaseTryAgain:
            'Thu thập thất bại, vui lòng thử lại!',
    },

    printtemplateChangeroom: {
        theOriginal: 'Ban đầu',
        changeDate: 'Ngày đổi phòng',
        roomRateUpgrade: 'Nâng cấp giá phòng:',
        roomRate: 'Giá phòng:',
    },

    printtemplateChangeroomprintsmall: {
        changeDate: 'Ngày đổi phòng',
        checkOutTime: 'Thời gian trả phòng',
        theOriginal: 'Ban đầu',
    },

    printtemplateGroupordertableprint: {
        position: 'Vị trí',
    },

    printtemplateStayinprint: {
        confidentiality: 'Bảo mật',
    },

    printtemplateStaymore: {
        departureDate: 'Ngày dự kiến trả phòng',
        newDepartureDate: 'Ngày trả phòng mới',
    },

    printtemplateStaymoreprint: {
        departureDate: 'Ngày dự kiến trả phòng',
        newDepartureDate: 'Ngày trả phòng mới',
    },

    noticeOrdernotice: {
        messageCenter: 'Trung tâm tin nhắn',
        orderInformation: 'Thông tin đơn hàng',
        dynamic: 'Tin động',
        settlement: 'Tin nhắn thanh toán',
        system: 'Tin nhắn hệ thống',
        noData: 'Chưa có tin nhắn mới',
        dynamicInformation: 'Thông tin động',
        systemInformation: 'Thông tin hệ thống',
        nightTrialFailTitle: 'Kiểm toán đêm thất bại',
        nightTrialFailContent: 'Kiểm toán đêm thất bại, vui lòng xử lý kịp thời.',
    },

    noticeServicemanage: {
        serviceManagement: 'Quản lý yêu cầu dịch vụ',
        roomService: 'Dịch vụ phòng',
        itemBorrow: 'Mượn vật dụng',
        extendStay: 'Dịch vụ gia hạn lưu trú',
    },

    operatelogLog: {
        nightAuditLog: 'Nhật ký kiểm toán đêm',
        downloadLog: 'Tải nhật ký',
        downloadSuccessfully: 'Tải xuống thành công',
    },

    operatelogNightauditlog: {
        nightTrialMethod: 'Phương thức kiểm toán đêm',
        nightTrialResult: 'Kết quả kiểm toán đêm',
        manualNightAudit: 'Kiểm toán đêm thủ công',
        automaticNightAudit: 'Kiểm toán đêm tự động',
        nightAuditFailure: 'Kiểm toán đêm thất bại',
        successfulNightAudit: 'Kiểm toán đêm thành công',
        nightTrialDate: 'Ngày kiểm toán đêm',
        nightAuditRecord: 'Lịch sử kiểm toán đêm',
    },

    operatelogWorkingday: {
        variableMode: 'Phương thức thay đổi',
    },
    financeAccountsreceivableaging: {
        bookName: 'Tên bộ sổ kế toán',
        totalAmountReceivable: 'Tổng công nợ phải thu',
        amountPayable030Days: 'Công nợ phải thu (0-30 ngày)',
        amountPayable3160Days: 'Công nợ phải thu (31-60 ngày)',
        amountPayable6190Days: 'Công nợ phải thu (61-90 ngày)',
        amountToBeCollected91DaysOrMore: 'Công nợ phải thu (trên 91 ngày)',
        typeOfExchange: 'Loại đổi phòng',
        originalRoomNumber: 'Số phòng ban đầu',
        existingRoomNumber: 'Số phòng hiện tại',
        currentHouseType: 'Loại phòng hiện tại',
        roomChangeTime: 'Thời gian đổi phòng',
        changeRoomsAfterCheckIn: 'Đổi phòng sau khi nhận phòng',
        originalRoomRate: 'Giá phòng ban đầu',
        spotRate: 'Giá phòng hiện tại',
    },

    financeAdjustmentCash: {
        financialStatement: 'Sổ giao dịch tài chính',
        occurrenceTime: 'Thời gian phát sinh',
        reconciliationStatement: 'Báo cáo điều chỉnh tài khoản',
    },

    financeAr: {
        channelReconciliationReport: 'Báo cáo đối soát kênh',
        writeOffStatus: 'Trạng thái đối trừ',
        amountOnCredit: 'Số tiền ghi nợ',
        estimatedSettlementPrice: 'Giá thanh toán ước tính',
        unapprovedAmount: 'Số tiền chưa đối soát',
        guestInvoiceRequirement: 'Yêu cầu hóa đơn của khách',
        roomNumbername: 'Số phòng/Tên',
    },

    financeBreakfastStatistic: {
        flatBreakfast: 'Bao gồm bữa sáng',
        advancePurchase: 'Mua bữa sáng',
        availableBreakfasts: 'Số suất ăn sáng khả dụng',
        verifiedBreakfasts: 'Bữa sáng đã xác nhận',
        breakfastAmount: 'Chi phí bữa sáng',
        breakfastStatisticsReport: 'Báo cáo thống kê bữa sáng',
        breakfastStatisticsReportxls: 'Báo cáo thống kê bữa sáng.xls',
    },

    financeChannelConsume: {
        typeOfCompany: 'Loại công ty',
        roomNights: 'Số đêm phòng',
    },

    financeCheckout: {
        checkOutBusinessDay: 'Ngày kinh doanh trả phòng',
        helpOneself: 'Tự sử dụng',
        team2: 'Đoàn',
        checkOutStatement: 'Báo cáo trả phòng và thanh toán',
    },

    financeCreatedCompanyAccountOfAge: {
        scale: 'Tỷ lệ',
        aged180DaysOrMore: 'Tuổi nợ trên 180 ngày',
        agingStatementOfCreditCompany: 'Báo cáo tuổi nợ công ty tín dụng',
        accountAge030Days: 'Tuổi nợ 0~30 ngày',
        accountAge3160Days: 'Tuổi nợ 31~60 ngày',
        accountAge6190Days: 'Tuổi nợ 61~90 ngày',
        accountAge91180Days: 'Tuổi nợ 91~180 ngày',
    },

    financeDemandAccount: {
        collectTheRoomChargeInAdvance: 'Thu trước tiền phòng',
        estimatedArrears: 'Khoản nợ dự kiến',
        collectionStatement: 'Báo cáo nhắc nợ',
    },

    financeHangAccount: {
        accountStatus: 'Trạng thái tài khoản',
        businessDayOfHangingAccount: 'Ngày kinh doanh ghi nợ',
        hangTheAccountOperator: 'Người thực hiện ghi nợ',
        currentBalance: 'Số dư hiện tại',
        closingTime: 'Thời gian thanh toán',
        noteOfHangingAccount: 'Ghi chú ghi nợ',
        temporaryDebitStatement: 'Báo cáo ghi nợ tạm thời',
        membercompany: 'Thành viên/Công ty',
    },

    financeInventoryInOut: {
        inOutDate: 'Ngày nhập/xuất kho',
        storageType: 'Hình thức nhập/xuất kho',
        storageTypeOut: 'Xuất kho',
        fileName: 'Báo cáo nhập xuất kho',
        columns: {
            inStoragePrice: 'Giá trị nhập kho',
            outStoragePrice: 'Giá trị xuất kho',
        },
    },

    financeHousekeeping: {
        cleaningDate: 'Ngày dọn phòng',
        cleanType: 'Loại dọn phòng',
        cleaner: 'Nhân viên vệ sinh',
        status: 'Trạng thái công việc',
        dailyCleaningAndLinen: 'Dọn phòng thường ngày + thay ga giường',
        dailyCleaning: 'Dọn phòng thường ngày',
        dispatchTime: 'Thời gian phân công',
        cleanTime: 'Thời gian dọn dẹp',
        checkRoomTime: 'Thời gian kiểm tra phòng',
        recleaningReason: 'Lý do dọn lại',
        checkerName: 'Giám sát kiểm tra phòng',
        statuses: {
            toBeCleared: 'Chờ dọn dẹp',
            finishCleaning: 'Hoàn thành dọn dẹp',
            noCleaning: 'Không cần dọn dẹp',
            cancelOrder: 'Hủy phân công',
            unauditedRoom: 'Chờ kiểm tra phòng',
            wardRoundRejection: 'Kiểm tra phòng không đạt',
        },
    },

    settingHousekeeping: {
        cleaners: 'Nhân viên vệ sinh',
        selectCleaners: 'Vui lòng chọn nhân viên vệ sinh',
        onDutyConfig: 'Cấu hình thời gian làm việc của nhân viên vệ sinh',
        roomAssign: 'Phân công phòng',
        assignMode: {
            free: 'Phân công tự do',
            byFloor: 'Phân theo tầng',
            byRoom: 'Phân theo phòng',
        },
        viewAssign: 'Xem phân công',
        cleanerPrefix: 'Vệ sinh:',
        autoDispatchConfig: 'Cấu hình tự động phân công dọn phòng',
        autoDispatch: {
            off: 'Tắt tự động phân công',
            on: 'Bật tự động phân công',
        },
        autoDispatchRoomType: 'Loại phòng tự động phân công',
        leaveRoom: 'Phòng trả',
        stayRoom: 'Phòng đang ở',
        dispatchRule: 'Quy tắc phân công',
        rules: {
            byTotal: 'Phân đều theo tổng số công việc của mỗi người',
            byPending: 'Phân đều theo số công việc đang chờ xử lý',
        },
        leaveCleanType: 'Loại dọn phòng tự động cho phòng trả',
        stayCleanType: 'Loại dọn phòng tự động cho phòng đang ở',
        dispatchTimeForStay: 'Thời gian phân công phòng đang ở',
        afterCleanCheck: 'Có cần kiểm tra phòng sau khi dọn không',
        needCheck: {
            no: 'Không cần',
            yes: 'Cần',
        },
        dialog: {
            assignRelation: 'Quan hệ phân công',
            selectFloor: 'Vui lòng chọn tầng',
        },
        messages: {
            selectCleaners: 'Vui lòng chọn nhân viên vệ sinh',
            dutyTimeInvalid:
                'Thời gian kết thúc ca làm việc không được sớm hơn thời gian bắt đầu',
        },
    },

    financeBreakfastDetails: {
        mealDate: 'Ngày dùng bữa',
        includeWaitingForCheckIn: 'Có thống kê phòng chờ nhận phòng hay không',
        title: 'Báo cáo chi tiết bữa sáng',
        columns: {
            guestNum: 'Số người',
            roomContainsBreakfastNum: 'Phòng bao gồm bữa sáng',
            buyBreakfastNum: 'Mua bữa sáng',
            useBreakfastNum: 'Số lượng đã sử dụng',
        },
    },

    breakfastVerification: {
        checkedInRoomList: 'Danh sách phòng đang ở',
        roomNo: 'Số phòng',
        breakfastCount: 'Số bữa sáng',
        verified: 'Đã xác nhận',
        buyBreakfast: 'Mua bữa sáng',
        verificationRecord: 'Bản ghi xác nhận',
        verificationTime: 'Thời gian xác nhận',
        cardReading: 'Đang đọc thẻ',
        swipeCardVerification: 'Quẹt thẻ xác nhận',
        breakfastVerification: 'Xác nhận bữa sáng',
        pendingBreakfast: 'Bữa sáng chờ xác nhận',
        verificationCount: 'Số lượng xác nhận',
        confirmVerification: 'Xác nhận',
        noRoomRead: 'Không đọc được thông tin phòng',
        cardReadFailed: 'Đọc thẻ thất bại. Vui lòng kiểm tra thẻ phòng hoặc đầu đọc thẻ.',
        noPendingBreakfast: 'Phòng này hiện không có bữa sáng chờ xác nhận',
        verificationCountPositive: 'Số lượng xác nhận phải lớn hơn 0',
        verificationCountExceedsPending: 'Số lượng xác nhận không được vượt quá số bữa sáng chờ xác nhận',
        verificationSuccess: 'Xác nhận thành công',
    },
    buyBreakfastDialog: {
        title: 'Mua bữa sáng',
        entryAccount: 'Tài khoản ghi nhận',
        count: 'Số lượng',
        totalAmount: 'Tổng tiền',
        payVerificationCode: 'Mã xác nhận thanh toán',
        positiveMoney: 'Vui lòng nhập số tiền lớn hơn 0, tối đa 2 chữ số thập phân',
        positiveInteger: 'Vui lòng nhập số nguyên lớn hơn 0',
        priceRequired: 'Vui lòng nhập đơn giá',
        countRequired: 'Vui lòng nhập số lượng',
        roomOrderNoMissing: 'Không lấy được số phiếu phòng, không thể mua bữa sáng',
        selectAccountSet: 'Vui lòng chọn bộ tài khoản',
        onlinePaymentFailed: 'Thu tiền trực tuyến thất bại',
        paymentIncomplete: 'Thanh toán chưa hoàn tất, chưa tạo ghi nhận bữa sáng',
        buySuccess: 'Mua bữa sáng thành công',
    },
    financeBreakfastVerificateDetail: {
        title: 'Báo cáo chi tiết xác nhận bữa sáng',
    },
    readDoorCardRoom: {
        lockNotConfigured: 'Chưa cấu hình khóa cửa hoặc khóa cửa chưa được bật',
        getLockInfoFailed: 'Lấy thông tin khóa cửa thất bại',
        readCardTimeout: 'Đọc thẻ quá thời gian, vui lòng kiểm tra đầu đọc thẻ',
        emptyCard: 'Thẻ này là thẻ trống, vui lòng tạo thẻ trước',
        notGuestCard: 'Thẻ này không phải thẻ khách, vui lòng tạo lại thẻ',
        readCardServiceFailed: 'Đọc thẻ thất bại, vui lòng liên hệ hỗ trợ kỹ thuật để kiểm tra dịch vụ phần cứng',
        readCardFailed: 'Đọc thẻ thất bại, vui lòng kiểm tra thẻ phòng hoặc đầu đọc thẻ',
        noRoomInfo: 'Không đọc được thông tin phòng',
        unsupportedLockReadMode: 'Chưa hỗ trợ phương thức đọc thẻ của khóa cửa hiện tại',
    },
    financePreauth: {
        authorizationStatus: 'Trạng thái ủy quyền',
        authorizationDate: 'Ngày ủy quyền',
        settlementDate: 'Ngày thanh toán',
        expirationDate: 'Ngày hết hạn',
        preAuthorizationStatement: 'Báo cáo ủy quyền trước',
        settlementTime: 'Thời gian thanh toán',
    },
    financeRedeemDetail: {
        dateType: 'Loại ngày',
        writeOffDate: 'Ngày đối trừ',
        dateOfPosting: 'Ngày ghi nợ',
        dateOfEntry2: 'Ngày hạch toán',
        bookType: 'Loại bộ sổ',
        businessDayOfHangingAccount: 'Ngày kinh doanh ghi nợ',
        hangTheAccountOperator: 'Người thao tác ghi nợ',
        theRoomNumberIsCharged: 'Số phòng ghi nợ',
        writeOffTheAmountCredited: 'Số tiền hạch toán đối trừ',
        writeOffTheEntryTime: 'Thời gian hạch toán đối trừ',
        writeOffTheAccountOperator: 'Người hạch toán đối trừ',
        amountWrittenOff2: 'Số tiền đối trừ',
        writeOffTime: 'Thời gian đối trừ',
        writeOffTheOperator: 'Người thực hiện đối trừ',
        channelWriteOffDetailReport: 'Báo cáo chi tiết đối trừ theo kênh',
    },

    financeRushCash: {
        financialStatement: 'Sổ giao dịch tài chính',
        occurrenceTime: 'Thời gian phát sinh',
        debitStatement: 'Báo cáo bù trừ công nợ',
    },

    financeSellRank: {
        agreementUnitConsumptionRankingTable:
            'Bảng xếp hạng tiêu dùng của đơn vị hợp đồng',
    },

    financeTodayGuestBalance: {
        roomFee3: 'Tiền phòng',
        balanceSheetForGuestsInResidence:
            'Bảng số dư khách đang lưu trú',
    },

    financeTransferCash: {
        turnOutOfRoom: 'Phòng chuyển đi',
        bookkeepingTime: 'Thời gian ghi sổ',
        turnIntoARoom: 'Phòng chuyển đến',
        transferTime: 'Thời gian chuyển khoản',
        transferStatement: 'Báo cáo chuyển khoản',
    },

    financeZeroRoomFee: {
        zeroRoomRateReport: 'Báo cáo phòng miễn phí',
    },

    incomeBaseprice: {
        totalRevenue: 'Tổng doanh thu',
        roomNight: 'Tổng đêm phòng',
        storeRevenue: 'Doanh thu khách sạn',
        interstoreNight: 'Đêm phòng khách sạn',
        directRevenuebasePrice: 'Doanh thu kết nối trực tiếp (giá gốc)',
        straightInternight: 'Đêm phòng kết nối trực tiếp',
        miniProgramRevenuebasePrice:
            'Doanh thu Mini Program (giá gốc)',
        smallProgramNight: 'Đêm phòng Mini Program',

        xinmeituanDirectRevenuebasePrice:
            'Doanh thu Meituan Direct mới (giá gốc)',
        newUnitedStatesGroupStraightInternight:
            'Đêm phòng Meituan Direct mới',

        ctripDirectRevenuebasePrice:
            'Doanh thu Ctrip Direct (giá gốc)',
        ctripDirectConnectionBetweenNight:
            'Đêm phòng Ctrip Direct',

        directRevenuebasePrice2:
            'Doanh thu Tongcheng Direct (giá gốc)',
        theSameJourneyDirectlyConnectedToTheNight:
            'Đêm phòng Tongcheng Direct',

        qunarDirectRevenuebasePrice:
            'Doanh thu Qunar Direct (giá gốc)',
        whereToGoStraightToTheNight:
            'Đêm phòng Qunar Direct',

        tiktokDirectRevenuebasePrice:
            'Doanh thu TikTok Direct (giá gốc)',
        tiktokStraightBetweenNight:
            'Đêm phòng TikTok Direct',

        flyingPigDirectRevenuebasePrice:
            'Doanh thu Fliggy Direct (giá gốc)',
        flyingPigsStraightInternight:
            'Đêm phòng Fliggy Direct',

        baiduMapRevenuebasePrice:
            'Doanh thu Baidu Maps (giá gốc)',
        baiduMapNight:
            'Đêm phòng Baidu Maps',

        jingdongDirectRevenuebasePrice:
            'Doanh thu JD Direct (giá gốc)',
        jingdongDirectConnectionBetweenNight:
            'Đêm phòng JD Direct',

        lightResidentialAndCommercialTravelRevenuebasePrice:
            'Doanh thu Qingzhu Business Travel (giá gốc)',
        lightStayBusinessNights:
            'Đêm phòng Qingzhu Business Travel',

        lightHomeDistributionRevenuebasePrice:
            'Doanh thu Qingzhu Distribution (giá gốc)',
        lightNightInTheDistributionRoom:
            'Đêm phòng Qingzhu Distribution',

        storeAdr: 'ADR khách sạn',

        usGroupEbRevenue: 'Doanh thu Meituan EB',
        usGroupEbNight: 'Đêm phòng Meituan EB',
        meituanEbadr: 'ADR Meituan EB',

        ctripEbRevenue: 'Doanh thu Ctrip EB',
        ctripEbNight: 'Đêm phòng Ctrip EB',
        ctripEbadr: 'ADR Ctrip EB',

        flyingPigEbRevenue: 'Doanh thu Fliggy EB',
        flyingPigEbNight: 'Đêm phòng Fliggy EB',
        ebadrTheFlyingPig: 'ADR Fliggy EB',

        douyinGroupPurchaseEbRevenue:
            'Doanh thu TikTok Group Buy EB',
        douyinGroupPurchaseEbNight:
            'Đêm phòng TikTok Group Buy EB',
        douyinGroupPurchaseEbadr:
            'ADR TikTok Group Buy EB',

        directAdrbasePrice:
            'ADR kết nối trực tiếp (giá gốc)',
        miniProgramAdrbasePrice:
            'ADR Mini Program (giá gốc)',
        newMeituanDirectAdrbasePrice:
            'ADR Meituan Direct mới (giá gốc)',
        directRouteAdrbasePrice:
            'ADR Ctrip Direct (giá gốc)',
        sameRouteDirectAdrbasePrice:
            'ADR Tongcheng Direct (giá gốc)',
        whereToDirectAdrbasePrice:
            'ADR Qunar Direct (giá gốc)',
        tiktokDirectAdrbasePrice:
            'ADR TikTok Direct (giá gốc)',
        flyingPigDirectAdrbasePrice:
            'ADR Fliggy Direct (giá gốc)',
        baiduMapAdrbasePrice:
            'ADR Baidu Maps (giá gốc)',
        jingdongDirectLinkAdrbasePrice:
            'ADR JD Direct (giá gốc)',
        lightResidentialAndBusinessAdrbasePrice:
            'ADR Qingzhu Business Travel (giá gốc)',
        lightLiveDistributionAdrbasePrice:
            'ADR Qingzhu Distribution (giá gốc)',
    },

    incomeExpense: {
        consumptionAccountStatisticsReport:
            'Báo cáo thống kê hạng mục tiêu dùng',
        accountId: 'ID tài khoản',
        roomNumbername: 'Số phòng/Tên',
    },
    incomeGuestSourceDetail: {
        selfUseRoom: 'Phòng sử dụng nội bộ',
        roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
            'Dữ liệu đêm phòng được thống kê theo ngày kinh doanh được truy vấn',
        calculationMode: 'Phương thức tính',
        guestCheckInDetailsReport:
            'Báo cáo chi tiết nguồn khách lưu trú',
        freeRoom: 'Phòng miễn phí',
        teamRoom: 'Phòng đoàn',
        singleRoom: 'Phòng dài hạn',
        roomRate2: 'Tiền phòng',
    },

    incomeHandleover: {
        shiftSummaryStatisticsReport:
            'Báo cáo thống kê tổng hợp bàn giao ca',
        income: 'Thu nhập',
        disburse: 'Chi tiêu',
        totalAmount: 'Tổng số tiền',
        shiftSummaryReport:
            'Báo cáo tổng hợp bàn giao ca',
    },

    incomeManageSingle: {
        category: 'Danh mục',
        today: 'Hôm nay',
        accumulatedThisMonth: 'Lũy kế tháng này',
        lastMonthCumulative:
            'Lũy kế cùng kỳ tháng trước',
        monthlyGrowthRate: 'Tỷ lệ tăng trưởng tháng',
        currentYearAccumulation:
            'Lũy kế năm nay',
        accumulatedInTheSamePeriodOfLastYear:
            'Lũy kế cùng kỳ năm trước',
        annualGrowthRate: 'Tỷ lệ tăng trưởng năm',

        operatingStatementsingleDay:
            'Báo cáo kinh doanh (Theo ngày)',

        operatingStatementOneDayxlsx:
            'Báo cáo kinh doanh theo ngày.xlsx',

        orderSourceBedNightsIncludeFreeRoomsAndSelfUsedRoomNights:
            'Đêm phòng theo nguồn đơn hàng: bao gồm phòng miễn phí và phòng tự sử dụng',

        rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
            'Tỷ lệ cho thuê (không tính phòng tự dùng và phòng miễn phí) = Số đêm phòng cho thuê (không tính phòng tự dùng và phòng miễn phí) / Tổng số phòng',

        totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
            'Tổng doanh thu phòng (bao gồm hoa hồng): không bao gồm phòng miễn phí và phòng tự dùng',

        youHaveNotOpenedThecustomerCheckInDetailsReportViewingPermission:
            'Bạn chưa được cấp quyền xem báo cáo chi tiết nguồn khách lưu trú',

        averageRoomRate:
            'ADR (không tính phòng tự dùng và phòng miễn phí) = Tổng doanh thu phòng / Số đêm phòng cho thuê (không tính phòng tự dùng và phòng miễn phí)',

        revparFormula:
            'RevPAR = Tổng doanh thu phòng / Tổng số phòng',

        totalRevenueFormula:
            'Tổng doanh thu = Tổng doanh thu phòng + Tất cả doanh thu khác (bao gồm hoa hồng, không bao gồm nạp tiền hội viên)',
    },

    incomeManageTotal: {
        generalLedger: 'Sổ cái',

        totalAverageRoomRateyuan:
            'ADR tổng (CNY)',

        rentalTotalRoomNightroom:
            'Tổng đêm phòng cho thuê',

        fullDayRoomNightroom:
            'Đêm phòng cả ngày',

        longBagRoomNightroom:
            'Đêm phòng dài hạn',

        hourRoomNightroom:
            'Đêm phòng theo giờ',

        teamRoomNightroom:
            'Đêm phòng đoàn',

        freeRoomNightroom:
            'Đêm phòng miễn phí',

        privateRoomNightroom:
            'Đêm phòng tự sử dụng',

        totalRoomRateyuan:
            'Tổng tiền phòng (CNY)',

        smallCommoditiesyuan:
            'Hàng hóa nhỏ (CNY)',

        mealFeeyuan:
            'Phí ăn uống (CNY)',

        serviceChargeyuan:
            'Phí dịch vụ (CNY)',

        membershipFeermb:
            'Phí hội viên (CNY)',

        otherExpensesyuan:
            'Chi phí khác (CNY)',

        totalRevenue:
            'Tổng doanh thu (CNY)',

        totalRevenueWithTax:
            'Tổng doanh thu (đã bao gồm thuế)',

        roomNightsroom:
            'Số đêm phòng',

        averageRoomRateyuan:
            'ADR (CNY)',

        totalRoomRateyuan2:
            'Tổng tiền phòng (CNY)',

        operatingStatementcumulative:
            'Báo cáo kinh doanh (Lũy kế)',

        theQueryTimeRangeCannotBeLongerThanOneYear:
            'Khoảng thời gian truy vấn không được vượt quá 1 năm',

        totalOccupancyRate:
            'Tỷ lệ lấp đầy tổng (%)',

        fullDayOccupancyRate:
            'Tỷ lệ lấp đầy phòng cả ngày (%)',

        hourlyOccupancyRate:
            'Tỷ lệ lấp đầy phòng theo giờ (%)',

        lettingRate:
            'Tỷ lệ cho thuê (%)',

        internightRatio:
            'Tỷ lệ đêm phòng (%)',

        totalRevpar:
            'REVPAR tổng (CNY)',

        cumulativeOperatingStatementxls:
            'Báo cáo kinh doanh lũy kế.xls',

        rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
            'Tỷ lệ cho thuê (không tính phòng tự dùng và phòng miễn phí) = Số đêm phòng cho thuê (không tính phòng tự dùng và phòng miễn phí) / Tổng số phòng',

        totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
            'Tổng doanh thu phòng (bao gồm hoa hồng): không bao gồm phòng miễn phí và phòng tự dùng',

        averageRoomRate:
            'ADR (không tính phòng tự dùng và phòng miễn phí) = Tổng doanh thu phòng / Số đêm phòng cho thuê (không tính phòng tự dùng và phòng miễn phí)',

        totalRevenueFormula:
            'Tổng doanh thu = Tổng doanh thu phòng + Tất cả doanh thu khác (bao gồm hoa hồng, không bao gồm nạp tiền hội viên)',
    },

    incomeOperatingIncome: {
        yesterdaysBalance: 'Số dư hôm qua',
        todaysBalance: 'Số dư hôm nay',

        statisticalStatementOfBusinessIncome:
            'Báo cáo thống kê doanh thu kinh doanh',

        totalconsumptionTotalPaymentTotal:
            'Tổng cộng = Tổng tiêu dùng - Tổng thanh toán',

        yesterdaysBalancetheHotelsCumulativeConsumptionTotalFromThePreviousBusinessDayMinusPaymentTotal:
            'Số dư hôm qua = Tổng tiêu dùng lũy kế của các ngày kinh doanh trước - Tổng thanh toán',

        todaysBalancetotalyesterdaysBalance:
            'Số dư hôm nay = Tổng cộng + Số dư hôm qua',
    },

    incomeOverduty: {
        category: 'Danh mục',
        firstLevelSubject: 'Hạng mục cấp 1',
        description: 'Mô tả',
        shiftStatisticsReport:
            'Báo cáo thống kê bàn giao ca',
    },

    incomePayExpense: {
        cashPaymentStatement3:
            'Báo cáo chi tiết tiêu dùng thanh toán tiền mặt',
        abstract: 'Diễn giải',
    },

    incomePayment: {
        paymentAccountStatisticsReport:
            'Báo cáo thống kê tài khoản thanh toán',
        submitted: 'Đã gửi',
        earlyMorningWatch: 'Ca đêm',
        roomNumberName: 'Số phòng - Tên',
        dateRangeCannotExceedThreeMonths: 'Khoảng thời gian truy vấn không được vượt quá 3 tháng',
    },

    incomeRoomTypeReport: {
        totalRoomRate: 'Tổng tiền phòng',
        numberOfOutages: 'Số phòng ngừng sử dụng',
        numberOfNightsForRent: 'Số đêm phòng cho thuê',

        roomTypeReport:
            'Báo cáo loại phòng',

        theEndTimeOfTheBusinessDayCannotExceedTheCurrentTime:
            'Thời gian kết thúc ngày kinh doanh không được vượt quá thời gian hiện tại',

        theSelectionPeriodCannotBeLongerThan31Days:
            'Khoảng thời gian lựa chọn không được vượt quá 31 ngày',
    },

    incomeSellercount: {
        roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
            'Dữ liệu đêm phòng được thống kê theo ngày kinh doanh được truy vấn',

        calculationMode: 'Phương thức tính',

        salesPerformanceStatement:
            'Báo cáo hiệu suất bán hàng',

        roomFee3: 'Tiền phòng',
    },
    incomeSmallwaredetail: {
        detailedSalesReportOfSmallGoods:
            'Báo cáo chi tiết bán hàng hóa nhỏ',
    },

    incomeSmallwaresummary: {
        summaryReportOfSmallCommoditySales:
            'Báo cáo tổng hợp bán hàng hóa nhỏ',
        averageUnitPrice: 'Đơn giá trung bình',
    },

    kanbanIndex: {
        yesterday: 'Hôm qua',
        last7Days: '7 ngày gần đây',
        lastWeek: 'Tuần trước',
        last30Days: '30 ngày gần đây',
        lastMonth: 'Tháng trước',

        managementProfile: 'Tổng quan kinh doanh',
        flowConversion: 'Chuyển đổi lưu lượng',
        serviceIndicator: 'Chỉ số dịch vụ',
        competitiveCircleAnalysis: 'Phân tích cạnh tranh',
        writeAReport: 'Soạn báo cáo',

        theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
            'Mốc thời gian thống nhất với ngày đã chọn, doanh thu đặt phòng được tính theo số tiền khách thực trả',

        operationPersonnelManagementOverviewSuggestions2:
            'Đề xuất tổng quan kinh doanh',

        theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
            'Mốc thời gian thống nhất với ngày đã chọn, bao gồm dữ liệu tổng hợp từ tất cả nền tảng Meituan, Ctrip và Fliggy',

        operationPersonnelFlowConversionSuggestions2:
            'Đề xuất tối ưu chuyển đổi lưu lượng',

        theTimeDimensionIsTheEndDateAndTheDayBeforeTheStartDateOfTheCurrentSelectedDateIncludingTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
            'Mốc thời gian là ngày kết thúc được chọn và ngày trước ngày bắt đầu, bao gồm dữ liệu tổng hợp từ tất cả nền tảng Meituan, Ctrip và Fliggy',

        operationPersonnelServiceIndicatorsSuggestions2:
            'Đề xuất cải thiện chỉ số dịch vụ',

        theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanAndCtrip:
            'Mốc thời gian thống nhất với ngày đã chọn, bao gồm dữ liệu tổng hợp từ tất cả nền tảng Meituan và Ctrip',

        operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
            'Đề xuất phân tích cạnh tranh',

        amountOfExposure: 'Lượt hiển thị',
        pageView: 'Lượt xem',
        orderQuantity: 'Số đơn đặt',
        myExposureCount: 'Lượt hiển thị của tôi',
        numberOfPeopleExposedInThePreviousIssue:
            'Lượt hiển thị kỳ trước',

        myExposureConversionRate2:
            'Tỷ lệ chuyển đổi hiển thị của tôi',

        previousExposureConversionRate2:
            'Tỷ lệ chuyển đổi hiển thị kỳ trước',

        myNumberOfViewers: 'Lượt xem của tôi',
        numberOfVisitorsInTheLastIssue:
            'Lượt xem kỳ trước',

        myConversionRate2:
            'Tỷ lệ chuyển đổi đơn hàng của tôi',

        conversionRateOfLastPeriodTransaction2:
            'Tỷ lệ chuyển đổi đơn hàng kỳ trước',

        paymentOrderNumber: 'Số đơn thanh toán',
        myPaymentOrderNumber:
            'Số đơn thanh toán của tôi',

        previousPaymentOrderNumber:
            'Số đơn thanh toán kỳ trước',
    },

    kanbanReportManage: {
        reportTitle: 'Tiêu đề báo cáo',
        reportWriter: 'Người viết báo cáo',
        reportDate: 'Ngày báo cáo',
        reportNumber: 'Mã báo cáo',
        draft: 'Bản nháp',
        haveReleased: 'Đã phát hành',
        reportTime: 'Thời gian báo cáo',
        exportDaily: 'Xuất báo cáo ngày',
    },

    kanbanSeeKanban: {
        dataBoard: 'Bảng dữ liệu',
        managementProfile: 'Tổng quan kinh doanh',

        operationPersonnelManagementOverviewSuggestions2:
            'Đề xuất tổng quan kinh doanh',

        flowConversion: 'Chuyển đổi lưu lượng',

        operationPersonnelFlowConversionSuggestions2:
            'Đề xuất tối ưu chuyển đổi lưu lượng',

        serviceIndicator: 'Chỉ số dịch vụ',

        operationPersonnelServiceIndicatorsSuggestions2:
            'Đề xuất cải thiện chỉ số dịch vụ',

        competitiveCircleAnalysis: 'Phân tích cạnh tranh',

        operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
            'Đề xuất phân tích cạnh tranh',

        theProportionOfSalesAmount:
            'Tỷ trọng doanh thu bán hàng',

        salesRoomNightProportion:
            'Tỷ trọng đêm phòng bán ra',

        noProposal: 'Chưa có đề xuất',
    },

    componentsDataReport: {
        compose: 'Soạn thảo',
        dataReport: 'Báo cáo dữ liệu',

        reportType: 'Loại báo cáo',
        pleaseSelectAReportType:
            'Vui lòng chọn loại báo cáo',

        dailyOperationReport:
            'Báo cáo vận hành hàng ngày',

        weeklyOperationsReport:
            'Báo cáo vận hành hàng tuần',

        monthlyOperatingReport:
            'Báo cáo vận hành hàng tháng',

        runCustomReports:
            'Báo cáo vận hành tùy chỉnh',

        reportTitle: 'Tiêu đề báo cáo',
        analysisDate: 'Ngày phân tích',

        businessDataAnalysisDimension:
            'Chiều phân tích dữ liệu kinh doanh',

        businessAnalysisAndSuggestion:
            'Phân tích và đề xuất kinh doanh',

        trafficAnalysisSuggestion:
            'Đề xuất phân tích lưu lượng',

        serviceIndicatorSuggestion:
            'Đề xuất chỉ số dịch vụ',

        competitiveCircleAnalysisSuggestion:
            'Đề xuất phân tích cạnh tranh',

        previewReport: 'Xem trước báo cáo',
        saveReport: 'Lưu báo cáo',
        saveReleaseReport:
            'Lưu và phát hành báo cáo',

        pleaseEnterTheTitleOfTheReport:
            'Vui lòng nhập tiêu đề báo cáo',

        pleaseEnterBusinessAnalysisSuggestions:
            'Vui lòng nhập đề xuất phân tích kinh doanh',

        pleaseEnterTrafficAnalysisSuggestions:
            'Vui lòng nhập đề xuất phân tích lưu lượng',

        pleaseEnterTheServiceIndicatorSuggestion:
            'Vui lòng nhập đề xuất chỉ số dịch vụ',

        pleaseEnterTheCompetitionCircleAnalysisSuggestion:
            'Vui lòng nhập đề xuất phân tích cạnh tranh',
    },

    componentsFlowLine: {
        myExposureConversionRate2:
            'Tỷ lệ chuyển đổi hiển thị của tôi',

        previousExposureConversionRate2:
            'Tỷ lệ chuyển đổi hiển thị kỳ trước',

        myConversionRate2:
            'Tỷ lệ chuyển đổi đơn hàng của tôi',

        conversionRateOfLastPeriodTransaction2:
            'Tỷ lệ chuyển đổi đơn hàng kỳ trước',

        exposureToViewConversionRate:
            'Tỷ lệ chuyển đổi từ hiển thị sang xem',

        browseToTheConversionRateOfTheTransaction:
            'Tỷ lệ chuyển đổi từ xem sang đặt phòng',
    },

    componentsRatioPieChart: {
        directConnection3: 'Kết nối trực tiếp',
    },

    competeCChannelData: {
        lostOrders: 'Số đơn bị mất',
        single: 'đơn',

        numberOfLostNights:
            'Số đêm phòng bị mất',

        lossAmount: 'Giá trị thất thoát',

        distanceFromMe:
            'Khoảng cách tới khách sạn',

        mark: 'Điểm đánh giá',
        startingPrice: 'Giá từ',

        theProportionOfLostOrders:
            'Tỷ lệ đơn hàng bị mất',

        drainType: 'Loại phòng bị mất khách',

        orderConversionRate:
            'Tỷ lệ chuyển đổi đơn đặt phòng',

        viewTheProportionOfUsers:
            'Tỷ lệ người dùng xem',

        finalPurchaseRatio:
            'Tỷ lệ mua cuối cùng',
    },

    flowFChart: {
        browseToTheConversionRateOfTheTransaction:
            'Tỷ lệ chuyển đổi từ xem sang đặt phòng',

        exposureToViewConversionRate:
            'Tỷ lệ chuyển đổi từ hiển thị sang xem',
    },
    flowFTable: {
        myHotel: 'Khách sạn của tôi',
        monthOnMonth: 'So với kỳ trước',
        onlinePaymentSingular: 'Số đơn thanh toán trực tuyến',
        single: 'đơn',
    },

    flowFlowTable: {
        payForOrderQuantity: 'Số lượng đơn thanh toán',
        exposureConversionRate: 'Tỷ lệ chuyển đổi hiển thị',
        transactionConversionRate: 'Tỷ lệ chuyển đổi giao dịch',
    },

    reportManageLog: {
        dataReportOperationLogs: 'Nhật ký thao tác báo cáo dữ liệu',
        logNumber: 'Mã nhật ký',
        operationName: 'Tên thao tác',
    },

    serveindexServeAnnularChart: {
        scoreDistributionGraph: 'Biểu đồ phân bố điểm đánh giá',
        article: 'mục',
        numberOfCommentsWithChart: 'Số đánh giá có hình ảnh',
        newBadReviewsThisPeriod: 'Đánh giá tiêu cực mới kỳ này: {num} mục',
        unrepliedBadReviews: 'Đánh giá tiêu cực chưa phản hồi: {num} mục',
    },

    serveindexServeRadarChart: {
        radarMap: 'Biểu đồ Radar',
    },

    serveindexServelist: {
        basicScore: 'Điểm cơ bản',
        awardPoints: 'Điểm thưởng',
        penaltyPoint: 'Điểm phạt',
    },

    situationSChannelTable: {
        salesNight: 'Đêm phòng bán ra',
        averageSalesRate: 'ADR bán hàng',
        consumptionNight: 'Đêm phòng tiêu dùng',
        averageHousePriceOfConsumption: 'ADR tiêu dùng',
        cancelNight: 'Đêm phòng hủy',
        cancellationRate: 'Tỷ lệ hủy',
        noSingleRoomNights: 'Đêm phòng từ chối',
        rejectRate: 'Tỷ lệ từ chối',
        onlinePermeability: 'Tỷ lệ thâm nhập trực tuyến',
        channelOnlineStatus: 'Trạng thái kênh trực tuyến',
        lightHoldTheDirectConnection: 'Kết nối trực tiếp EaseStay',
    },

    situationSGrid: {
        onAYearOnYearBasis: 'So với cùng kỳ',
        chainRatio: 'So với kỳ trước',
        cancellationRate: 'Tỷ lệ hủy',
        rejectRate: 'Tỷ lệ từ chối',

        theBookingAmountIncludesCancelledAndRejectedOrders:
            'Doanh thu đặt phòng bao gồm các đơn đã hủy và bị từ chối',

        reservationAmountCancelAndRejectOrders:
            'Doanh thu đặt phòng không bao gồm các đơn đã hủy và bị từ chối',

        accessSource: 'Nguồn truy cập',

        onlineChannelConsumptionBedNightstotalAvailableInventory:
            'Đêm phòng tiêu dùng từ kênh trực tuyến / Tổng tồn kho có thể bán',

        advanceBookingBedNightstotalSalesBedNights:
            'Đêm phòng đặt trước / Tổng đêm phòng bán ra',

        cancelBedNightssalesBedNights:
            'Đêm phòng hủy / Đêm phòng bán ra',

        rejectBedNightssalesBedNights:
            'Đêm phòng từ chối / Đêm phòng bán ra',
    },

    situationSalePieChart: {
        salesRoomNightProportion: 'Tỷ trọng đêm phòng bán ra',
        theProportionOfSalesAmount: 'Tỷ trọng doanh thu bán hàng',
    },

    orderDiscontinuedrooms: {
        operationalDowntime: 'Thời gian ngừng sử dụng',
        disableStartEndTime: 'Thời gian bắt đầu/kết thúc ngừng sử dụng',
        releaseTime2: 'Thời gian khôi phục',
        inactiveRoomReport: 'Báo cáo phòng ngừng sử dụng',
        deactivationOperator: 'Người thao tác ngừng sử dụng',
        releaseOperator: 'Người khôi phục',
        normalExchange: 'Đổi phòng thông thường',
        freeUpgrade: 'Nâng hạng miễn phí',
        chargeEscalation: 'Nâng hạng có thu phí',
    },

    orderGuest: {
        reportType2: 'Loại báo cáo',
        sameDayCheckIn: 'Nhận phòng trong ngày',
        sameDayCheckOut: 'Trả phòng trong ngày',
        dailyArrivalsAndDepartures: 'Nhận và trả phòng trong ngày',
        contractCompany: 'Công ty hợp đồng',
        firstDayRate: 'Giá phòng ngày đầu',
        nation2: 'Quốc gia',
        roomListRemarks: 'Ghi chú phòng',
        guestStatement: 'Báo cáo lưu trú khách hàng',
    },

    orderRoomChange: {
        unterracedHouse: 'Chưa xếp phòng',

        typeOfExchange: 'Loại đổi phòng',

        normalExchange: 'Đổi phòng thông thường',
        freeUpgrade: 'Nâng hạng miễn phí',
        chargeEscalation: 'Nâng hạng có thu phí',

        originalRoomNumber: 'Số phòng cũ',
        existingRoomNumber: 'Số phòng mới',
        currentHouseType: 'Loại phòng hiện tại',

        roomChangeTime: 'Thời gian đổi phòng',
        changeRoomsAfterCheckIn: 'Đổi phòng sau khi nhận phòng',

        originalRoomRate: 'Giá phòng cũ',
        spotRate: 'Giá phòng mới',
    },

    checkInIndex: {
        viewListingDetails: 'Xem chi tiết phòng',

        message: 'Thông tin',

        individualStepIntoSuccess:
            'Khách lẻ nhận phòng thành công',

        automaticallyRedirectsToListingDetails:
            'Tự động chuyển đến trang chi tiết phòng',

        successfulCodeScanning:
            'Quét mã thành công',

        thereIsNoCorrespondingProductForTheCurrentRoomType:
            'Hiện không có sản phẩm tương ứng cho loại phòng này',

        memberBalanceIs:
            'Số dư hội viên là',

        pleaseSelectAnotherRecipient:
            'VND, vui lòng chọn phương thức thu khác',
    },
    checkInNewindex: {
        committedParameter: 'Tham số đã gửi',
        individualStepIntoSuccess:
            'Khách lẻ nhận phòng thành công',
    },

    checkInRoomerItem: {
        moreInformation: 'Thông tin thêm',
        number: 'Số',
    },

    componentsBookertypesearch: {
        pleaseEnterTheMemberInformationYouWantToQuery:
            'Vui lòng nhập thông tin hội viên cần tra cứu',

        enterTheInformationAboutTheProtocolUnitToBeQueried:
            'Vui lòng nhập thông tin đơn vị hợp đồng cần tra cứu',
    },

    componentsDepositsection: {
        selectPaymentMethod:
            'Chọn phương thức thanh toán',
    },

    componentsOpenpagetemplate: {
        conditionOfTheHouse2:
            'Trạng thái phòng',
    },

    componentsProductsection: {
        noProductAvailableOnBookingDateForThisRoomType:
            'Không tìm thấy sản phẩm cho loại phòng này trong ngày đặt phòng',
    },

    componentsRoomerItem: {
        moreInformation: 'Thông tin thêm',

        genderBirthday:
            'Giới tính - Ngày sinh',

        nationalityNationality:
            'Quốc tịch - Dân tộc',

        pleaseEnterTheFullAddress2:
            'Vui lòng nhập địa chỉ chi tiết',

        validityPeriod:
            'Thời hạn hiệu lực',
    },

    utilsLehuimixin: {
        viewListingDetails:
            'Xem chi tiết phiếu phòng',

        automaticallyRedirectsToListingDetails:
            'Tự động chuyển đến chi tiết phiếu phòng',

        successfulCodeScanning:
            'Quét mã thành công',

        callbackRoute:
            'Tuyến đường callback',

        checkInSuccessful:
            'Nhận phòng thành công',

        listingDetails:
            'Chi tiết phiếu phòng',

        orderDetails:
            'Chi tiết đơn hàng',
    },

    utilsUtils: {
        noProductAvailableOnBookingDateForThisRoomType:
            'Không tìm thấy sản phẩm cho loại phòng này trong ngày đặt phòng',

        thisRoomTypeIsSoldOutWithinTheBookingDate:
            'Loại phòng này đã hết phòng trong khoảng thời gian đặt',

        noPriceIsSetForThisRoomTypeDuringTheBookingDate:
            'Loại phòng này chưa được thiết lập giá trong khoảng thời gian đặt',

        memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
            'Số dư hội viên không đủ, vui lòng chọn phương thức thanh toán khác',
    },

    componentsAuthcode: {
        laterOn: 'Sau',
        verificationCodeSentSuccessfullyPleaseNoteThatCheck:
            'Mã xác minh đã được gửi thành công, vui lòng kiểm tra',
    },

    componentsBookingcommonmixin: {
        reset: 'Đặt lại',
    },

    componentsBookingmixin: {
        nineHours: '9 giờ',
        tenHours: '10 giờ',
        elevenHours: '11 giờ',
        twelveHours: '12 giờ',

        hourStore:
            'Giờ - Khách sạn',

        noRoomTypesAvailable:
            'Hiện không có loại phòng khả dụng',

        houseList:
            'Danh sách xếp phòng',

        totalPrice:
            'Tổng giá',
    },

    componentsLimitinput: {
        insufficientStock:
            'Tồn kho không đủ',
    },

    componentsMembersearch: {
        memberInformationDoesNotExistOrHasBeenDisabled:
            'Thông tin hội viên không tồn tại hoặc đã bị vô hiệu hóa',

        pleaseEnterTheMemberInformationYouWantToQuery3:
            'Vui lòng nhập thông tin hội viên cần tra cứu',

        memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
            'Số dư hội viên không đủ, vui lòng chọn phương thức thanh toán khác',

        theMembersMobilePhoneNumberIsIncorrectAndTheStoredValuePaymentCannotBeUsed:
            'Số điện thoại hội viên không chính xác, không thể sử dụng thanh toán bằng số dư lưu trữ',

        memberNamephoneNumbermembershipNumber:
            'Tên hội viên / Số điện thoại / Số thẻ',
    },

    componentsPaytip: {
        memberPaymentFailure:
            'Thanh toán hội viên thất bại',

        pleaseReEnterTheAccount:
            'Vui lòng ghi sổ lại',
    },

    futureIndex: {
        roomTypeSummary:
            'Tổng hợp loại phòng',

        roomDetail:
            'Chi tiết phòng',
    },

    futureSummary: {
        soldNumberavailableNumberoverSoldNumberdisabledNumber:
            'Đã bán / Có thể bán (Quá bán) / Ngừng sử dụng',

        totalNumberOfRoomsPhysicalTotalNumberOfRooms:
            'Tổng số phòng: Tổng số phòng vật lý của khách sạn',

        availableNumberTotalNumberOfRoomsSoldNumberDisabledNumberFullDayRoomOverSoldNumber:
            'Số phòng có thể bán = Tổng số phòng - Đã bán - Ngừng sử dụng + Quá bán phòng cả ngày',

        disabledNumberNumberOfDisabledRoomsInTheHotel:
            'Số phòng ngừng sử dụng: Số phòng bị khóa/ngừng sử dụng trong khách sạn',

        soldNumberRoomsBookedOnTheDayRoomsCurrentlyOccupiedOnTheDayWithoutTodaysDepartureAndClockRoom:
            'Số phòng đã bán: Phòng được đặt trong ngày + Phòng đang ở trong ngày (không bao gồm phòng trả trong ngày và phòng theo giờ)',
    },

    groupbookingIndex: {
        pleaseEnterTeamName:
            'Vui lòng nhập tên đoàn',

        memberBalanceNotEnough:
            'Số dư hội viên là {balance} VND, vui lòng chọn phương thức thanh toán khác',

        bookingRoomCannotBeZero:
            'Số lượng phòng đặt không được bằng 0',

        roomTypeStockNotEnough:
            'Tồn kho loại phòng không đủ',

        pleaseEnterContractNo:
            'Vui lòng nhập số hợp đồng',

        remarkPlaceholder:
            'Tối đa 150 ký tự',

        discountPricePlaceholder:
            'Vui lòng nhập giá ưu đãi',

        leftRoomsTip:
            'Còn {count} phòng chưa được xếp',

        searchMemberPlaceholder:
            'Tên / Số điện thoại / Mã hội viên',

        groupBooking:
            'Đặt phòng đoàn',

        contractNumber:
            'Số hợp đồng',

        teamBookingSuccessful:
            'Đặt phòng đoàn thành công',
    },

    longbookingIndex: {
        singleRoom:
            'Phòng dài hạn',
    },

    longbookingProductionlist: {
        houseList:
            'Danh sách xếp phòng',

        inAddition:
            'Ngoài ra còn',
    },

    onlinedataIndex: {
        chainRatio:
            'So với kỳ trước',

        onAYearOnYearBasis:
            'So với cùng kỳ',

        theDirectConnectionChannelHasNotBeenOpenedInOrderToPreventTheLossOfOrdersPleaseContactTheOperationManagerAsSoonAsPossibleToOpenTheDirectConnectionChannel:
            'Kênh kết nối trực tiếp chưa được kích hoạt. Để tránh mất đơn hàng, vui lòng liên hệ quản lý vận hành để kích hoạt sớm nhất có thể',

        relevance:
            'Liên kết',

        onlineRevenue:
            'Doanh thu trực tuyến',

        onlineNight:
            'Đêm phòng trực tuyến',

        channelProportion:
            'Tỷ lệ kênh',

        channelOnlineStatus:
            'Trạng thái kênh trực tuyến',

        directConnection3:
            'Kết nối trực tiếp',

        temporarilyWithoutAuthority:
            'Tạm thời không có quyền',

        totalOnlineRevenue:
            'Tổng doanh thu trực tuyến',

        onlineTotalNight:
            'Tổng đêm phòng trực tuyến',

        online:
            'Trực tuyến',

        thisEbAccountIsNotBoundPleaseBindEbAccountInEbAccountManagement:
            'Tài khoản EB chưa được liên kết, vui lòng liên kết trong mục Quản lý tài khoản EB',
    },
    realTimeIndex: {
        allBuildings: 'Tất cả tòa nhà',
        allFloors: 'Tất cả tầng',

        depositShort: 'Cọc',
        roomRateShort: 'Giá',
        totalShort: 'Tổng',
        preAuthShort: 'Ủy quyền',
        balanceShort: 'Dư',

        powerOff: 'Ngắt',
        powerOn: 'Bật',

        new2: 'Mới',
        al: 'Liên',

        openChannelsForDirectConnection: 'Mở kênh kết nối trực tiếp',
        createRoomType: 'Tạo loại phòng',
        createARoom: 'Tạo phòng',

        renewalOrder2: 'Đơn gia hạn',
        roomChangeConfirmationForm3: 'Phiếu xác nhận đổi phòng',
        checkInSlip4: 'Phiếu đăng ký nhận phòng',

        whenExtendingYourStayTheRoomPriceDisplayedIsForTheFirstDayOfTheExtendedStayWhenCheckingOutEarlyOrChangingTheExpectedDepartureTimeThePriceDisplayedIsForTheLastNight2:
            'Khi gia hạn lưu trú, giá phòng hiển thị là giá của ngày đầu tiên gia hạn; khi trả phòng sớm hoặc thay đổi thời gian dự kiến trả phòng, giá hiển thị là giá của đêm cuối cùng',

        friendlyReminderPleaseMakeSureToDoubleCheckAllTheDetailsAndThenSignForConfirmationAfterChangingRoomsRememberToTakeYourPersonalBelongingsFromTheOriginalRoom3:
            'Lưu ý: Vui lòng kiểm tra kỹ mọi thông tin trước khi ký xác nhận. Sau khi đổi phòng, nhớ mang theo toàn bộ đồ dùng cá nhân từ phòng cũ',

        continuationRoomsShowTheFirstDayPrice2:
            'Phòng gia hạn hiển thị giá của ngày đầu tiên',

        friendlyReminderPleaseDoubleCheckAllTheDetailsAndSignForConfirmationDontForgetToTakeYourPersonalBelongings3:
            'Lưu ý: Vui lòng kiểm tra kỹ mọi thông tin trước khi ký xác nhận và nhớ mang theo đồ dùng cá nhân',

        liveLightlyInTheDirectCamp: 'Light Stay Trực tiếp',
        whereToConnectDirectly: 'Kết nối trực tiếp Qunar',
        baiduMap: 'Baidu Maps',
        jingdong: 'JD.com',

        flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
            'Đơn FlyPig Credit Stay không hỗ trợ liên phòng',

        flyingPigCreditOrdersCanNotBeSustained2:
            'Đơn FlyPig Credit Stay không hỗ trợ gia hạn lưu trú',

        itHasPassedTheCheckOutDateAndCannotBeExtended2:
            'Đã quá ngày trả phòng, không thể gia hạn lưu trú',

        theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
            'Đã quá thời gian trả phòng, không hỗ trợ nâng hạng phòng',

        theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
            'Đã quá 6 giờ sáng của ngày trả phòng, không hỗ trợ nâng hạng phòng',

        theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
            'Đã quá thời gian trả phòng, không hỗ trợ đổi phòng',

        successfulRoomExchange2:
            'Đổi phòng thành công',

        successfulDisposal:
            'Đánh dấu phòng bẩn thành công',

        cleanAndSuccessful:
            'Đánh dấu phòng sạch thành công',

        deactivateSuccessfully:
            'Hủy ngừng sử dụng thành công',

        temporaryPassword:
            'Mật khẩu tạm thời',

        thisPasswordIsValidFor30MinutesAndExpiresImmediatelyAfterUse:
            'Mật khẩu này có hiệu lực trong 30 phút và sẽ hết hiệu lực ngay sau khi sử dụng',

        quickSearch:
            'Tìm nhanh theo số phòng hoặc tên',

        batchModify:
            'Thay đổi trạng thái phòng hàng loạt',

        ignore:
            'Bỏ qua',

        goAndOperate:
            'Đi xử lý',

        bookingInfo:
            'Thông tin đặt phòng chờ nhận phòng',

        orderNo:
            'Mã đơn hàng',

        channelName:
            'Tên kênh',

        bookerName:
            'Tên người đặt phòng',

        arrivalTime:
            'Thời gian dự kiến đến',

        roomRate:
            'Giá phòng',
    },

    realTimeServicemsg: {
        dateOfService: 'Ngày dịch vụ',

        applicationTime2:
            'Thời gian yêu cầu',

        serviceType:
            'Loại dịch vụ',

        serviceTime:
            'Thời gian phục vụ',

        serviceSuccess:
            'Phục vụ thành công',

        serviceFailure:
            'Phục vụ thất bại',

        serviceCompletion:
            'Hoàn thành phục vụ',

        theRoomRequestHasBeenServiced:
            'Yêu cầu dịch vụ phòng đã được hoàn thành',
    },

    componentsCommon: {
        roomBalance: 'Số dư phòng',

        depositWithPreAuth:
            'Tiền cọc (bao gồm tiền ủy quyền trước)',

        madeCardCount:
            'Số thẻ đã tạo',

        stayOver:
            'Gia hạn',

        checkOut4:
            'Trả phòng',

        temporaryPassword:
            'Mật khẩu tạm thời',

        sendPassword:
            'Gửi mật khẩu',

        muck:
            'Đánh dấu bẩn',

        setAside:
            'Đánh dấu sạch',

        deactivate:
            'Hủy ngừng sử dụng',

        faceEast:
            'Hướng Đông',

        faceWest:
            'Hướng Tây',

        faceSouth:
            'Hướng Nam',

        faceNorth:
            'Hướng Bắc',

        decorativeFalseWindow:
            'Cửa sổ giả trang trí',

        stayAwayFromElevators:
            'Xa thang máy',

        nearTheStairs:
            'Gần cầu thang',

        closeToTheRoad:
            'Gần đường',

        windowWall:
            'Ngoài cửa sổ là tường',

        bedTypeDescription:
            'Mô tả loại giường',

        guestControl:
            'Điều khiển phòng thông minh',

        latestCheckIn:
            'Lần lưu trú gần nhất',

        noHistoricalCheckInInfo:
            'Phòng này không có thông tin lịch sử lưu trú',

        temporaryMakeCard:
            'Tạo thẻ tạm thời',

        validDoorCard:
            'Thẻ phòng còn hiệu lực',

        createTime:
            'Thời gian tạo',
    },

    componentsEmpty: {
        searchNull:
            'Không có kết quả tìm kiếm',
    },

    componentsGrouphandle: {
        batchModify:
            'Thay đổi trạng thái phòng hàng loạt',

        pleaseSelectAnActiveArea:
            'Vui lòng chọn khu vực hoạt động',

        selectStartDate:
            'Chọn ngày bắt đầu',

        selectEndDate:
            'Chọn ngày kết thúc',

        emptyCleanToEmptyDirty:
            'Phòng trống sạch → Phòng trống bẩn',

        emptyDirtyToEmptyClean:
            'Phòng trống bẩn → Phòng trống sạch',

        stayCleanAndTurnDirty:
            'Phòng ở sạch → Phòng ở bẩn',

        stayDirtyAndTurnClean:
            'Phòng ở bẩn → Phòng ở sạch',

        batchOutage:
            'Ngừng sử dụng hàng loạt',

        batchDeactivation:
            'Hủy ngừng sử dụng hàng loạt',

        pleaseEnterTheStartTime:
            'Vui lòng nhập thời gian bắt đầu',

        pleaseEnterTheEndTime:
            'Vui lòng nhập thời gian kết thúc',

        pleaseSelectTheRoomForBatchOperation:
            'Vui lòng chọn phòng cần thao tác hàng loạt',

        batchOperationSuccessful:
            'Thao tác hàng loạt thành công',

        whetherToConfirmTheDeactivationBatchDeactivationIncludesrowRooms:
            'Xác nhận ngừng sử dụng? Danh sách có bao gồm các phòng đã được xếp phòng',
    },

    componentsHourcheckinconfirm: {
        checkInTimeConfirmation:
            'Xác nhận thời gian nhận phòng',

        continuousHousing:
            'Tiếp tục xếp phòng',

        theArrivalTimeHasBeenExceededPleaseConfirmTheGuestCheckInTime:
            'Đã vượt quá thời gian dự kiến đến, vui lòng xác nhận thời gian nhận phòng của khách',

        itHasBeenOccupiedPleaseManuallyArrangeTheRoomAfterFurtherProcessing:
            'Phòng đã được sử dụng, sau khi tiếp tục xử lý vui lòng xếp phòng thủ công',
    },

    componentsOperationlog: {
        operationRecord:
            'Nhật ký thao tác',
    },

    componentsStopservice: {
        successfulDeactivation:
            'Ngừng sử dụng thành công',

        selectStartDate:
            'Chọn ngày bắt đầu',

        selectEndDate:
            'Chọn ngày kết thúc',

        noteAtLeast3Words:
            'Ghi chú tối thiểu 3 ký tự',
        startMustAfterNow: 'Ngày bắt đầu phải lớn hơn hoặc bằng ngày hiện tại',
        endMustAfterStart: 'Ngày kết thúc phải lớn hơn ngày bắt đầu',
    },
    serviceHandle: {
        accept: 'Chấp nhận',
        turnDown2: 'Từ chối',
        serviceProcessing: 'Xử lý dịch vụ',
        whetherToProcess: 'Có xử lý hay không',
        reasonForRefusal: 'Lý do từ chối',
        pleaseEnterTheReasonForTheRejection: 'Vui lòng nhập lý do từ chối',
        accepted: 'Đã chấp nhận',
        denialOfService: 'Từ chối dịch vụ',
    },

    sankebookingArrangeroom: {
        noRoomAvailablePleaseConfirmAndTryAgain: 'Không có phòng khả dụng, vui lòng xác nhận và thử lại',
        upgradeNumberOfRooms: 'Số lượng phòng nâng cấp',
        pleaseEnterRoomChangeRemarks: 'Vui lòng nhập ghi chú đổi phòng',
        conditionOfTheHouse2: 'Trạng thái phòng',
        pleaseSelectTheRoomYouWantToUpgrade: 'Vui lòng chọn phòng cần nâng cấp',
        thereAreCurrentlyNoRoomTypesAvailableForUpgrade: 'Hiện không có loại phòng nào có thể nâng cấp',
        theNumberOfRowRoomsCannotBeGreaterThanTheNumberOfReservedRooms: 'Số lượng phòng được xếp không được lớn hơn số lượng phòng đã đặt',
        thisRoomTypeIsNotOnline: 'Loại phòng này chưa được mở bán',
        hourProductPleaseSelectAnotherRoomType: 'Sản phẩm phòng theo giờ, vui lòng chọn loại phòng khác',
        thisRoomType: 'Loại phòng này',
        productsAreSoldOutPleaseChooseAnotherRoomType: 'Sản phẩm phòng theo giờ đã hết, vui lòng chọn loại phòng khác',
        noPriceIsSetForTheHourProductPleaseSelectAnotherRoomType: 'Sản phẩm phòng theo giờ chưa được thiết lập giá, vui lòng chọn loại phòng khác',
        yourUpgradedRoomTypeIsAllThatIsLeft: 'Loại phòng nâng cấp bạn chọn chỉ còn',
        pleaseChangeToAnotherRoomTypeOrReduceTheNumberOfRoomUpgrades: 'phòng, vui lòng chọn loại phòng khác hoặc giảm số lượng phòng nâng cấp',
    },

    sankebookingIndex: {
        channelOrderRoomType: 'Loại phòng đặt từ kênh',
        operationPrompt: 'Nhắc nhở thao tác',
        furtherBooking: 'Tiếp tục đặt phòng',
        thisOrderHasAlreadyBeenBookedPleaseDoNotRepeat: 'Đơn hàng này đã được đặt phòng, vui lòng không thao tác lại',
        floorPriceModel: 'Chế độ giá đáy',
        sellingPriceModel: 'Chế độ giá bán',
        theNumberOfReservedRoomsCannotBe: 'Số lượng phòng đặt không được là',
        reservationNumber: 'Số lượng đơn đặt phòng',
        inAddition: 'Còn',
        useEbInformation: 'Sử dụng thông tin EB',
        useEbOrderInformation: 'Sử dụng thông tin đơn hàng EB',
        theNumberOfBookingRoomsIsInconsistentWithTheNumberOfChannelOrdersWhetherToContinueBooking:
            'Số lượng phòng đặt không khớp với số lượng phòng trong đơn hàng kênh, có tiếp tục đặt phòng không?',
        thisOrderCannotBeBooked: 'Đơn hàng này không thể đặt phòng',
    },

    activityData: {
        dailySpecial: 'Ưu đãi đặc biệt mỗi ngày',
        keepPricesLow: 'Duy trì giá thấp',
        motivateUsersToBuyMore: 'Khuyến khích khách đặt nhiều hơn',
        earlyRush: 'Thu hút khách đặt sớm',
    },

    componentsActivitydetail: {
        discount: 'Giảm giá',

        promotionInfo:
            'Sau khi đăng ký chương trình thành công, chương trình sẽ có hiệu lực ngay. Trong thời gian diễn ra chương trình, khách sạn có thể chỉnh sửa hoặc rút khỏi chương trình, tuy nhiên các đơn hàng đã hoàn tất vẫn được áp dụng theo quy định hiện hành. Giá gốc của loại phòng tham gia chương trình không được cao hơn giá trên các kênh khác, nếu không có thể không được hiển thị.',

        offerDetails:
            'Các loại phòng tham gia chương trình có giá trước khuyến mãi không cao hơn các kênh khác sẽ nhận được nhiều cơ hội hiển thị hơn. Khuyến nghị chọn loại phòng có giá thấp nhất tham gia để nhận được nhiều lưu lượng truy cập hơn.',

        backToActivityList: 'Quay lại danh sách chương trình',
        quantitySold: 'Số lượng bán',
        sellLowEachNight: 'Giảm giá mỗi đêm',

        pleaseSelectAnEventProduct:
            'Vui lòng chọn sản phẩm tham gia chương trình',

        noRoomTypeInformationAvailable:
            'Không có thông tin loại phòng',

        productsHaveBeenSelectedForTheEvent:
            'Đã chọn sản phẩm tham gia chương trình',

        selectOffer: 'Chọn ưu đãi',

        iHaveReadAndAgree:
            'Tôi đã đọc và đồng ý',

        activityRelatedClause:
            'Điều khoản liên quan đến chương trình',

        selectedOffer:
            'Ưu đãi đã chọn',

        signUpNow:
            'Đăng ký ngay',

        activeTime:
            'Thời gian chương trình',

        activityProfile:
            'Giới thiệu chương trình',

        activityRequirement:
            'Yêu cầu chương trình',

        preferentialDetails:
            'Chi tiết ưu đãi',

        specialSpecification:
            'Quy định đặc biệt',

        entryAndExitRules:
            'Quy tắc tham gia và rút khỏi',

        costAttribution:
            'Phân bổ chi phí',

        midAutumnFestival:
            'Tết Trung Thu',

        specialProduct:
            'Sản phẩm đặc biệt',

        areYouSureYouWantToCommitYourChanges:
            'Bạn có chắc chắn muốn lưu thay đổi không?',

        pleaseSelectTheRoomTypeToParticipateInTheEvent:
            'Vui lòng chọn loại phòng tham gia chương trình',

        pleaseSelectDiscount:
            'Vui lòng chọn mức giảm giá',

        pleaseReadAndAgreeToTheTermsOfTheEvent:
            'Vui lòng đọc và đồng ý với các điều khoản của chương trình',

        successfulRegistration:
            'Đăng ký thành công',
    },

    componentsSelfactivitylist: {
        expired:
            'Đã hết hạn',

        copyPromotion:
            'Sao chép khuyến mãi',

        promotionType:
            'Loại khuyến mãi',

        marginOfPreference:
            'Mức ưu đãi',

        eventDate:
            'Ngày diễn ra chương trình',

        beOffline:
            'Đã ngừng hoạt động',

        merchantsPushThemselvesOffline:
            'Khách sạn tự ngừng chương trình',

        offlineSuccess:
            'Ngừng chương trình thành công',

        areYouSureYouWantToDeleteTheActivity:
            'Bạn có chắc chắn muốn xóa chương trình này không?',
    },
    componentsActivitycontent: {
        activityRequirement: 'Yêu cầu chương trình',
        quantitySold: 'Số lượng bán',
        signUpNow: 'Đăng ký ngay',
        cancelRegistration: 'Hủy đăng ký',
        reEnroll: 'Đăng ký lại',
        areYouSureYouWantToCancelYourRegistration: 'Bạn có chắc chắn muốn hủy đăng ký không?',
    },

    componentsSelfactivitylog: {
        inquire: 'Tìm kiếm',
        back: 'Quay lại',
    },

    componentsDialog: {
        rule: 'Quy tắc',
        new: 'Tạo mới',
        content: 'Nội dung',
        activityRelatedClause: 'Điều khoản liên quan đến chương trình',
    },

    componentsSelfactivitydetail: {
        discountInfo:
            'Khi bật tính năng gia hạn tự động, hệ thống sẽ tự động gia hạn chương trình trước 30 ngày so với ngày kết thúc khuyến mãi và tạo một chương trình khuyến mãi mới. Nếu thời gian còn lại đến ngày kết thúc dưới 30 ngày, chương trình sẽ được tự động kéo dài thêm 30 ngày.',

        chooseToParticipateInPromotionalProducts:
            'Chọn sản phẩm tham gia khuyến mãi',

        noRoomTypeInformationAvailable:
            'Không có thông tin loại phòng',

        selectedProductsForPromotion:
            'Sản phẩm đã chọn tham gia khuyến mãi',

        selectTheChannelWhereThePromotionIsEffective:
            'Chọn kênh áp dụng khuyến mãi',

        allChannels: 'Tất cả kênh',

        designatedChannel: 'Kênh chỉ định',

        noEffectiveChannelInformationIsAvailable:
            'Không có thông tin kênh áp dụng',

        youHaveSelectedTheChannelWhereThePromotionTakesEffect:
            'Đã chọn kênh áp dụng khuyến mãi',

        activeConfiguration:
            'Cấu hình chương trình',

        setForAtLeast2Days:
            'Thiết lập tối thiểu 2 ngày',

        setThisParameterForAtLeast1Day:
            'Thiết lập tối thiểu 1 ngày',

        discount:
            'Giảm giá',

        theDiscountValueIsSetToAtLeast95Off:
            'Mức giảm giá tối thiểu là 95% giá gốc',

        theMinimumAmountOfImmediateReductionIsSetAt5:
            'Mức giảm trực tiếp tối thiểu là 5 CNY',

        immediateReductionPromotionIsNotEffectiveForCtrip:
            'Khuyến mãi giảm trực tiếp không áp dụng cho Ctrip',

        thePromotionIsValidOnlyOnCtrip:
            'Khuyến mãi này chỉ áp dụng trên Ctrip',

        thePromotionIsOnlyEffectiveOnCtripAndTongcheng:
            'Khuyến mãi này chỉ áp dụng trên Ctrip và Tongcheng',

        link:
            'Ở liên tiếp',

        advanceBooking:
            'Đặt trước',

        preferentialMode:
            'Hình thức ưu đãi',

        firstStayDiscount:
            'Giảm giá lần lưu trú đầu tiên',

        automaticExtension:
            'Gia hạn tự động',

        saleTime:
            'Thời gian flash sale',

        theFollowingDay:
            'Ngày hôm sau',

        theIntervalShallNotBeLessThan30Days:
            'Khoảng thời gian không được nhỏ hơn 30 ngày',

        areYouSureYouWantToCommitYourChanges:
            'Bạn có chắc chắn muốn lưu thay đổi không?',

        pleaseSelectTheRoomTypeToParticipateInTheEvent:
            'Vui lòng chọn loại phòng tham gia chương trình',

        pleaseSelectAnEventCheckInDate:
            'Vui lòng chọn ngày nhận phòng áp dụng chương trình',

        pleaseFillInTheDiscountAmount:
            'Vui lòng nhập mức ưu đãi',

        atLeast95OffUpTo30Off:
            'Mức giảm giá từ 95% đến tối đa 30% giá gốc',

        theDiscountAmountIsAtLeast5AndUpTo500:
            'Mức ưu đãi từ 5 đến 500 CNY',

        pleaseFillInTheNumberOfConsecutiveDays:
            'Vui lòng nhập số đêm lưu trú liên tiếp',

        theNumberOfConsecutiveDaysMustBeGreaterThanOrEqualTo1DayAndLessThanOrEqualTo10Days:
            'Số đêm lưu trú liên tiếp phải từ 1 đến 10 ngày',

        pleaseFillInTheAdvanceBookingDays:
            'Vui lòng nhập số ngày đặt trước',

        pleaseFillInTheSaleTime:
            'Vui lòng nhập thời gian flash sale',

        congratulationsOnYourPromotionCreation:
            'Chúc mừng! Tạo chương trình khuyến mãi thành công',

        congratulationsOnYourSuccessfulCopyPromotion:
            'Chúc mừng! Sao chép chương trình khuyến mãi thành công',

        back:
            'Quay lại',
    },

    componentsSelfactivitytemp: {
        createNow: 'Tạo ngay',
    },

    productOversaleSetting: {
        timePeriod: 'Khoảng thời gian',

        numberSold: 'Đã bán',

        oversold: 'Cho phép bán vượt',

        oversoldQuantity: 'Số lượng bán vượt',

        oversoldCannotBeGreaterThanTheRemainingPhysicalRoomCapacityOfTheHotelOnThatDay:
            'Số lượng bán vượt trong ngày không được lớn hơn số lượng phòng vật lý còn lại của khách sạn trong ngày đó',

        oversoldStockIsActivatedWhenTheActualPhysicalStockOfTheRoomTypeIsSoldOutForTheDay:
            'Tồn kho bán vượt sẽ được kích hoạt khi tồn kho thực tế của loại phòng trong ngày đã bán hết',

        pleaseOpenTheAutomaticOverbookingSettingInMoreSystemSettingsBasicSettingsDirectConnectionOrderToAvoidAutomaticRejectionOfOverbookingOrderTimeout:
            'Vui lòng bật tính năng tự động nhận đơn bán vượt trong mục Thêm > Cài đặt hệ thống > Cài đặt cơ bản > Đơn hàng kết nối trực tiếp để tránh đơn hàng bán vượt bị tự động từ chối do quá thời gian xử lý',

        timeSelectionIsOutOfRange:
            'Khoảng thời gian được chọn vượt quá phạm vi cho phép',

        configurationSuccessful:
            'Cấu hình thành công',

        theSetOverbookingQuantityMustBeGreaterThanOrEqualTo:
            'Số lượng bán vượt được thiết lập phải lớn hơn hoặc bằng',
    },
    productDelayprice: {
        holidayFactorRange:
            'Phạm vi hệ số ngày lễ có thể nhập: số thập phân từ 1 đến 5, tối đa 1 chữ số sau dấu phẩy.',

        holidayPricingRule:
            'Sau khi thiết lập hệ số ngày lễ, giá phòng trong các ngày nghỉ lễ chính thức của Trung Quốc sẽ được tính theo giá ngày thường nhân với hệ số này. Ví dụ: khi hệ số là 2 và giá ngày thường là 100 CNY, hệ thống sẽ tự động đặt giá ngày lễ là 2 × 100 = 200 CNY.',

        holidayFactor:
            'Sau khi thiết lập hệ số ngày lễ, giá phòng trong các ngày nghỉ lễ chính thức của Trung Quốc sẽ bằng',

        priceCopy:
            'Sao chép giá trong 2 tháng',

        open:
            'Đã bật',

        deferredProduct:
            'Sản phẩm gia hạn giá',

        allDayRoomProducts:
            'Sản phẩm phòng cả ngày',

        deferralOnlyAppliesToProductsWithFullDayOccupancyType:
            'Chỉ áp dụng gia hạn giá cho sản phẩm có loại lưu trú là phòng cả ngày',

        priceExtensionTime:
            'Thời gian gia hạn giá',

        holidayCoefficient:
            'Hệ số ngày lễ',

        statutoryHolidayPricesAreWeekdays:
            'Giá ngày lễ chính thức bằng',

        times:
            'lần giá ngày thường',

        automaticDeferralDescription:
            'Mô tả gia hạn giá tự động',

        theSystemCopiesThePriceOfTheMostRecentWeekToAFutureDateWithoutAPriceAndDatesThatAlreadyHaveAPriceWillNotBeOverwrittenByTheSystem:
            'Hệ thống sẽ sao chép giá của tuần gần nhất sang các ngày trong tương lai chưa được thiết lập giá. Những ngày đã có giá sẽ không bị ghi đè.',

        thePriceSourceOfTheAutomaticPriceExtensionIsThePriceOfTheWeekBeforeTheAutomaticPriceExtensionDateInCaseOfHolidaysItIsSkippedAndThePriceOfThePreviousWeekIsTaken:
            'Nguồn giá của tính năng gia hạn giá tự động là giá của tuần trước ngày được gia hạn. Nếu tuần đó rơi vào ngày lễ, hệ thống sẽ bỏ qua và lấy giá của tuần trước nữa.',

        turnOffAutomaticDeferral:
            'Tắt gia hạn giá tự động',
    },

    productManageSetting: {
        advanceSale:
            'Bán trước',

        needChannelConnection:
            'Sản phẩm này chỉ có thể được tạo sau khi kích hoạt kết nối kênh bán. Bạn có muốn mở kết nối kênh ngay bây giờ không?',

        confirmChangeProductType:
            'Việc thay đổi loại sản phẩm sẽ xóa toàn bộ kênh phát hành và các quy tắc hiện có của sản phẩm. Bạn có chắc chắn muốn tiếp tục không?',

        limitSale:
            'Giới hạn bán (phòng)',

        checkInDay:
            'Ngày nhận phòng',

        beforeCheckIn:
            'Trước ngày nhận phòng',

        atLatest:
            'Muộn nhất',

        theHourlyIncreaseCannotBeGreaterThanThePrice:
            'Phụ phí mỗi giờ không được lớn hơn giá phòng',

        physicalRoomType:
            'Loại phòng thực tế',

        earliestCheckInTime:
            'Thời gian nhận phòng sớm nhất',

        latestCheckOutTime:
            'Thời gian trả phòng muộn nhất',

        howLongNoAdditionalRoomChargeminutes:
            'Gia hạn bao lâu thì không tính thêm phí phòng (phút)',

        howLongIsTheFullDayRoomChargehours:
            'Lưu trú bao lâu thì tính phí phòng cả ngày (giờ)',

        cancelRule:
            'Quy tắc hủy phòng',

        paymentPolicy:
            'Chính sách thanh toán',

        validForOnlineSalesOnly:
            'Chỉ áp dụng cho bán trực tuyến',

        releaseChannel:
            'Kênh phát hành',

        productRegulation:
            'Quy tắc sản phẩm',

        effectiveChannel:
            'Kênh áp dụng',

        priceyuan:
            'Giá (CNY)',

        inputPrice:
            'Nhập giá',

        extraChargePerHourrmb:
            'Phụ phí cho mỗi giờ vượt quá (CNY)',

        forSaleOnly:
            'Giới hạn bán (phòng)',

        inputSpace:
            'Nhập số phòng',

        enjoyHotelStayLight:
            'Khách sạn Qingzhu Premium',

        pleaseEnterTheNumberOfRooms:
            'Vui lòng nhập số phòng',

        additionalRule:
            'Thêm quy tắc',

        found:
            'Tạo',

        containing:
            'Bao gồm',

        pleaseEnterTheNumberOfRestrictedRooms:
            'Vui lòng nhập số lượng phòng giới hạn bán',

        nonDeletable:
            'Không thể xóa',

        early:
            'Sớm',

        withoutBreakfast:
            'Không bao gồm bữa sáng',

        liveLightAndEnjoy:
            'Qingzhu Preferred',

        confirmToDeleteThisRule:
            'Xác nhận xóa quy tắc này?',

        areYouSureToKeepItForSale:
            'Bạn có chắc chắn muốn lưu và tiếp tục bán không?',

        areYouSureToCreateASale:
            'Bạn có chắc chắn muốn tạo sản phẩm bán không?',

        areYouSureYouWantToLeave:
            'Bạn có chắc chắn muốn rời khỏi trang này không?',
    },

    productPriceCalendar: {
        is:
            '?',

        confirmDeleteWarning:
            'Vui lòng xác nhận sản phẩm hiện tại không còn phòng đang lưu trú hoặc chưa trả phòng để tránh ảnh hưởng đến việc gia hạn lưu trú. Nếu xác nhận xóa, vui lòng nhấn nút "Xác nhận xóa" bên dưới.',

        totalAvailableRooms:
            'Tổng số phòng có thể bán: 10 phòng (bao gồm 3 phòng bán vượt)',

        limitZeroFull:
            'Khi số lượng giới hạn bán bằng 0, trạng thái sẽ là hết phòng. Sau khi đóng phòng, phòng sẽ không được bán trên các kênh trực tuyến.',

        openRoomAvailable:
            'Khi mở phòng và còn tồn phòng, phòng sẽ được bán trực tuyến; sau khi đóng phòng sẽ ngừng bán.',

        allProducts3:
            'Tất cả sản phẩm',

        onlineProduct2:
            'Sản phẩm trực tuyến',

        offLineProduct2:
            'Sản phẩm ngoại tuyến',

        theReckoner:
            'Máy tính',

        preSaleFullDayRoom:
            'Phòng cả ngày bán trước',

        presaleHourRoom:
            'Phòng theo giờ bán trước',

        viewIsNotSupported:
            'Tạm thời không hỗ trợ xem',

        channelPricesCannotBeSet:
            'Không thể thiết lập giá theo kênh',

        smallProgramChannelPriceCanBeAdjustedToUpdate:
            'Có thể điều chỉnh giá trên kênh Mini Program để cập nhật',

        switchRoom:
            'Mở / Đóng phòng',

        limitedSalesNumber:
            'Số lượng giới hạn bán',

        unlimitedSale:
            'Không giới hạn',

        packUpAllProducts:
            'Thu gọn tất cả sản phẩm',

        expandAllProducts:
            'Mở rộng tất cả sản phẩm',

        modifyProductPrice:
            'Chỉnh sửa giá sản phẩm',

        extraChargeForMoreThan1Hour:
            'Phụ phí khi vượt quá 1 giờ',

        enjoyHotelStayLight:
            'Khách sạn Qingzhu Premium',

        pleaseEnterLimitedNumber:
            'Vui lòng nhập số lượng giới hạn',

        maintenancePrice:
            'Duy trì giá',

        priceNotMaintained:
            'Chưa thiết lập giá',

        amendTheSalesRestrictionRules:
            'Chỉnh sửa quy tắc giới hạn bán',

        confirmOrNot:
            'Xác nhận hay không',

        areYouSureYouWantToContinue:
            'Bạn có chắc chắn muốn tiếp tục chỉnh sửa không?',

        theCurrentRateExceedsTheThresholdSetByTheHotel5:
            'Giá hiện tại vượt quá ngưỡng được thiết lập bởi khách sạn',

        definiteModification:
            'Xác nhận chỉnh sửa',
    },
    productPriceCalendarNew: {
        open: 'Mở bán',
        iss: '?',

        remainingContractReservedRooms:
            'Số phòng giữ lại theo hợp đồng còn lại',

        roomsCannotBeLower:
            ' phòng, số lượng phòng giữ lại không được thấp hơn giá trị này',

        confirmDeleteWarning:
            'Vui lòng xác nhận sản phẩm hiện tại không có phòng đang lưu trú hoặc chưa trả phòng để tránh ảnh hưởng đến việc gia hạn lưu trú. Nếu xác nhận xóa, vui lòng nhấn nút "Xác nhận xóa" bên dưới.',

        Thenumberofremainingcontractreservedroomsforthisproduct:
            'Số lượng phòng giữ lại theo hợp đồng còn lại của sản phẩm này không bằng 0. Yêu cầu đóng phòng đã được gửi, vui lòng chờ xét duyệt.',

        cannotCloseRoom:
            'Số lượng phòng giữ lại theo hợp đồng còn lại của sản phẩm này không bằng 0, không thể đóng phòng. Vui lòng liên hệ quản lý kênh để xử lý.',

        confirmModification:
            'Xác nhận chỉnh sửa',

        EBDeepOperationFailed:
            'Đồng bộ EB nâng cao thất bại',

        syncCurrentPageEBData:
            'Đồng bộ dữ liệu EB của trang hiện tại',

        previousTwoWeeks:
            '2 tuần trước',

        nextTwoWeeks:
            '2 tuần tiếp theo',

        batchChangeInventory:
            'Chỉnh sửa tồn kho hàng loạt',

        theReckoner:
            'Máy tính',

        preSaleFullDayRoom:
            'Phòng cả ngày bán trước',

        presaleHourRoom:
            'Phòng theo giờ bán trước',

        underRevision:
            'Đang chỉnh sửa',

        viewIsNotSupported:
            'Tạm thời không hỗ trợ xem',

        dataSynchronizationIsUnderwayPleaseQueryTheDataAgainAfter1Minute:
            'Đang đồng bộ dữ liệu, vui lòng thử lại sau 1 phút',

        lightLiveDistributionChannelPriceCannotBeSet:
            'Không thể thiết lập giá cho kênh phân phối Qingzhu',

        smallProgramChannelPriceCanBeAdjustedToUpdate:
            'Có thể điều chỉnh giá trên kênh Mini Program để cập nhật',

        switchRoomSetup:
            'Thiết lập mở/đóng phòng',

        notModify:
            'Không chỉnh sửa',

        roomSetting:
            'Thiết lập số lượng phòng',

        unlimitedSale:
            'Không giới hạn',

        reserveRoomSetup:
            'Thiết lập phòng giữ lại',

        pleaseSelectRoomType:
            'Loại phòng',

        pleaseSelectCheckInType:
            'Loại lưu trú',

        notShowPreSaleProduct:
            'Ẩn sản phẩm bán trước',

        showPreSaleProduct:
            'Hiển thị sản phẩm bán trước',

        notShowEbProduct:
            'Ẩn sản phẩm EB',

        showEbProduct:
            'Hiển thị sản phẩm EB',

        allCheckInTypes:
            'Tất cả loại lưu trú',

        holiday:
            'Ngày lễ',

        packItAllUp:
            'Thu gọn',

        expandAll:
            'Mở rộng tất cả',

        extraChargeForMoreThan1Hour:
            'Phụ phí khi vượt quá 1 giờ',

        theNumberOfReservedRoomsCanBeIncreasedAtMostNotMoreThanTheCurrentInventoryAtLeastNotLessThanTheNumberOfRemainingContractedReservedRooms:
            'Số lượng phòng giữ lại có thể tăng lên nhưng không được vượt quá tồn kho hiện tại và không được thấp hơn số lượng phòng giữ lại theo hợp đồng còn lại',

        offLineProduct2:
            'Sản phẩm ngoại tuyến',

        onlineProduct2:
            'Sản phẩm trực tuyến',

        allProducts3:
            'Tất cả sản phẩm',

        showFloor:
            'Hiển thị giá sàn',

        theReservePriceIsNotDisplayed:
            'Ẩn giá sàn',

        directChannel4:
            'Kênh kết nối trực tiếp',

        goWhereTheDirectConnection:
            'Kết nối trực tiếp Qunar',

        unboundChannel:
            'Chưa liên kết kênh',

        synchronizationFailure:
            'Đồng bộ thất bại',

        theStartDateOfTheLastTwoWeeksCannotBeLessThanTheCurrentDate:
            'Ngày bắt đầu của 2 tuần trước không được nhỏ hơn ngày hiện tại',

        pleaseSelectTheCurrentStartEndDate:
            'Vui lòng chọn ngày bắt đầu và ngày kết thúc',

        pleaseEnterTheNumberOfReservedRooms:
            'Vui lòng nhập số lượng phòng giữ lại',

        pleaseEnterLimitedNumber:
            'Vui lòng nhập số lượng giới hạn bán',

        maintenancePrice:
            'Duy trì giá',

        priceNotMaintained:
            'Chưa thiết lập giá',

        modifyProductPrice:
            'Chỉnh sửa giá sản phẩm',

        modifyProductInventory:
            'Chỉnh sửa tồn kho sản phẩm',

        confirmOrNot:
            'Xác nhận hay không',

        theCurrentRateExceedsTheThresholdSetByTheHotel5:
            'Giá hiện tại vượt quá ngưỡng được khách sạn thiết lập',

        areYouSureYouWantToContinue:
            'Bạn có chắc chắn muốn tiếp tục chỉnh sửa không?',

        definiteModification:
            'Xác nhận chỉnh sửa',

        ebChannel:
            'Kênh EB',

        ebMeituan:
            'EB Meituan',

        ebCtrip:
            'EB Ctrip',

        ebFeizhu:
            'EB Fliggy',
    },

    productPriceAudit: {
        allRejectedSuccessfully:
            'Đã từ chối tất cả thành công',

        pass:
            'Phê duyệt',

        turnDown:
            'Từ chối',

        revisedPrice:
            'Giá sau chỉnh sửa',

        rangeOfVariation:
            'Phạm vi thay đổi giá',

        priceChanger:
            'Người chỉnh giá',

        auditor:
            'Người xét duyệt',

        auditTime:
            'Thời gian xét duyệt',

        toBeReviewed:
            'Chờ xét duyệt',

        passTheExamination:
            'Đã phê duyệt',

        expired:
            'Hết hạn',

        successfulAudit:
            'Xét duyệt thành công',
    },

    pcncomponentDataexplain: {
        totalAvailableRooms:
            'Tổng số phòng có thể bán: 10 phòng (bao gồm 3 phòng bán vượt)',

        ebPriceSoldRemaining:
            'Giá phòng (giá bán EB) / Số phòng đã bán / Số phòng còn lại',

        ebPriceSoldCloseStatus:
            'Giá phòng (giá bán EB) / Số phòng đã bán / Trạng thái đóng phòng',

        ebBasePriceReservedUnlimited:
            'Giá sàn EB / Số phòng giữ lại còn lại (bao gồm phòng giữ lại theo hợp đồng và phòng giữ lại tạm thời) / Bán không giới hạn',

        hourRoomProductsShowHourRoomIdentification:
            'Sản phẩm phòng theo giờ sẽ hiển thị biểu tượng phòng theo giờ',

        whenTheProductPriceIsChangedOrTheHousingStatusIsNotImmediatelyEffectiveInTheAuditTheIdentificationInTheAuditIsDisplayedAndTheIdentificationInTheAuditIsHiddenAfterTheAuditPassesTheModificationAndBecomesEffective:
            'Khi thay đổi giá hoặc trạng thái phòng mà chưa có hiệu lực ngay và đang chờ xét duyệt, hệ thống sẽ hiển thị trạng thái "Đang xét duyệt". Sau khi được phê duyệt và có hiệu lực, trạng thái này sẽ được ẩn.',

        underRevision:
            'Đang chỉnh sửa',

        thePriceOrInventoryHasDataThatIsBeingModifiedTheIdentifierIsDisplayedWhenTheModificationResultIsNotObtainedTheIdentifierIsHiddenOnlyAfterSuccessOrFailure:
            'Khi giá hoặc tồn kho đang được chỉnh sửa và chưa nhận được kết quả, hệ thống sẽ hiển thị trạng thái tương ứng. Trạng thái này chỉ được ẩn sau khi thao tác thành công hoặc thất bại.',

        ifTheProductFailsToChangeThePriceOrChangeTheRoomStatusTheFailureIdentifierWillBeDisplayedAndTheIdentifierWillBeHiddenOnlyAfterTheNextOperationSucceedsInChangingThePriceOrChangingTheRoomStatus:
            'Nếu thay đổi giá hoặc trạng thái phòng thất bại, hệ thống sẽ hiển thị trạng thái thất bại. Trạng thái này chỉ được ẩn khi lần thao tác tiếp theo thành công.',

        theProductFailsToBeObtainedContactTheOperationManagerToCheckWhetherTheProductHasBeenChanged:
            'Không thể lấy thông tin sản phẩm. Vui lòng liên hệ quản lý vận hành để xác nhận sản phẩm có thay đổi hay không.',

        statusDeclaration:
            'Giải thích trạng thái',

        whenTheLimitedNumberOfSalesIs0TheRoomIsFullAndItCannotBeSoldAfterClosingTheRoomOnlyTheRelevantRoomWillStopSellingInTheUnlimitedNumberState:
            'Khi số lượng giới hạn bán bằng 0, trạng thái sẽ là hết phòng. Sau khi đóng phòng sẽ không thể bán. Trong chế độ bán không giới hạn, chỉ khi đóng phòng mới ngừng bán.',

        ctripEbPrepaidProductsShowThePrepaidLogo:
            'Sản phẩm EB trả trước của Ctrip sẽ hiển thị biểu tượng "Trả trước"',

        ctripEbCashProductsShowTheCashLogo:
            'Sản phẩm EB thanh toán tại khách sạn của Ctrip sẽ hiển thị biểu tượng "Thanh toán tại chỗ"',
    },
    pcncomponentBatchUpdateStock: {
        cannotCloseRoomTip:
            'Khi số lượng phòng giữ lại còn lại của sản phẩm EB khác 0, không thể đóng phòng',

        roomSettingTip:
            'Điều chỉnh số lượng phòng thực chất là điều chỉnh số lượng giới hạn bán, áp dụng cho tất cả sản phẩm thuộc loại phòng. Tồn kho của sản phẩm trực tiếp và sản phẩm EB sẽ lấy giá trị nhỏ hơn giữa số lượng giới hạn bán và tồn kho thực tế.',

        infiniteQuantityTip:
            'Không giới hạn tương ứng với: Meituan EB = Không giới hạn, Fliggy = Không giới hạn, Ctrip = Free Sale; đối với kênh trực tiếp là không giới hạn bán.',

        notModify: 'Không chỉnh sửa',

        roomSetting: 'Thiết lập số lượng phòng',

        restrictedSalesIncrease: 'Tăng số lượng giới hạn bán',

        restrictedSalesReduction: 'Giảm số lượng giới hạn bán',

        directlyConnectedProductsOnlySupportToModifyTheSwitchingRoomStatusDoNotSupportToModifyTheInventory:
            'Sản phẩm kết nối trực tiếp chỉ hỗ trợ thay đổi trạng thái mở/đóng phòng, không hỗ trợ chỉnh sửa tồn kho',

        batchChangeInventory: 'Chỉnh sửa tồn kho hàng loạt',

        productSelection: 'Chọn sản phẩm',

        whetherToDisplayPreSaleProducts: 'Hiển thị sản phẩm bán trước',

        channelSelection: 'Chọn kênh',

        paymentType: 'Hình thức thanh toán',

        selectionWeek2: 'Chọn thứ trong tuần',

        switchRoomSetup: 'Thiết lập mở/đóng phòng',

        open: 'Mở phòng',

        someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
            'Một số sản phẩm chỉnh sửa thất bại. Vui lòng lấy dữ liệu giá và tồn kho mới nhất rồi thử lại.',

        pleaseSelectADateRange2:
            'Vui lòng chọn khoảng thời gian',

        pleaseSelectAWeek2:
            'Vui lòng chọn thứ trong tuần',

        pleaseEnterTheNumberOfRestrictedRooms:
            'Vui lòng nhập số lượng phòng giới hạn bán',

        pleaseEnterTheNumberOfRestrictedAdditionalRooms:
            'Vui lòng nhập số lượng phòng tăng thêm',

        pleaseEnterTheNumberOfRestrictedReducedRooms:
            'Vui lòng nhập số lượng phòng giảm bớt',
    },

    pcncomponentPriceunified: {
        weekend: 'Cuối tuần',

        officialWebsiteDirect:
            'Website chính thức',

        dateCannotRepeat:
            'Ngày không được trùng lặp',

        displayNextPage:
            'Hiển thị trang tiếp theo',

        priceCannotBeLessThan20:
            'Giá bán không được nhỏ hơn hoặc bằng 20',

        lowSellingPriceTip:
            'Giá bán của các sản phẩm sau quá thấp, vui lòng xác nhận có tiếp tục chỉnh sửa hay không',

        priceExceedsThresholdTip:
            'Lần điều chỉnh giá này vượt quá phạm vi cho phép, vui lòng liên hệ quản lý khách sạn để xét duyệt',

        selectProduct:
            'Chọn sản phẩm',

        weekdays:
            'Ngày thường',

        noDifference:
            'Không phân biệt',

        distinguish:
            'Phân biệt',

        bulkAdjustment:
            'Điều chỉnh hàng loạt',

        increase:
            'Tăng',

        reduce:
            'Giảm',

        weekdayWeekend:
            'Ngày thường / Cuối tuần',

        someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
            'Một số sản phẩm chỉnh sửa thất bại. Vui lòng cập nhật dữ liệu mới nhất rồi thử lại.',

        weekendPrice:
            'Giá cuối tuần',

        repricingDate:
            'Ngày điều chỉnh giá',

        effectiveWeek:
            'Thứ áp dụng',

        maxFiveDates:
            'Tối đa 5 ngày',

        priceChangeModeTip:
            'Chế độ điều chỉnh giá cho phép sửa Giá bán + Hoa hồng hoặc Giá sàn. Ở chế độ Giá bán + Hoa hồng, chỉ sản phẩm Ctrip hỗ trợ chỉnh hoa hồng và chỉ được tăng. Chế độ Giá sàn cũng chỉ hỗ trợ cho sản phẩm Ctrip.',

        sellPriceCommission:
            'Giá bán + Hoa hồng',

        ebChannel:
            'Kênh EB',

        ebMeituan:
            'EB Meituan',

        ebCtrip:
            'EB Ctrip',

        ebFeizhu:
            'EB Fliggy',

        splitPricing:
            'Điều chỉnh riêng biệt',

        uniformPriceChange:
            'Điều chỉnh đồng loạt',

        productSelection:
            'Chọn sản phẩm',

        paymentType:
            'Hình thức thanh toán',

        selectionWeek2:
            'Chọn thứ trong tuần',

        thePreviousStepReselectTheProduct:
            'Bước trước - Chọn lại sản phẩm',

        methodOfRepricing:
            'Phương thức điều chỉnh giá',

        separatePriceChangesCanSetThePriceOfEachProductAndUnifiedPriceChangesCanBeAddedAndReducedInBatches:
            'Điều chỉnh riêng biệt cho phép đặt giá cho từng sản phẩm. Điều chỉnh đồng loạt cho phép tăng hoặc giảm giá hàng loạt.',

        priceModel:
            'Chế độ giá',

        priceBeforeModification:
            'Giá trước khi chỉnh sửa',

        extraChargeAfterOneHour:
            'Phụ thu khi vượt quá 1 giờ',

        commission:
            'Hoa hồng',

        directChannel4:
            'Kênh trực tiếp',

        goWhereTheDirectConnection:
            'Qunar Direct',

        value:
            'Giá trị',
    },

    pcncomponentTable: {
        passTheVerification:
            'Xác thực thành công',

        verificationFail:
            'Xác thực thất bại',
    },

    pcncomponentLog: {
        revisedPrice3:
            'Giá sau chỉnh sửa',

        pleaseEnterTheRevisedPrice:
            'Vui lòng nhập giá sau chỉnh sửa',

        pleaseSelectAStandardProduct:
            'Vui lòng chọn sản phẩm tiêu chuẩn',

        straight:
            'Trực',
    },

    giftPro: {
        bindUnbind:
            'Liên kết / Hủy liên kết',

        giftValueInfo:
            'Giá trị gói quà chỉ dùng để hiển thị, không phát sinh chi phí thực tế',

        thePackageCanOnlyBeConfiguredWithAllDayRoomProducts:
            'Gói quà chỉ có thể áp dụng cho sản phẩm phòng cả ngày',

        eachProductCanBeConfiguredWithOnlyOnePackage:
            'Mỗi sản phẩm chỉ được cấu hình một gói quà',

        theGiftPackageIsOnlyValidForMeituanDirectConnectionProducts:
            'Gói quà chỉ áp dụng cho sản phẩm kết nối trực tiếp Meituan',

        packageDescription:
            'Mô tả gói quà',

        allProducts2:
            'Tất cả sản phẩm',

        modifiedGiftPack:
            'Chỉnh sửa gói quà',

        packageName:
            'Tên gói quà',

        giftPackageGiving:
            'Hình thức tặng',

        packageType:
            'Loại gói quà',

        packageStatus:
            'Trạng thái gói quà',

        activeProduct:
            'Sản phẩm áp dụng',

        createPackage:
            'Tạo mới',

        packageValue:
            'Giá trị gói quà',

        packageEffectiveDate:
            'Ngày hiệu lực',

        upperLimit1500:
            'Tối đa 1500',

        upperLimit:
            'Giới hạn tối đa',

        packageDetails:
            'Chi tiết gói quà',

        maximum80Characters:
            'Tối đa 80 ký tự',

        wayOfGiving:
            'Hình thức tặng',

        thePackageValueCannotBeEmpty:
            'Giá trị gói quà không được để trống',

        oneDeliveryPerRoom:
            'Tặng một lần cho mỗi phòng',

        complimentaryOnceADayPerRoom:
            'Tặng một lần mỗi ngày cho mỗi phòng',

        pleaseEnterThePackageName:
            'Vui lòng nhập tên gói quà',

        pleaseSelectTheGiftMethod:
            'Vui lòng chọn hình thức tặng',

        pleaseSelectAPackageType:
            'Vui lòng chọn loại gói quà',

        pleaseSelectPackageDetails:
            'Vui lòng chọn chi tiết gói quà',

        pleaseSelectAnEffectiveProduct:
            'Vui lòng chọn sản phẩm áp dụng',

        pleaseSelectAnEffectiveDate:
            'Vui lòng chọn ngày hiệu lực',

        whetherToDropTheGiftPackage:
            'Xác nhận ngừng áp dụng gói quà?',

        giftBagOffLine:
            'Ngừng áp dụng gói quà',

        offlineSuccess:
            'Ngừng áp dụng thành công',

        offlineFailure:
            'Ngừng áp dụng thất bại',

        methodOfCancellation:
            'Phương thức hủy',

        createdSuccessfully:
            'Tạo thành công',

        creationFailure:
            'Tạo thất bại',
    },
    giftLog: {
        packageOperationLog: 'Nhật ký thao tác gói quà',
    },

    pullnewMember: {
        memberInformationEntry: 'Nhập thông tin hội viên',

        areRequiredFieldsOtherFieldsAreNotRequired:
            'là trường bắt buộc, các trường khác không bắt buộc',

        idNumber: 'Số giấy tờ',

        inputResult: 'Kết quả nhập liệu',

        recordSuccessfully: 'Nhập thành công',

        entryFailure: 'Nhập thất bại',

        memberSale: 'Ưu đãi đặc biệt cho hội viên',

        enter: 'Nhập',

        passport: 'Hộ chiếu',

        pleaseEnterTheIdNumber:
            'Vui lòng nhập số giấy tờ',

        theNameFormatIsIncorrect:
            'Định dạng họ tên không đúng',

        theMobilePhoneNumberCannotBeEmpty:
            'Số điện thoại không được để trống',

        theMobilePhoneNumberFormatIsIncorrect:
            'Định dạng số điện thoại không đúng',

        theFormatOfTheIdCardNumberIsIncorrect:
            'Định dạng số CMND/CCCD không đúng',

        memberInformationEnteredSuccessfully:
            'Nhập thông tin hội viên thành công',
    },

    pullnewNewlist: {
        promoter: 'Người giới thiệu',

        pullTime: 'Thời gian giới thiệu',

        pleaseEnterYourPromoterName:
            'Vui lòng nhập tên người giới thiệu',

        memberNickname: 'Biệt danh hội viên',

        pulsingType: 'Loại giới thiệu hội viên mới',
    },

    pullnewQrcode: {
        aboutHalfA4:
            'Khoảng một nửa khổ giấy A4',

        sizeLarge:
            'Lớn',

        sizeSmall:
            'Nhỏ',

        sizeMedium:
            'Trung bình',

        lShapedStand:
            'Standee chữ L',

        paperSize:
            'Kích thước giấy',

        downloadPicture:
            'Tải ảnh',

        memberPullNewCodeGenerationPleaseWait:
            'Đang tạo mã giới thiệu hội viên mới, vui lòng chờ',

        memberPoster:
            'Poster hội viên',

        frontDeskStaff:
            'Nhân viên lễ tân',

        foreground:
            'Quầy lễ tân',

        commonArea:
            'Khu vực công cộng',

        corridor:
            'Hành lang',

        elevator:
            'Thang máy',

        displayStand:
            'Kệ trưng bày',
    },
    tiktokpresalecouponDetail: {
        name: 'Tên',

        totalGoodsPrice: 'Tổng giá sản phẩm (giá niêm yết)',

        uploadImageTips:
            'Tải lên từ 1-5 ảnh, dung lượng mỗi ảnh không quá 5MB; độ phân giải đề xuất 375×280px; tỷ lệ ảnh 4:3',

        unavailableCheckInDates:
            'Ngày không áp dụng lưu trú:',

        otherInStoreOffers:
            'Có thể sử dụng cùng các ưu đãi khác tại khách sạn (liên hệ khách sạn để biết chi tiết)',

        createACoupon:
            'Tạo voucher bán trước',

        support:
            'Hỗ trợ',

        nonsupport:
            'Không hỗ trợ',

        putUp:
            'Lưu trú',

        bindAvailableProducts:
            'Liên kết sản phẩm áp dụng',

        bindAtLeastOneProduct:
            'Liên kết ít nhất một sản phẩm',

        meal:
            'Bữa ăn',

        addMeal:
            'Thêm bữa ăn',

        courteousReception:
            'Ưu đãi tặng kèm',

        addItem:
            'Thêm hạng mục',

        unlimitedInventory:
            'Không giới hạn tồn kho',

        stockLimit:
            'Giới hạn tồn kho',

        whenAutomaticExtensionIsEnabledTheProductWillBeAutomaticallyExtendedFor30DaysAfterTheExpirationDate:
            'Khi bật gia hạn tự động, sản phẩm sẽ tự động được gia hạn thêm 30 ngày sau khi hết hạn bán',

        namedDate:
            'Ngày chỉ định',

        specifiedDays:
            'Số ngày chỉ định',

        fromTheDateOfPurchase:
            'Kể từ ngày mua',

        availableWithinDays:
            'ngày có hiệu lực',

        unavailableWeek:
            'Ngày trong tuần không áp dụng',

        unavailableHolidays:
            'Ngày lễ không áp dụng',

        unavailableDate:
            'Ngày không áp dụng',

        subjectToAMarkup:
            'Có phụ thu',

        noMarkup:
            'Không phụ thu',

        allStores:
            'Tất cả khách sạn',

        addMarkupRules:
            'Thêm quy tắc phụ thu',

        limitOnePurchasePerOrder:
            'Mỗi đơn chỉ được mua 1 voucher',

        purchaseLimitPerPerson:
            'Giới hạn mua mỗi người',

        maximumPurchasePerPerson:
            'Mỗi người được mua tối đa',

        zhang:
            'vé',

        noAdvanceReservationRequired:
            'Không cần đặt trước',

        advanceReservationRequired:
            'Cần đặt trước',

        aheadOfSchedule:
            'Trước',

        dailyReservation:
            'ngày đặt trước',

        beforeCheckIn:
            'trước khi nhận phòng',

        cannotBeCombinedWithOtherInStoreOffers:
            'Không được sử dụng đồng thời với các ưu đãi khác tại khách sạn',

        theMealTypeCannotBeEmpty:
            'Loại bữa ăn không được để trống',

        theNameOfTheOfferCannotBeEmpty:
            'Tên ưu đãi không được để trống',

        ticketName:
            'Tên voucher bán trước',

        pleaseEnterTicketNamemaximum24Words:
            'Vui lòng nhập tên voucher bán trước (tối đa 60 ký tự)',

        fractionalAppointment:
            'Đặt chỗ nhiều lần',

        commodityContent:
            'Nội dung sản phẩm',

        lunch:
            'Bữa trưa',

        automaticExtension:
            'Gia hạn tự động',

        availabilityDate:
            'Ngày áp dụng lưu trú',

        markUpPolicy:
            'Chính sách phụ thu',

        additionalChargesApply:
            'Hạng mục cần thanh toán thêm',

        purchaseRestrictionRule:
            'Quy tắc giới hạn mua',

        reservationRule:
            'Quy tắc đặt chỗ',

        upload110PicturesImageSize5mOrLessRecommendedResolution375280pxImageRatio:
            'Tải lên 1-10 ảnh, dung lượng không quá 5MB; độ phân giải đề xuất 375×280px; tỷ lệ ảnh',

        preSaleTicketHeadChart:
            'Ảnh bìa voucher',

        longMapOfAdvanceTickets:
            'Ảnh dài voucher',

        reservationValidity:
            'Thời hạn đặt chỗ',

        markupStore:
            'Khách sạn áp dụng phụ thu',

        markupSession:
            'Khung thời gian phụ thu',

        unit:
            'Đơn vị',

        pleaseEnterTheUnit:
            'Vui lòng nhập đơn vị',

        priceyuan:
            'Giá (VND)',

        cancellationRules:
            'Quy tắc hủy đặt chỗ',

        rulesOfUse:
            'Quy tắc sử dụng',

        otherDescriptiveInformation:
            'Thông tin mô tả khác',

        pleaseEnterAdditionalExplanatoryInformation:
            'Vui lòng nhập thông tin mô tả bổ sung',

        found:
            'Tạo',

        picturePreview:
            'Xem trước hình ảnh',

        theNameOfTheVoucherCannotBeEmpty:
            'Tên voucher bán trước không được để trống',

        theNameOfTheVoucherCannotExceed24Characters:
            'Tên voucher bán trước không được vượt quá 60 ký tự',

        pleaseSelectASaleDate:
            'Vui lòng chọn thời gian bán',

        pleaseSelectTheReservationValidityPeriod:
            'Vui lòng chọn thời hạn đặt chỗ',

        pleaseSelectTheHeaderDiagram:
            'Vui lòng chọn ảnh bìa',

        pleaseSelectALongMap:
            'Vui lòng chọn ảnh dài',

        thePurchaseLimitPerPersonCanOnlyBeANumber:
            'Số lượng giới hạn mua mỗi người phải là số',

        pleaseFillInTheLengthOfStay:
            'Vui lòng nhập thời gian lưu trú',

        mealPriceMustBeGreaterThan:
            'Giá bữa ăn phải lớn hơn',

        theCourtesyPriceMustBeGreaterThan:
            'Giá trị ưu đãi tặng kèm phải lớn hơn',

        theTotalPriceOfTheGoodsCannotBeEmpty:
            'Tổng giá sản phẩm không được để trống',

        theTotalPriceOfTheGoodsMustBeGreaterThan:
            'Tổng giá sản phẩm phải lớn hơn',

        pleaseFillInTheActualPricePaidByTheGuest:
            'Vui lòng nhập giá thực tế khách thanh toán',

        theActualPricePaidMustBeGreaterThan:
            'Giá thực tế khách thanh toán phải lớn hơn',

        theActualPricePaidByTheGuestCannotBeGreaterThanTheTotalPriceOfTheProduct:
            'Giá thực tế khách thanh toán không được lớn hơn tổng giá sản phẩm',

        youCanOnlyUploadPictureFiles:
            'Chỉ được tải lên tệp hình ảnh',

        pleaseUploadAtLeast1HeaderImage:
            'Vui lòng tải lên ít nhất 1 ảnh bìa',

        pleaseUploadAtLeast1LongPicture:
            'Vui lòng tải lên ít nhất 1 ảnh dài',

        pleaseEnterTheMaximumPurchasePerPerson:
            'Vui lòng nhập số lượng mua tối đa mỗi người',

        pleaseFillInTheDailyLimit:
            'Vui lòng nhập giới hạn mỗi ngày',

        confirmTheDateToDeleteThis:
            'Xác nhận xóa ngày này',

        confirmToDeleteThisProduct:
            'Xác nhận xóa sản phẩm này',

        confirmToDeleteThisMeal:
            'Xác nhận xóa bữa ăn này',

        removeMarkupRules:
            'Xóa quy tắc phụ thu',

        confirmToRemoveThisMarkupPolicy:
            'Xác nhận xóa chính sách phụ thu này',

        newMarkupRules:
            'Thêm quy tắc phụ thu mới',

        confirmToDeleteThisOffer:
            'Xác nhận xóa ưu đãi này',

        addProjectData:
            'Thêm dữ liệu hạng mục',

        popUpsAreClosed:
            'Cửa sổ đã đóng',

        beSureToRemoveThisRestriction:
            'Xác nhận xóa giới hạn này',

        imageUploadFailed:
            'Tải ảnh lên thất bại',
    },

    tiktokpresalecouponList: {
        deleteConfirm:
            'Sau khi xóa, sản phẩm không thể khôi phục. Xác nhận xóa?',

        shelveConfirm:
            'Sau khi gỡ bán, sản phẩm sẽ không thể tiếp tục bán. Xác nhận gỡ bán?',

        unrestrictedInventory:
            'Không giới hạn tồn kho',

        theRemovalHasBeenCancelled:
            'Đã hủy gỡ bán',

        productId:
            'Mã sản phẩm',

        product:
            'Sản phẩm',

        createACoupon:
            'Thêm mới',

        listing:
            'Đăng bán',

        delist:
            'Gỡ bán',

        auditFailure:
            'Kiểm duyệt thất bại',

        soldInventory:
            'Tồn kho đã bán',

        modifiedPricePool:
            'Chỉnh sửa kho giá',

        copy:
            'Sao chép',

        exportListOfPreSaleTickets:
            'Xuất danh sách voucher bán trước',

        itemDeletion:
            'Xóa sản phẩm',

        goodsOffTheProductionLine:
            'Ngừng bán sản phẩm',

        removedSuccessfully:
            'Gỡ bán thành công',
    },
    assemblyAddpriceruledialog: {
        allStores: 'Tất cả khách sạn',
        byDate: 'Theo ngày',
        byHoliday: 'Theo ngày lễ',
        addMarkupRules: 'Thêm quy tắc phụ thu',
        markupStore: 'Khách sạn áp dụng phụ thu',
        markUpPeriod: 'Khoảng thời gian phụ thu',
        pleaseEnterTheAmountOfTheIncrease: 'Vui lòng nhập số tiền phụ thu',
        theIncreaseMustBeGreaterThan: 'Số tiền phụ thu phải lớn hơn',
        pleaseSelectTheIncreasePeriod: 'Vui lòng chọn khoảng thời gian phụ thu',
        pleaseSelectAFestival: 'Vui lòng chọn ngày lễ',
        pleaseSelectTheWeekOfIncrease: 'Vui lòng chọn thứ áp dụng phụ thu',
    },

    assemblyAddmeals: {
        addMeal: 'Thêm bữa ăn',
        typeOfMeal: 'Loại bữa ăn',
        pleaseSelectTheTypeOfMeal: 'Vui lòng chọn loại bữa ăn',
        lunch: 'Bữa trưa',
        dinner: 'Bữa tối',
        copies: 'Số phần',
        pleaseEnterTheNumberOfCopies: 'Vui lòng nhập số phần',
        theNumberOfCopiesMustBeGreaterThan: 'Số phần phải lớn hơn',
    },

    settingHardware: {
        hardwareManagementToBeDeveloped: 'Quản lý phần cứng, đang phát triển',
    },

    settingMessage: {
        messageManagementToBeDeveloped: 'Quản lý tin nhắn, đang phát triển',
    },

    baseinfotabBase: {
        orientation: 'Định vị',
        china: 'Trung Quốc',
        province: 'Tỉnh',
        hotelRating: 'Hạng sao khách sạn',
        detailedAddress: 'Địa chỉ chi tiết',
        city: 'Thành phố',
        hotelPrice: 'Giá khách sạn',
        hotelReceptionCellPhone: 'Số di động lễ tân khách sạn',
        hotelFrontDesk: 'Điện thoại bàn lễ tân khách sạn',
        areaCode: 'Mã vùng',
        landlineNumber: 'Số điện thoại bàn',
        extensionNumber: 'Số máy lẻ',
        serviceStatus: 'Trạng thái dịch vụ',
        ctripHotelStars: 'Hạng sao khách sạn Ctrip',
        noStarLevel: 'Không có hạng sao',
        starLevel: '{num} sao',
        whetherToSellItOnTheInternet: 'Có bán trên kênh trực tuyến hay không',
        currency: 'Loại tiền tệ',
        longitude: 'Kinh độ',
        latitude: 'Vĩ độ',
        baiduLatitudeAndLongitude: 'Kinh vĩ độ Baidu',
        pleaseEnterTheCorrectPhoneNumberWithAMaximumOf11Digits:
            'Vui lòng nhập đúng số điện thoại, tối đa 11 chữ số',
        theLengthIs78Characters: 'Độ dài từ 7-8 ký tự',
        theLengthIs34Characters: 'Độ dài từ 3-4 ký tự',
        pleaseEnterAnInteger: 'Vui lòng nhập số nguyên',
        pleaseEnterTheHotelName: 'Vui lòng nhập tên khách sạn',
        lengthOf250ChineseCharacters: 'Độ dài từ 2-50 ký tự tiếng Trung',
        theValueContains34Digits: 'Độ dài từ 3-4 chữ số',
        theValueContains78Characters: 'Độ dài từ 7-8 chữ số',
        pleaseEnterTheValue: 'Vui lòng nhập giá trị',
        pleaseSelectAProvince: 'Vui lòng chọn tỉnh',
        pleaseSelectCity: 'Vui lòng chọn thành phố',
        pleaseSelectACounty: 'Vui lòng chọn quận/huyện',
        pleaseEnterTheFullAddress2: 'Vui lòng nhập địa chỉ chi tiết',
        theDetailedAddressDoesNotExceed50ChineseCharacters:
            'Địa chỉ chi tiết không được vượt quá 50 ký tự tiếng Trung',
        pleaseSelectHotelClass: 'Vui lòng chọn hạng sao khách sạn',
        pleaseSelectACtripHotelStar: 'Vui lòng chọn hạng sao khách sạn Ctrip',
        selectWhetherTheExternalNetworkIsVisible:
            'Vui lòng chọn có hiển thị trên kênh ngoài hay không',
        pleaseSelectHotelServiceStatus: 'Vui lòng chọn trạng thái dịch vụ khách sạn',
        economical: 'Khách sạn phổ thông',
        quasi1Star: 'Gần 1 sao',
        true1Star: '1 sao',
        quasi2Star: 'Gần 2 sao',
        true2Star: '2 sao',
        quasi3Star: 'Gần 3 sao',
        true3Star: '3 sao',
        quasi4Star: 'Gần 4 sao',
        true4Star: '4 sao',
        quasi5Star: 'Gần 5 sao',
        true5Star: '5 sao',
        inOperation: 'Đang hoạt động',
        suspendBusiness: 'Tạm ngừng kinh doanh',
        tencentMapLatitudeAndLongitudeCanNotBeEmpty:
            'Kinh vĩ độ Tencent Map không được để trống',
        theNameAndAddressOfTheHotelAreUnderReview:
            'Tên và địa chỉ khách sạn đang được xét duyệt',
        districtcounty: 'Quận/Huyện',
        tencentamapLatitudeAndLongitude: 'Kinh vĩ độ Tencent/Amap',
        pleaseEnterTheCorrectPhoneNumberAndTheMaximumIs11Digits:
            'Vui lòng nhập đúng số điện thoại, tối đa 11 chữ số',
    },
    baseinfotabFull: {
        hotelTimezone: 'Múi giờ khách sạn',

        fixedRoomNumber: 'Số lượng phòng cố định',

        businessCircle: 'Khu thương mại',

        hotelBuildingHeight: 'Số tầng khách sạn',

        subordinateBusinessCircle: 'Khu thương mại phụ',

        totalNumberOfRooms: 'Tổng số phòng',

        hotelOpeningHours: 'Thời gian khai trương khách sạn',

        pleaseSelectADate5: 'Vui lòng chọn năm/tháng',

        affiliatedGroup: 'Tập đoàn trực thuộc',

        hotelRenovationTime: 'Thời gian cải tạo khách sạn',

        affiliatedBrand: 'Thương hiệu trực thuộc',

        hotelTypeupToThree: 'Loại hình khách sạn (tối đa 3 lựa chọn)',

        hotelThemeupToThreeCanBeSelected: 'Chủ đề khách sạn (tối đa 3 lựa chọn)',

        settlementMethod: 'Phương thức thanh toán',

        hotelProfile: 'Giới thiệu khách sạn',

        hotelTransportationLocation: 'Vị trí giao thông khách sạn',

        pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits:
            'Vui lòng nhập số lớn hơn hoặc bằng 0, tối đa 3 chữ số',

        pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits:
            'Vui lòng nhập số lớn hơn hoặc bằng 0, tối đa 2 chữ số',

        pleaseEnterADescriptionOfTheHotelWithAMaximumLengthOf800Characters:
            'Vui lòng nhập giới thiệu khách sạn, tối đa 800 ký tự',

        pleaseEnterTheHotelTransportationLocation:
            'Vui lòng nhập thông tin vị trí giao thông khách sạn',

        pleaseEnterTheHotelTransportationLocationInAMaximumOf800Characters:
            'Vui lòng nhập thông tin vị trí giao thông khách sạn, tối đa 800 ký tự',

        pleaseEnterTheTotalNumberOfRooms:
            'Vui lòng nhập tổng số phòng',

        pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits2:
            'Vui lòng nhập số lớn hơn hoặc bằng 0 và không quá 3 chữ số',

        pleaseSelectYourBrand:
            'Vui lòng chọn thương hiệu',

        pleaseEnterTheHotelBuildingHeight:
            'Vui lòng nhập số tầng khách sạn',

        pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits2:
            'Vui lòng nhập số lớn hơn hoặc bằng 0 và không quá 2 chữ số',

        pleaseEnterHotelRenovationTime:
            'Vui lòng nhập thời gian cải tạo khách sạn',

        pleaseEnterHotelOpeningHours:
            'Vui lòng nhập thời gian khai trương khách sạn',

        pleaseEnterTheCheckoutSupportCardType:
            'Vui lòng nhập loại thẻ hỗ trợ thanh toán',

        pleaseSelectHotelType:
            'Vui lòng chọn loại hình khách sạn',

        pleaseSelectAHotelTheme:
            'Vui lòng chọn chủ đề khách sạn',

        bizumi: 'Meizhu',

        theBusinessCircleIsUnderReview:
            'Khu thương mại đang được xét duyệt',

        includesButNotLimitedToHotelAddressHotelFacilitiesHotelServicesProvidedHotelFeaturesAndAdvantages:
            'Bao gồm nhưng không giới hạn: địa chỉ khách sạn, cơ sở vật chất, dịch vụ cung cấp, đặc điểm và lợi thế của khách sạn',

        includesButNotLimitedToTrafficFacilitiesNearTheHotelSuchAsDistanceFromTheBusStation100MetersDistanceFromTheHighSpeedTrainStation25Km:
            'Bao gồm nhưng không giới hạn: các tiện ích giao thông gần khách sạn, ví dụ: cách bến xe buýt 100m, cách ga tàu cao tốc 2,5km',
    },

    baseinfotabInfo: {
        commission2: 'Thuế và phí',

        bookingInstructions: 'Lưu ý đặt phòng',

        variousFaults: 'Các loại sự cố',

        earliestCheckInTime: 'Thời gian nhận phòng sớm nhất',

        latestDepartureTime: 'Thời gian trả phòng muộn nhất',

        hourRoomEarliestCheckInTime:
            'Thời gian nhận phòng sớm nhất của phòng theo giờ',

        hourRoomLatestCheckOutTime:
            'Thời gian trả phòng muộn nhất của phòng theo giờ',

        aMaximumOf30Characters:
            'Tối đa 30 ký tự',

        taxTitle: 'Tên thuế/phí',

        chargingStandard: 'Tiêu chuẩn tính phí',

        reservationNotes: 'Ghi chú đặt phòng',

        chineseDescription: 'Mô tả tiếng Trung',

        pleaseEnterYourEarliestCheckInTime:
            'Vui lòng nhập thời gian nhận phòng sớm nhất',

        pleaseEnterTheLatestDepartureTime:
            'Vui lòng nhập thời gian trả phòng muộn nhất',

        pleaseEnterTheEarliestCheckInTimeForTheHourRoom:
            'Vui lòng nhập thời gian nhận phòng sớm nhất của phòng theo giờ',

        pleaseEnterTheLatestCheckOutTimeForTheHourRoom:
            'Vui lòng nhập thời gian trả phòng muộn nhất của phòng theo giờ',

        pleaseSelectTheBookingInstructions:
            'Vui lòng chọn lưu ý đặt phòng',

        noMoreThan10ChineseCharactersInLength:
            'Độ dài không quá 10 ký tự',

        theLengthCannotExceed20Characters:
            'Độ dài không quá 20 ký tự',

        noMoreThan20ChineseCharactersInLength:
            'Độ dài không quá 20 ký tự',

        noMoreThan30ChineseCharactersInLength:
            'Độ dài không quá 30 ký tự',

        theLengthCannotExceed60Characters:
            'Độ dài không quá 60 ký tự',

        cutOffTheWaterSupply:
            'Mất nước',

        powerFailure:
            'Mất điện',

        elevatorFailure:
            'Sự cố thang máy',

        cantUseBankCard:
            'Không thể thanh toán bằng thẻ ngân hàng',

        networkFault:
            'Sự cố mạng',

        pleaseEnterTheStartTimeAndEndTime:
            'Vui lòng nhập thời gian bắt đầu và kết thúc',

        theStartTimeMustBeYoungerThanTheEndTime:
            'Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc',
    },

    baseinfotabServer: {
        squareMeter: 'Mét vuông',

        parkingLot: 'Bãi đỗ xe',

        elevator2: 'Thang máy',

        pleaseEnterArea:
            'Vui lòng nhập diện tích',

        internetAccessInPublicAreas:
            'Internet tại khu vực công cộng',

        hotelFacilities:
            'Tiện nghi khách sạn',

        otherFacilities:
            'Tiện nghi khác',

        hotelService:
            'Dịch vụ khách sạn',

        otherServices:
            'Dịch vụ khác',

        fallow:
            'Giải trí',

        otherLeisure:
            'Hoạt động giải trí khác',

        pleaseEnterAMaximumOf10DigitsInEnglish:
            'Vui lòng nhập tối đa 10 ký tự (tiếng Anh, tiếng Trung hoặc số)',

        pleaseSelectParking:
            'Vui lòng chọn bãi đỗ xe',

        pleaseSelectTheHall:
            'Vui lòng chọn sảnh',

        pleaseEnterTheHallArea:
            'Vui lòng nhập diện tích sảnh',

        pleaseSelectElevator:
            'Vui lòng chọn thang máy',

        pleaseSelectPublicAreasToAccessTheInternet:
            'Vui lòng chọn internet khu vực công cộng',

        pleaseSelectHotelFacilities:
            'Vui lòng chọn tiện nghi khách sạn',

        pleaseSelectHotelServices:
            'Vui lòng chọn dịch vụ khách sạn',

        pleaseSelectLeisure:
            'Vui lòng chọn tiện ích giải trí',

        oneToFiveStars:
            'Chuẩn 1-5 sao',

        true15Stars:
            '1-5 sao',

        walkUp:
            'Không có thang máy',

        thereIsAnElevator:
            'Có thang máy',

        lobbyless:
            'Không có sảnh',

        haveALobby:
            'Có sảnh',

        noInternetAccess:
            'Không có Internet',

        freeParking:
            'Bãi đỗ xe miễn phí',

        noParking:
            'Không có bãi đỗ xe',

        parkingLotAvailable:
            'Có bãi đỗ xe',

        paidParking:
            'Bãi đỗ xe tính phí',

        charge:
            'Có tính phí',
    },
    borrowBorrowrecord: {
        loanDate2: 'Ngày mượn',

        newBorrowing: 'Thêm mới',

        return: 'Trả lại',

        cannotBeGreaterThanTheAvailableAmount:
            'Không được lớn hơn số lượng khả dụng',

        enterItemNameAndRoomNumber:
            'Tên vật phẩm, số phòng',

        unitPriceOfGoods2:
            'Đơn giá vật phẩm',

        quantityBorrowed:
            'Số lượng mượn',

        borrowARoom:
            'Phòng mượn',

        dateOfReturn:
            'Ngày trả',

        returnQuantity:
            'Số lượng trả',

        borrowedState:
            'Trạng thái mượn',

        amountOfCompensation:
            'Tiền bồi thường',

        serviceSuccess:
            'Phục vụ thành công',

        serviceFailure:
            'Phục vụ thất bại',

        reasonForRefusal:
            'Lý do từ chối',

        enterAMaximumOf30Characters:
            'Tối đa 30 ký tự',

        returnOrNot:
            'Có trả hay không',

        hasItBeenReturned:
            'Đã trả hay chưa',

        onlyNumbersGreaterThan0CanBeEntered:
            'Chỉ được nhập số lớn hơn 0',

        theAmountReturnedCannotBeGreaterThanOrEqualToTheAmountBorrowed:
            'Số lượng trả không được lớn hơn hoặc bằng số lượng đã mượn',

        upTo20Characters:
            'Tối đa 20 ký tự',

        pleaseEnterTheReturnQuantity:
            'Vui lòng nhập số lượng trả',

        onLoan:
            'Đang mượn',

        theRoomRequestHasBeenServiced:
            'Yêu cầu dịch vụ phòng đã hoàn thành',

        serviceCompletion:
            'Hoàn thành dịch vụ',

        returned:
            'Đã trả',

        noReturn:
            'Chưa trả',

        enterAMaximumOf9Characters:
            'Tối đa 9 ký tự',

        chooseToBorrowRoom:
            'Chọn phòng mượn',
    },

    borrowBorrowset: {
        newItem:
            'Thêm mới',

        usable:
            'Khả dụng',

        notAvailable:
            'Không khả dụng',

        alreadyRemoved:
            'Đã xóa',

        enterItemName:
            'Tên vật phẩm',

        unitPriceOfGoods2:
            'Đơn giá vật phẩm',

        inventory:
            'Tồn kho',

        amountBorrowed:
            'Số lượng đã mượn',

        loanableQuantity:
            'Số lượng có thể cho mượn',

        theNameCannotExceed9CharactersPleaseEnterANewName:
            'Tên không được vượt quá 9 ký tự, vui lòng nhập lại',

        priceCannotBeLessThan0PleaseReEnter:
            'Giá không được nhỏ hơn 0, vui lòng nhập lại',

        priceCannotBeGreaterThan9999PleaseReEnter:
            'Giá không được lớn hơn 9999, vui lòng nhập lại',

        theInventoryCannotBeLessThan0PleaseReEnter:
            'Tồn kho không được nhỏ hơn 0, vui lòng nhập lại',

        inventoryCannotBeLessThanTheBorrowedAmountPleaseReEnter:
            'Tồn kho không được nhỏ hơn số lượng đã mượn, vui lòng nhập lại',

        areYouSureYouWantToDeleteThisItem:
            'Bạn có chắc muốn xóa vật phẩm này không?',

        areYouSureYouWantToDisableThisItem:
            'Bạn có chắc muốn vô hiệu hóa vật phẩm này không?',

        thisItemHasNotBeenReturnedConfirmToDelete:
            'Vật phẩm này vẫn còn chưa được trả, xác nhận xóa?',
    },

    businessCardIndex: {
        pleaseUploadPictures:
            'Vui lòng tải lên hình ảnh',

        pleaseEnterRoomType:
            'Vui lòng nhập loại phòng',

        uploadBackground:
            'Tải ảnh nền',

        saveOperation:
            'Lưu',

        uploadProfilePicture:
            'Tải ảnh đại diện',

        pleaseEnterAValidNumber:
            'Vui lòng nhập số hợp lệ',

        businessCardType:
            'Loại danh thiếp',

        currentPriceOfRoomType:
            'Giá hiện tại của loại phòng',

        roomTypeOriginalPrice:
            'Giá gốc của loại phòng',

        backgroundImage:
            'Ảnh nền',

        avatar:
            'Ảnh đại diện',

        hotelRecommendation:
            'Khách sạn đề xuất',

        roomTypeRecommendation:
            'Loại phòng đề xuất',

        theNameCannotBeBlank2:
            'Tên không được để trống',

        thePhoneNumberCannotBeEmpty:
            'Số điện thoại không được để trống',

        pleaseEnterAValidPhoneNumber:
            'Vui lòng nhập số điện thoại hợp lệ',

        roomTypeNameCannotBeEmpty:
            'Tên loại phòng không được để trống',

        theCurrentPriceOfTheRoomTypeCannotBeEmpty:
            'Giá hiện tại của loại phòng không được để trống',

        roomTypeOriginalPriceCannotBeEmpty:
            'Giá gốc của loại phòng không được để trống',

        pleaseUploadTheBackgroundImage:
            'Vui lòng tải lên ảnh nền',

        pleaseUploadPhoto:
            'Vui lòng tải lên ảnh đại diện',

        areYouSureYouWantToLeaveTheCurrentPage:
            'Bạn có chắc muốn rời khỏi trang hiện tại không?',

        pleaseSelectImageUpload:
            'Vui lòng chọn ảnh để tải lên',

        theCurrentPriceOfTheRoomTypeShallNotBeLessThan:
            'Giá hiện tại của loại phòng không được nhỏ hơn',

        roomTypeOriginalPriceMustNotBeLessThan:
            'Giá gốc của loại phòng không được nhỏ hơn',
    },

    businessCardUploadavatar: {
        selectPicture:
            'Chọn ảnh',

        uploadProfilePicture:
            'Tải ảnh đại diện',

        pleaseSelectImageUpload:
            'Vui lòng chọn ảnh để tải lên',

        onlyJpgAndPngImagesAreSupportedAndTheSizeOfTheImageDoesNotExceed5m:
            'Chỉ hỗ trợ ảnh JPG và PNG, dung lượng ảnh không vượt quá 5MB',
    },
    ctnhotelHotelserver: {
        applicationTime2: 'Thời gian đăng ký',

        toDealWith: 'Đi xử lý',

        pleaseRenewYourStayOnTheDayOfDeparture:
            'Vui lòng gia hạn lưu trú vào ngày trả phòng',

        applicant:
            'Người đăng ký',

        originalExpectedArrivalDate:
            'Ngày đến dự kiến ban đầu',

        originalDepartureDate:
            'Ngày trả phòng dự kiến ban đầu',

        applicationType:
            'Loại yêu cầu',

        renewTheNewOrderNumber:
            'Mã đơn gia hạn mới',

        renewalDate:
            'Ngày gia hạn lưu trú',
    },

    ebaccountLogin: {
        accountLogin:
            'Đăng nhập tài khoản',

        gotTheMessage:
            'Đã nhận được tin nhắn',
    },

    ebaccountSetting: {
        accountBinding:
            'Liên kết tài khoản',

        goToMaintain:
            'Đi bảo trì',

        priceModel:
            'Mô hình giá',

        automaticOrder:
            'Tự động chuyển đơn',

        comingSoon:
            'Sắp ra mắt',

        hourlyRoomOrder:
            'Nhận đơn phòng theo giờ',

        orderCancellation:
            'Hủy đơn hàng',

        bound:
            'Đã liên kết',

        roomTypeSetting:
            'Cài đặt loại phòng',

        goToSettings:
            'Đi cài đặt',

        lastStep:
            'Bước trước',

        correlationState:
            'Trạng thái liên kết',

        bindAccount:
            'Liên kết tài khoản',

        synchronizationTime:
            'Thời gian đồng bộ',

        onSale:
            'Đang bán',

        associated:
            'Đã liên kết',

        uncorrelated:
            'Chưa liên kết',

        bind:
            'Liên kết',

        noDataIsQueried:
            'Không tìm thấy dữ liệu',

        whetherToUnbindTheAccount:
            'Bạn có muốn hủy liên kết tài khoản không?',

        pleaseEnterTheCommissionRate:
            'Vui lòng nhập tỷ lệ hoa hồng',

        channelSetting:
            'Cài đặt kênh',

        floorPriceModel:
            'Chế độ giá sàn',

        sellingPriceModel:
            'Chế độ giá bán',

        viewSettings:
            'Xem cài đặt',

        orderSetup:
            'Cài đặt đơn hàng',

        pleaseSelectAPriceModel:
            'Vui lòng chọn mô hình giá',

        pleaseSelectHourRoomPickUp:
            'Vui lòng chọn cài đặt nhận đơn phòng giờ',

        dataSynchronization:
            'Đồng bộ dữ liệu',

        ctripRoomType:
            'Loại phòng Ctrip',

        usGroupRoomType:
            'Loại phòng Meituan',

        lightWinTreasureRoomTypeName:
            'Tên loại phòng EaseHUB',

        commissionRate:
            'Tỷ lệ hoa hồng',

        pleaseEnterTheSmsVerificationCode:
            'Vui lòng nhập mã xác thực SMS',

        pleaseEnterTheContentInThePicture:
            'Vui lòng nhập nội dung trong hình',

        groggery:
            'Khách sạn',

        ctripProductName:
            'Tên sản phẩm Ctrip',

        meituanProductName:
            'Tên sản phẩm Meituan',

        ctripProducts:
            'Sản phẩm Ctrip',

        meituanProducts:
            'Sản phẩm Meituan',

        lightWinTreasureProductName:
            'Tên sản phẩm EaseHUB',

        commissionRateIsGreaterThanOrEqualTo0AndLessThan100:
            'Tỷ lệ hoa hồng phải lớn hơn hoặc bằng 0 và nhỏ hơn 100',

        commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
            'Tỷ lệ hoa hồng phải là số và giữ tối đa 2 chữ số thập phân',

        pleaseSelectTheHourlyOrderSetting:
            'Vui lòng chọn cài đặt chuyển đơn phòng giờ',

        automaticCancellation:
            'Tự động hủy',

        manualCancellation:
            'Hủy thủ công',

        automaticConfirmation:
            'Tự động xác nhận',

        manualValidation:
            'Xác nhận thủ công',

        meituancom:
            'Meituan',

        ctrip:
            'Ctrip',

        pleaseEnterTheImageVerificationCode:
            'Vui lòng nhập mã xác thực hình ảnh',

        pleaseSelectHotel:
            'Vui lòng chọn khách sạn',

        theDataSynchronizationIsSuccessfulQueryTheDataAgain10MinutesLater:
            'Đồng bộ dữ liệu thành công, vui lòng kiểm tra lại sau 10 phút',

        unbind:
            'Hủy liên kết',

        whetherToUnbindTheProduct:
            'Bạn có muốn hủy liên kết sản phẩm này không?',

        pleaseSelectTheProductName:
            'Vui lòng chọn tên sản phẩm EaseHUB',

        unbindSuccessfully:
            'Hủy liên kết thành công',

        whetherToUnbindTheBindingRelationshipOfTheHouseType:
            'Bạn có muốn hủy liên kết loại phòng này không?',

        pleaseSelectLightWinTreasureRoomTypeName:
            'Vui lòng chọn tên loại phòng EaseHUB',

        feizhu:
            'Fliggy',

        notYetUnlocked:
            'Chưa kích hoạt',

        pleaseBindTheAccountFirst:
            'Vui lòng liên kết tài khoản trước',

        areYouSureYouWantToUnbindTheAccount:
            'Bạn có chắc chắn muốn hủy liên kết tài khoản không?',

        notYetBound:
            'Chưa liên kết',

        pleaseConfirmTheHotelYouWantToBindTo:
            'Vui lòng xác nhận khách sạn cần liên kết',

        ctripEbAccount:
            'Tài khoản Ctrip EB',

        meituanEbAccount:
            'Tài khoản Meituan EB',

        pleaseContactYourHotelOperationsManagerToSetUpACtripHotelid:
            'Vui lòng liên hệ quản lý vận hành để thiết lập HotelID của Ctrip',

        useEbOrderInformation:
            'Sử dụng thông tin đơn hàng EB',

        pleaseSelectEbOrderCancellation:
            'Vui lòng chọn cách hủy đơn EB',

        meituanEbRoomType:
            'Loại phòng Meituan EB',

        lightWinTreasureRoomTypeId:
            'ID loại phòng EaseHUB',

        lightWinTreasureProductId:
            'ID sản phẩm EaseHUB',

        pleaseSelectTheEbOrderCancellationSettings:
            'Vui lòng chọn cài đặt hủy đơn EB',

        whenYouAutomaticallyMoveTheOrderIfYouDoNotSetTheRoomTypeYouWillMoveTheOrderManually:
            'Khi tự động chuyển đơn, nếu chưa cấu hình loại phòng thì sẽ chuyển sang xử lý thủ công',

        whenYouManuallyMoveTheOrderYouWillBeGivenPriorityToMatchTheRoomTypeSetSavingTheTimeOfMovingTheOrder:
            'Khi chuyển đơn thủ công, hệ thống sẽ ưu tiên ghép loại phòng đã cấu hình để tiết kiệm thời gian',

        thisEbOrderSetupCompletedPleaseProceedAsSoonAsPossible:
            'Cài đặt đơn hàng EB đã hoàn tất, vui lòng tiếp tục càng sớm càng tốt',

        reminderIfYouNeedToSetOrAddARoomTypePleaseContactYourOperationalManager:
            'Lưu ý: Nếu cần thiết lập hoặc thêm loại phòng, vui lòng liên hệ quản lý vận hành',

        orderSetupCompletedPleaseProceedAsSoonAsPossible:
            'Cài đặt đơn hàng đã hoàn tất, vui lòng tiếp tục càng sớm càng tốt',

        yourctripTravelEbkAccountisNotBoundAndYouWillNotBeAbleTo:
            'Tài khoản Ctrip EBK của bạn chưa được liên kết, bạn sẽ không thể thực hiện',

        associationToAvoidAffectingEbMovingOrdersPleaseBindAsSoonAsPossible:
            'liên kết. Để tránh ảnh hưởng đến việc chuyển đơn EB, vui lòng liên kết sớm nhất có thể',

        yourctripTravelEbkAccounthasExpiredAndYouWillNotBeAbleTo:
            'Tài khoản Ctrip EBK của bạn đã hết hạn, bạn sẽ không thể thực hiện',

        associationToAvoidAffectingEbMovingOrdersPleaseunbindAndReBindAfterThe:
            'liên kết. Để tránh ảnh hưởng đến việc chuyển đơn EB, vui lòng hủy liên kết và liên kết lại',

        yourmeituanEbkAccountisNotBoundAndYouWillNotBeAbleTo:
            'Tài khoản Meituan EBK của bạn chưa được liên kết, bạn sẽ không thể thực hiện',

        automaticallyCreditedToArAccount:
            'Tự động ghi nhận vào tài khoản AR',

        noticeOfMovingOrderEb:
            'EB tự động nhận đơn sau khi chuyển đơn thành công',

        checkInSuccessNoticeEb:
            'Thông báo nhận phòng',

        meituanMovingOrderDeductsPublicGoods:
            'Khấu trừ quỹ công ích khi chuyển đơn Meituan',

        meituanMovingOrderServiceRate:
            'Tỷ lệ phí dịch vụ vận hành Meituan (%)',

        yourctripTravelEbkAccounthasExpired:
            'Tài khoản Ctrip EB của bạn đã hết hạn, vui lòng nhấn "Đi bảo trì" để thiết lập lại tài khoản EB',

        yourmeituanEbkAccounthasExpired:
            'Tài khoản Meituan EB của bạn đã hết hạn, vui lòng nhấn "Đi bảo trì" để thiết lập lại tài khoản EB',
    },
    ebmanagementIndex: {
        accountBinding:
            'Liên kết tài khoản',

        commissionRate:
            'Tỷ lệ hoa hồng',

        theAccountIsBoundSuccessfullyAndTheInDepthOperationIsStartedSimultaneously:
            'Liên kết tài khoản thành công và đồng thời kích hoạt vận hành chuyên sâu',

        whetherToUnbindTheAccount:
            'Bạn có muốn hủy liên kết tài khoản không?',

        pleaseEnterTheCommissionRate:
            'Vui lòng nhập tỷ lệ hoa hồng',

        theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
            'Chiều thời gian nhất quán với ngày được chọn, doanh thu đặt phòng được tính theo số tiền thực tế khách đã thanh toán',

        pleaseEnterTheSmsVerificationCode:
            'Vui lòng nhập mã xác thực SMS',

        pleaseEnterTheContentInThePicture:
            'Vui lòng nhập nội dung trong hình',

        groggery:
            'Khách sạn',

        commissionRateIsGreaterThanOrEqualTo0AndLessThan100:
            'Tỷ lệ hoa hồng phải lớn hơn hoặc bằng 0 và nhỏ hơn 100',

        commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
            'Tỷ lệ hoa hồng phải là số và tối đa 2 chữ số thập phân',

        pleaseSelectHotel:
            'Vui lòng chọn khách sạn',

        pleaseEnterTheImageVerificationCode:
            'Vui lòng nhập mã xác thực hình ảnh',

        accountUntying:
            'Hủy liên kết tài khoản',

        unbindSuccessfully:
            'Hủy liên kết thành công',

        pleaseConfirmTheHotelYouWantToBindTo:
            'Vui lòng xác nhận khách sạn cần liên kết',

        noEbAccountHasBeenBound:
            'Chưa liên kết bất kỳ tài khoản EB nào',

        ebAccountLogin:
            'Đăng nhập tài khoản EB',
    },

    hardwareBluetoothlock: {
        smartDoorLock:
            'Khóa cửa thông minh',

        configurationFailure:
            'Cấu hình thất bại',

        thisFunctionSpecificallyRefersToTheConnectionOfSmartDoorLocksSuchAsPasswordAndBluetoothWhichCanBeOpenedByUsingPasswordAndBluetoothThroughSmallProgramsAndAppsToImproveTheCustomersCheckInExperience:
            'Chức năng này dùng để tích hợp khóa cửa thông minh như mật khẩu và Bluetooth. Khách có thể mở cửa bằng mật khẩu hoặc Bluetooth thông qua Mini App và ứng dụng di động, giúp nâng cao trải nghiệm nhận phòng.',
    },

    hardwareChoseroom: {
        selectARoom2:
            'Chọn phòng',
    },

    hardwareCreatepassworddialog: {
        createPassword:
            'Tạo mật khẩu',

        selectType:
            'Chọn loại',

        pleaseEnterAgain:
            'Vui lòng nhập lại',

        validUntil:
            'Có hiệu lực đến',

        pleaseEnterA6DigitPassword:
            'Vui lòng nhập mật khẩu gồm 6 chữ số',

        passwordIsDifferentPleaseReEnter:
            'Mật khẩu không khớp, vui lòng nhập lại',

        oneTimePassword:
            'Mật khẩu một lần',

        timePeriodCipher:
            'Mật khẩu theo thời gian',

        offlinePassword:
            'Mật khẩu ngoại tuyến',

        longAgingOfflinePassword:
            'Mật khẩu ngoại tuyến dài hạn',
    },

    hardwareEditpassworddialog: {
        oneTimePassword:
            'Mật khẩu một lần',

        timePeriodCipher:
            'Mật khẩu theo thời gian',

        offlinePasswordForALongTime:
            'Mật khẩu ngoại tuyến dài hạn',

        offlinePassword:
            'Mật khẩu ngoại tuyến',

        recover2:
            'Khôi phục',

        currentPassword:
            'Mật khẩu hiện tại',

        pleaseEnterAgain:
            'Vui lòng nhập lại',

        validUntil:
            'Có hiệu lực đến',

        pleaseEnterA6DigitPassword:
            'Vui lòng nhập mật khẩu gồm 6 chữ số',

        passwordIsDifferentPleaseReEnter:
            'Mật khẩu không khớp, vui lòng nhập lại',

        longAgingOfflinePassword:
            'Mật khẩu ngoại tuyến dài hạn',
    },

    hardwareHousepricecard: {
        memberRightsShowStoreActivitiesShow:
            'Hiển thị quyền lợi thành viên và chương trình khuyến mãi của khách sạn',

        openThePriceBoard:
            'Mở bảng giá phòng',

        downloadRateBoard:
            'Tải xuống bảng giá phòng',

        failedToConfigureElectronicPriceBoard:
            'Cấu hình bảng giá điện tử thất bại',
    },

    hardwareIdcard: {
        whenTheIdCardTypeIsIdCardTheIdCardInformationCanBeReadByTheIdCardReaderAndAutomaticallyFilledIntoTheTextBox:
            'Khi loại giấy tờ là CMND/CCCD, có thể sử dụng đầu đọc thẻ để đọc thông tin khách và tự động điền vào biểu mẫu',

        idCardReader:
            'Đầu đọc CMND/CCCD',

        failedToConfigureTheIdCardReader:
            'Cấu hình đầu đọc CMND/CCCD thất bại',
    },
    hardwareLock: {
        doorLockType:
            'Loại khóa cửa',

        selectiveLock:
            'Chọn khóa cửa',

        areYouSureYouWantToDeleteTheDoorLockConfigurationForThisRoom:
            'Bạn có chắc muốn xóa cấu hình khóa cửa của phòng này không?',

        pleaseEnterRoomNumberAndEquipmentModel:
            'Vui lòng nhập số phòng hoặc model thiết bị',

        doorLockCardPrintingRecord:
            'Lịch sử tạo thẻ khóa',

        roomDoorLockConfiguration2:
            'Cấu hình khóa cửa phòng',

        passwordSetting2:
            'Cài đặt mật khẩu',

        deviceType:
            'Loại thiết bị',

        equipmentBrand:
            'Thương hiệu thiết bị',

        equipmentType:
            'Model thiết bị',

        versionNumber:
            'Phiên bản',

        roomLockNumber:
            'Số khóa phòng',

        doorLock:
            'Khóa cửa',

        doorLockPower:
            'Pin khóa cửa',

        editDoorLockConfiguration:
            'Chỉnh sửa cấu hình khóa cửa',

        selectDevice:
            'Chọn thiết bị',

        setTheDoorLock:
            'Cài đặt khóa cửa',

        setTheRoomLockNumber:
            'Thiết lập số khóa phòng',

        pleaseEnterDoorLock:
            'Vui lòng nhập khóa cửa',

        settingNmsParameters:
            'Thiết lập tham số quản lý mạng',

        pleaseEnterNetworkManagementParameters:
            'Vui lòng nhập tham số quản lý mạng',

        traditionalDoorLock:
            'Khóa cửa truyền thống',

        smartDoorLock:
            'Khóa cửa thông minh',

        pleaseEnterTheLockId:
            'Vui lòng nhập ID khóa cửa',

        pleaseEnterLockmac:
            'Vui lòng nhập lockMac',

        batchDelete:
            'Xóa hàng loạt',

        confirmBatchDeleteText:
            'Bạn có chắc muốn xóa hàng loạt cấu hình khóa cửa của các phòng đã chọn không?',

        pleaseSelectRecordsToDelete:
            'Vui lòng chọn bản ghi cần xóa',

        batchDeleteSuccess:
            'Xóa hàng loạt thành công',

        batchDeleteFail:
            'Xóa hàng loạt thất bại',
    },

    hardwareLockpassword: {
        createPassword:
            'Tạo mật khẩu',

        comeIntoForce:
            'Có hiệu lực',

        activationCode:
            'Mã kích hoạt',

        applicableRoom:
            'Phòng áp dụng',

        expirationDate3:
            'Ngày hết hạn',

        theDoorLockThatSupportsThePasswordIsNotEnabled:
            'Chưa kích hoạt khóa cửa hỗ trợ chức năng mật khẩu',

        passwordSetting:
            'Cài đặt mật khẩu',

        invalidate:
            'Vô hiệu hóa',

        restore:
            'Khôi phục',

        confirmInvalidatePassword:
            'Bạn có chắc muốn vô hiệu hóa mật khẩu hiện tại không?',
    },

    hardwareLockroom: {
        importTemplateFileName:
            'Mẫu nhập khóa cửa.xlsx',

        downloadSuccess:
            'Tải mẫu nhập khóa cửa thành công',

        downloadFail:
            'Tải mẫu nhập khóa cửa thất bại',

        importDialogTitle:
            'Nhập khóa cửa hàng loạt',

        roomDoorLockConfiguration:
            'Cấu hình khóa cửa phòng',

        customRule:
            'Quy tắc tùy chỉnh',

        rule:
            'Quy tắc',

        deviceType:
            'Loại thiết bị',

        selectDevice:
            'Chọn thiết bị',

        empty:
            'Trống',

        selectLock:
            'Chọn khóa cửa',

        deviceBrand:
            'Thương hiệu thiết bị',

        deviceModel:
            'Model thiết bị',

        version:
            'Phiên bản',

        configurationInfo:
            'Thông tin cấu hình',

        selectRoom:
            'Chọn phòng',

        lockDeviceId:
            'ID thiết bị khóa cửa',

        remainingPower:
            'Pin còn lại',

        remoteOpenDoorType:
            'Phương thức mở cửa từ xa',

        gatewayOpen:
            'Mở cửa qua Gateway',

        bluetoothOpen:
            'Mở cửa qua Bluetooth',

        rule1:
            'Số khóa = Số phòng',

        rule2Prefix:
            'Số khóa =',

        rule3Prefix:
            'Số khóa =',

        trimRoomNumber:
            'Bỏ ký tự đầu của số phòng',

        import:
            'Nhập dữ liệu',

        clickUpload:
            'Nhấn để tải lên',

        imported:
            'Đã nhập',

        rulePrefix:
            'Quy tắc:',

        generateLockId:
            'Tạo số khóa',

        lockIdLabel:
            'ID khóa cửa',

        roomLockNumberLabel:
            'Số khóa phòng',

        enterRoomLockNumber:
            'Vui lòng nhập số khóa phòng',

        enterLockId:
            'Vui lòng nhập ID khóa cửa',

        gatewayParams:
            'Tham số Gateway',

        enterGatewayParams:
            'Vui lòng nhập tham số Gateway',

        enterLockMac:
            'Vui lòng nhập lockMac',

        getFreeGoLock:
            'Lấy khóa cửa FreeGo',
    },
    hardwareNfclock: {
        thisFunctionRefersToTheDockingOfCarmenLockWhichCanImproveTheEfficiencyOfCheckInByMakingTheGuestsRoomCardThroughLightWinTreasure:
            'Chức năng này dùng để tích hợp khóa thẻ từ Carmen, cho phép tạo thẻ phòng cho khách thông qua EaseHUB PMS, giúp nâng cao hiệu quả làm thủ tục nhận phòng',

        traditionalDoorLock:
            'Khóa cửa truyền thống',

        doorLockInformationConfiguration2:
            'Cấu hình thông tin khóa cửa',

        functionCardManagement2:
            'Quản lý thẻ chức năng',

        failedToConfigureATraditionalDoorLock:
            'Cấu hình khóa cửa truyền thống thất bại',
    },

    hardwarePricecard: {
        full:
            'Hết phòng',

        serviceHotline:
            'Hotline hỗ trợ',

        downloadRateBoard:
            'Tải bảng giá phòng',
    },

    hardwareSelfdevicedialog: {
        selfServiceMachinePaymentConfiguration:
            'Cấu hình thanh toán cho máy tự phục vụ',

        depositAllocationCollection:
            'Cấu hình thu tiền đặt cọc',

        orderRetentionTimeConfiguration:
            'Cấu hình thời gian giữ đơn',

        whetherTheUnpaidOrderIsCancelledImmediately:
            'Hủy ngay đơn hàng chưa thanh toán',

        minutes:
            'phút',

        checkOutArrangement:
            'Cấu hình trả phòng',

        checkOutAccountingConfiguration:
            'Cấu hình nghiệp vụ trả phòng',

        temporaryCheckOut:
            'Trả phòng với công nợ tạm treo',

        checkOut2:
            'Thanh toán và trả phòng',

        autoAddRoomFeeConfig:
            'Cấu hình tự động thu thêm tiền phòng',

        whetherToEnableAutoAddRoomFee:
            'Bật chức năng tự động thu thêm tiền phòng',

        occupancyConfiguration:
            'Cấu hình nhận phòng',

        whetherToSupportHourRoomWithoutReservation:
            'Hỗ trợ nhận phòng giờ mà không cần đặt trước',

        supportForTimePeriodsWithoutReservation:
            'Khung giờ hỗ trợ nhận phòng giờ không cần đặt trước',

        theSelfServiceMachineIsSuccessfullyConfigured:
            'Cấu hình máy tự phục vụ thành công',

        selfServiceMachineConfiguration2:
            'Cấu hình máy tự phục vụ',

        pleaseFillInTheDepositConfiguration:
            'Vui lòng nhập cấu hình tiền đặt cọc',

        pleaseSelectTheTimePeriodWhenTheHourRoomIsNotBooked:
            'Vui lòng chọn khung giờ nhận phòng giờ không cần đặt trước',
    },

    hardwareSelfservice: {
        selfServiceMachine:
            'Máy tự phục vụ',

        selfServiceMachineConfiguration2:
            'Cấu hình máy tự phục vụ',

        failedToConfigureTheSelfServiceMachine:
            'Cấu hình máy tự phục vụ thất bại',

        thereIsNoSelfServiceMachineInTheHotel:
            'Khách sạn chưa cấu hình máy tự phục vụ',

        thisSwitchIsToOpenTheSelfServiceMachineAndPmsSystemInterfaceSwitchIfTheHotelNeedsToConnectToTheSelfServiceCheckInMachineYouNeedToTurnOnTheSwitch:
            'Công tắc này dùng để kích hoạt kết nối giữa máy tự phục vụ và hệ thống PMS. Nếu khách sạn cần kết nối với máy check-in tự động, vui lòng bật công tắc này',
    },

    hardwareSetWitness: {
        title:
            'Thiết bị nhận diện khuôn mặt và giấy tờ',

        desc:
            'Xác thực giấy tờ và khuôn mặt, hỗ trợ tự nhận phòng',

        setting:
            'Cài đặt',

        configSuccess:
            'Kích hoạt cấu hình nhận diện thành công',

        configClose:
            'Tắt cấu hình nhận diện thành công',

        configFailed:
            'Cấu hình thất bại',
    },

    hardwareWitness: {
        deviceSnSetting:
            'Cài đặt mã thiết bị',

        deviceSn:
            'SN thiết bị',

        addSn:
            'Thêm SN',

        enterSn:
            'Vui lòng nhập SN',

        addSnBtn:
            '+ Thêm SN',

        saveSuccess:
            'Lưu thành công',

        deleteSuccess:
            'Xóa thành công',

        snRepeatError:
            'SN không được trùng lặp',

        deleteConfirmMsg:
            'Bạn có chắc muốn xóa SN thiết bị này không?',

        deleteConfirmTitle:
            'Thông báo',
    },

    hardwareSethouserpricecard: {
        transversePlate:
            'Bản ngang',

        verticalVersion:
            'Bản dọc',

        addPictureUpload:
            'Thêm hình ảnh',

        show:
            'Hiển thị',

        doNotShow:
            'Không hiển thị',

        format:
            'Bố cục',

        storePicture:
            'Hình ảnh khách sạn',

        pleaseEnterADescription:
            'Vui lòng nhập mô tả',

        hourRoomRates:
            'Giá phòng theo giờ',

        pleaseSelectTheNumberOfHours:
            'Vui lòng chọn số giờ',

        whetherToDisplayMemberPrices:
            'Hiển thị giá thành viên',

        roomReservationPhone:
            'Điện thoại đặt phòng',

        pleaseEnterTheReservationNumber:
            'Vui lòng nhập số điện thoại đặt phòng',

        bookingGuide:
            'Nội dung hướng dẫn đặt phòng',

        pleaseEnterThePreOrderGuideCopy:
            'Vui lòng nhập nội dung hướng dẫn đặt phòng',

        hotelAnnouncement:
            'Thông báo khách sạn',

        pleaseEnterTheHotelBulletin:
            'Vui lòng nhập thông báo khách sạn',

        uploadedPictures:
            'Hình ảnh đã tải lên',

        storePicturesMustBeUploaded:
            'Bắt buộc tải lên hình ảnh khách sạn',

        onlyJpgjepgpngFormatIsSupported:
            'Chỉ hỗ trợ định dạng jpg, jpeg, png',
    },
    functionalcardAuthorizationcard: {
        authorizationCardBeforeReportingTheLoss:
            'Thẻ ủy quyền trước khi báo mất',

        authorizationCard:
            'Thẻ ủy quyền',

        generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
            'Thông thường chỉ cần quẹt thẻ ủy quyền lên khóa một lần. Nếu khóa phát ra hai tiếng "bíp bíp" nghĩa là ủy quyền thành công',

        whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
            'Khi thông tin số phòng hoặc thời gian trên khóa bị mất, có thể dùng thẻ cài đặt số phòng hoặc thẻ cài đặt thời gian để cấu hình lại khóa; hoặc quẹt thẻ ủy quyền liên tiếp 3 lần, sau đó dùng thẻ khách của phòng để mở cửa',
    },

    functionalcardExtendssetting: {
        after:
            'Sau',

        inMinutes:
            'phút',

        findRoomNumber:
            'Tìm số phòng',

        timeDeviation:
            'Sai lệch thời gian',

        roomNumberRequired:
            'Bắt buộc nhập số phòng',

        whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
            'Khi thông tin số phòng hoặc thời gian trên khóa bị mất, có thể dùng thẻ cài đặt số phòng hoặc thẻ cài đặt thời gian để cấu hình lại khóa; hoặc quẹt thẻ ủy quyền liên tiếp 3 lần rồi dùng thẻ khách để mở cửa',

        generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
            'Thông thường chỉ cần quẹt thẻ ủy quyền một lần, khóa phát ra hai tiếng "bíp bíp" là ủy quyền thành công',
    },

    functionalcardIndex: {
        selectiveClassification:
            'Chọn danh mục',

        functionCardManagement2:
            'Quản lý thẻ chức năng',

        authorizationCard:
            'Thẻ ủy quyền',

        extendedSettingsClass:
            'Nhóm cài đặt mở rộng',

        openCategory:
            'Nhóm mở cửa',

        specificFunctionClass:
            'Nhóm chức năng đặc biệt',

        businessCardFailure:
            'Tạo thẻ thất bại',
    },

    functionalcardOpendoor: {
        beforeTheLossWasReported:
            'Trước khi báo mất',

        publicDoorsCanBeOpened:
            'Có thể mở cửa công cộng',

        canOpenTheLock:
            'Có thể mở khóa chốt trong',

        availablePeriod:
            'Khung thời gian hiệu lực',

        startTimeRequired:
            'Bắt buộc nhập thời gian bắt đầu',

        theEndTimeIsRequired:
            'Bắt buộc nhập thời gian kết thúc',

        floorFill:
            'Bắt buộc nhập tầng',

        theFloorMustConsistOf4PureDigits:
            'Tầng phải gồm 4 chữ số',

        layerControlCardUsedToOpenAllLocksInASpecificLayerOfABuilding:
            'Thẻ kiểm soát tầng: dùng để mở tất cả khóa cửa trên một tầng cụ thể của tòa nhà',

        totalCardCanOpenAllLocksInThisSystem:
            'Thẻ tổng: có thể mở tất cả khóa trong hệ thống',
    },

    functionalcardParticularfeature: {
        checkOutCardBeforeTheLossWasReported:
            'Thẻ trả phòng trước khi báo mất',

        theMissingCardNumber:
            'Số thẻ bị mất',

        pleaseEnterTheCardNumberToFind:
            'Vui lòng nhập số thẻ để tìm kiếm',

        theLostCardNumberIsRequired:
            'Bắt buộc nhập số thẻ bị mất',

        lostCardIfACardIsLostItCanBeReportedEnterTheNumberOfTheLostCardMakeALostCardAndBrushItOnceOnTheDoorThatCanOpenTheLostCard:
            'Thẻ báo mất: Khi một thẻ bị thất lạc, có thể báo mất bằng cách nhập số thẻ bị mất và tạo thẻ báo mất. Quẹt thẻ báo mất lên khóa mà thẻ cũ có thể mở để vô hiệu hóa thẻ đó',

        checkOutCardUsedByTheWaiterGenerallyTheWaiterHasTwoCardsOneIsTheLayerControlCardUsedToOpenTheDoorAndTheOtherIsTheCheckOutCardWhenTheGuestNotifiesTheCheckOutTheWaiterChecksTheRoomAndTheCheckOutCardIsBrushedOnceOnTheDoorThatCanOpenTheCheckOutCardThePreviousGuestCardCannotBeOpenedAndDoesNotAffectTheNewGuestCard:
            'Thẻ trả phòng: Dành cho nhân viên phục vụ. Thông thường nhân viên có hai thẻ: một thẻ kiểm soát tầng để mở cửa và một thẻ trả phòng. Sau khi khách thông báo trả phòng và nhân viên kiểm tra phòng, chỉ cần quẹt thẻ trả phòng lên khóa một lần. Khi đó thẻ khách cũ sẽ mất hiệu lực nhưng không ảnh hưởng đến thẻ khách mới',
    },

    sdkinitIndex: {
        theLockInformationIsInitializedSuccessfullyProcedure:
            'Khởi tạo thông tin khóa cửa thành công',

        afterEnteringTheCardManagement:
            'Sau đó vào quản lý thẻ',

        performTheInitialConfigurationOfDoorLockInformationFirst:
            'Vui lòng thực hiện cấu hình khởi tạo thông tin khóa cửa trước',

        hardwareDeviceType:
            'Loại thiết bị phần cứng',

        hardwareBrand:
            'Thương hiệu phần cứng',

        configurationInformation:
            'Thông tin cấu hình',

        thisParameterIsMandatory:
            'Thông tin cấu hình là bắt buộc',

        initialConfiguration:
            'Cấu hình khởi tạo',

        doorLockInformationConfiguration2:
            'Cấu hình thông tin khóa cửa',

        theDoorLockInformationIsConfiguredSuccessfully:
            'Cấu hình thông tin khóa cửa thành công',

        configurationFailure:
            'Cấu hình thất bại',
    },

    hotelBaseInfo: {
        basicInformation3:
            'Thông tin cơ bản',

        detailedInformation:
            'Thông tin chi tiết',

        hotelFacilitiesAndServices:
            'Tiện nghi và dịch vụ khách sạn',

        hotelPoliciesAndNotices:
            'Chính sách và thông báo khách sạn',
    },

    hotelFloor: {
        floorInformationToBeDeveloped:
            'Thông tin tầng (đang phát triển)',
    },

    hotelPicture: {
        acquiesce:
            'Mặc định',

        theLatestTime:
            'Mới nhất',

        theFarthestTime:
            'Cũ nhất',

        batchDeletion:
            'Xóa hàng loạt',

        undelete:
            'Hủy xóa',

        cover:
            'Ảnh bìa',

        firstMap:
            'Ảnh đầu tiên',

        setAsHotelCover:
            'Đặt làm ảnh bìa khách sạn',

        noPictureInformationIsAvailable:
            'Không có hình ảnh',

        submit2:
            'Gửi',

        photoEditor:
            'Chỉnh sửa ảnh',

        setAsTheFirstPictureOfTheRoomType:
            'Đặt làm ảnh đầu tiên của loại phòng',

        recentRevision:
            'Chỉnh sửa gần đây',

        appearance:
            'Ngoại thất',

        guestRoom:
            'Phòng khách',

        publicFacilities:
            'Tiện ích công cộng',

        catering:
            'Ẩm thực',

        surroundingEnvironment:
            'Môi trường xung quanh',

        theCoverImageAndFirstImageCannotBeDeletedDirectly:
            'Ảnh bìa và ảnh đầu tiên không thể xóa trực tiếp',

        areYouSureToDeleteThePicture:
            'Bạn có chắc muốn xóa hình ảnh này không?',

        operate:
            'Vận hành',

        pleaseSelectAtLeastOnePicture:
            'Vui lòng chọn ít nhất một hình ảnh',

        pleaseSelectCategory:
            'Vui lòng chọn danh mục',

        pleaseUploadThePictureSuccessfullyBeforeSubmitting:
            'Vui lòng tải ảnh lên thành công trước khi gửi',

        imagesCannotBeUploadedInBatchEditingMode:
            'Không thể tải ảnh lên trong chế độ chỉnh sửa hàng loạt',

        logoOnlyOne:
            'Logo chỉ được tải lên một ảnh',

        logoSizeLimit:
            'Kích thước ảnh Logo không được vượt quá 500KB',

        logoRatioError:
            'Logo phải là ảnh vuông tỷ lệ 1:1, kích thước hiện tại là {width}×{height}',
    },
    assemblyModifyinventoryprice: {
        unlimitedInventory:
            'Không giới hạn tồn kho',

        stockLimit:
            'Giới hạn tồn kho',

        modifiedPricePool:
            'Kho giá đã chỉnh sửa',

        soldInventory:
            'Tồn kho đã bán',
    },

    hotelPreview: {
        viewPicture:
            'Xem hình ảnh',
    },

    hotelRoomType: {
        batchImportRoomType:
            'Nhập loại phòng hàng loạt',

        importTemplateFileName:
            'Mẫu nhập loại phòng.xlsx',

        downloadSuccess:
            'Tải mẫu nhập loại phòng thành công',

        downloadFail:
            'Tải mẫu nhập loại phòng thất bại',

        newHousingType:
            'Thêm loại phòng',

        partialWindow:
            'Cửa sổ một phần',

        skylight:
            'Cửa sổ mái',

        closedWindow:
            'Cửa sổ kín',

        bayWindow:
            'Cửa sổ lồi',

        hotelCode:
            'Mã khách sạn',

        roomTypeCode:
            'Mã loại phòng',

        externalRoomTypeCode2:
            'Mã loại phòng bên ngoài',

        whetherToSellOnline:
            'Bán trực tuyến',

        bedType2:
            'Loại giường',
    },

    hotelRoom: {
        newRoom:
            'Thêm phòng',

        pleaseArrangeTheRoomInformationAccordingToTheRequirementsInTheTemplate:
            'Vui lòng chuẩn bị thông tin phòng theo yêu cầu trong mẫu',

        downloadTemplate:
            'Tải mẫu',

        downloadFailureData:
            'Tải dữ liệu lỗi',

        batchImport:
            'Nhập hàng loạt',

        floor2:
            'Tầng',

        building:
            'Tòa nhà',

        housingType:
            'Loại phòng',

        faceEast:
            'Hướng Đông',

        faceWest:
            'Hướng Tây',

        faceSouth:
            'Hướng Nam',

        faceNorth:
            'Hướng Bắc',

        stayAwayFromElevators:
            'Xa thang máy',

        nearTheStairs:
            'Gần cầu thang',

        closeToTheRoad:
            'Gần đường',

        windowWall:
            'Tường chắn ngoài cửa sổ',

        decorativeFalseWindow:
            'Cửa sổ giả trang trí',

        theRoomNumberCannotBeEmpty:
            'Số phòng không được để trống',

        theFloorOnWhichTheRoomIsLocatedCannotBeEmpty:
            'Tầng của phòng không được để trống',

        theRoomTypeCannotBeEmpty:
            'Loại phòng không được để trống',

        editSuccessfully:
            'Cập nhật thành công',

        newSuccess:
            'Thêm mới thành công',

        theHouseTypeAndNameCannotBeEmptyTheFloorWhereTheHouseResidesCannotBeEmpty:
            'Tên và loại phòng không được để trống, tầng của phòng không được để trống',

        currentLimitSelect1FilePleaseRemoveAndAdd:
            'Hiện chỉ được chọn 1 tệp, vui lòng xóa tệp hiện tại trước khi thêm',

        definitiveRemoval:
            'Xác nhận xóa',

        abnormalDataInformationTemplate:
            'Mẫu dữ liệu lỗi',

        xlsFormatOnly:
            'Chỉ hỗ trợ tệp định dạng XLS',

        dataCannotBeRecoveredAfterDeletingTheRoomAreYouSureToDeleteIt:
            'Dữ liệu không thể khôi phục sau khi xóa phòng. Bạn có chắc chắn muốn xóa không?',
    },
    hotelTypedetail: {
        newHousingType:
            'Thêm loại phòng',

        editRoomType:
            'Chỉnh sửa loại phòng',

        viewRoomType:
            'Xem loại phòng',

        basicInformation3:
            'Thông tin cơ bản',

        squareMeter:
            'm²',

        bedSize:
            'Kích thước giường',

        extraBedCondition:
            'Chính sách giường phụ',

        internetAccess:
            'Kết nối Internet',

        roomTypeFacilities:
            'Tiện nghi phòng',

        roomTypeStatus:
            'Trạng thái loại phòng',

        saveAndSubmit:
            'Lưu và gửi',

        roomTypeNameAMaximumOf50Characters:
            'Tên loại phòng tối đa 50 ký tự',

        floorArea:
            'Diện tích',

        roomTypeEnglishName:
            'Tên loại phòng tiếng Anh',

        floorType:
            'Loại tầng',

        floor2:
            'Tầng',

        pleaseEnter1511:
            'Vui lòng nhập ví dụ: -1,5,11',

        chineseRemarks:
            'Ghi chú tiếng Trung',

        capacity:
            'Sức chứa',

        englishRemarks:
            'Ghi chú tiếng Anh',

        externalRoomTypeCode2:
            'Mã loại phòng bên ngoài',

        extraBed:
            'Giường phụ',

        internetAccess2:
            'Có Internet',

        roomInternetInformation:
            'Thông tin Internet trong phòng',

        broadbandTariff:
            'Phí Internet',

        disposableToiletries:
            'Đồ vệ sinh cá nhân dùng một lần',

        bathroomType:
            'Loại phòng tắm',

        numberOfToilets:
            'Số lượng phòng tắm',

        computer:
            'Máy tính',

        showerRoom:
            'Phòng tắm vòi sen',

        smokeFreeInformation:
            'Thông tin phòng không hút thuốc',

        bathroom:
            'Phòng tắm',

        pleaseEnterAnIntegerWithNoMoreThanTwoDigits:
            'Vui lòng nhập số nguyên tối đa 2 chữ số',

        pleaseEnterAnIntegerGreaterThan0:
            'Vui lòng nhập số nguyên lớn hơn 0',

        dataDuplicationPleaseConfirm:
            'Dữ liệu bị trùng lặp, vui lòng xác nhận',

        pleaseEnterAValueOfAThreeDigitIntegerUpTo500:
            'Vui lòng nhập số nguyên tối đa 500',

        enterAMaximumOfTwoDecimalsAndAMaximumOf6Characters:
            'Tối đa 2 chữ số thập phân và không quá 6 ký tự',

        pleaseEnterBuildingArea:
            'Vui lòng nhập diện tích',

        pleaseEnterTheCapacity:
            'Vui lòng nhập sức chứa',

        pleaseEnterAnIntegerOfUpToTwoDigits:
            'Vui lòng nhập số nguyên tối đa 2 chữ số',

        roomTypeNameCannotBeEmpty:
            'Tên loại phòng không được để trống',

        roomTypeNameCannotExceed50Characters:
            'Tên loại phòng không được vượt quá 50 ký tự',

        theLengthCannotExceed30Characters:
            'Không được vượt quá 30 ký tự',

        theTotalNumberOfRoomsCannotBeEmpty:
            'Tổng số phòng không được để trống',

        theLengthCannotExceed60Characters:
            'Không được vượt quá 60 ký tự',

        pleaseSelectBedSize:
            'Vui lòng chọn kích thước giường',

        pleaseSelectWindowType:
            'Vui lòng chọn loại cửa sổ',

        pleaseSelectRoomTypeStatus:
            'Vui lòng chọn trạng thái loại phòng',

        pleaseSelectExtraBedCondition:
            'Vui lòng chọn chính sách giường phụ',

        pleaseSelectWhetherYouCanAccessTheInternet:
            'Vui lòng chọn trạng thái Internet',

        pleaseSelectAPhone:
            'Vui lòng chọn điện thoại',

        pleaseSelectDisposableToiletries:
            'Vui lòng chọn đồ vệ sinh cá nhân dùng một lần',

        pleaseSelectABathroomType:
            'Vui lòng chọn loại phòng tắm',

        pleaseSelectTheNumberOfBathrooms:
            'Vui lòng chọn số lượng phòng tắm',

        pleaseSelectComputer:
            'Vui lòng chọn máy tính',

        pleaseSelectABathRoom:
            'Vui lòng chọn phòng tắm vòi sen',

        pleaseSelectSmokeFreeInformation:
            'Vui lòng chọn thông tin phòng không hút thuốc',

        pleaseSelectOther:
            'Vui lòng chọn',

        pleaseSelectBathroom:
            'Vui lòng chọn phòng tắm',

        commonFloor:
            'Tầng thường',

        executiveFloor:
            'Tầng Executive',

        businessFloor:
            'Tầng thương gia',

        noExtraBed:
            'Không hỗ trợ giường phụ',

        freeExtraBed:
            'Miễn phí giường phụ',

        payExtraBed:
            'Giường phụ có tính phí',

        haveInternetAccess:
            'Có Internet',

        someInternetAccess:
            'Một số phòng có Internet',

        noInternetAccess:
            'Không có Internet',

        freeWireless:
            'Wi-Fi miễn phí',

        tollWireless:
            'Wi-Fi có phí',

        freeWire:
            'Internet có dây miễn phí',

        tollWire:
            'Internet có dây tính phí',

        nationalTollCall:
            'Điện thoại đường dài nội địa',

        internationalCall:
            'Điện thoại quốc tế',

        freeDomesticLongDistanceCalls:
            'Miễn phí gọi đường dài nội địa',

        disposableToiletriesAreNotProvided:
            'Không cung cấp đồ vệ sinh cá nhân dùng một lần',

        disposableToiletriesAreProvidedForFree:
            'Cung cấp miễn phí đồ vệ sinh cá nhân dùng một lần',

        disposableToiletriesAreProvidedForAFee:
            'Cung cấp đồ vệ sinh cá nhân có tính phí',

        indoor:
            'Riêng trong phòng',

        commonality:
            'Dùng chung',

        aroom:
            'Một phòng',

        twoRooms:
            'Hai phòng',

        moreThanTwoRooms:
            'Trên hai phòng',

        allRoomsChargeComputers:
            'Máy tính có tính phí trong tất cả các phòng',

        freeComputersInAllRooms:
            'Máy tính miễn phí trong tất cả các phòng',

        freeComputersInSomeRooms:
            'Máy tính miễn phí trong một số phòng',

        nonSmokingRoomsAreNotAvailable:
            'Không có phòng không hút thuốc',

        nonSmokingRoomsAvailable:
            'Có phòng không hút thuốc',

        noSmoking:
            'Cấm hút thuốc',

        partialWindow:
            'Cửa sổ một phần',

        skylight:
            'Cửa sổ mái',

        closedWindow:
            'Cửa sổ kín',

        bayWindow:
            'Cửa sổ lồi',

        roomTypeNameAndBedSizeAreUnderReview:
            'Tên loại phòng và kích thước giường đang được xét duyệt',

        roomTypeAddedSuccessfully:
            'Thêm loại phòng thành công',

        containsAMaximumOf7CharactersOnlyDigitsCanBeEntered:
            'Tối đa 7 ký tự, chỉ cho phép nhập số và ký hiệu "." "-"',

        pleaseEnterAnIntegerAndEnsureItsLegalitySuchAs3SquareMeters5SquareMeters:
            'Vui lòng nhập diện tích hợp lệ, ví dụ: 3-5 m²',

        personbed:
            'người/phòng',
    },

    managementAccountList: {
        searchAccountAndEmployeeName:
            'Tài khoản / Tên nhân viên',

        staffPosition:
            'Chức vụ',

        createAnAccount:
            'Tạo mới',

        employeeName:
            'Tên nhân viên',

        employeeRole:
            'Vai trò nhân viên',

        confirmTo:
            'Xác nhận',

        user:
            'Người dùng',

        areYouSureYouWantToDeleteThisUser:
            'Bạn có chắc muốn xóa người dùng này không?',

        isThisMaterial:
            'mục này không?',
    },

    managementRoleList: {
        enterARoleName:
            'Nhập tên vai trò',

        newRole:
            'Thêm mới',

        roleName:
            'Tên vai trò',

        roleDescription:
            'Mô tả vai trò',

        editorRole:
            'Chỉnh sửa vai trò',

        modifyPermission:
            'Chỉnh sửa quyền',

        deletingARole:
            'Xóa vai trò',

        areYouSureYouWantToDeleteThisRole:
            'Bạn có chắc muốn xóa vai trò này không?',
    },
    componentsCreateaneditingrole: {
        roleName: 'Tên vai trò',

        roleDescription: 'Mô tả vai trò',

        standardPostBased: 'Dựa trên vị trí tiêu chuẩn',

        limitsOfAuthority: 'Quyền hạn',

        pleaseEnterARoleName: 'Vui lòng nhập tên vai trò',

        modifyRole: 'Chỉnh sửa vai trò',

        newRole: 'Thêm vai trò',

        succeededInModifyingTheRole: 'Chỉnh sửa vai trò thành công',

        creatingTheRoleSucceeded: 'Tạo vai trò thành công',
    },

    componentsPopupeditingpermission: {
        editPermission: 'Chỉnh sửa quyền',
    },

    componentsUpdatematerial: {
        staffPosition: 'Chức vụ nhân viên',

        employeeRole: 'Vai trò nhân viên',

        thePhoneNumberCannotBeEmpty: 'Số điện thoại không được để trống',

        pleaseEnterYourConfirmationPassword: 'Vui lòng nhập lại mật khẩu xác nhận',

        pleaseEnterEmployeeName: 'Vui lòng nhập tên nhân viên',

        pleaseSelectEmployeeStatus: 'Vui lòng chọn trạng thái nhân viên',

        pleaseSelectAnEmployeePosition: 'Vui lòng chọn chức vụ nhân viên',

        modifyAccount: 'Chỉnh sửa tài khoản',

        viewInformation: 'Xem thông tin',

        addAnAccount: 'Thêm tài khoản',

        theTwoPasswordEntriesAreDifferent: 'Hai lần nhập mật khẩu không khớp',

        modifyingTheMaterialInformationMayAffectTheInformationAboutStoredGoodsExerciseCautionWhenPerformingThisOperation:
            'Việc chỉnh sửa thông tin vật tư có thể ảnh hưởng đến dữ liệu hàng hóa đã nhập kho, vui lòng thao tác cẩn thận',

        materialUnit: 'Đơn vị vật tư',

        pleaseSelectTheMaterialType: 'Vui lòng chọn loại vật tư',

        pleaseFillInTheMaterialName: 'Vui lòng nhập tên vật tư',

        pleaseSelectMaterialUnit: 'Vui lòng chọn đơn vị vật tư',

        modifyMaterial: 'Chỉnh sửa vật tư',

        newMaterial2: 'Thêm vật tư',

        materialModificationSucceeded: 'Chỉnh sửa vật tư thành công',

        newMaterialSuccessfully: 'Tạo vật tư thành công',

        pleaseEnterTheCorrectPhoneNumber3: 'Vui lòng nhập đúng tài khoản',
    },

    smallwareMaterial: {
        newMaterial: 'Thêm mới',

        thereIsInventoryUnderTheCurrentMaterialDoNotSupportToDeleteTheMaterialPleaseDeleteAfterTheWarehouse:
            'Vật tư này vẫn còn tồn kho, không thể xóa. Vui lòng xuất kho trước khi xóa',

        areYouSureYouWantToDeleteThisMaterial:
            'Bạn có chắc chắn muốn xóa vật tư này không?',

        confirmTo: 'Xác nhận',

        isThisMaterial: 'vật tư này?',
    },
    smallwareRealtimestock: {
        saleStatus: 'Trạng thái bán',

        exportedInventory: 'Xuất dữ liệu',

        resumptionOfSale: 'Khôi phục bán',

        banOnSale: 'Ngừng bán',

        averagePurchasePriceyuan: 'Giá nhập trung bình (VNĐ)',

        sellingPriceyuan: 'Đơn giá bán (VNĐ)',

        unmarketable: 'Không được bán',

        vendibility: 'Được phép bán',

        exportFileName: 'Danh sách tồn kho thời gian thực',

        areYouSureYouWantToStopSellingThisMaterial:
            'Bạn có chắc chắn muốn ngừng bán vật tư này không?',

        successfulClosure: 'Ngừng bán thành công',

        successfulResumptionOfSale: 'Khôi phục bán thành công',
    },

    smallwareStockshift: {
        undoSuccessfully: 'Hoàn tác thành công',

        outboundTime: 'Thời gian xuất kho',

        newDelivery2: 'Thêm mới',

        outboundMode: 'Phương thức xuất kho',

        theNumberOfTheWarehouseReceipt: 'Mã phiếu xuất kho',

        deliveryFromStorage: 'Xuất kho',

        cancel: 'Hủy',

        exportFileList: 'Danh sách xuất file xuất kho',

        doYouConfirmTheCancellation: 'Xác nhận hoàn tác?',
    },

    smallwareStockunshift: {
        warehousingTime: 'Thời gian nhập kho',

        newStorage: 'Thêm mới',

        theCodeOfTheEntrySlip: 'Mã phiếu nhập kho',

        purchasePriceyuan: 'Đơn giá nhập (VNĐ)',

        importFileExportList: 'Danh sách xuất file nhập kho',
    },

    componentsAddnewstock: {
        adjustableQuantity: 'Số lượng có thể điều chỉnh',

        purchasePrice: 'Đơn giá nhập',

        whetherToSell: 'Có bán hay không',

        unitSellingPrice: 'Đơn giá bán',

        pleaseFillInTheUnitPrice: 'Vui lòng nhập đơn giá bán',

        pleaseFillInTheQuantityOfStorage: 'Vui lòng nhập số lượng nhập kho',

        pleaseSelectTheMaterialType: 'Vui lòng chọn loại vật tư',

        pleaseSelectAMaterialName: 'Vui lòng chọn tên vật tư',

        modifiedEntry: 'Chỉnh sửa nhập kho',

        newStorage: 'Thêm nhập kho',

        createdSuccessfully2: 'Tạo thành công',

        theStorageQuantityCannotBe: 'Số lượng nhập kho không được bằng',

        theModifiedQuantityCannotBeSmallerThanTheConsumedQuantity:
            'Số lượng sau khi chỉnh sửa không được nhỏ hơn số lượng đã tiêu thụ',
    },

    componentsAddoutstock: {
        selected: 'Đã chọn',

        newDelivery2: 'Thêm mới',

        pleaseSelectOutgoingMaterials: 'Vui lòng chọn vật tư xuất kho',

        pleaseSelectTheMaterialToBeShippedOut:
            'Vui lòng chọn vật tư cần xuất kho',

        successfulDelivery: 'Xuất kho thành công',
    },

    componentsSellricedialog: {
        unitSellingPrice: 'Đơn giá bán',

        pleaseFillInThePrice: 'Vui lòng nhập giá bán',
    },
    systemsetBase: {
        requireIdNumberEnabled: 'Đã bật thành công chức năng bắt buộc nhập số giấy tờ',

        requireIdNumberDisabled: 'Đã tắt thành công chức năng bắt buộc nhập số giấy tờ',

        requireIdNumberForCheckin: 'Có bắt buộc nhập số giấy tờ khi nhận phòng hay không',

        enableAutomaticDepositRefund: 'Bật hoàn tiền đặt cọc tự động',

        refundImmediatelyAfterCheckOut: 'Hoàn tiền ngay sau khi khách trả phòng',

        refundAfter: 'Sau khi khách trả phòng',

        hoursAutoRefund: 'Tự động hoàn sau (giờ)',

        pleaseEnterDelayRefundHours: 'Vui lòng nhập thời gian hoàn cọc trễ',

        delayRefundHoursRangeError:
            'Thời gian hoàn cọc trễ không được nhỏ hơn 1 giờ và không được lớn hơn 48 giờ',

        depositConfigSuccess: 'Cấu hình tiền đặt cọc thành công',

        tempMakeCardEnabled: 'Bật chế độ làm thẻ tạm thời',

        tempMakeCardEnabledSuccess: 'Đã bật chức năng làm thẻ tạm thời',

        tempMakeCardDisabledSuccess: 'Đã tắt chức năng làm thẻ tạm thời',

        hideCheckInRegisterRoomPrice: 'Ẩn giá phòng trên phiếu đăng ký nhận phòng',

        hideCheckInRegisterRoomPriceEnabledSuccess: 'Đã ẩn giá phòng trên phiếu đăng ký nhận phòng',

        hideCheckInRegisterRoomPriceDisabledSuccess: 'Đã hiển thị giá phòng trên phiếu đăng ký nhận phòng',

        weeHours: 'Ca đêm',

        shiftPattern: 'Chế độ bàn giao ca',

        messageVoiceReminder: 'Nhắc nhở bằng giọng nói',

        directConnectionSingleSettings: 'Cài đặt nhận đơn trực tiếp',

        automaticHouseSetting: 'Cài đặt tự động xếp phòng',

        sameDayAdvanceOrders: 'Đơn đặt trước đến trong ngày',

        allOrders: 'Tất cả đơn hàng',

        unreservedRoomOrderAutomaticRoomSchedulingPeriod:
            'Khoảng thời gian tự động xếp phòng cho đơn chưa xếp phòng',

        inThisTimePeriodTheUnreservedRoomOrderWillBeAutomaticallyExecuted:
            'Trong khoảng thời gian này, các đơn chưa được xếp phòng sẽ được tự động xếp phòng',

        inventorySyncSetup: 'Cài đặt đồng bộ tồn kho',

        orderSynchronizationSettings: 'Cài đặt đồng bộ đơn hàng',

        nightAuditSetup: 'Cài đặt kiểm toán đêm',

        nightTrialMethod: 'Phương thức kiểm toán đêm',

        manualOperation: 'Thủ công',

        auto: 'Tự động',

        storeOrdersHaveNotArrived: 'Đơn hàng cửa hàng chưa đến ngày nhận phòng',
        preArrivalDepartureHandle: 'Pre-arrival & Pre-departure Order Handling',
        preArrivalDepartureHandleTip: 'Configure automatic handling for pre-arrival and pre-departure orders. The system will automatically execute the corresponding operations during night audit',
        preArrivalHandle: 'Pre-arrival Order Handling',
        preDepartureHandle: 'Pre-departure Order Handling',
        noHandle: 'No handling',
        autoCheckIn: 'Auto check-in',
        autoNoshow: 'Auto no-show',
        autoCheckOut: 'Auto check-out',
        autoExtendStay: 'Auto extend stay',
        autoSkip: 'Tự động bỏ qua',

        shiftSetting: 'Cài đặt ca làm việc',

        noOverlapIsAllowedAndTheTotalTimeIntervalMustCover24HoursOfTheDay:
            'Các ca làm việc không được chồng lấn và tổng thời gian phải bao phủ đủ 24 giờ',

        morningShiftSetting: 'Cài đặt ca đêm',

        shiftReportimprestMode: 'Báo cáo bàn giao ca (chế độ quỹ tạm ứng)',

        hourRoomCheckOutMessage: 'Thông báo trả phòng phòng giờ',

        fullDayCheckOutMessage: 'Thông báo trả phòng phòng ngày',

        onlineChannelNewOrderAlerts: 'Thông báo đơn hàng mới từ kênh trực tuyến',

        onlineChannelOrderCancellationAlerts: 'Thông báo hủy đơn từ kênh trực tuyến',

        hourCheckOutReminder: 'Nhắc nhở trả phòng phòng giờ',

        fullDayCheckOutReminder: 'Nhắc nhở trả phòng phòng ngày',

        automaticOrderSettingWhenOversold:
            'Cài đặt tự động nhận đơn khi bán vượt phòng',

        hourRoomAutomaticOrderSetting:
            'Cài đặt tự động nhận đơn phòng giờ',

        automaticRowHouseConfiguration: 'Trạng thái phòng dùng cho tự động xếp phòng',

        automaticHouseRules: 'Quy tắc tự động xếp phòng',

        supportBillingTypes: 'Loại hóa đơn hỗ trợ',

        '30MinutesBeforeCheckOut': '30 phút trước khi trả phòng',

        '15MinutesBeforeCheckOut': '15 phút trước khi trả phòng',

        atCheckOut: 'Khi trả phòng',

        pleaseEnterTheTime: 'Vui lòng nhập thời gian',

        automaticCancellation: 'Tự động hủy',

        manualCancellation3: 'Hủy thủ công',

        automaticOverbookingSetReminders:
            'Nhắc nhở cài đặt tự động nhận đơn khi bán vượt phòng',

        hourRoomAutomaticOrderSettingReminder:
            'Nhắc nhở cài đặt tự động nhận đơn phòng giờ',

        autoEnterArAccountText: 'Tự động ghi nhận vào tài khoản AR cho đơn trực tiếp',

        pleaseSelectABusinessDay: 'Vui lòng chọn ngày kinh doanh',

        operationSuccessfulPleaseManuallyTriggerTheNightAudit:
            'Thao tác thành công, vui lòng kích hoạt kiểm toán đêm thủ công',

        theStartTimeAndEndTimeOfTheMorningShiftCannotBeTheSame:
            'Thời gian bắt đầu và kết thúc của ca đêm không được trùng nhau',

        earlyMorningWatch: 'Ca đêm',
        theAutomaticRowHouseIsSetSuccessfully: 'Cài đặt tự động xếp phòng thành công',

        theEbRoomStatusIsAutomaticallyClosedWhenTheRoomIsFull:
            'Tự động đóng trạng thái phòng EB khi hết phòng',

        supportSwitchOrderSynchronization:
            'Hỗ trợ đồng bộ đơn hàng Switch',

        inventoryAutomaticSynchronizationSystemInventory:
            'Tự động đồng bộ tồn kho với hệ thống',

        whenTheStoreOrderIsSetToautoCancelTheSystemWillAutomaticallyCancelTheStoreOrderForUnpaidOrdersAtNightAuditPleaseHandleTheCheckInInAdvanceToAvoidCancellation:
            'Gia hạn lưu trú cho đơn dự kiến đi có ưu tiên cao hơn nhận phòng cho đơn dự kiến đến. Nếu không còn phòng trống khi hệ thống tự động làm thủ tục nhận phòng, hệ thống sẽ tự động đánh dấu NoShow; nếu không còn phòng trống khi hệ thống tự động gia hạn lưu trú, hệ thống sẽ tự động làm thủ tục trả phòng',

        whenTheStoreOrderIsSetTomanualCancelPleaseHandleTheCheckInOrCancelTheStorePreArrivalOrderInAdvanceToAvoidTheNightAuditNotPassing:
            'Gia hạn lưu trú cho đơn dự kiến đi có ưu tiên cao hơn nhận phòng cho đơn dự kiến đến. Nếu không còn phòng trống khi hệ thống tự động làm thủ tục nhận phòng, hệ thống sẽ tự động đánh dấu NoShow; nếu không còn phòng trống khi hệ thống tự động gia hạn lưu trú, hệ thống sẽ tự động làm thủ tục trả phòng',

        whenTheRoomIsFullTheEbRoomStatusSwitchIsAutomaticallyTurnedOff:
            'Đã lưu cài đặt tự động tắt trạng thái phòng EB khi hết phòng',

        inventoryAutomaticSynchronizationSystemInventorySwitchSettingsSaved:
            'Đã lưu cài đặt tự động đồng bộ tồn kho hệ thống',

        atLeastOneMessageReminderSettingMustBeSelected:
            'Phải chọn ít nhất một mục trong cài đặt nhắc nhở',

        closeturnOnToAutomaticallySortRoomsAtNight:
            'Tắt (sau khi bật, đơn hàng mới sẽ được tự động xếp phòng cả ngày)',

        crossBusinessDayShiftsYouCanSetTheNightShiftSeparatelyForAccountingPurposesTheNightShiftDoesNotParticipateInNormalShiftTimeCalculations:
            'Đối với ca làm việc xuyên ngày kinh doanh, có thể thiết lập riêng ca đêm để thuận tiện cho việc thống kê tài chính. Ca đêm không tham gia tính toán thời gian ca làm việc thông thường',

        dailyPredeparture: 'Dự kiến trả phòng trong ngày',

        theHotelSupportsSynchronousSwitchOrderChannelSettingsSaving:
            'Khách sạn hỗ trợ lưu đồng bộ cài đặt kênh đơn hàng Switch',

        theNightAuditTimeMustBeBetween2100And0800TheNextDay:
            'Thời gian kiểm toán đêm phải nằm trong khoảng từ 21:00 đến 08:00 ngày hôm sau',

        theScheduleNeedsToCover24HoursADayPleaseReset:
            'Thời gian các ca làm việc phải bao phủ đủ 24 giờ trong ngày, vui lòng thiết lập lại',

        showMemberRechargeAmount:
            'Hiển thị số tiền nạp hội viên trong báo cáo bàn giao ca',

        splitDeposit:
            'Tách riêng tiền đặt cọc trong báo cáo bàn giao ca',

        splitArAccount:
            'Tách riêng tài khoản AR trong báo cáo bàn giao ca',

        allowTimeConflict:
            'Cho phép xếp phòng có xung đột thời gian',

        selfCheckInDepositSetting:
            'Cài đặt tiền đặt cọc cho tự nhận phòng',

        depositConfig:
            'Cấu hình thu tiền đặt cọc',

        defaultDepositAmount:
            'Số tiền đặt cọc mặc định',

        defaultDepositError:
            'Giá trị mặc định của tiền đặt cọc không hợp lệ, vui lòng nhập lại',

        roomDepositError:
            'Cấu hình tiền đặt cọc của loại phòng "{roomName}" không hợp lệ, vui lòng thiết lập lại',

        additionalRoomFeeSetting:
            'Cài đặt thu thêm phí phòng',

        fulldayAddFeeRule:
            'Quy tắc thu thêm phí phòng ngày',

        fulldayAddFeeType:
            'Loại thu thêm phí phòng ngày',

        memberRechargeSetting:
            'Cài đặt thanh toán nạp tiền hội viên',

        noVerificationPayment:
            'Thanh toán không cần mã xác thực',

        enforceAdditionalRoomCharge:
            'Bắt buộc thu thêm phí phòng sau thời gian quy định',

        manualAdditionalRoomFee:
            'Thu thêm phí phòng thủ công',

        halfDayAdditionalRoomFee:
            'Thu thêm nửa ngày tiền phòng',

        fullDayAdditionalRoomFee:
            'Thu thêm một ngày tiền phòng',

        popUpMethodSetting:
            'Cách mở trang mới',

        newTab:
            'Mở tab mới',

        originalTabRedirection:
            'Chuyển hướng trên tab hiện tại',

        popupNotification:
            'Cửa sổ bật lên',

        sidebar:
            'Ngăn kéo bên phải',

        morningOrderCheckInAddFee:
            'Có thu thêm phí phòng khi nhận phòng vào rạng sáng hay không',

        morningOrderAddFeeEnabled:
            'Đã bật chức năng thu thêm phí phòng cho khách nhận phòng rạng sáng',

        morningOrderAddFeeDisabled:
            'Đã tắt chức năng thu thêm phí phòng cho khách nhận phòng rạng sáng',

        breakfastReportCtrl:
            'Quy tắc thống kê báo cáo bữa sáng',

        repotShowByUserNums:
            'Thống kê theo số lượng khách thực tế nhận phòng',

        repotShowByProductNums:
            'Thống kê theo số suất ăn sáng bao gồm trong phòng',

        breakfastReportCtrlSuccessByUserNums:
            'Đã thiết lập quy tắc thống kê báo cáo bữa sáng là "Theo số lượng khách thực tế nhận phòng"',

        breakfastReportCtrlSuccessByProductNums:
            'Đã thiết lập quy tắc thống kê báo cáo bữa sáng là "Theo số suất ăn sáng bao gồm trong phòng"',
    },
    systemsetConditionConfig: {
        unspaced: 'Hiển thị không xuống dòng',

        arrangeByFloorBranch: 'Hiển thị theo từng tầng',

        lineUpByRoomType: 'Hiển thị theo loại phòng',

        theSizeOfTheCell: 'Kích thước ô trạng thái phòng',

        small: 'Nhỏ',

        inThe: 'Trung bình',

        big: 'Lớn',

        wide: 'Rộng',

        high: 'Cao',

        custom: 'Tùy chỉnh',

        roomTypeFont: 'Phông chữ loại phòng',

        size: 'Kích thước',

        colour: 'Màu sắc',

        roomNumberFont: 'Phông chữ số phòng',

        whetherFullGuestNamesAreDisplayed:
            'Hiển thị đầy đủ tên khách',

        alreadyRowHouseStatusDisplayContent:
            'Nội dung hiển thị trạng thái phòng đã xếp',

        alreadyRowHouseStatusDetailsDisplayContent:
            'Nội dung chi tiết trạng thái phòng đã xếp',

        noRowRoomStatusDetailsDisplayContent:
            'Nội dung chi tiết trạng thái phòng chưa xếp',

        arrearsIncludeToday:
            'Công nợ có tính cả tiền phòng chưa phát sinh trong ngày hay không',

        bedType2: 'Loại giường',

        restoreDefault: 'Khôi phục mặc định',

        roomDiagramArrangement:
            'Cách sắp xếp sơ đồ trạng thái phòng',

        theAppletTakesEffectAtTheSameTime:
            'Đồng thời áp dụng cho Mini App',

        cellColor: 'Màu ô trạng thái phòng',

        unarrangedRoomStatusContent:
            'Nội dung hiển thị trạng thái phòng chưa xếp',

        powerSwitch: 'Thiết bị cấp điện',

        roomBalance: 'Số dư phòng',

        depositAmount: 'Số tiền đặt cọc',
    },

    systemsetConfiguration: {
        changePriceRangeSettings:
            'Cài đặt phạm vi thay đổi giá',

        revaluationRange:
            'Phạm vi điều chỉnh giá',

        theSystemWillJudgeWhetherTheAveragePriceOfEachRoomTypeInThePast30DaysExceedsTheChangePriceRangeIfSoTheChangePriceWillBeEnteredIntoTheChangePriceAuditAndThePriceWillBeEffectiveAfterTheAuditTheChangePriceWillBeAutomaticallyRejectedAfter1HourIfItIsNotProcessed:
            'Hệ thống sẽ dựa trên giá trung bình của từng loại phòng trong 30 ngày gần nhất để xác định xem mức điều chỉnh có vượt quá phạm vi cho phép hay không. Nếu vượt quá, yêu cầu thay đổi giá sẽ được đưa vào quy trình phê duyệt. Giá mới chỉ có hiệu lực sau khi được phê duyệt. Nếu yêu cầu không được xử lý trong vòng 1 giờ, hệ thống sẽ tự động từ chối yêu cầu thay đổi giá.',
    },

    systemsetLog: {
        operationRecord: 'Nhật ký thao tác',
    },

    systemsetPrint: {
        documentType: 'Loại chứng từ',

        paperSize: 'Khổ giấy',

        typeSize: 'Cỡ chữ',

        printingMode: 'Chế độ in',

        noticeToGuests: 'Lưu ý dành cho khách',
    },
    systemsetTarget: {
        monthlyGoalSetting: 'Thiết lập mục tiêu tháng',

        goal: 'Mục tiêu',

        goalAchievementRate: 'Tỷ lệ hoàn thành mục tiêu',

        intertargetNight: 'Mục tiêu số đêm phòng',

        targetOccupancyRate: 'Mục tiêu tỷ lệ lấp đầy phòng',

        recommendedTargetValue: 'Giá trị mục tiêu đề xuất',

        actualAchievement: 'Kết quả thực tế',

        reachedLastMonth: 'Kết quả tháng trước',

        theSamePeriodLastYear: 'Cùng kỳ năm trước',

        commitFailure: 'Gửi thất bại',
    },

    systemsetWarning: {
        earningsWarning: 'Cảnh báo hoàn thành doanh thu',

        dailyWarning: 'Cảnh báo hàng ngày',
    },

    systemsetWifi: {
        commonality: 'Khu vực công cộng',

        batchModification: 'Chỉnh sửa hàng loạt',

        pleaseCompleteTheWiFiAccountPassword:
            'Vui lòng nhập đầy đủ tài khoản và mật khẩu Wi-Fi',

        pleaseEnterAValidWifiName:
            'Vui lòng nhập tên Wi-Fi hợp lệ',

        noPasswordOrMobilePhoneAuthenticationOfTheWifiDoNotNeedToFillIn:
            'Wi-Fi không có mật khẩu hoặc xác thực qua điện thoại không cần nhập thông tin',

        pleaseFillInTheWiFiAccount:
            'Vui lòng nhập tài khoản Wi-Fi',

        roomWifiSettings:
            'Cài đặt Wi-Fi phòng',

        wifiName: 'Tên Wi-Fi',

        wifiPassword: 'Mật khẩu Wi-Fi',
    },

    assemblyBindavailableproducts: {
        bindAvailableProducts: 'Liên kết sản phẩm khả dụng',

        bindAtLeastOneProduct:
            'Phải liên kết ít nhất một sản phẩm',
    },

    componentsWarning: {
        byTheMonth: 'Hàng tháng',

        achievedOnDays: 'Đạt được vào ngày',

        below: 'Dưới',

        viewRemainingConditions:
            'Xem các điều kiện còn lại',

        newEarlyWarningItems:
            'Thêm mục cảnh báo mới',

        achieved: 'Đạt được',

        additionalCondition:
            'Thêm điều kiện',

        internightMoonTargetReachWarning:
            'Cảnh báo hoàn thành mục tiêu số đêm phòng theo tháng',

        earlyWarningOfMonthlyTargetOfRentalRate:
            'Cảnh báo hoàn thành mục tiêu tỷ lệ lấp đầy phòng theo tháng',

        surplusRoom:
            'Số phòng còn trống',

        pointScoring:
            'Điểm đánh giá',

        gmvMonthlyTargetWarning:
            'Cảnh báo tỷ lệ hoàn thành mục tiêu GMV theo tháng',

        revparMonthlyTargetWarning:
            'Cảnh báo tỷ lệ hoàn thành mục tiêu RevPAR theo tháng',
    },
    componentsWarningday: {
        overallHotel: 'Toàn bộ khách sạn',

        everyday: 'Hàng ngày',

        theDayBefore: 'Ngày trước',

        viewRemainingConditions: 'Xem các điều kiện còn lại',

        newEarlyWarningItems: 'Thêm mục cảnh báo mới',

        additionalCondition: 'Thêm điều kiện',

        lessThan: 'Nhỏ hơn',

        greaterThan: 'Lớn hơn',

        pointScoring: 'Điểm đánh giá',

        surplusRoom: 'Số phòng còn trống',
    },

    payLehuipaySetting: {
        youHaveNotOpenedOnlinePayment:
            'Bạn chưa kích hoạt thanh toán trực tuyến',

        contactOperationOrTechnicalSupportToEnableTheService:
            'Vui lòng liên hệ bộ phận vận hành hoặc hỗ trợ kỹ thuật để kích hoạt',

        lehuiPay: 'LeHui Pay',

        download: 'Tải xuống',

        inquire: 'Tra cứu',

        withdraw: 'Rút tiền',

        withdrawalRecord: 'Lịch sử rút tiền',

        billDownload: 'Tải sao kê',

        accountBalanceInquiry: 'Tra cứu số dư tài khoản',

        theWithdrawalAmountIsRequired:
            'Vui lòng nhập số tiền rút',

        theAmountRangeIs:
            'Phạm vi số tiền hợp lệ là',

        doYouWantToChangeThePaymentMethod:
            'Bạn có chắc chắn muốn thay đổi phương thức thanh toán không?',

        modifyingThePaymentModeSucceeded:
            'Thay đổi phương thức thanh toán thành công',

        pleaseFillInTheWithdrawalAmount:
            'Vui lòng nhập số tiền rút',

        ifTheWithdrawalFailsTheWithdrawalAmountCannotBeLessThan10Yuan:
            'Rút tiền thất bại, số tiền rút không được nhỏ hơn 10 Nhân dân tệ',
    },

    foodLogin: {
        cashierSystem: 'Hệ thống thu ngân nhà hàng',
        shopSystem: 'Hệ thống cửa hàng nhà hàng',
        pleaseEnterYourAccount: 'Vui lòng nhập tài khoản',
        noFoodSystemPermission: 'Bạn không có quyền truy cập {system}',
        systemConfigurationError: 'Lỗi cấu hình hệ thống, vui lòng liên hệ bộ phận hỗ trợ kỹ thuật',
        loginFailed: 'Đăng nhập thất bại, vui lòng thử lại sau',
    },
    loginIndex: {
        hotelManagementSystem: 'Hệ thống quản lý khách sạn',

        qrCodeExpired: 'Mã QR đã hết hạn',

        pleaseClickRefresh: 'Vui lòng nhấn làm mới',

        openWechatScanTheQrCode:
            'Mở WeChat để quét mã QR',

        customerServiceNumber: 'Số hotline hỗ trợ',

        theAccountOrPasswordYouEnteredIsIncorrect:
            'Tài khoản hoặc mật khẩu bạn nhập không chính xác',

        forgotPassword: 'Quên mật khẩu',

        verificationCodeSentToYourMobilePhoneValidFor5Minutes:
            'Mã xác thực đã được gửi đến điện thoại của bạn, có hiệu lực trong 5 phút',

        enter820CharactersIncludingLettersNumbersAndSymbolsOfTwoOrMoreTypes:
            'Nhập từ 8-20 ký tự, bao gồm ít nhất hai loại trong số chữ cái, số và ký hiệu',

        submit2: 'Gửi',

        loginPasswordUpdateSuccessful:
            'Cập nhật mật khẩu đăng nhập thành công',

        reLogin: 'Đăng nhập lại',

        bind: 'Liên kết',

        findPassword: 'Khôi phục mật khẩu',

        pleaseEnterTheVerificationCode:
            'Vui lòng nhập mã xác thực',

        mobilePhoneSmsVerificationCode:
            'Mã xác thực SMS',

        pleaseEnterTheMobilePhoneVerificationCode:
            'Vui lòng nhập mã xác thực điện thoại',

        pleaseVerifyTheNewPassword:
            'Vui lòng xác nhận mật khẩu mới',

        bindWechat: 'Liên kết WeChat',

        pleaseEnterTheLoginPassword:
            'Vui lòng nhập mật khẩu đăng nhập',

        theTwoPasswordsEnteredAreInconsistent:
            'Hai mật khẩu nhập vào không khớp',

        pleaseEnterTheVerificationCode3:
            'Vui lòng nhập mã xác thực hình ảnh',

        loggingIn: 'Đang đăng nhập',

        acquire: 'Lấy mã',

        resendVerificationCode:
            'Gửi lại mã xác thực',

        loginNow: 'Đăng nhập ngay',

        currentPhoneNumber: 'Số điện thoại hiện tại',

        changeSuccessful: 'Thay đổi thành công',

        afterReGetting: 'sau đó lấy lại',

        pleaseEnterCorrectAccount:
            'Vui lòng nhập đúng tài khoản',
    },
    accountIndex: {
        scope: 'Phạm vi áp dụng',

        confirmDelete: 'Bạn có chắc chắn muốn xóa bộ sổ kế toán này không?',

        onlyDeleteDisabled:
            'Chỉ có thể xóa bộ sổ kế toán ở trạng thái vô hiệu hóa',

        cancelDelete: 'Đã hủy thao tác xóa',
    },

    accountsetMember: {
        accountSubject: 'Hạch toán tài khoản',

        addCash: 'Thêm tài khoản thanh toán tiền mặt',

        roomAccount: 'Ghi nợ vào phòng',

        pleaseEnterTheExternalOrderNumber:
            'Vui lòng nhập mã đơn hàng bên ngoài',

        consumptionStatement: 'Phiếu thanh toán chi tiêu',

        submitted: 'Đã gửi',

        pleaseFillInTheAmountSpent:
            'Vui lòng nhập số tiền tiêu dùng',

        theAmountSpentMustBeGreaterThan:
            'Số tiền tiêu dùng phải lớn hơn',

        blanked: 'Đã hủy',

        pleaseFillInTheRoomAccount:
            'Vui lòng chọn có ghi nợ vào phòng hay không',

        pleaseSelectAnAccount:
            'Vui lòng chọn tài khoản',

        pleaseSelectASmallItem:
            'Vui lòng chọn hàng hóa nhỏ',

        newSuccess: 'Thêm mới thành công',

        goAndCheck: 'Đi xem',
    },

    pcncomponentRoomtypesortingcomponent: {
        roomTypeRanking: 'Sắp xếp loại phòng',
    },

    activitySelfHelp: {
        selfHelpPromotionDescription:
            'Mô tả chương trình khuyến mãi tự phục vụ',

        promotionalOffersAreAllBorneByTheMerchantDifferentChannelsOfSettlementMethodsAreDifferent:
            'Toàn bộ chi phí khuyến mãi do khách sạn chịu, phương thức thanh toán của từng kênh có thể khác nhau',

        inCaseOfFalsePromotionTheConsequencesShallBeBorneByTheMerchant:
            'Nếu xảy ra khuyến mãi không đúng sự thật, mọi hậu quả sẽ do khách sạn chịu trách nhiệm',

        onceCreatedThePromotionWillTakeEffectAcrossAllChannels:
            'Sau khi tạo thành công, chương trình khuyến mãi sẽ có hiệu lực trên tất cả các kênh',

        promotionType: 'Loại khuyến mãi',

        promotionalProduct: 'Sản phẩm khuyến mãi',

        effectiveChannel: 'Kênh áp dụng',

        promotionStatus: 'Trạng thái khuyến mãi',

        noRegistrationIsAvailable:
            'Hiện không có chương trình nào có thể đăng ký',

        dailySpecial: 'Ưu đãi mỗi ngày',

        tonightSpecial: 'Ưu đãi đêm nay',

        firstStayDiscount: 'Giảm giá lần lưu trú đầu tiên',

        travelSpecial: 'Ưu đãi du lịch',

        festivalCoverage: 'Ưu đãi ngày lễ',

        studentOnly: 'Ưu đãi dành riêng cho sinh viên',

        batchOffLine: 'Gỡ xuống hàng loạt',

        thereAreNoRegisteredActivities:
            'Chưa có chương trình nào đã đăng ký',

        thereAreNoCanceledEvents:
            'Chưa có chương trình nào đã hủy',

        pleaseSelectThePostPromotionOperationBatchOfflineFeature:
            'Vui lòng chọn chức năng gỡ khuyến mãi hàng loạt',

        massMerchantsSelfPromotionOffline:
            'Gỡ chương trình tự khuyến mãi của khách sạn hàng loạt',

        allChannels: 'Tất cả các kênh',
    },
    componentsPrintsettingdialog: {
        previewEditing: 'Xem trước và chỉnh sửa',

        printTheFullIdNumber: 'In đầy đủ số giấy tờ tùy thân',

        printGuestAddress: 'In địa chỉ khách',

        printPaymentInformation: 'In thông tin thanh toán',

        modifySettings: 'Chỉnh sửa cài đặt',

        documentType: 'Loại chứng từ',

        paperSize: 'Khổ giấy',

        typeSize: 'Cỡ chữ',

        printingMode: 'Chế độ in',

        noticeToGuests: 'Lưu ý dành cho khách',

        thisContentWillBeDisplayedOnTheDocumentWhenPrintingPleaseBeSureToPrintATestAfterFillingInTheDocumentToAvoidTheDisplayEffectAffectedByTheNumberOfLinesOrExcessiveWords:
            'Nội dung này sẽ được hiển thị trên chứng từ khi in. Sau khi nhập nội dung, vui lòng in thử để đảm bảo việc hiển thị không bị ảnh hưởng bởi quá nhiều dòng hoặc quá nhiều ký tự.',

        defaultPrint: 'In mặc định',

        manualSelection: 'Chọn thủ công',

        standard: 'Tiêu chuẩn',

        larger: 'Lớn hơn',

        pleaseSelectPaperSize: 'Vui lòng chọn khổ giấy',

        pleaseSelectAPrintingMethod: 'Vui lòng chọn phương thức in',

        pleaseSelectTheSize: 'Vui lòng chọn cỡ chữ',
    },

    assemblyAddprojectdialog: {
        addItem: 'Thêm hạng mục',

        projectName: 'Tên hạng mục',

        pleaseEnterAProjectName: 'Vui lòng nhập tên hạng mục',

        copies: 'Số lượng',

        pleaseEnterTheNumberOfCopies: 'Vui lòng nhập số lượng',

        pleaseEnterTheNameOfTheOffer: 'Vui lòng nhập tên ưu đãi',

        theNumberOfCopiesMustBeGreaterThan:
            'Số lượng phải lớn hơn',
    },

    viewsHomePageIndex: {
        commonFunctions: 'Chức năng thường dùng',

        roomStatusOverview: 'Tổng quan tình trạng phòng',

        todayData: 'Dữ liệu hôm nay',

        thisMonthData: 'Dữ liệu tháng này',

        dataAsOf: 'Dữ liệu tính đến:',

        todoList: 'Danh sách công việc',

        allRead: 'Đánh dấu tất cả đã đọc',

        noTodos: 'Bạn đã xử lý xong tất cả công việc cần làm',

        efficientDay: 'Thật là một ngày làm việc hiệu quả!',

        logUpdates: 'Cập nhật nhật ký',

        selectedFunctionsTitle: 'Chức năng đã chọn',

        selectedFunctionsTip:
            'Nhấn và kéo để thay đổi thứ tự, phải chọn ít nhất 1 chức năng',

        maxSix: 'Tối đa 6 chức năng',

        allReadSuccess: 'Đánh dấu tất cả đã đọc thành công',
    },

    viewsReportFinanceOnlinePaymentReconciliation: {
        tradeDate: 'Ngày giao dịch',

        billType: 'Loại giao dịch',

        platform: 'Nền tảng thanh toán',

        qzTradeNo: 'Mã giao dịch thanh toán',

        qzTradeNoPlaceholder:
            'Vui lòng nhập mã giao dịch thanh toán',

        amountTotal: 'Tổng số tiền',

        feeTotal: 'Tổng phí',

        reportName: 'Báo cáo đối soát thanh toán trực tuyến',

        pleaseSelectAtLeastOneDateType:
            'Vui lòng chọn ít nhất một loại ngày để tra cứu',

        income: 'Thu tiền',

        alipay: 'Alipay',

        wechat: 'WeChat Pay',

        merchantCode: 'Mã thương gia',

        merchantName: 'Tên thương gia',

        qzTradeNoColumn: 'Mã giao dịch thanh toán',

        externalOrderNo: 'Mã đơn hàng bên ngoài',

        orderAmount: 'Giá trị đơn hàng',

        merchantRate: 'Tỷ lệ phí thương gia',

        commission: 'Phí giao dịch',

        billTypeColumn: 'Loại giao dịch',

        finishTime: 'Thời gian hoàn tất',

        oriQzTradeNo: 'Mã giao dịch thu tiền gốc',

        platformColumn: 'Nền tảng thanh toán',
    },
    appShop: {
        label1: '🔥 "Tiết kiệm ngay 25% phí thu hộ"',

        label2: '💰 "Bí quyết giúp doanh nghiệp tiết kiệm hàng nghìn đồng phí mỗi tháng"',

        label3: '⚠ "Vẫn đang đau đầu vì phí rút tiền quá cao?"',

        label4: '⏳ "100 khách hàng đầu tiên đăng ký sẽ nhận hộp quét mã miễn phí"',

        label5: '❓ "Vì sao các thương hiệu lớn đều sử dụng giải pháp thanh toán này?"',

        label6: '🛡 "Chứng nhận bảo mật cấp ngân hàng | Được hàng chục nghìn doanh nghiệp tin dùng"',

        label7: '📞 "Đăng ký ngay | Giảm ngay 25% phí dịch vụ"',

        label8: '💼 "Chủ khách sạn chia sẻ: Tăng thêm 3.000 NDT/tháng nhờ giải pháp này"',
    },

    settleDialog: {
        entryRoom: 'Phòng ghi sổ',
        selectEntryRoom: 'Vui lòng chọn phòng ghi sổ',
        confirmTotalRoomRate: 'Xác nhận tổng tiền phòng',

        preAuthorizationSettlement: 'Thanh toán tiền đặt cọc ủy quyền',

        completeCheckout: 'Hoàn tất trả phòng',

        additionalChargeAmount: 'Khoản phụ thu',

        hourlyRoomTip:
            'Phòng theo giờ: Vui lòng xác nhận số tiền phòng thực tế cần thu',

        fullDayRoomTip:
            'Phòng cả ngày: Vui lòng nhập số tiền phòng cần phụ thu thêm',

        noAdditionalCharge: 'Không phụ thu',

        generateRoomFee: 'Tạo tiền phòng',

        hangAccount: 'Ghi nợ',

        hangToMaster: 'Ghi vào đơn chính',

        hangAccountReason: 'Lý do ghi nợ',

        hangAccountTip:
            'Thao tác ghi nợ sẽ được lưu vào tài khoản của đơn chính.',

        inputAdditionalAmount: 'Vui lòng nhập số tiền phụ thu',

        detail: 'Chi tiết',

        selectAtLeastOneRoom:
            'Vui lòng chọn ít nhất một phiếu phòng',

        transferBeforeHangAccount:
            'Vui lòng chuyển các phòng ở trạng thái "Chờ nhận phòng" ra ngoài trước khi thực hiện ghi nợ',

        pleaseAddRoomFee:
            'Vui lòng phụ thu tiền phòng trước',

        noRoomOrderFound:
            'Không tìm thấy phiếu phòng cần thanh toán, vui lòng làm mới trang và thử lại',
    },

    notUploadList: {
        searchPlaceholder: 'Nhập tên khách hoặc số phòng',

        uploadStatus: 'Trạng thái tải lên',

        notUploaded: 'Chưa tải lên',

        uploaded: 'Đã tải lên',

        loggedOut: 'Đã trả phòng',

        downloadAllGuestInfo:
            'Tải xuống toàn bộ thông tin khách',

        idAddress: 'Địa chỉ trên giấy tờ tùy thân',

        uploadStatusColumn:
            'Đã tải lên cơ quan công an',

        downloadInfo: 'Tải thông tin',

        finishUpload: 'Hoàn tất tải lên',
    },

    notification: {
        markAllRead: 'Đánh dấu tất cả đã đọc',

        expand: 'Mở rộng ({count})',

        collapse: 'Thu gọn ({count})',

        ignore: 'Bỏ qua',
    },

    adjustFinance: {
        title: 'Điều chỉnh tài chính',

        adjustAccount: 'Điều chỉnh sổ sách',

        balanceZeroWarning:
            'Vui lòng đảm bảo số dư bằng 0 trước khi gửi',

        addOneRecordWarning:
            'Vui lòng thêm ít nhất một bản ghi hạch toán',
    },

    roomStatusStatistics: {
        details: 'Thông tin chi tiết',
    },

    hotelStateDialog: {
        title: 'Thống kê tình trạng phòng',

        checkIn: 'Đang ở',

        prepareCheckIn: 'Chờ nhận phòng',

        sold: 'Đã bán',

        available: 'Còn bán',

        fetchError:
            'Không thể lấy dữ liệu loại phòng',
    },
    futureRoomIndex: {
        quickSearch: 'Tìm kiếm nhanh',

        reEnable: 'Kích hoạt lại',

        confirmChangeRoomTitle:
            'Bạn có muốn chuyển từ phòng hiện tại sang phòng mới không?',

        originalRoom: 'Phòng hiện tại',

        newRoom: 'Phòng mới',

        dragTargetInvalid: 'Kéo thả thất bại: không tìm thấy ô đích',

        selectSameRoomTypeSameStayDate:
            'Vui lòng chọn phòng cùng loại với ngày đến và ngày đi giống nhau',

        differentRoomTypeSwapNotSupported:
            'Chưa hỗ trợ đổi với đơn phòng hiện có khi khác loại phòng',

        AVL: 'Còn',
    },

    financePaymentIndex: {
        addPaymentSubject: 'Thêm mới',

        paymentSubjectName: 'Tên hạng mục thanh toán',

        symbol: 'Ký hiệu',

        confirmDelete:
            'Bạn có chắc chắn muốn xóa hạng mục này không?',
    },

    financeAccountDialog: {
        pleaseEnterSubject:
            'Vui lòng nhập hạng mục {type}',

        pleaseSelectCategoryType:
            'Vui lòng chọn loại hạng mục {type}',

        addTitle: 'Thêm hạng mục {type}',

        editTitle: 'Chỉnh sửa hạng mục {type}',

        subjectName: 'Hạng mục {type}',

        subjectCategory: 'Danh mục hạng mục {type}',

        isEnabled: 'Kích hoạt',
    },

    financeConsumerAccount: {
        subjectCategory: 'Danh mục hạng mục',

        addSubject: 'Thêm mới',

        subjectName: 'Tên hạng mục tiêu dùng',

        symbol: 'Ký hiệu',

        confirmDelete:
            'Bạn có chắc chắn muốn xóa hạng mục này không?',
    },

    financeSubjectSorting: {
        consumeSortTitle:
            'Sắp xếp hạng mục tiêu dùng',

        paySortTitle:
            'Sắp xếp hạng mục thanh toán',

        consumeSubjectName:
            'Tên hạng mục tiêu dùng',

        paySubjectName:
            'Tên hạng mục thanh toán',

        sortSuccess: 'Sắp xếp thành công',
    },
    aiPms: {
        common: {
            aiDriven: 'Được hỗ trợ bởi AI',
            justNow: 'Vừa xong',
            minutesAgo: '{count} phút trước',
            hoursAgo: '{count} giờ trước',
        },
        aiConfig: { pageTitle: 'AI Configuration', save: 'Save', hotelSection: 'Hotel Configuration', roomTypeSection: 'Room Type Configuration', priceGuard: 'Price Guardrail', enabled: 'Enabled', disabled: 'Disabled', hotelFloorPrice: 'Hotel Floor Price', hotelCeilingPrice: 'Hotel Ceiling Price', floorPrice: 'Floor Price (CNY)', ceilingPrice: 'Ceiling Price (CNY)', floorPricePlaceholder: 'Enter floor price', ceilingPricePlaceholder: 'Enter ceiling price', yuan: 'CNY', roomTypeName: 'Room Type Name', roomTypeCode: 'Room Type Code', amountNonNegative: ' amount must be greater than or equal to 0', floorGreaterThanCeiling: ' floor price cannot exceed ceiling price', hotelLabel: 'Hotel', roomTypeLabel: 'Room type “{name}”', noChanges: 'No configuration changes detected', saveSuccess: 'Saved successfully', pricingSelloutTimeTitle: 'Target Sellout Time Policy', pricingSelloutTimeTip: 'Used for same-day price increases, slow-selling price reductions, and peer-traffic urgency.', custom: 'Custom Policy', legalHoliday: 'Legal Holiday', weekend: 'Friday and Saturday', defaultDate: 'Other Dates (including Sunday)', selectTime: 'Select time', pricingSelloutTimeInvalid: 'The sellout time policy returned by the server is invalid. Explicitly handle it before saving.', pricingSelloutTimeRequired: 'All target sellout times must use HH:mm and be within 14:00–23:59 or 00:00–06:00.' },
        roomPricingReport: { reportTitle: 'Room Type Pricing Report', reportTip: 'AI recommendations, operating basis, and pricing factors', hotelInfo: 'Hotel Information', sellDate: 'Sale Date', metricDate: 'Metric Business Date', hotelOcc: 'Current Hotel OCC', hotelRevpar: 'Current Hotel RevPAR', currentPrice: 'Current Price', aiRecommendedPrice: 'AI Recommended Price', aiCurrentDelta: 'AI vs. Current Price', sameDayOcc: 'Same-day OCC', sameDayRevpar: 'Same-day RevPAR', confidence: 'AI Confidence', inventorySnapshot: 'Đã bán / Còn bán (Bán quá) / Ngừng sử dụng', operatingBasis: 'Room Type Operating Basis', aiDecision: 'AI Decision', tradeoff: 'Multi-factor Trade-off: ', aiFactors: 'AI Pricing Factors', historicalPrice: 'Historical Price', operation: 'Operating Data', market: 'Market Position', timeEvent: 'Time and Events', guardrailRisk: 'Guardrails and Risks', status: 'Status: ', priceImpact: 'Price Impact: ', conclusion: 'Conclusion: ', reason: 'Reason: ', evidence: 'Evidence: ', riskReminder: 'Risk Reminders', noRisk: 'No additional risk reminders', severity: 'Severity: ', suggestion: 'Suggested Action: ', used: 'Used', notUsed: 'Not Used', notAvailable: 'No Data Available', up: 'Supports Increase', hold: 'Hold', down: 'Supports Decrease', limit: 'Guardrail Limit', none: 'No Direct Impact', yes: 'Yes', no: 'No', yuan: 'CNY', priceAdjustment: 'Điều chỉnh giá sản phẩm', priceAdjustmentDialogTitle: 'Định giá thông minh: điều chỉnh giá sản phẩm', noAdjustableProducts: 'Không có sản phẩm có thể điều chỉnh cho loại phòng này', roomTypeName: 'Loại phòng: ', roomTypeCode: 'Mã loại phòng: ', roomTypeCurrentPrice: 'Giá hiện tại của loại phòng', algorithmRecommendedPrice: 'Giá đề xuất bởi thuật toán', aiAdjustmentDelta: 'Mức thay đổi giá AI', currencySymbol: '¥', snapshotPriceNote: 'Đề xuất AI dựa trên ảnh chụp nhanh của thông báo định giá thông minh này.', product: 'Sản phẩm: ', channel: 'Kênh', channelId: 'ID kênh: {id}', channelCurrentPrice: 'Giá bán hiện tại của kênh', aiAdjustedPrice: 'Giá bán sau điều chỉnh AI', operationLabel: 'Thao tác', oneClickAdjustment: 'Điều chỉnh giá', confirmGroupAdjustment: 'Điều chỉnh giá cho {count} kênh của sản phẩm này?', confirmChannelAdjustment: 'Điều chỉnh giá cho sản phẩm kênh này?', confirmAdjustmentTitle: 'Xác nhận điều chỉnh giá', confirm: 'Xác nhận', cancel: 'Hủy', adjustmentSuccess: 'Điều chỉnh giá thành công', bookingHourPreference: 'Ưu tiên đặt phòng theo khung giờ trong 7 ngày gần đây', bookingHourNoData: 'Chưa có dữ liệu đặt phòng theo khung giờ', bookingHourDateRange: '{start} đến {end}', bookingHourTooltip: '{hour}:00<br/>Tỷ lệ đặt phòng: {value}%' },
        roomPricingFeedback: { button: 'Chấp nhận', dialogTitle: 'Gửi phản hồi', accept: 'Chấp nhận', reject: 'Không chấp nhận', rejectReasonPlaceholder: 'Vui lòng nhập lý do không chấp nhận', actionRequired: 'Vui lòng chọn kết quả phản hồi', rejectReasonRequired: 'Vui lòng nhập lý do không chấp nhận', rejectReasonTooLong: 'Lý do không chấp nhận không được vượt quá 100 ký tự', acceptSuccess: 'Đã chấp nhận đề xuất', rejectSuccess: 'Đã gửi phản hồi không chấp nhận' },
        roomPricing: {
            empty: 'Hiện chưa có kết quả định giá để hiển thị',
            roomTypeFallback: 'Loại phòng {index}',
            decisionTitle: 'Giải thích quyết định',
            riskLabel: 'Cảnh báo rủi ro:',
            modeLabel: 'Chế độ:',
            floorPriceLabel: 'Ngưỡng giá:',
            confidenceLabel: 'Mức độ tin cậy:',
            directionFlat: 'Đề xuất giữ nguyên giá',
            directionUp: 'Đề xuất tăng giá',
            directionDown: 'Đề xuất giảm giá',
            priorityLow: 'Ưu tiên thấp',
            priorityMedium: 'Ưu tiên trung bình',
            priorityHigh: 'Ưu tiên cao',
        },
        roomPricingCard: { pricingTime: 'Thời gian định giá: ', expand: 'Mở rộng', collapse: 'Thu gọn' },
        noticeCenter: {
            unreadCount: '{count} chưa đọc',
            readAll: 'Đánh dấu tất cả là đã đọc',
            defaultTitle: 'Thông báo AI',
            browserNotificationTitle: 'Nhắc nhở AI',
            browserNotificationBody: 'Bạn đã nhận được một thông báo AI mới.',
            browserPermissionGuide: 'Bật để nhận thông báo AI mới trên trình duyệt khi chạy nền.',
            enableBrowserNotification: 'Bật thông báo trình duyệt',
            skipBrowserNotification: 'Để sau',
            statusRead: 'Đã đọc',
            statusUnread: 'Chưa đọc',
            emptySummary: 'Không có tóm tắt thông báo',
            like: 'Thích',
            dislike: 'Không thích',
            viewDetail: 'Xem chi tiết',
            markRead: 'Đánh dấu đã đọc',
            emptyList: 'Không có thông báo',
            dislikeDialogTitle: 'Gửi lý do không thích',
            dislikePlaceholder: 'Vui lòng để lại góp ý của bạn',
            categoryAll: 'Tất cả',
            readAllSuccess: 'Đã đánh dấu tất cả là đã đọc',
            markReadSuccess: 'Đã đánh dấu là đã đọc',
            likeSuccess: 'Cảm ơn phản hồi của bạn',
            dislikeReasonRequired: 'Vui lòng nhập lý do không thích',
            dislikeSuccess: 'Gửi thành công',
            uncategorized: 'Chưa phân loại',
        },
        noticeDetail: {
            back: 'Quay lại thông báo AI',
            sendTime: 'Thời gian tạo: ',
            businessType: 'Phân loại cấp 1: ',
            businessSubType: 'Phân loại cấp 2: ',
            sideLabel: 'Chi tiết thông báo',
            contentTitle: 'Nội dung thông báo',
            contentTip: 'Hiển thị nội dung gốc của thông báo theo kiểu markdown',
            badReviewTitle: 'Chi tiết đánh giá xấu',
            badReviewTip: 'Hiển thị nội dung đánh giá và phản hồi do AI gợi ý',
            badReviewContent: 'Nội dung đánh giá',
            badReviewReply: 'Phản hồi gợi ý',
            structuredTitle: 'Kết quả có cấu trúc',
            structuredTip: 'Hiển thị dữ liệu có cấu trúc và nội dung phân tích theo từng phần báo cáo AI',
            structuredEmptyTip: 'Nội dung hiện tại chưa phân tích được dữ liệu có thể hiển thị',
            missingNoticeNo: 'Thiếu noticeNo',
        },
    smartPricing: {
            pageTitle: 'Định giá thông minh',
            empty: 'Hiện chưa có thông báo định giá thông minh mới nhất',
            peerHotelMonitor: {
                title: 'Giám sát giá thu hút khách của đối thủ',
                refresh: 'Làm mới',
                meituan: 'Meituan',
                empty: 'Chưa có dữ liệu giá thu hút khách của đối thủ',
                unnamedHotel: 'Khách sạn đối thủ chưa đặt tên',
                crawlSubmitted: 'Hãy làm mới trang sau để xem dữ liệu.',
      },
    },
    futurePricing: { realtimeTab: 'Báo cáo giá thời gian thực', futureTab: 'Báo cáo giá tương lai', reportTitle: 'Báo cáo giá loại phòng trong tương lai', reportTip: 'Hiển thị đề xuất và phân tích giá đã đóng băng cho 14 ngày tới', empty: 'Không có báo cáo giá tương lai', hotelOverview: 'Tổng quan giá tương lai', priceSource: 'Nguồn giá', pricingBusinessDate: 'Ngày kinh doanh định giá', forecastDateRange: 'Khoảng ngày dự báo', to: 'đến', confidence: 'Độ tin cậy 14 ngày', dailyEmpty: 'Không có kết quả giá hàng ngày', analysis: 'Phân tích', aiDecision: 'Quyết định AI', decisionSummary: 'Tóm tắt quyết định', pricingFactors: 'Yếu tố định giá', noFactor: 'Không có chi tiết yếu tố', status: 'Trạng thái', priceImpact: 'Tác động giá', reason: 'Lý do', conclusion: 'Kết luận', tradeoff: 'Cân nhắc', riskReminder: 'Nhắc nhở rủi ro', noRisk: 'Không có nhắc nhở rủi ro', severity: 'Mức độ nghiêm trọng', suggestion: 'Đề xuất', sellDate: 'Ngày bán', algorithmReferencePrice: 'Giá tham chiếu thuật toán', aiRecommendedPrice: 'Giá AI đề xuất', historicalExpectedOcc: 'OCC dự kiến lịch sử', historicalExpectedRevpar: 'RevPAR dự kiến lịch sử', holidayEvent: 'Ngày lễ / Sự kiện', systemRisk: 'Rủi ro hệ thống', yes: 'Có', no: 'Không', legalHoliday: 'Ngày lễ hợp pháp', weekendPeak: 'Cao điểm cuối tuần', normalDate: 'Ngày thường', reportGeneratedAt: 'Thời gian tạo báo cáo', listEmpty: 'Không có báo cáo giá tương lai đã hoàn thành', selectDate: 'Chọn ngày', dailyAverageOrders: 'Đơn hàng trung bình mỗi ngày trong 7 ngày gần nhất', viewAllReports: 'Xem tất cả báo cáo', backToAllReports: 'Quay lại danh sách báo cáo', realtimeListEmpty: 'Không có báo cáo giá loại phòng đã hoàn thành' },
    futurePricingCalendar: { calendarTitle: 'Lịch định giá tương lai theo loại phòng', roomType: 'Loại phòng', expectedOcc: 'OCC dự kiến', expectedRevpar: 'RevPAR dự kiến', pricingBasis: 'Cơ sở định giá', dataIntegrityRisk: 'Nhắc nhở về tính toàn vẹn dữ liệu / rủi ro', highRisk: 'Rủi ro cao', calendarEmpty: 'Không có dữ liệu lịch định giá tương lai', priceUp: 'Tăng', priceDown: 'Giảm', priceHold: 'Giữ nguyên', overallPricingBasis: 'Cơ sở định giá tổng thể', roomOverallRisk: 'Nhắc nhở rủi ro tổng thể của loại phòng', dailyRiskReminder: 'Nhắc nhở rủi ro hằng ngày' },
    storeManagerReport: {
            pageTitle: 'Báo cáo quản lý cửa hàng',
            pageDesc: 'Xem kết quả báo cáo tổng hợp mới nhất theo ngày, tuần và tháng.',
            dailyButton: 'Ngày',
            weeklyButton: 'Tuần',
            monthlyButton: 'Tháng',
            datePlaceholder: 'Chọn thời gian',
            empty: 'Không có báo cáo quản lý cửa hàng mới nhất cho giai đoạn đã chọn',
            contentTitle: 'Nội dung báo cáo',
            contentTip: 'Hiển thị nguyên văn nội dung báo cáo tổng hợp mới nhất',
            analysisTitle: 'Phân tích có cấu trúc',
            analysisTip: 'Hiển thị nội dung phân tích tổng hợp theo các nút có cấu trúc',
            monthLabel: '{year}-{month}',
            weekLabel: '{start} đến {end}',
            dailyTitle: 'Báo cáo cửa hàng hằng ngày',
            weeklyTitle: 'Báo cáo cửa hàng hằng tuần',
            monthlyTitle: 'Báo cáo cửa hàng hằng tháng',
            periodLabel: 'Khoảng thời gian: {range}',
        },
        storeDiagnosis: {
            pageTitle: 'Chẩn đoán cửa hàng',
            pageDesc: 'Mỗi ngày một báo cáo chẩn đoán cửa hàng, được tạo tự động từ dữ liệu tĩnh và đánh giá 31 ngày gần nhất. Mỗi ngày chỉ tạo 1 lần. Trang hiển thị kết quả gần nhất.',
            refresh: 'Làm mới',
            generate: 'Tạo báo cáo chẩn đoán',
            hotelInfoIncomplete: 'Thông tin khách sạn chưa đầy đủ. Vui lòng xác nhận đã đăng nhập và chọn khách sạn.',
            emptyTitle: 'Chưa có báo cáo chẩn đoán',
            emptyDesc: 'Khi hồ sơ khách sạn, loại phòng, hình ảnh và dữ liệu liên quan đã đủ, AI tự động bắt đầu chẩn đoán. Sau khi tạo không thể thao tác lại.',
            emptyMeta: 'Mã khách sạn {hotelCode}  Lô {batchNo}',
            taskInfo: 'Thông tin tác vụ',
            batch: 'Lô',
            todayTask: 'Tác vụ hôm nay',
            preparingData: 'Đang chuẩn bị dữ liệu',
            generating: 'Đang tạo chẩn đoán',
            failedNoRetry: 'Đã thất bại, không thể tạo lại',
            generated: 'Đã tạo',
            notGenerated: 'Chưa tạo, có thể tạo thủ công',
            noReport: 'Chưa có báo cáo',
            latestDone: 'Lần gần nhất đã hoàn thành',
            latestFailed: 'Lần gần nhất thất bại',
            done: 'Đã hoàn thành',
            failed: 'Tạo thất bại',
            statusWait: '1 / Chờ kiểm tra',
            statusDiagnosing: '2 / Đang chẩn đoán',
            statusDone: '3 / Hoàn thành',
            statusFailed: '4 / Thất bại',
            metaStatus: 'Trạng thái',
            failSummary: 'Tóm tắt lỗi',
            currentStage: 'Giai đoạn hiện tại',
            crawlRetry: 'Số lần thử gộp dữ liệu',
            diagnoseDone: 'Chẩn đoán hoàn tất',
            diagnosingStage: 'Đang tạo chẩn đoán',
            generateFailedShort: 'Tạo thất bại',
            failTitle: 'Chẩn đoán chưa hoàn thành',
            failMessageToday: 'Gộp dữ liệu hoặc AI tạo thất bại. Hôm nay không thể tạo lại.',
            failMessageLatest: 'Lần chẩn đoán gần nhất thất bại. Báo cáo hôm nay chưa được tạo và có thể tạo thủ công.',
            failHintToday: 'Hôm nay không thể tạo lại. Có thể thử lại ngày hôm sau, hoặc liên hệ vận hành.',
            failHintLatest: 'Trên đây là bản ghi thất bại gần nhất. Báo cáo hôm nay chưa được tạo. Hãy bấm Tạo báo cáo chẩn đoán.',
            stepCrawl: '① Bắt đầu gộp dữ liệu',
            stepSuccess: '② Gộp dữ liệu thành công',
            stepSync: '③ Đồng bộ dữ liệu',
            stepAdp: '④ Bắt đầu chẩn đoán',
            progressDiagnosing: 'Đã gộp và đồng bộ dữ liệu, đang tạo báo cáo chẩn đoán.',
            progressWait: 'Đang lấy hồ sơ Meituan/Ctrip, loại phòng và hình ảnh. Sẽ tự động chẩn đoán khi dữ liệu đủ.',
            reportPending: 'Báo cáo chưa có. Khi dữ liệu đủ sẽ tự động chẩn đoán. Có thể rời trang và quay lại sau.',
            reportGenerating: 'Đang tạo báo cáo chẩn đoán, vui lòng đợi…',
            reportBody: 'Nội dung báo cáo chẩn đoán',
            reportEmpty: 'Nội dung báo cáo trống',
            generateSuccess: 'Đã tạo tác vụ chẩn đoán, đang chuẩn bị dữ liệu',
            retryCount: '{count} / {max}',
        },
        structured: {
            channelAnalysis: 'Phân tích kênh',
            roomTypeAnalysis: 'Phân tích loại phòng',
            commentAnalysis: 'Phân tích đánh giá',
            marketAnalysis: 'Mức độ nóng của thị trường / khu vực',
            momLabel: 'So với kỳ trước: ',
            yoyLabel: 'So với cùng kỳ năm trước: ',
            dayMomLabel: 'So với kỳ trước: ',
            dayYoyLabel: 'So sánh theo tuần: ',
            weekMomLabel: 'So với kỳ trước: ',
            weekYoyLabel: 'So sánh theo tháng: ',
            monthMomLabel: 'So với kỳ trước: ',
            monthYoyLabel: 'So với cùng kỳ năm trước: ',
            channel: 'Kênh',
            revenue: 'Doanh thu',
            roomNight: 'Số đêm phòng',
            channelShare: 'Tỷ trọng kênh',
            roomTypeName: 'Tên loại phòng',
            totalRooms: 'Tổng số phòng',
            soldRoomNights: 'Số đêm phòng đã bán',
            totalRoomRevenue: 'Tổng doanh thu phòng',
            occupancyRate: 'Tỷ lệ lấp đầy',
            averageRoomRate: 'ADR',
            disabledRooms: 'Số phòng ngừng sử dụng',
            commentType: 'Loại đánh giá',
            count: 'Số lượng',
            share: 'Tỷ lệ',
            goodMediumBad: 'Tốt / Trung bình / Xấu',
            goodRate: 'Tỷ lệ đánh giá tốt',
            eventName: 'Tên sự kiện',
            eventFallback: 'Sự kiện',
            summaryAnalysis: 'Phân tích tổng hợp',
            goodComment: 'Đánh giá tốt',
            mediumComment: 'Đánh giá trung bình',
            badComment: 'Đánh giá xấu',
            channelRevenueChart: 'Doanh thu theo kênh',
            roomTypeRevenueChart: 'Doanh thu theo loại phòng',
        },
        revenueManager: {
            pageTitle: 'Quản lý doanh thu',
            adviceTitle: 'Gợi ý vận hành từ AI',
            pendingCount: '{count} mục chờ xử lý',
            trafficTitle: 'Giám sát lưu lượng',
            trafficSubtitle: 'Dự báo AI · cập nhật thời gian thực',
            selectDate: 'Chọn ngày',
            todayShortcut: 'Hôm nay',
            allDay: 'Cả ngày',
            timeLabel: 'Thời gian',
            storeTrafficLabel: 'Lưu lượng của khách sạn',
            orderLabel: 'Đơn hàng',
            orderCount: '{count} đơn',
            summaryNote: 'Kênh {channel} · cập nhật lúc {time}',
            forecastLabel: 'Dự báo cả ngày (mô hình AI)',
            meituanForecast: 'Dự báo lưu lượng Meituan',
            ctripForecast: 'Dự báo lưu lượng Ctrip',
            allDayVisit: 'Lượt truy cập cả ngày',
            occLabel: 'Tỷ lệ lấp đầy',
            roomNightLabel: 'Số đêm phòng',
            revenueLabel: 'Doanh thu',
            analysisTag: 'Phân tích AI',
            defaultStrategyTag: 'Chiến lược giá',
            collapse: 'Thu gọn',
            expandMore: 'Xem thêm',
            badReviewLoading: 'Đang tải nội dung phản hồi đánh giá xấu...',
            badReviewReply: 'Phản hồi',
            badReviewEmpty: 'Không có nội dung phản hồi đánh giá xấu để hiển thị',
            realtimeTitle: 'Tổng quan thời gian thực',
            revenueForecastTitle: 'Dự báo doanh thu ({range})',
            occForecastTitle: 'Dự báo tỷ lệ lấp đầy ({range})',
            aiForecastBadge: 'AI Forecast',
            todayForecast: 'Dự báo hôm nay {value}',
            peakLabel: 'Đỉnh',
            channelMeituan: 'Meituan',
            channelCtrip: 'Ctrip',
            hours1: '1 giờ gần đây',
            hours3: '3 giờ gần đây',
            hours5: '5 giờ gần đây',
            hours12: '12 giờ gần đây',
            yesterdayValue: 'Hôm qua {value}',
            futureSevenDays: '7 ngày tới',
            dailyAdviceTitle: 'Gợi ý AI trong ngày {date}',
            allDayAdviceTitle: 'Gợi ý AI cả ngày',
            hoursAdviceTitle: 'Gợi ý AI {hours} giờ gần đây',
            adrForecastLabel: 'Dự báo ADR ',
            defaultAdviceDetail: 'Khuyến nghị điều chỉnh giá phòng và chiến lược phân phối theo nhu cầu hiện tại.',
            displayDate: '{year}-{month}-{day}',
            roomNightValue: '{count} phòng',
            revenueInsightCollapse: 'Thu gọn phần giải thích doanh thu AI',
            revenueInsightExpand: 'Mở rộng phần giải thích doanh thu AI',
            forecastForDate: 'Dự báo ngày {date}: {value}',
            revenueInsightTitle: 'Giải thích doanh thu AI',
            revenueInsightJudgment: 'Đánh giá doanh thu',
            revenueInsightKeySteps: 'Cơ sở chính',
            revenueInsightRisks: 'Cảnh báo rủi ro',
            revenueInsightRecommendations: 'Khuyến nghị vận hành',
            metricTips: {
                traffic: {
                    meituan: { title: 'Giải thích lưu lượng Meituan', p1: 'Lưu lượng Meituan cho biết lượt truy cập vào khách sạn từ kênh Meituan trong khoảng thời gian đã chọn.', p2: 'Hệ thống xem xét kết quả kinh doanh trước đây, xu hướng gần đây, lượt truy cập đã phát sinh hôm nay, ngày lễ và các yếu tố liên quan.', p3: 'Phù hợp để đánh giá xu hướng theo khung giờ và biến động bất thường, không phải tổng số cuối ngày.' },
                    ctrip: { title: 'Giải thích lưu lượng Ctrip', p1: 'Lưu lượng Ctrip cho biết lượt truy cập vào khách sạn từ kênh Ctrip trong khoảng thời gian đã chọn.', p2: 'Hệ thống tham chiếu các ngày lịch sử tương tự, hiệu quả kênh gần đây, thay đổi thời gian thực hôm nay và ngày lễ.', p3: 'Nên xem cùng thay đổi đơn hàng để đánh giá việc chuyển đổi lưu lượng thành đặt phòng.' },
                    order: { title: 'Giải thích đơn hàng', p1: 'Đơn hàng cho biết thay đổi đặt phòng phát sinh theo kênh, ngày và khoảng thời gian hiện tại.', p2: 'Chỉ số này phản ánh chuyển đổi đặt phòng theo thời gian thực với bộ lọc đang áp dụng.', p3: 'Khi biến động ngắn hạn lớn, nên xem cùng dự báo cả ngày và kết quả kinh doanh trước đây.' },
                },
                hotelForecast: {
                    meituan: { title: 'Giải thích dự báo lưu lượng Meituan', p1: 'Đây là ước tính tổng lượt truy cập kênh Meituan trong hôm nay.', p2: 'Hệ thống sử dụng lưu lượng lịch sử, thay đổi kênh gần đây, kết quả hôm nay, ngày lễ và nhịp vận hành.', p3: 'Dùng để dự báo nhu cầu sớm và hỗ trợ kế hoạch giá, tồn phòng và vận hành.' },
                    ctrip: { title: 'Giải thích dự báo lưu lượng Ctrip', p1: 'Đây là ước tính tổng lượt truy cập kênh Ctrip trong hôm nay.', p2: 'Hệ thống xem xét các ngày lịch sử tương tự, xu hướng gần đây, kết quả thời gian thực hôm nay và ngày lễ.', p3: 'Dùng để đánh giá nhu cầu tiềm năng và so sánh với dự báo Meituan.' },
                    occ: { title: 'Giải thích tỷ lệ lấp đầy', p1: 'Tỷ lệ lấp đầy là tỷ lệ phòng dự kiến bán được hôm nay.', p2: 'Hệ thống xem xét tỷ lệ lấp đầy lịch sử, nhịp đặt phòng gần đây, lưu lượng và đơn hàng hôm nay, cùng ngày lễ.', p3: 'Dùng để đánh giá áp lực lưu trú, rủi ro phòng chưa bán và hướng điều chỉnh giá hoặc khuyến mãi.' },
                    roomNights: { title: 'Giải thích số đêm phòng', p1: 'Số đêm phòng là lượng đêm phòng dự kiến có thể bán được hôm nay.', p2: 'Hệ thống tham chiếu doanh số lịch sử, nhịp đặt phòng gần đây, lưu lượng và đơn hàng hôm nay, cùng ngày lễ.', p3: 'Nên xem cùng tỷ lệ lấp đầy để đánh giá tốc độ tiêu thụ tồn phòng.' },
                    adr: { title: 'Giải thích ADR', p1: 'ADR là giá phòng trung bình dự kiến cho các phòng bán được hôm nay.', p2: 'Hệ thống sử dụng giá lịch sử, giao dịch gần đây, nhu cầu hôm nay và ngày lễ.', p3: 'Nên xem cùng tỷ lệ lấp đầy và doanh thu để tránh chỉ theo đuổi tỷ lệ lấp đầy.' },
                    revenue: { title: 'Giải thích doanh thu', p1: 'Doanh thu là doanh thu bán phòng dự kiến trong hôm nay.', p2: 'Hệ thống kết hợp số đêm phòng và ADR dự kiến, kết quả lịch sử, nhu cầu gần đây và ngày lễ.', p3: 'Dùng để đánh giá kết quả kinh doanh có đạt kỳ vọng và xác định cơ hội tăng doanh thu.' },
                },
                futureRevenue: { title: 'Giải thích dự báo doanh thu', p1: 'Dự báo doanh thu cho biết doanh thu phòng ước tính theo ngày trong 7 ngày tới.', p2: 'Hệ thống xem xét kết quả lịch sử, đặt phòng gần đây, lưu lượng và đơn hàng, kết quả hôm nay và ngày lễ.', p3: 'Dùng để nhận diện ngày nhu cầu cao và thấp, từ đó lập kế hoạch giá, phòng và vận hành.' },
                occRevenue: { title: 'Giải thích dự báo tỷ lệ lấp đầy', p1: 'Dự báo tỷ lệ lấp đầy cho biết tỷ lệ phòng ước tính bán được mỗi ngày trong 7 ngày tới.', p2: 'Hệ thống tham chiếu tỷ lệ lấp đầy lịch sử, đặt phòng gần đây, lưu lượng kênh, đơn hàng, thay đổi hôm nay và ngày lễ.', p3: 'Dùng để nhận diện sớm rủi ro hết phòng hoặc lấp đầy chưa đủ và lập kế hoạch giá, khuyến mãi.' },
            },
        },
    },
    route: {
        ai: 'AI',
        aiRevenueManager: 'Quản lý doanh thu',
        aiSmartPricing: 'Định giá thông minh',
        aiNoticeCenter: 'Trung tâm thông báo',
        aiStoreManagerReport: 'Báo cáo quản lý cửa hàng',
        aiStoreDiagnosis: 'Chẩn đoán cửa hàng',
        aiNoticeDetail: 'Chi tiết thông báo',
        aiConfig: 'AI Configuration',
        businessLog:
            'Nhật ký thay đổi ngày kinh doanh',

        nightAuditLog:
            'Nhật ký kiểm toán đêm',
        turnoverSubmit: 'Doanh thu từ hoạt động kinh doanh',

        channelConfig: 'Cấu hình kênh',
    },

    systemsetNotice: {
        systemMessageReminder:
            'Nhắc nhở tin nhắn hệ thống',

        messageReminderSettingsAtLeastOneItem:
            'Cài đặt nhắc nhở (chọn ít nhất một mục)',

        hourlyRoomCheckoutMessage:
            'Thông báo trả phòng theo giờ',

        fullDayCheckoutMessage:
            'Thông báo trả phòng cả ngày',

        messageVoiceReminder:
            'Nhắc nhở bằng giọng nói',

        onlineChannelNewOrderReminder:
            'Nhắc nhở đơn hàng mới từ kênh trực tuyến',

        onlineChannelOrderCancellationReminder:
            'Nhắc nhở hủy đơn hàng từ kênh trực tuyến',

        hourlyRoomCheckoutReminder:
            'Nhắc nhở trả phòng theo giờ',

        fullDayCheckoutReminder:
            'Nhắc nhở trả phòng cả ngày',

        operationFailed: 'Thao tác thất bại',

        thirtyMinutesBeforeCheckout:
            '30 phút trước khi trả phòng',

        fifteenMinutesBeforeCheckout:
            '15 phút trước khi trả phòng',

        atCheckoutTime:
            'Khi trả phòng',

        checkoutTimeUpdated:
            'Cập nhật thời gian nhắc trả phòng thành công',

        voiceSettingUpdated:
            'Cập nhật trạng thái nhắc nhở bằng giọng nói thành công',
    },
    binding: {
        publicAccountMessageReminder: 'Nhắc nhở tin nhắn tài khoản công khai',

        scanToBindUser: 'Quét mã để liên kết nhân viên',

        cancelEdit: 'Hủy chỉnh sửa',

        allMembers: 'Tất cả thành viên',

        scanToBindTitle: 'Quét mã để liên kết tài khoản công khai',

        scanWithWechat: 'Vui lòng dùng WeChat để quét mã liên kết',

        qrCodeGenerateFail:
            'Tạo mã QR thất bại, vui lòng thử lại sau',

        unbindSuccess: 'Hủy liên kết thành công!',

        unbindFail:
            'Hủy liên kết thất bại, vui lòng thử lại',

        confirmCloseQrDialog:
            'Bạn có chắc muốn đóng cửa sổ mã QR không?',

        orderCreate: 'Đơn hàng mới',

        orderCancel: 'Hủy đơn hàng',

        orderConfirm: 'Đơn hàng chờ xác nhận',

        orderCheckOutTip: 'Trước khi trả phòng',

        orderCheckOut: 'Trả phòng',

        orderCreateEbk: 'Đơn hàng EBK mới',

        orderCancelEbk: 'Hủy đơn hàng EBK',

        roomCleanDone: 'Dọn phòng hoàn tất',

        ebAccountOffline: 'Tài khoản EB ngoại tuyến',

        computerHardwareOffline: 'Thiết bị máy tính ngoại tuyến',

        ebWarnNotice: 'Cảnh báo quá tải phòng',
    },

    writeDoorCardIndex: {
        preIssuedDoorCard: 'Thẻ phòng cấp trước',

        effectiveTime: 'Thời gian hiệu lực',

        expiryTime: 'Thời gian hết hiệu lực',

        viewPassword: 'Xem mật khẩu',

        passwordStatusNotSent: 'Chưa gửi',

        passwordStatusSending: 'Đang gửi',

        passwordStatusSent: 'Gửi thành công',

        passwordStatusFailed: 'Gửi thất bại',

        generatePasswordOnly: 'Chỉ tạo mật khẩu',

        generateAndSendPassword: 'Tạo và gửi mật khẩu',

        getLockInfoFailed:
            'Lấy thông tin khóa cửa phòng thất bại',

        makeCardFailedPrefix: 'Tạo thẻ thất bại: ',

        deactivateFailedPrefix: 'Hủy kích hoạt thẻ thất bại: ',

        pleaseEnterValidPhoneNumber:
            'Vui lòng nhập số điện thoại hợp lệ',

        passwordSendSuccess:
            'Gửi mật khẩu thành công',

        roomPasswordGeneratedAndSent:
            'Mật khẩu phòng đã được tạo và gửi cho khách. Vui lòng nhắc khách kiểm tra tin nhắn SMS để nhận mật khẩu mở cửa',

        roomPasswordGenerated:
            'Mật khẩu phòng đã được tạo',

        invalidTimeString:
            'Chuỗi thời gian không hợp lệ',

        temporaryMakeCard:
            'Tạo thẻ tạm thời',

        makeCardLogTitle:
            'Lịch sử tạo thẻ',

        makeType: 'Loại tạo thẻ',

        operationResult: 'Kết quả thao tác',
    },

    operating: {
        total: 'Tổng cộng',

        index: 'STT',

        businessDay: 'Ngày kinh doanh',

        totalAccount: 'Tổng doanh thu',

        totalOcc: 'Tỷ lệ lấp đầy tổng (%)',

        fullDayOcc: 'Tỷ lệ lấp đầy phòng ngày (%)',

        hourDayOcc: 'Tỷ lệ lấp đầy phòng giờ (%)',

        avgPrice: 'Giá phòng trung bình (VNĐ)',

        revPar: 'REVPAR tổng (VNĐ)',

        totalRoomNight: 'Tổng số đêm phòng bán được',

        fullDayRoomNight: 'Đêm phòng ngày',

        busLongRoomNight: 'Đêm phòng dài hạn',

        hourRoomNight: 'Đêm phòng giờ',

        teamRoomNight: 'Đêm phòng đoàn',

        freeRoomNight: 'Đêm phòng miễn phí',

        privateRoomNight: 'Đêm phòng sử dụng nội bộ',

        houseRent: 'Tổng doanh thu phòng (VNĐ)',

        smallGoods: 'Hàng hóa nhỏ (VNĐ)',

        meals: 'Doanh thu ăn uống (VNĐ)',

        serviceFee: 'Phí dịch vụ (VNĐ)',

        memberFee: 'Phí thành viên (VNĐ)',

        otherFee: 'Chi phí khác (VNĐ)',

        generalIncome: 'Tổng doanh thu hoạt động (VNĐ)',

        roomNight: 'Số đêm phòng',

        avgRoomPrice: 'Giá phòng trung bình (VNĐ)',

        totalHouseRent: 'Tổng doanh thu phòng (VNĐ)',

        rentalRate: 'Tỷ lệ lấp đầy (%)',

        roomNightProportion: 'Tỷ lệ đêm phòng (%)',

        calcFormula: 'Công thức tính',

        known: 'Đã hiểu',
    },
    incomeIncomesum: {
        pleaseCheckTheStartAndEndTimesOfTheSearch:
            'Vui lòng kiểm tra thời gian bắt đầu và kết thúc tìm kiếm',

        roomRateIncome: 'Doanh thu phòng',

        smallwareIncome: 'Doanh thu hàng hóa nhỏ',

        mealFeeIncome: 'Doanh thu ăn uống',

        reportTitle: 'Báo cáo tổng hợp doanh thu',

        cooperationModel: 'Mô hình hợp tác',

        status: 'Ký mới / Gia hạn',

        roomsCount: 'Số lượng phòng vật lý',

        startBusiness: 'Ngày khai trương',
    },

    commonImportDialog: {
        tip: 'Vui lòng sắp xếp dữ liệu theo yêu cầu trong mẫu',

        downloadTemplate: 'Tải mẫu',

        removeFileConfirm: 'Xác nhận xóa',

        limitOneFile:
            'Chỉ được chọn 1 tệp, vui lòng xóa tệp hiện tại trước khi thêm mới',

        uploadError: 'Tải lên thất bại, vui lòng thử lại',

        reupload: 'Tải lên lại',
    },

    orderAntiflyRoom: {
        powerOnTime: 'Thời gian cấp điện',

        powerOffTime: 'Thời gian ngắt điện',

        isAntifly: 'Có phải phòng bay không',

        powerDuration: 'Thời gian cấp điện',
    },

    roomOccupiedDetail: {
        title: 'Chi tiết chiếm phòng',

        unassigned: 'Chưa xếp phòng',

        roomOrderNo: 'Mã phòng lưu trú',

        roomCount: 'Số lượng phòng',

        roomType: 'Loại phòng',

        roomNo: 'Số phòng',

        contact: 'Người liên hệ',

        arrival: 'Ngày đến dự kiến',

        departure: 'Ngày đi dự kiến',

        orderAndPayStatus: 'Trạng thái đơn hàng (Trạng thái thanh toán)',

        unpaidOrderNotAllowed:
            'Không thể thao tác với đơn hàng chưa thanh toán',

        invalidRoomOrderOperation:
            'Không thể thao tác với phòng chưa thanh toán, chờ nhận phòng hoặc chưa được xếp phòng',
    },

    hardware: {
        smartRoomControl: 'Điều khiển phòng thông minh',

        smartRoomControlDesc:
            'Hỗ trợ điều khiển từ xa các thiết bị thông minh trong phòng',

        smartRoomControlSetting:
            'Cài đặt điều khiển phòng thông minh',

        appKey: 'AppKey',

        appKeyPlaceholder: 'Vui lòng nhập AppKey',

        appSecret: 'AppSecret',

        appSecretPlaceholder: 'Vui lòng nhập AppSecret',

        thirdHotel: 'Khách sạn bên thứ ba',

        thirdHotelPlaceholder:
            'Vui lòng nhập mã khách sạn bên thứ ba',

        thirdGroup: 'Tập đoàn bên thứ ba',

        thirdGroupPlaceholder:
            'Vui lòng nhập mã tập đoàn bên thứ ba',

        enable: 'Bật',

        disable: 'Tắt',

        deviceType: 'Loại thiết bị',

        fullDayAutoOff:
            'Tự động ngắt điện khi phòng qua đêm đến thời gian trả phòng dự kiến',

        hourAutoOff:
            'Tự động ngắt điện khi phòng theo giờ đến thời gian trả phòng dự kiến',
    },

    lockpwd: {
        makeCardLogTitle:
            'Nhật ký tạo thẻ phòng',

        operationType: 'Loại thao tác',

        operationTime: 'Thời gian thao tác',

        makeCard: 'Tạo thẻ',

        cancelCard: 'Hủy thẻ',

        roomTypeCode: 'Mã loại phòng',

        roomTypeName: 'Tên loại phòng',

        roomNumber: 'Số phòng',

        lockBrandName: 'Tên thương hiệu khóa cửa',

        lockId: 'ID khóa cửa',

        orderRoomNo: 'Mã phòng lưu trú',

        operator: 'Người thao tác',

        makeType: 'Loại tạo thẻ',

        validPeriod: 'Thời hạn hiệu lực của thẻ',

        operationResult: 'Kết quả thao tác',

        errorMessage: 'Thông tin lỗi',
    },

    roomType: {
        createBundleRoomType:
            'Tạo loại phòng nguyên căn',

        roomTypeName: 'Tên loại phòng',

        relatedRoomTypes: 'Loại phòng liên kết',

        relateRoom: 'Liên kết phòng',

        selectedRooms: 'Các phòng đã chọn',
    },
    turnoverSubmit: {
        summaryLoadFailed: 'Tải dữ liệu nộp doanh thu thất bại. Các thao tác trên trang này đã bị vô hiệu hóa.',
        reload: 'Tải lại',
        initBeforeUse: 'Vui lòng khởi tạo số dư két tiền hiện tại trước khi sử dụng lần đầu.',
        initCashier: 'Khởi tạo két tiền',
        submitManage: 'Quản lý nộp doanh thu',
        summaryTipPrefix: 'Ghi chú: Dữ liệu tiêu dùng và thanh toán được thống kê tại đây là từ',
        to: 'đến',
        summaryTipSuffix: '',
        consumeSubject: 'Khoản mục tiêu dùng',
        paymentSubject: 'Khoản mục thanh toán',
        serialNumber: 'STT',
        subtotal: 'Tổng phụ',
        subject: 'Khoản mục',
        amount: 'Số tiền',
        dataSummary: 'Tổng hợp dữ liệu',
        lastBalanceSummary: 'Số dư két tiền kỳ trước: {total} = Tiền mặt({cash}) + Thẻ ngân hàng({bankCard}) + Khác({other})',
        currentAmountSummary: 'Số tiền két hiện tại: {total} = Tiền mặt({cash}) + Thẻ ngân hàng({bankCard}) + Khác({other})',
        currentCash: 'Tiền mặt hiện tại trong két:',
        currentBankCard: 'Thẻ ngân hàng hiện tại trong két:',
        currentOther: 'Khoản khác hiện tại trong két:',
        submitCash: 'Nộp tiền mặt',
        submitBankCard: 'Nộp thẻ ngân hàng',
        submitOther: 'Nộp khoản khác',
        cashBalance: 'Số dư tiền mặt:',
        bankCardBalance: 'Số dư thẻ ngân hàng:',
        otherBalance: 'Số dư khoản khác:',
        remark: 'Ghi chú:',
        submit: 'Nộp',
        submitHistory: 'Lịch sử nộp',
        submitTime: 'Thời gian nộp',
        startDate: 'Ngày bắt đầu',
        endDate: 'Ngày kết thúc',
        operator: 'Người thao tác',
        pleaseEnter: 'Vui lòng nhập',
        search: 'Tìm kiếm',
        export: 'Xuất',
        lastCashierBalance: 'Số dư két tiền kỳ trước',
        cash: 'Tiền mặt',
        bankCard: 'Thẻ ngân hàng',
        other: 'Khác',
        currentCashierAmount: 'Số tiền két kỳ này',
        currentSubmitAmount: 'Số tiền nộp kỳ này',
        currentCashierBalance: 'Số dư két kỳ này',
        initTipLine1: 'Vui lòng nhập số tiền két thực tế hiện tại.',
        initTipLine2: 'Sau khi khởi tạo, hệ thống sẽ tạo một bản ghi lịch sử với ghi chú [Dữ liệu khởi tạo].',
        currentCashierCash: 'Tiền mặt hiện tại trong két',
        currentCashierBankCard: 'Thẻ ngân hàng hiện tại trong két',
        currentCashierOther: 'Khoản khác hiện tại trong két',
        skipInit: 'Chưa khởi tạo',
        confirmInit: 'Xác nhận khởi tạo',
        pleaseEnterAmount: 'Vui lòng nhập số tiền',
        invalidAmountFormat: 'Định dạng số tiền không đúng, tối đa 2 chữ số thập phân.',
        notGreaterThanCurrentCash: 'Không được lớn hơn [Tiền mặt hiện tại trong két]',
        notGreaterThanCurrentBankCard: 'Không được lớn hơn [Thẻ ngân hàng hiện tại trong két]',
        notGreaterThanCurrentOther: 'Không được lớn hơn [Khoản khác hiện tại trong két]',
        hotelHistoricalTotal: 'Tổng lũy kế lịch sử của khách sạn',
        currentTime: 'Thời gian hiện tại',
        initBalanceCannotBeNegative: 'Số dư khởi tạo không được nhỏ hơn 0',
        cashierInitSuccess: 'Khởi tạo két tiền thành công',
        exportFailed: 'Xuất thất bại',
        checkSubmitAmount: 'Vui lòng kiểm tra số tiền nộp có chính xác không',
        confirmSubmitMessage: 'Xác nhận nộp bản ghi doanh thu lần này?',
        tip: 'Thông báo',
        submitSuccess: 'Nộp thành công',
        submitFailed: 'Nộp thất bại',
        total: 'Tổng',
        pushPriceLibrary: 'Đẩy giá và tồn kho',
        pushPriceLibrarySuccess: 'Đẩy giá và tồn kho thành công',
        pushPriceLibraryFail: 'Đẩy giá và tồn kho thất bại',
    },

    channelConfig: {
        noChannelConfigData: 'Chưa có dữ liệu cấu hình kênh',
        directConnected: 'Đã kết nối trực tiếp',
        notDirectConnected: 'Chưa kết nối trực tiếp',
        roomTypeMatch: 'Ghép loại phòng',
        bindNewAccount: 'Liên kết tài khoản mới',
        openDirectConnection: 'Mở kết nối trực tiếp',
        meituanHomestayStore: 'Cửa hàng Meituan Homestay',
        tujiaHomestayAccount: 'Tài khoản Tujia Homestay',
        deleteAccount: 'Xóa tài khoản',
        noBoundAccount: 'Chưa có tài khoản liên kết',
        breakDirectConnection: 'Ngắt kết nối trực tiếp',
        directConnectionStatus: 'Trạng thái kết nối',
        channelDiscount: 'Chiết khấu kênh',
        channelCommission: 'Hoa hồng kênh',
        qzCommission: 'Hoa hồng Qingzhu',
        meituanRoomType: 'Loại phòng Meituan',
        meituanRoomTypeId: 'ID loại phòng Meituan',
        tujiaHouse: 'Nhà Tujia',
        tujiaHouseId: 'ID nhà Tujia',
        meituanHomestay: 'Meituan Homestay',
        tujiaHomestay: 'Tujia Homestay',
        homestay: 'Homestay',
        goodsTypeNormal: 'Sản phẩm tiêu chuẩn',
        goodsTypeFree: 'Sản phẩm phòng miễn phí',
        goodsTypeOnlineHour: 'Phòng theo giờ online',
        goodsTypePresaleFullDay: 'Presale phòng cả ngày',
        goodsTypePresaleHour: 'Presale phòng theo giờ',
        fetchChannelConfigFail: 'Lấy cấu hình kênh thất bại',
        goodsTypePrefix: 'Loại sản phẩm {type}',
        openDirectSuccess: 'Mở kết nối trực tiếp thành công',
        openDirectFail: 'Mở kết nối trực tiếp thất bại',
        channelNotSupportRoomMatch: 'Kênh này chưa hỗ trợ ghép loại phòng',
        fetchRoomMatchFail: 'Lấy dữ liệu ghép loại phòng thất bại',
        pleaseSelectRoomType: 'Vui lòng chọn loại phòng Qingyingbao',
        pleaseSelectProduct: 'Vui lòng chọn sản phẩm Qingyingbao',
        bindFail: 'Liên kết thất bại',
        confirmUnbindRoomType: 'Bạn có chắc muốn hủy liên kết loại phòng này?',
        unbindFail: 'Hủy liên kết thất bại',
        channelNotSupportAccountBind: 'Kênh này chưa hỗ trợ liên kết tài khoản',
        bindAccountSuccess: 'Liên kết tài khoản thành công',
        bindAccountFail: 'Liên kết tài khoản thất bại',
        fetchAccountDetailFail: 'Lấy chi tiết tài khoản thất bại',
        confirmDeleteAccount: 'Bạn có chắc muốn xóa tài khoản này?',
        confirmBreakDirect: 'Bạn có chắc muốn ngắt kết nối trực tiếp?',
        breakDirectSuccess: 'Ngắt kết nối thành công',
        breakDirectFail: 'Ngắt kết nối thất bại',
        pushPriceLibrary: 'Đẩy giá và tồn kho 90 ngày',
        pushPriceLibrarySuccess: 'Đẩy giá và tồn kho thành công',
        pushPriceLibraryFail: 'Đẩy giá và tồn kho thất bại',
        pushPriceLibrarySwitch: 'Công tắc đẩy giá',
        pushSwitchOnSuccess: 'Đã bật công tắc đẩy',
        pushSwitchOffSuccess: 'Đã tắt công tắc đẩy',
        pushSwitchChangeFail: 'Đổi công tắc đẩy thất bại',
    },
    aiPmsRoomPricingSync: {
        hotelChannelSource: 'Nguồn giá', bookingHourOrderCountTitle: 'Số đơn đặt phòng theo giờ', bookingHourOrderCountNoData: 'Không có dữ liệu đơn đặt phòng theo giờ', bookingHourOrderCountDateRange: '7 ngày gần nhất {start} đến {end} | Hôm nay {date}', bookingHourOrderCountDateOnly: 'Hôm nay {date}', bookingHourOrderCountSevenDay: 'Đơn đặt phòng trong 7 ngày', bookingHourOrderCountToday: 'Đơn đặt phòng hôm nay', bookingHourOrderUnit: 'đơn', bookingHourOrderAxis: 'Đơn đặt phòng', viewTodayReports: 'Xem báo cáo hôm nay', backToTodayReports: 'Quay lại báo cáo hôm nay', backToLatestReport: 'Quay lại báo cáo mới nhất', historyEmpty: 'Không có báo cáo định giá thông minh này', todayReportTitle: 'Báo cáo {date}', pricingTime: 'Thời gian định giá', reportTitle: 'Tiêu đề báo cáo', pricingChannel: 'Kênh định giá', viewDetail: 'Chi tiết', todayReportEmpty: 'Không có báo cáo định giá loại phòng hoàn thành hôm nay',
    },
    commonBook: {
        commonBooking: 'Đặt phòng hợp nhất', fitBooking: 'Đặt phòng khách lẻ', longStayBooking: 'Đặt phòng dài hạn', teamBooking: 'Đặt phòng đoàn', walkIn: 'Khách vãng lai', ebkManualMove: 'Chuyển đơn EBK thủ công',
        sourceType: 'Loại nguồn khách', externalChannel: 'Kênh bên ngoài', channelOrderNo: 'Mã đơn kênh', arrivalTime: 'Thời gian đến', departureTime: 'Thời gian đi', retentionTime: 'Giữ phòng đến', stayDuration: 'Thời lượng lưu trú', days: 'Số ngày', contact: 'Người liên hệ', contactPhone: 'Điện thoại liên hệ', teamType: 'Loại đoàn', teamName: 'Tên đoàn', contractNo: 'Mã hợp đồng',
        paymentInfo: 'Thông tin thanh toán', paymentMethod: 'Phương thức thanh toán', amount: 'Số tiền', storedValueMember: 'Hội viên có số dư', paymentCode: 'Mã xác minh thanh toán', remark: 'Ghi chú', totalRooms: 'Số phòng', stayDays: 'Số ngày lưu trú', taxAmount: 'Thuế', roomPrice: 'Giá phòng', totalPrice: 'Tổng giá', submitBooking: 'Xác nhận đặt phòng',
        addRoom: 'Thêm phòng', addRoomType: 'Thêm loại phòng', roomType: 'Loại phòng', roomStatus: 'Trạng thái phòng', room: 'Phòng', loading: 'Đang tải', noAvailableRoomType: 'Không có loại phòng khả dụng', noAvailableRoom: 'Không có phòng khả dụng. Vui lòng điều chỉnh loại hoặc trạng thái phòng.', noValidRoomType: 'Không có loại phòng hợp lệ', selectedRoomCount: 'Đã chọn {count} phòng; chọn ít nhất 1 phòng', emptyClean: 'Phòng trống sạch', emptyDirty: 'Phòng trống bẩn', selectRoomType: 'Chọn loại phòng',
        availableRooms: 'Có thể đặt', breakfast: 'Bữa sáng', roomCount: 'Số phòng', bookedRoomCount: 'Phòng đã đặt', walkInRoomCount: 'Số phòng nhận', arrangeRoom: 'Xếp phòng', dailyPrice: 'Giá hằng ngày', unassignedRooms: '{count} phòng chưa xếp', assignedRoom: 'Đã xếp {room}', selectedRoom: 'Đã chọn {room}', delete: 'Xóa', to: 'đến', addGuest: 'Thêm khách', channelRoomType: 'Loại phòng trên kênh', currencyUnit: 'CNY', tax: 'Thuế',
        pleaseSelect: 'Vui lòng chọn', pleaseEnter: 'Vui lòng nhập', enterChannelName: 'Nhập tên kênh', cancel: 'Hủy', confirm: 'Xác nhận', close: 'Đóng', roomDetail: 'Chi tiết phiếu phòng',
        selectSourceType: 'Chọn loại nguồn khách', selectMemberInfo: 'Chọn thông tin hội viên', selectCompany: 'Chọn công ty hợp đồng', selectStayType: 'Chọn loại lưu trú', selectArrivalTime: 'Chọn thời gian đến', selectDepartureTime: 'Chọn thời gian đi', enterContact: 'Nhập người liên hệ', selectTeamType: 'Chọn loại đoàn', enterTeamName: 'Nhập tên đoàn',
        basePriceMode: 'Chế độ giá đáy', sellingPriceMode: 'Chế độ giá bán', useEbkOrderInfo: 'Dùng thông tin đơn EB', initializationFailed: 'Khởi tạo đặt phòng hợp nhất thất bại. Hãy đóng và thử lại.', dictionaryLoadFailed: 'Tải dữ liệu đặt phòng thất bại', companyNotFound: 'Không tìm thấy công ty hợp đồng phù hợp',
        minimumStayDays: 'Thời gian ở tối thiểu là {count} ngày', maximumStayDays: 'Thời gian ở tối đa là {count} ngày', retentionBeforeArrival: 'Thời gian giữ phòng không được sớm hơn thời gian đến', retentionTooLate: 'Thời gian giữ phòng vượt quá giới hạn cho phép', retentionOutOfRange: 'Thời gian giữ phòng ngoài phạm vi cho phép',
        invalidBreakfast: 'Số bữa sáng của {roomType} phải là số nguyên từ 0 đến 999 và không được để trống', invalidRoomCount: 'Số phòng của {roomType} phải là số nguyên không âm và không được để trống', enterExternalChannel: 'Nhập tên kênh bên ngoài', invalidHourDuration: 'Thời lượng lưu trú phải là số nguyên từ 1 đến 12 giờ', invalidStayDays: 'Số ngày lưu trú phải là số nguyên từ {min} đến {max}', incompleteStay: '{roomType} có kỳ lưu trú chưa đầy đủ', arrivalBeforeBusinessDate: 'Ngày đến của {roomType} không được trước ngày kinh doanh hiện tại', roomTypeStayRange: 'Kỳ lưu trú của {roomType} phải từ 1 đến {max} ngày', roomTypeDuplicateStay: 'Không thể thêm kỳ lưu trú trùng cho {roomType}',
        selectAtLeastOneRoomType: 'Chọn ít nhất một loại phòng có thể đặt', selectMember: 'Chọn hội viên', missingProductOrPrice: 'Loại phòng đã chọn thiếu sản phẩm hoặc giá hằng ngày', roomCountExceedsAvailability: 'Số phòng đặt vượt quá số phòng khả dụng', walkInRequiresRoom: 'Khách vãng lai phải được xếp phòng cụ thể', guestRequiredPerRoom: 'Nhập khách cho từng phòng', completeGuestName: 'Hoàn tất tên của tất cả khách', selectPaymentForDeposit: 'Chọn phương thức thanh toán khi thu tiền cọc', selectMemberForStoredValue: 'Chọn hội viên để thanh toán bằng số dư', insufficientMemberBalance: 'Số dư hội viên là {balance} CNY. Hãy chọn phương thức khác.', enterStoredValueCode: 'Nhập mã xác minh thanh toán bằng số dư',
        bookingFailed: 'Đặt phòng thất bại. Hãy điều chỉnh và thử lại.', bookingSuccess: 'Đặt phòng thành công', overOccupancyConfirmation: 'Số khách vượt quá sức chứa tối đa của phòng. Tiếp tục nhận phòng?', overOccupancyPromptTitle: 'Thông báo', walkInMissingMasterRoom: 'Nhận phòng thành công nhưng không trả về mã phiếu phòng chính', checkInSuccess: 'Nhận phòng thành công', createdWithoutOrderNo: 'Tạo thành công nhưng không trả về mã đơn. Hãy bổ sung khoản thu tại trang tài chính.', walkInWithoutMasterRoomForPayment: 'Nhận phòng thành công nhưng không trả về phiếu phòng chính. Hãy bổ sung khoản thu tại trang tài chính.', onlinePaymentFailed: 'Yêu cầu thanh toán trực tuyến thất bại', paymentStatusFailed: 'Truy vấn trạng thái thanh toán thất bại',
        sameStayExists: 'Loại phòng này đã có cùng kỳ lưu trú', departureAfterArrival: 'Thời gian đi phải sau thời gian đến', duplicateStayNotAllowed: 'Không cho phép kỳ lưu trú trùng trong cùng loại phòng', selectUnaddedRoom: 'Chọn phòng chưa được thêm', keepOneWalkInRoom: 'Khách vãng lai phải giữ lại ít nhất một phòng', ebkRoomCountMismatch: 'Số phòng đặt khác với số phòng trong đơn hàng kênh. Tiếp tục đặt phòng?', continueBooking: 'Tiếp tục đặt phòng', modify: 'Chỉnh sửa',
    },
    aiPmsRoomPricingSync: {
        hotelChannelSource: 'Nguồn giá', bookingHourOrderCountTitle: 'Số đơn đặt phòng theo giờ', bookingHourOrderCountNoData: 'Không có dữ liệu đơn đặt phòng theo giờ', bookingHourOrderCountDateRange: '7 ngày gần nhất {start} đến {end} | Hôm nay {date}', bookingHourOrderCountDateOnly: 'Hôm nay {date}', bookingHourOrderCountSevenDay: 'Đơn đặt phòng trong 7 ngày', bookingHourOrderCountToday: 'Đơn đặt phòng hôm nay', bookingHourOrderUnit: 'đơn', bookingHourOrderAxis: 'Đơn đặt phòng', viewTodayReports: 'Xem báo cáo hôm nay', backToTodayReports: 'Quay lại báo cáo hôm nay', backToLatestReport: 'Quay lại báo cáo mới nhất', historyEmpty: 'Không có báo cáo định giá thông minh này', todayReportTitle: 'Báo cáo {date}', pricingTime: 'Thời gian định giá', reportTitle: 'Tiêu đề báo cáo', pricingChannel: 'Kênh định giá', viewDetail: 'Chi tiết', todayReportEmpty: 'Không có báo cáo định giá loại phòng hoàn thành hôm nay',
    },

  inventoryPhase1: {
    itemType: '物品类型',
    itemSpec: '物品规格',
    itemTypeName: '物品类型名称',
    itemSpecName: '物品规格名称',
    itemName: '物品名称',
    itemCode: '物品编码',
    enterItemName: '输入物品名称',
    itemUnit: '规格单位',
    itemSort: '物品排序',
    enterItemTypeName: '输入物品类型名称',
    enterItemSpecName: '输入物品规格名称',
    newType: '新建类型',
    newSpec: '新建规格',
    newItem: '新建物品',
    modifyItem: '修改物品',
    warningQty: '预警数量',
    warningQtyLabel: '库存预警数量',
    salePoint: '销售点',
    scene: '使用场景',
    guestRoom: '客房',
    fnb: '餐饮',
    meeting: '会议',
    sceneSale: '支持售卖',
    sceneClean: '支持房间打扫添加',
    sceneBorrow: '支持借用',
    selectType: '请选择物品类型',
    selectSpec: '请选择物品规格',
    fillItemName: '请填写物品名称',
    selectSalePoint: '请至少选择一个销售点',
    warningCloseHint: '0表示关闭预警',
    inboundType: '入库方式',
    outboundType: '出库方式',
    manualInbound: '手工入库',
    sale: '商品售卖',
    roomClean: '房间打扫添加',
    roomBorrow: '房间借用',
    manualOutbound: '手工出库',
    newOutbound: 'Thêm xuất kho',
    selectOutboundType: 'Vui lòng chọn cách xuất kho',
    createTime: '创建时间',
    catalogSource: '来源',
    groupCatalog: '集团底账',
    hotelCatalog: '本店',
    groupCatalogCannotEdit: '集团底账不能修改',
    groupCatalogCannotDelete: '集团底账不能删除',
    confirmDeleteType: '确认要删除该物品类型吗？',
    confirmDeleteSpec: '确认要删除该物品规格吗？',
    modifySuccess: '修改成功',
    createSuccess: '新建成功',
    filterSale: '可售卖',
    filterRoomClean: '房间打扫可添加',
    filterRoomBorrow: '可借用',
    availableSalePoint: '可用销售点',
    borrowReturn: '借用归还',
    saleVoid: '售卖冲账',
    sortOrder: '排序',
    fillWarningQty: '请填写库存预警数量',
    warningQtyInvalid: '库存预警数量须为不小于0的整数',
  },
  aiPmsCtripPeerSync: {
    ctrip: 'Ctrip',
    account: 'Tài khoản',
    mobilePlaceholder: 'Nhập số điện thoại',
    code: 'Mã SMS',
    codePlaceholder: 'Nhập mã SMS',
    login: 'Đăng nhập',
    resend: 'Gửi lại',
    send: 'Gửi mã',
    collectFailed: 'Không thể thu thập giá đối thủ Ctrip. Vui lòng làm mới sau.',
    dataFailed: 'Không thể tải dữ liệu',
    relogin: 'Đăng nhập lại',
    unbind: 'Hủy liên kết',
    updatedAt: 'Cập nhật: {time}',
    hotelName: 'Khách sạn',
    price: 'Giá',
    empty: 'Chưa có giá thu hút khách của đối thủ trên {channel}',
    accountRequired: 'Nhập tài khoản Ctrip',
    codeRequired: 'Nhập mã xác minh SMS',
    loggingIn: 'Đang đăng nhập; giá đối thủ Ctrip sẽ được thu thập sau khi đăng nhập',
    smsSent: 'Đã gửi mã SMS. Vui lòng nhập mã',
    smsFailed: 'Gửi mã SMS thất bại. Vui lòng gửi lại',
    verifyFailed: 'Xác minh SMS thất bại. Nhập lại mã để đăng nhập',
    loginFailed: 'Đăng nhập Ctrip thất bại. Gửi mã mới để đăng nhập',
    deviceVerify: 'Hoàn tất xác minh thiết bị cho tài khoản Ctrip, rồi gửi mã mới để đăng nhập',
    loginRequired: 'Gửi mã SMS để đăng nhập lại Ctrip',
    expired: 'Tài khoản Ctrip hết hạn. Vui lòng đăng nhập',
    sending: 'Đang gửi mã SMS…',
    collecting: 'Đã đăng nhập. Đang thu thập giá đối thủ Ctrip…',
    today: 'Hôm nay {time}',
    daysAgo: '{days} ngày trước',
    crawlSubmitted: 'Đã gửi tác vụ thu thập khách sạn yêu thích Ctrip',
    smsSubmitted: 'Đã gửi yêu cầu mã SMS',
    unbindConfirm: 'Hủy liên kết tài khoản Ctrip hiện tại? Lịch sử giá sẽ được giữ lại.',
    unbindTitle: 'Hủy liên kết tài khoản Ctrip',
    unbound: 'Đã hủy liên kết tài khoản Ctrip',
  },
};
